(function (Ht) {
  typeof define == 'function' && define.amd ? define(Ht) : Ht();
})(function () {
  'use strict';
  var Ul = Object.defineProperty;
  var Wl = (Ht, pt, ce) =>
    pt in Ht
      ? Ul(Ht, pt, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: ce,
        })
      : (Ht[pt] = ce);
  var Bt = (Ht, pt, ce) => (
    Wl(Ht, typeof pt != 'symbol' ? pt + '' : pt, ce), ce
  );
  var Ht,
    pt,
    ce,
    Ie,
    Ar,
    Er,
    Ke = {},
    Lr = [],
    Eo = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
  function ne(e, n) {
    for (var t in n) e[t] = n[t];
    return e;
  }
  function Tr(e) {
    var n = e.parentNode;
    n && n.removeChild(e);
  }
  function Wt(e, n, t) {
    var r,
      o,
      i,
      a = {};
    for (i in n)
      i == 'key' ? (r = n[i]) : i == 'ref' ? (o = n[i]) : (a[i] = n[i]);
    if (
      (arguments.length > 2 &&
        (a.children = arguments.length > 3 ? Ht.call(arguments, 2) : t),
      typeof e == 'function' && e.defaultProps != null)
    )
      for (i in e.defaultProps) a[i] === void 0 && (a[i] = e.defaultProps[i]);
    return Re(e, a, r, o, null);
  }
  function Re(e, n, t, r, o) {
    var i = {
      type: e,
      props: n,
      key: t,
      ref: r,
      __k: null,
      __: null,
      __b: 0,
      __e: null,
      __d: void 0,
      __c: null,
      __h: null,
      constructor: void 0,
      __v: o == null ? ++ce : o,
    };
    return o == null && pt.vnode != null && pt.vnode(i), i;
  }
  function Lo() {
    return { current: null };
  }
  function qt(e) {
    return e.children;
  }
  function Yt(e, n) {
    (this.props = e), (this.context = n);
  }
  function we(e, n) {
    if (n == null) return e.__ ? we(e.__, e.__.__k.indexOf(e) + 1) : null;
    for (var t; n < e.__k.length; n++)
      if ((t = e.__k[n]) != null && t.__e != null) return t.__e;
    return typeof e.type == 'function' ? we(e) : null;
  }
  function Ir(e) {
    var n, t;
    if ((e = e.__) != null && e.__c != null) {
      for (e.__e = e.__c.base = null, n = 0; n < e.__k.length; n++)
        if ((t = e.__k[n]) != null && t.__e != null) {
          e.__e = e.__c.base = t.__e;
          break;
        }
      return Ir(e);
    }
  }
  function zn(e) {
    ((!e.__d && (e.__d = !0) && Ie.push(e) && !Je.__r++) ||
      Ar !== pt.debounceRendering) &&
      ((Ar = pt.debounceRendering) || setTimeout)(Je);
  }
  function Je() {
    for (var e; (Je.__r = Ie.length); )
      (e = Ie.sort(function (n, t) {
        return n.__v.__b - t.__v.__b;
      })),
        (Ie = []),
        e.some(function (n) {
          var t, r, o, i, a, s;
          n.__d &&
            ((a = (i = (t = n).__v).__e),
            (s = t.__P) &&
              ((r = []),
              ((o = ne({}, i)).__v = i.__v + 1),
              Nn(
                s,
                i,
                o,
                t.__n,
                s.ownerSVGElement !== void 0,
                i.__h != null ? [a] : null,
                r,
                a == null ? we(i) : a,
                i.__h
              ),
              Mr(r, i),
              i.__e != a && Ir(i)));
        });
  }
  function Rr(e, n, t, r, o, i, a, s, l, g) {
    var c,
      w,
      b,
      h,
      _,
      d,
      v,
      m = (r && r.__k) || Lr,
      k = m.length;
    for (t.__k = [], c = 0; c < n.length; c++)
      if (
        (h = t.__k[c] =
          (h = n[c]) == null || typeof h == 'boolean'
            ? null
            : typeof h == 'string' ||
              typeof h == 'number' ||
              typeof h == 'bigint'
            ? Re(null, h, null, null, h)
            : Array.isArray(h)
            ? Re(qt, { children: h }, null, null, null)
            : h.__b > 0
            ? Re(h.type, h.props, h.key, null, h.__v)
            : h) != null
      ) {
        if (
          ((h.__ = t),
          (h.__b = t.__b + 1),
          (b = m[c]) === null || (b && h.key == b.key && h.type === b.type))
        )
          m[c] = void 0;
        else
          for (w = 0; w < k; w++) {
            if ((b = m[w]) && h.key == b.key && h.type === b.type) {
              m[w] = void 0;
              break;
            }
            b = null;
          }
        Nn(e, h, (b = b || Ke), o, i, a, s, l, g),
          (_ = h.__e),
          (w = h.ref) &&
            b.ref != w &&
            (v || (v = []),
            b.ref && v.push(b.ref, null, h),
            v.push(w, h.__c || _, h)),
          _ != null
            ? (d == null && (d = _),
              typeof h.type == 'function' && h.__k === b.__k
                ? (h.__d = l = Or(h, l, e))
                : (l = Dr(e, h, b, m, _, l)),
              typeof t.type == 'function' && (t.__d = l))
            : l && b.__e == l && l.parentNode != e && (l = we(b));
      }
    for (t.__e = d, c = k; c--; )
      m[c] != null &&
        (typeof t.type == 'function' &&
          m[c].__e != null &&
          m[c].__e == t.__d &&
          (t.__d = we(r, c + 1)),
        Br(m[c], m[c]));
    if (v) for (c = 0; c < v.length; c++) Fr(v[c], v[++c], v[++c]);
  }
  function Or(e, n, t) {
    for (var r, o = e.__k, i = 0; o && i < o.length; i++)
      (r = o[i]) &&
        ((r.__ = e),
        (n =
          typeof r.type == 'function'
            ? Or(r, n, t)
            : Dr(t, r, r, o, r.__e, n)));
    return n;
  }
  function re(e, n) {
    return (
      (n = n || []),
      e == null ||
        typeof e == 'boolean' ||
        (Array.isArray(e)
          ? e.some(function (t) {
              re(t, n);
            })
          : n.push(e)),
      n
    );
  }
  function Dr(e, n, t, r, o, i) {
    var a, s, l;
    if (n.__d !== void 0) (a = n.__d), (n.__d = void 0);
    else if (t == null || o != i || o.parentNode == null)
      t: if (i == null || i.parentNode !== e) e.appendChild(o), (a = null);
      else {
        for (s = i, l = 0; (s = s.nextSibling) && l < r.length; l += 2)
          if (s == o) break t;
        e.insertBefore(o, i), (a = i);
      }
    return a !== void 0 ? a : o.nextSibling;
  }
  function To(e, n, t, r, o) {
    var i;
    for (i in t)
      i === 'children' || i === 'key' || i in n || Qe(e, i, null, t[i], r);
    for (i in n)
      (o && typeof n[i] != 'function') ||
        i === 'children' ||
        i === 'key' ||
        i === 'value' ||
        i === 'checked' ||
        t[i] === n[i] ||
        Qe(e, i, n[i], t[i], r);
  }
  function Pr(e, n, t) {
    n[0] === '-'
      ? e.setProperty(n, t)
      : (e[n] =
          t == null ? '' : typeof t != 'number' || Eo.test(n) ? t : t + 'px');
  }
  function Qe(e, n, t, r, o) {
    var i;
    t: if (n === 'style')
      if (typeof t == 'string') e.style.cssText = t;
      else {
        if ((typeof r == 'string' && (e.style.cssText = r = ''), r))
          for (n in r) (t && n in t) || Pr(e.style, n, '');
        if (t) for (n in t) (r && t[n] === r[n]) || Pr(e.style, n, t[n]);
      }
    else if (n[0] === 'o' && n[1] === 'n')
      (i = n !== (n = n.replace(/Capture$/, ''))),
        (n = n.toLowerCase() in e ? n.toLowerCase().slice(2) : n.slice(2)),
        e.l || (e.l = {}),
        (e.l[n + i] = t),
        t
          ? r || e.addEventListener(n, i ? Nr : zr, i)
          : e.removeEventListener(n, i ? Nr : zr, i);
    else if (n !== 'dangerouslySetInnerHTML') {
      if (o) n = n.replace(/xlink(H|:h)/, 'h').replace(/sName$/, 's');
      else if (
        n !== 'href' &&
        n !== 'list' &&
        n !== 'form' &&
        n !== 'tabIndex' &&
        n !== 'download' &&
        n in e
      )
        try {
          e[n] = t == null ? '' : t;
          break t;
        } catch {}
      typeof t == 'function' ||
        (t != null && (t !== !1 || (n[0] === 'a' && n[1] === 'r'))
          ? e.setAttribute(n, t)
          : e.removeAttribute(n));
    }
  }
  function zr(e) {
    this.l[e.type + !1](pt.event ? pt.event(e) : e);
  }
  function Nr(e) {
    this.l[e.type + !0](pt.event ? pt.event(e) : e);
  }
  function Nn(e, n, t, r, o, i, a, s, l) {
    var g,
      c,
      w,
      b,
      h,
      _,
      d,
      v,
      m,
      k,
      E,
      I,
      A,
      U = n.type;
    if (n.constructor !== void 0) return null;
    t.__h != null &&
      ((l = t.__h), (s = n.__e = t.__e), (n.__h = null), (i = [s])),
      (g = pt.__b) && g(n);
    try {
      t: if (typeof U == 'function') {
        if (
          ((v = n.props),
          (m = (g = U.contextType) && r[g.__c]),
          (k = g ? (m ? m.props.value : g.__) : r),
          t.__c
            ? (d = (c = n.__c = t.__c).__ = c.__E)
            : ('prototype' in U && U.prototype.render
                ? (n.__c = c = new U(v, k))
                : ((n.__c = c = new Yt(v, k)),
                  (c.constructor = U),
                  (c.render = Ro)),
              m && m.sub(c),
              (c.props = v),
              c.state || (c.state = {}),
              (c.context = k),
              (c.__n = r),
              (w = c.__d = !0),
              (c.__h = [])),
          c.__s == null && (c.__s = c.state),
          U.getDerivedStateFromProps != null &&
            (c.__s == c.state && (c.__s = ne({}, c.__s)),
            ne(c.__s, U.getDerivedStateFromProps(v, c.__s))),
          (b = c.props),
          (h = c.state),
          w)
        )
          U.getDerivedStateFromProps == null &&
            c.componentWillMount != null &&
            c.componentWillMount(),
            c.componentDidMount != null && c.__h.push(c.componentDidMount);
        else {
          if (
            (U.getDerivedStateFromProps == null &&
              v !== b &&
              c.componentWillReceiveProps != null &&
              c.componentWillReceiveProps(v, k),
            (!c.__e &&
              c.shouldComponentUpdate != null &&
              c.shouldComponentUpdate(v, c.__s, k) === !1) ||
              n.__v === t.__v)
          ) {
            (c.props = v),
              (c.state = c.__s),
              n.__v !== t.__v && (c.__d = !1),
              (c.__v = n),
              (n.__e = t.__e),
              (n.__k = t.__k),
              n.__k.forEach(function (W) {
                W && (W.__ = n);
              }),
              c.__h.length && a.push(c);
            break t;
          }
          c.componentWillUpdate != null && c.componentWillUpdate(v, c.__s, k),
            c.componentDidUpdate != null &&
              c.__h.push(function () {
                c.componentDidUpdate(b, h, _);
              });
        }
        if (
          ((c.context = k),
          (c.props = v),
          (c.__v = n),
          (c.__P = e),
          (E = pt.__r),
          (I = 0),
          'prototype' in U && U.prototype.render)
        )
          (c.state = c.__s),
            (c.__d = !1),
            E && E(n),
            (g = c.render(c.props, c.state, c.context));
        else
          do
            (c.__d = !1),
              E && E(n),
              (g = c.render(c.props, c.state, c.context)),
              (c.state = c.__s);
          while (c.__d && ++I < 25);
        (c.state = c.__s),
          c.getChildContext != null && (r = ne(ne({}, r), c.getChildContext())),
          w ||
            c.getSnapshotBeforeUpdate == null ||
            (_ = c.getSnapshotBeforeUpdate(b, h)),
          (A =
            g != null && g.type === qt && g.key == null ? g.props.children : g),
          Rr(e, Array.isArray(A) ? A : [A], n, t, r, o, i, a, s, l),
          (c.base = n.__e),
          (n.__h = null),
          c.__h.length && a.push(c),
          d && (c.__E = c.__ = null),
          (c.__e = !1);
      } else i == null && n.__v === t.__v ? ((n.__k = t.__k), (n.__e = t.__e)) : (n.__e = Io(t.__e, n, t, r, o, i, a, l));
      (g = pt.diffed) && g(n);
    } catch (W) {
      (n.__v = null),
        (l || i != null) &&
          ((n.__e = s), (n.__h = !!l), (i[i.indexOf(s)] = null)),
        pt.__e(W, n, t);
    }
  }
  function Mr(e, n) {
    pt.__c && pt.__c(n, e),
      e.some(function (t) {
        try {
          (e = t.__h),
            (t.__h = []),
            e.some(function (r) {
              r.call(t);
            });
        } catch (r) {
          pt.__e(r, t.__v);
        }
      });
  }
  function Io(e, n, t, r, o, i, a, s) {
    var l,
      g,
      c,
      w = t.props,
      b = n.props,
      h = n.type,
      _ = 0;
    if ((h === 'svg' && (o = !0), i != null)) {
      for (; _ < i.length; _++)
        if (
          (l = i[_]) &&
          'setAttribute' in l == !!h &&
          (h ? l.localName === h : l.nodeType === 3)
        ) {
          (e = l), (i[_] = null);
          break;
        }
    }
    if (e == null) {
      if (h === null) return document.createTextNode(b);
      (e = o
        ? document.createElementNS('http://www.w3.org/2000/svg', h)
        : document.createElement(h, b.is && b)),
        (i = null),
        (s = !1);
    }
    if (h === null) w === b || (s && e.data === b) || (e.data = b);
    else {
      if (
        ((i = i && Ht.call(e.childNodes)),
        (g = (w = t.props || Ke).dangerouslySetInnerHTML),
        (c = b.dangerouslySetInnerHTML),
        !s)
      ) {
        if (i != null)
          for (w = {}, _ = 0; _ < e.attributes.length; _++)
            w[e.attributes[_].name] = e.attributes[_].value;
        (c || g) &&
          ((c && ((g && c.__html == g.__html) || c.__html === e.innerHTML)) ||
            (e.innerHTML = (c && c.__html) || ''));
      }
      if ((To(e, b, w, o, s), c)) n.__k = [];
      else if (
        ((_ = n.props.children),
        Rr(
          e,
          Array.isArray(_) ? _ : [_],
          n,
          t,
          r,
          o && h !== 'foreignObject',
          i,
          a,
          i ? i[0] : t.__k && we(t, 0),
          s
        ),
        i != null)
      )
        for (_ = i.length; _--; ) i[_] != null && Tr(i[_]);
      s ||
        ('value' in b &&
          (_ = b.value) !== void 0 &&
          (_ !== e.value ||
            (h === 'progress' && !_) ||
            (h === 'option' && _ !== w.value)) &&
          Qe(e, 'value', _, w.value, !1),
        'checked' in b &&
          (_ = b.checked) !== void 0 &&
          _ !== e.checked &&
          Qe(e, 'checked', _, w.checked, !1));
    }
    return e;
  }
  function Fr(e, n, t) {
    try {
      typeof e == 'function' ? e(n) : (e.current = n);
    } catch (r) {
      pt.__e(r, t);
    }
  }
  function Br(e, n, t) {
    var r, o;
    if (
      (pt.unmount && pt.unmount(e),
      (r = e.ref) && ((r.current && r.current !== e.__e) || Fr(r, null, n)),
      (r = e.__c) != null)
    ) {
      if (r.componentWillUnmount)
        try {
          r.componentWillUnmount();
        } catch (i) {
          pt.__e(i, n);
        }
      r.base = r.__P = null;
    }
    if ((r = e.__k))
      for (o = 0; o < r.length; o++)
        r[o] && Br(r[o], n, typeof e.type != 'function');
    t || e.__e == null || Tr(e.__e), (e.__e = e.__d = void 0);
  }
  function Ro(e, n, t) {
    return this.constructor(e, t);
  }
  function he(e, n, t) {
    var r, o, i;
    pt.__ && pt.__(e, n),
      (o = (r = typeof t == 'function') ? null : (t && t.__k) || n.__k),
      (i = []),
      Nn(
        n,
        (e = ((!r && t) || n).__k = Wt(qt, null, [e])),
        o || Ke,
        Ke,
        n.ownerSVGElement !== void 0,
        !r && t ? [t] : o ? null : n.firstChild ? Ht.call(n.childNodes) : null,
        i,
        !r && t ? t : o ? o.__e : n.firstChild,
        r
      ),
      Mr(i, e);
  }
  function Mn(e, n) {
    he(e, n, Mn);
  }
  function Fn(e, n, t) {
    var r,
      o,
      i,
      a = ne({}, e.props);
    for (i in n)
      i == 'key' ? (r = n[i]) : i == 'ref' ? (o = n[i]) : (a[i] = n[i]);
    return (
      arguments.length > 2 &&
        (a.children = arguments.length > 3 ? Ht.call(arguments, 2) : t),
      Re(e.type, a, r || e.key, o || e.ref, null)
    );
  }
  function Bn(e, n) {
    var t = {
      __c: (n = '__cC' + Er++),
      __: e,
      Consumer: function (r, o) {
        return r.children(o);
      },
      Provider: function (r) {
        var o, i;
        return (
          this.getChildContext ||
            ((o = []),
            ((i = {})[n] = this),
            (this.getChildContext = function () {
              return i;
            }),
            (this.shouldComponentUpdate = function (a) {
              this.props.value !== a.value && o.some(zn);
            }),
            (this.sub = function (a) {
              o.push(a);
              var s = a.componentWillUnmount;
              a.componentWillUnmount = function () {
                o.splice(o.indexOf(a), 1), s && s.call(a);
              };
            })),
          r.children
        );
      },
    };
    return (t.Provider.__ = t.Consumer.contextType = t);
  }
  (Ht = Lr.slice),
    (pt = {
      __e: function (e, n, t, r) {
        for (var o, i, a; (n = n.__); )
          if ((o = n.__c) && !o.__)
            try {
              if (
                ((i = o.constructor) &&
                  i.getDerivedStateFromError != null &&
                  (o.setState(i.getDerivedStateFromError(e)), (a = o.__d)),
                o.componentDidCatch != null &&
                  (o.componentDidCatch(e, r || {}), (a = o.__d)),
                a)
              )
                return (o.__E = o);
            } catch (s) {
              e = s;
            }
        throw e;
      },
    }),
    (ce = 0),
    (Yt.prototype.setState = function (e, n) {
      var t;
      (t =
        this.__s != null && this.__s !== this.state
          ? this.__s
          : (this.__s = ne({}, this.state))),
        typeof e == 'function' && (e = e(ne({}, t), this.props)),
        e && ne(t, e),
        e != null && this.__v && (n && this.__h.push(n), zn(this));
    }),
    (Yt.prototype.forceUpdate = function (e) {
      this.__v && ((this.__e = !0), e && this.__h.push(e), zn(this));
    }),
    (Yt.prototype.render = qt),
    (Ie = []),
    (Je.__r = 0),
    (Er = 0);
  function Vn() {
    return (Vn =
      Object.assign ||
      function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];
          for (var r in t)
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
      }).apply(this, arguments);
  }
  function Oo(e) {
    this.getChildContext = function () {
      return e.context;
    };
    var n = e.children,
      t = (function (r, o) {
        if (r == null) return {};
        var i,
          a,
          s = {},
          l = Object.keys(r);
        for (a = 0; a < l.length; a++)
          o.indexOf((i = l[a])) >= 0 || (s[i] = r[i]);
        return s;
      })(e, ['context', 'children']);
    return Fn(n, t);
  }
  function Do() {
    var e = new CustomEvent('_preact', {
      detail: {},
      bubbles: !0,
      cancelable: !0,
    });
    this.dispatchEvent(e),
      (this._vdom = Wt(
        Oo,
        Vn({}, this._props, { context: e.detail.context }),
        (function n(t, r) {
          if (t.nodeType === 3) return t.data;
          if (t.nodeType !== 1) return null;
          var o = [],
            i = {},
            a = 0,
            s = t.attributes,
            l = t.childNodes;
          for (a = s.length; a--; )
            s[a].name !== 'slot' &&
              ((i[s[a].name] = s[a].value), (i[Vr(s[a].name)] = s[a].value));
          for (a = l.length; a--; ) {
            var g = n(l[a], null),
              c = l[a].slot;
            c ? (i[c] = Wt(jr, { name: c }, g)) : (o[a] = g);
          }
          var w = r ? Wt(jr, null, o) : o;
          return Wt(r || t.nodeName.toLowerCase(), i, w);
        })(this, this._vdomComponent)
      )),
      (this.hasAttribute('hydrate') ? Mn : he)(this._vdom, this._root);
  }
  function Vr(e) {
    return e.replace(/-(\w)/g, function (n, t) {
      return t ? t.toUpperCase() : '';
    });
  }
  function Po(e, n, t) {
    if (this._vdom) {
      var r = {};
      (r[e] = t = t == null ? void 0 : t),
        (r[Vr(e)] = t),
        (this._vdom = Fn(this._vdom, r)),
        he(this._vdom, this._root);
    }
  }
  function zo() {
    he((this._vdom = null), this._root);
  }
  function jr(e, n) {
    var t = this;
    return Wt(
      'slot',
      Vn({}, e, {
        ref: function (r) {
          r
            ? ((t.ref = r),
              t._listener ||
                ((t._listener = function (o) {
                  o.stopPropagation(), (o.detail.context = n);
                }),
                r.addEventListener('_preact', t._listener)))
            : t.ref.removeEventListener('_preact', t._listener);
        },
      })
    );
  }
  function No(e, n, t, r) {
    function o() {
      var i = Reflect.construct(HTMLElement, [], o);
      return (
        (i._vdomComponent = e),
        (i._root = r && r.shadow ? i.attachShadow({ mode: 'open' }) : i),
        i
      );
    }
    return (
      ((o.prototype = Object.create(HTMLElement.prototype)).constructor = o),
      (o.prototype.connectedCallback = Do),
      (o.prototype.attributeChangedCallback = Po),
      (o.prototype.disconnectedCallback = zo),
      (t = t || e.observedAttributes || Object.keys(e.propTypes || {})),
      (o.observedAttributes = t),
      t.forEach(function (i) {
        Object.defineProperty(o.prototype, i, {
          get: function () {
            return this._vdom.props[i];
          },
          set: function (a) {
            this._vdom
              ? this.attributeChangedCallback(i, null, a)
              : (this._props || (this._props = {}),
                (this._props[i] = a),
                this.connectedCallback());
            var s = typeof a;
            (a != null &&
              s !== 'string' &&
              s !== 'boolean' &&
              s !== 'number') ||
              this.setAttribute(i, a);
          },
        });
      }),
      customElements.define(n || e.tagName || e.displayName || e.name, o)
    );
  }
  var be,
    Pt,
    jn,
    $r,
    Ce = 0,
    Ur = [],
    tn = [],
    Wr = pt.__b,
    Hr = pt.__r,
    Zr = pt.diffed,
    Yr = pt.__c,
    Gr = pt.unmount;
  function Oe(e, n) {
    pt.__h && pt.__h(Pt, e, Ce || n), (Ce = 0);
    var t = Pt.__H || (Pt.__H = { __: [], __h: [] });
    return e >= t.__.length && t.__.push({ __V: tn }), t.__[e];
  }
  function Mt(e) {
    return (Ce = 1), Xr(Jr, e);
  }
  function Xr(e, n, t) {
    var r = Oe(be++, 2);
    if (
      ((r.t = e),
      !r.__c &&
        ((r.__ = [
          t ? t(n) : Jr(void 0, n),
          function (i) {
            var a = r.__N ? r.__N[0] : r.__[0],
              s = r.t(a, i);
            a !== s && ((r.__N = [s, r.__[1]]), r.__c.setState({}));
          },
        ]),
        (r.__c = Pt),
        !Pt.u))
    ) {
      Pt.u = !0;
      var o = Pt.shouldComponentUpdate;
      Pt.shouldComponentUpdate = function (i, a, s) {
        if (!r.__c.__H) return !0;
        var l = r.__c.__H.__.filter(function (c) {
          return c.__c;
        });
        if (
          l.every(function (c) {
            return !c.__N;
          })
        )
          return !o || o.call(this, i, a, s);
        var g = !1;
        return (
          l.forEach(function (c) {
            if (c.__N) {
              var w = c.__[0];
              (c.__ = c.__N), (c.__N = void 0), w !== c.__[0] && (g = !0);
            }
          }),
          !!g && (!o || o.call(this, i, a, s))
        );
      };
    }
    return r.__N || r.__;
  }
  function $t(e, n) {
    var t = Oe(be++, 3);
    !pt.__s && Wn(t.__H, n) && ((t.__ = e), (t.i = n), Pt.__H.__h.push(t));
  }
  function en(e, n) {
    var t = Oe(be++, 4);
    !pt.__s && Wn(t.__H, n) && ((t.__ = e), (t.i = n), Pt.__h.push(t));
  }
  function _e(e) {
    return (
      (Ce = 5),
      De(function () {
        return { current: e };
      }, [])
    );
  }
  function Mo(e, n, t) {
    (Ce = 6),
      en(
        function () {
          return typeof e == 'function'
            ? (e(n()),
              function () {
                return e(null);
              })
            : e
            ? ((e.current = n()),
              function () {
                return (e.current = null);
              })
            : void 0;
        },
        t == null ? t : t.concat(e)
      );
  }
  function De(e, n) {
    var t = Oe(be++, 7);
    return Wn(t.__H, n) ? ((t.__V = e()), (t.i = n), (t.__h = e), t.__V) : t.__;
  }
  function qr(e, n) {
    return (
      (Ce = 8),
      De(function () {
        return e;
      }, n)
    );
  }
  function fe(e) {
    var n = Pt.context[e.__c],
      t = Oe(be++, 9);
    return (
      (t.c = e),
      n ? (t.__ == null && ((t.__ = !0), n.sub(Pt)), n.props.value) : e.__
    );
  }
  function $n(e, n) {
    pt.useDebugValue && pt.useDebugValue(n ? n(e) : e);
  }
  function Fo() {
    for (var e; (e = Ur.shift()); )
      if (e.__P && e.__H)
        try {
          e.__H.__h.forEach(nn), e.__H.__h.forEach(Un), (e.__H.__h = []);
        } catch (n) {
          (e.__H.__h = []), pt.__e(n, e.__v);
        }
  }
  (pt.__b = function (e) {
    (Pt = null), Wr && Wr(e);
  }),
    (pt.__r = function (e) {
      Hr && Hr(e), (be = 0);
      var n = (Pt = e.__c).__H;
      n &&
        (jn === Pt
          ? ((n.__h = []),
            (Pt.__h = []),
            n.__.forEach(function (t) {
              t.__N && (t.__ = t.__N), (t.__V = tn), (t.__N = t.i = void 0);
            }))
          : (n.__h.forEach(nn), n.__h.forEach(Un), (n.__h = []))),
        (jn = Pt);
    }),
    (pt.diffed = function (e) {
      Zr && Zr(e);
      var n = e.__c;
      n &&
        n.__H &&
        (n.__H.__h.length &&
          ((Ur.push(n) !== 1 && $r === pt.requestAnimationFrame) ||
            (
              ($r = pt.requestAnimationFrame) ||
              function (t) {
                var r,
                  o = function () {
                    clearTimeout(i),
                      Kr && cancelAnimationFrame(r),
                      setTimeout(t);
                  },
                  i = setTimeout(o, 100);
                Kr && (r = requestAnimationFrame(o));
              }
            )(Fo)),
        n.__H.__.forEach(function (t) {
          t.i && (t.__H = t.i),
            t.__V !== tn && (t.__ = t.__V),
            (t.i = void 0),
            (t.__V = tn);
        })),
        (jn = Pt = null);
    }),
    (pt.__c = function (e, n) {
      n.some(function (t) {
        try {
          t.__h.forEach(nn),
            (t.__h = t.__h.filter(function (r) {
              return !r.__ || Un(r);
            }));
        } catch (r) {
          n.some(function (o) {
            o.__h && (o.__h = []);
          }),
            (n = []),
            pt.__e(r, t.__v);
        }
      }),
        Yr && Yr(e, n);
    }),
    (pt.unmount = function (e) {
      Gr && Gr(e);
      var n,
        t = e.__c;
      t &&
        t.__H &&
        (t.__H.__.forEach(function (r) {
          try {
            nn(r);
          } catch (o) {
            n = o;
          }
        }),
        n && pt.__e(n, t.__v));
    });
  var Kr = typeof requestAnimationFrame == 'function';
  function nn(e) {
    var n = Pt,
      t = e.__c;
    typeof t == 'function' && ((e.__c = void 0), t()), (Pt = n);
  }
  function Un(e) {
    var n = Pt;
    (e.__c = e.__()), (Pt = n);
  }
  function Wn(e, n) {
    return (
      !e ||
      e.length !== n.length ||
      n.some(function (t, r) {
        return t !== e[r];
      })
    );
  }
  function Jr(e, n) {
    return typeof n == 'function' ? n(e) : n;
  }
  var zt = ((e) => (
      (e[(e.LOADING = 0)] = 'LOADING'),
      (e[(e.ERROR = 1)] = 'ERROR'),
      (e[(e.WAITING = 2)] = 'WAITING'),
      (e[(e.RUNNING = 3)] = 'RUNNING'),
      e
    ))(zt || {}),
    Bo = 0;
  function O(e, n, t, r, o) {
    var i,
      a,
      s = {};
    for (a in n) a == 'ref' ? (i = n[a]) : (s[a] = n[a]);
    var l = {
      type: e,
      props: s,
      key: t,
      ref: i,
      __k: null,
      __: null,
      __b: 0,
      __e: null,
      __d: void 0,
      __c: null,
      __h: null,
      constructor: void 0,
      __v: --Bo,
      __source: o,
      __self: r,
    };
    if (typeof e == 'function' && (i = e.defaultProps))
      for (a in i) s[a] === void 0 && (s[a] = i[a]);
    return pt.vnode && pt.vnode(l), l;
  }
  const Hn = Bn(void 0),
    Vo = ({ children: e, onError: n }) => {
      const [t, r] = Mt(zt.LOADING),
        [o, i] = Mt(void 0),
        [a, s] = Mt(!1),
        l = qr(
          (c) => {
            s(!1), n(c), r(zt.ERROR), i(c);
          },
          [n]
        ),
        g = {
          appState: t,
          setAppState: r,
          error: o,
          handleError: l,
          isCameraReady: a,
          setIsCameraReady: s,
        };
      return O(Hn.Provider, { value: g, children: e });
    },
    Zn = () => {
      const e = fe(Hn);
      if (e === void 0)
        throw new Error(
          'useAppStateContext must be used within a AppStateProvider'
        );
      return e;
    };
  var rn =
    typeof globalThis < 'u'
      ? globalThis
      : typeof window < 'u'
      ? window
      : typeof global < 'u'
      ? global
      : typeof self < 'u'
      ? self
      : {};
  function on(e) {
    throw new Error(
      'Could not dynamically require "' +
        e +
        '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.'
    );
  }
  var jo = { exports: {} };
  /*!

  JSZip v3.10.1 - A JavaScript class for generating and reading zip files
  <http://stuartk.com/jszip>

  (c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
  Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

  JSZip uses the library pako released under the MIT license :
  https://github.com/nodeca/pako/blob/main/LICENSE
  */ (function (e, n) {
    (function (t) {
      e.exports = t();
    })(function () {
      return (function t(r, o, i) {
        function a(g, c) {
          if (!o[g]) {
            if (!r[g]) {
              var w = typeof on == 'function' && on;
              if (!c && w) return w(g, !0);
              if (s) return s(g, !0);
              var b = new Error("Cannot find module '" + g + "'");
              throw ((b.code = 'MODULE_NOT_FOUND'), b);
            }
            var h = (o[g] = { exports: {} });
            r[g][0].call(
              h.exports,
              function (_) {
                var d = r[g][1][_];
                return a(d || _);
              },
              h,
              h.exports,
              t,
              r,
              o,
              i
            );
          }
          return o[g].exports;
        }
        for (var s = typeof on == 'function' && on, l = 0; l < i.length; l++)
          a(i[l]);
        return a;
      })(
        {
          1: [
            function (t, r, o) {
              var i = t('./utils'),
                a = t('./support'),
                s =
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
              (o.encode = function (l) {
                for (
                  var g,
                    c,
                    w,
                    b,
                    h,
                    _,
                    d,
                    v = [],
                    m = 0,
                    k = l.length,
                    E = k,
                    I = i.getTypeOf(l) !== 'string';
                  m < l.length;

                )
                  (E = k - m),
                    (w = I
                      ? ((g = l[m++]),
                        (c = m < k ? l[m++] : 0),
                        m < k ? l[m++] : 0)
                      : ((g = l.charCodeAt(m++)),
                        (c = m < k ? l.charCodeAt(m++) : 0),
                        m < k ? l.charCodeAt(m++) : 0)),
                    (b = g >> 2),
                    (h = ((3 & g) << 4) | (c >> 4)),
                    (_ = 1 < E ? ((15 & c) << 2) | (w >> 6) : 64),
                    (d = 2 < E ? 63 & w : 64),
                    v.push(
                      s.charAt(b) + s.charAt(h) + s.charAt(_) + s.charAt(d)
                    );
                return v.join('');
              }),
                (o.decode = function (l) {
                  var g,
                    c,
                    w,
                    b,
                    h,
                    _,
                    d = 0,
                    v = 0,
                    m = 'data:';
                  if (l.substr(0, m.length) === m)
                    throw new Error(
                      'Invalid base64 input, it looks like a data url.'
                    );
                  var k,
                    E =
                      (3 * (l = l.replace(/[^A-Za-z0-9+/=]/g, '')).length) / 4;
                  if (
                    (l.charAt(l.length - 1) === s.charAt(64) && E--,
                    l.charAt(l.length - 2) === s.charAt(64) && E--,
                    E % 1 != 0)
                  )
                    throw new Error(
                      'Invalid base64 input, bad content length.'
                    );
                  for (
                    k = a.uint8array ? new Uint8Array(0 | E) : new Array(0 | E);
                    d < l.length;

                  )
                    (g =
                      (s.indexOf(l.charAt(d++)) << 2) |
                      ((b = s.indexOf(l.charAt(d++))) >> 4)),
                      (c =
                        ((15 & b) << 4) |
                        ((h = s.indexOf(l.charAt(d++))) >> 2)),
                      (w = ((3 & h) << 6) | (_ = s.indexOf(l.charAt(d++)))),
                      (k[v++] = g),
                      h !== 64 && (k[v++] = c),
                      _ !== 64 && (k[v++] = w);
                  return k;
                });
            },
            { './support': 30, './utils': 32 },
          ],
          2: [
            function (t, r, o) {
              var i = t('./external'),
                a = t('./stream/DataWorker'),
                s = t('./stream/Crc32Probe'),
                l = t('./stream/DataLengthProbe');
              function g(c, w, b, h, _) {
                (this.compressedSize = c),
                  (this.uncompressedSize = w),
                  (this.crc32 = b),
                  (this.compression = h),
                  (this.compressedContent = _);
              }
              (g.prototype = {
                getContentWorker: function () {
                  var c = new a(i.Promise.resolve(this.compressedContent))
                      .pipe(this.compression.uncompressWorker())
                      .pipe(new l('data_length')),
                    w = this;
                  return (
                    c.on('end', function () {
                      if (this.streamInfo.data_length !== w.uncompressedSize)
                        throw new Error(
                          'Bug : uncompressed data size mismatch'
                        );
                    }),
                    c
                  );
                },
                getCompressedWorker: function () {
                  return new a(i.Promise.resolve(this.compressedContent))
                    .withStreamInfo('compressedSize', this.compressedSize)
                    .withStreamInfo('uncompressedSize', this.uncompressedSize)
                    .withStreamInfo('crc32', this.crc32)
                    .withStreamInfo('compression', this.compression);
                },
              }),
                (g.createWorkerFrom = function (c, w, b) {
                  return c
                    .pipe(new s())
                    .pipe(new l('uncompressedSize'))
                    .pipe(w.compressWorker(b))
                    .pipe(new l('compressedSize'))
                    .withStreamInfo('compression', w);
                }),
                (r.exports = g);
            },
            {
              './external': 6,
              './stream/Crc32Probe': 25,
              './stream/DataLengthProbe': 26,
              './stream/DataWorker': 27,
            },
          ],
          3: [
            function (t, r, o) {
              var i = t('./stream/GenericWorker');
              (o.STORE = {
                magic: '\0\0',
                compressWorker: function () {
                  return new i('STORE compression');
                },
                uncompressWorker: function () {
                  return new i('STORE decompression');
                },
              }),
                (o.DEFLATE = t('./flate'));
            },
            { './flate': 7, './stream/GenericWorker': 28 },
          ],
          4: [
            function (t, r, o) {
              var i = t('./utils'),
                a = (function () {
                  for (var s, l = [], g = 0; g < 256; g++) {
                    s = g;
                    for (var c = 0; c < 8; c++)
                      s = 1 & s ? 3988292384 ^ (s >>> 1) : s >>> 1;
                    l[g] = s;
                  }
                  return l;
                })();
              r.exports = function (s, l) {
                return s !== void 0 && s.length
                  ? i.getTypeOf(s) !== 'string'
                    ? (function (g, c, w, b) {
                        var h = a,
                          _ = b + w;
                        g ^= -1;
                        for (var d = b; d < _; d++)
                          g = (g >>> 8) ^ h[255 & (g ^ c[d])];
                        return -1 ^ g;
                      })(0 | l, s, s.length, 0)
                    : (function (g, c, w, b) {
                        var h = a,
                          _ = b + w;
                        g ^= -1;
                        for (var d = b; d < _; d++)
                          g = (g >>> 8) ^ h[255 & (g ^ c.charCodeAt(d))];
                        return -1 ^ g;
                      })(0 | l, s, s.length, 0)
                  : 0;
              };
            },
            { './utils': 32 },
          ],
          5: [
            function (t, r, o) {
              (o.base64 = !1),
                (o.binary = !1),
                (o.dir = !1),
                (o.createFolders = !0),
                (o.date = null),
                (o.compression = null),
                (o.compressionOptions = null),
                (o.comment = null),
                (o.unixPermissions = null),
                (o.dosPermissions = null);
            },
            {},
          ],
          6: [
            function (t, r, o) {
              var i = null;
              (i = typeof Promise < 'u' ? Promise : t('lie')),
                (r.exports = { Promise: i });
            },
            { lie: 37 },
          ],
          7: [
            function (t, r, o) {
              var i =
                  typeof Uint8Array < 'u' &&
                  typeof Uint16Array < 'u' &&
                  typeof Uint32Array < 'u',
                a = t('pako'),
                s = t('./utils'),
                l = t('./stream/GenericWorker'),
                g = i ? 'uint8array' : 'array';
              function c(w, b) {
                l.call(this, 'FlateWorker/' + w),
                  (this._pako = null),
                  (this._pakoAction = w),
                  (this._pakoOptions = b),
                  (this.meta = {});
              }
              (o.magic = '\b\0'),
                s.inherits(c, l),
                (c.prototype.processChunk = function (w) {
                  (this.meta = w.meta),
                    this._pako === null && this._createPako(),
                    this._pako.push(s.transformTo(g, w.data), !1);
                }),
                (c.prototype.flush = function () {
                  l.prototype.flush.call(this),
                    this._pako === null && this._createPako(),
                    this._pako.push([], !0);
                }),
                (c.prototype.cleanUp = function () {
                  l.prototype.cleanUp.call(this), (this._pako = null);
                }),
                (c.prototype._createPako = function () {
                  this._pako = new a[this._pakoAction]({
                    raw: !0,
                    level: this._pakoOptions.level || -1,
                  });
                  var w = this;
                  this._pako.onData = function (b) {
                    w.push({ data: b, meta: w.meta });
                  };
                }),
                (o.compressWorker = function (w) {
                  return new c('Deflate', w);
                }),
                (o.uncompressWorker = function () {
                  return new c('Inflate', {});
                });
            },
            { './stream/GenericWorker': 28, './utils': 32, pako: 38 },
          ],
          8: [
            function (t, r, o) {
              function i(h, _) {
                var d,
                  v = '';
                for (d = 0; d < _; d++)
                  (v += String.fromCharCode(255 & h)), (h >>>= 8);
                return v;
              }
              function a(h, _, d, v, m, k) {
                var E,
                  I,
                  A = h.file,
                  U = h.compression,
                  W = k !== g.utf8encode,
                  it = s.transformTo('string', k(A.name)),
                  j = s.transformTo('string', g.utf8encode(A.name)),
                  at = A.comment,
                  lt = s.transformTo('string', k(at)),
                  L = s.transformTo('string', g.utf8encode(at)),
                  V = j.length !== A.name.length,
                  f = L.length !== at.length,
                  M = '',
                  gt = '',
                  Y = '',
                  st = A.dir,
                  nt = A.date,
                  mt = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
                (_ && !d) ||
                  ((mt.crc32 = h.crc32),
                  (mt.compressedSize = h.compressedSize),
                  (mt.uncompressedSize = h.uncompressedSize));
                var B = 0;
                _ && (B |= 8), W || (!V && !f) || (B |= 2048);
                var T = 0,
                  K = 0;
                st && (T |= 16),
                  m === 'UNIX'
                    ? ((K = 798),
                      (T |= (function ($, P) {
                        var vt = $;
                        return (
                          $ || (vt = P ? 16893 : 33204), (65535 & vt) << 16
                        );
                      })(A.unixPermissions, st)))
                    : ((K = 20),
                      (T |= (function ($) {
                        return 63 & ($ || 0);
                      })(A.dosPermissions))),
                  (E = nt.getUTCHours()),
                  (E <<= 6),
                  (E |= nt.getUTCMinutes()),
                  (E <<= 5),
                  (E |= nt.getUTCSeconds() / 2),
                  (I = nt.getUTCFullYear() - 1980),
                  (I <<= 4),
                  (I |= nt.getUTCMonth() + 1),
                  (I <<= 5),
                  (I |= nt.getUTCDate()),
                  V &&
                    ((gt = i(1, 1) + i(c(it), 4) + j),
                    (M += 'up' + i(gt.length, 2) + gt)),
                  f &&
                    ((Y = i(1, 1) + i(c(lt), 4) + L),
                    (M += 'uc' + i(Y.length, 2) + Y));
                var H = '';
                return (
                  (H += `
\0`),
                  (H += i(B, 2)),
                  (H += U.magic),
                  (H += i(E, 2)),
                  (H += i(I, 2)),
                  (H += i(mt.crc32, 4)),
                  (H += i(mt.compressedSize, 4)),
                  (H += i(mt.uncompressedSize, 4)),
                  (H += i(it.length, 2)),
                  (H += i(M.length, 2)),
                  {
                    fileRecord: w.LOCAL_FILE_HEADER + H + it + M,
                    dirRecord:
                      w.CENTRAL_FILE_HEADER +
                      i(K, 2) +
                      H +
                      i(lt.length, 2) +
                      '\0\0\0\0' +
                      i(T, 4) +
                      i(v, 4) +
                      it +
                      M +
                      lt,
                  }
                );
              }
              var s = t('../utils'),
                l = t('../stream/GenericWorker'),
                g = t('../utf8'),
                c = t('../crc32'),
                w = t('../signature');
              function b(h, _, d, v) {
                l.call(this, 'ZipFileWorker'),
                  (this.bytesWritten = 0),
                  (this.zipComment = _),
                  (this.zipPlatform = d),
                  (this.encodeFileName = v),
                  (this.streamFiles = h),
                  (this.accumulate = !1),
                  (this.contentBuffer = []),
                  (this.dirRecords = []),
                  (this.currentSourceOffset = 0),
                  (this.entriesCount = 0),
                  (this.currentFile = null),
                  (this._sources = []);
              }
              s.inherits(b, l),
                (b.prototype.push = function (h) {
                  var _ = h.meta.percent || 0,
                    d = this.entriesCount,
                    v = this._sources.length;
                  this.accumulate
                    ? this.contentBuffer.push(h)
                    : ((this.bytesWritten += h.data.length),
                      l.prototype.push.call(this, {
                        data: h.data,
                        meta: {
                          currentFile: this.currentFile,
                          percent: d ? (_ + 100 * (d - v - 1)) / d : 100,
                        },
                      }));
                }),
                (b.prototype.openedSource = function (h) {
                  (this.currentSourceOffset = this.bytesWritten),
                    (this.currentFile = h.file.name);
                  var _ = this.streamFiles && !h.file.dir;
                  if (_) {
                    var d = a(
                      h,
                      _,
                      !1,
                      this.currentSourceOffset,
                      this.zipPlatform,
                      this.encodeFileName
                    );
                    this.push({ data: d.fileRecord, meta: { percent: 0 } });
                  } else this.accumulate = !0;
                }),
                (b.prototype.closedSource = function (h) {
                  this.accumulate = !1;
                  var _ = this.streamFiles && !h.file.dir,
                    d = a(
                      h,
                      _,
                      !0,
                      this.currentSourceOffset,
                      this.zipPlatform,
                      this.encodeFileName
                    );
                  if ((this.dirRecords.push(d.dirRecord), _))
                    this.push({
                      data: (function (v) {
                        return (
                          w.DATA_DESCRIPTOR +
                          i(v.crc32, 4) +
                          i(v.compressedSize, 4) +
                          i(v.uncompressedSize, 4)
                        );
                      })(h),
                      meta: { percent: 100 },
                    });
                  else
                    for (
                      this.push({ data: d.fileRecord, meta: { percent: 0 } });
                      this.contentBuffer.length;

                    )
                      this.push(this.contentBuffer.shift());
                  this.currentFile = null;
                }),
                (b.prototype.flush = function () {
                  for (
                    var h = this.bytesWritten, _ = 0;
                    _ < this.dirRecords.length;
                    _++
                  )
                    this.push({
                      data: this.dirRecords[_],
                      meta: { percent: 100 },
                    });
                  var d = this.bytesWritten - h,
                    v = (function (m, k, E, I, A) {
                      var U = s.transformTo('string', A(I));
                      return (
                        w.CENTRAL_DIRECTORY_END +
                        '\0\0\0\0' +
                        i(m, 2) +
                        i(m, 2) +
                        i(k, 4) +
                        i(E, 4) +
                        i(U.length, 2) +
                        U
                      );
                    })(
                      this.dirRecords.length,
                      d,
                      h,
                      this.zipComment,
                      this.encodeFileName
                    );
                  this.push({ data: v, meta: { percent: 100 } });
                }),
                (b.prototype.prepareNextSource = function () {
                  (this.previous = this._sources.shift()),
                    this.openedSource(this.previous.streamInfo),
                    this.isPaused
                      ? this.previous.pause()
                      : this.previous.resume();
                }),
                (b.prototype.registerPrevious = function (h) {
                  this._sources.push(h);
                  var _ = this;
                  return (
                    h.on('data', function (d) {
                      _.processChunk(d);
                    }),
                    h.on('end', function () {
                      _.closedSource(_.previous.streamInfo),
                        _._sources.length ? _.prepareNextSource() : _.end();
                    }),
                    h.on('error', function (d) {
                      _.error(d);
                    }),
                    this
                  );
                }),
                (b.prototype.resume = function () {
                  return (
                    !!l.prototype.resume.call(this) &&
                    (!this.previous && this._sources.length
                      ? (this.prepareNextSource(), !0)
                      : this.previous ||
                        this._sources.length ||
                        this.generatedError
                      ? void 0
                      : (this.end(), !0))
                  );
                }),
                (b.prototype.error = function (h) {
                  var _ = this._sources;
                  if (!l.prototype.error.call(this, h)) return !1;
                  for (var d = 0; d < _.length; d++)
                    try {
                      _[d].error(h);
                    } catch {}
                  return !0;
                }),
                (b.prototype.lock = function () {
                  l.prototype.lock.call(this);
                  for (var h = this._sources, _ = 0; _ < h.length; _++)
                    h[_].lock();
                }),
                (r.exports = b);
            },
            {
              '../crc32': 4,
              '../signature': 23,
              '../stream/GenericWorker': 28,
              '../utf8': 31,
              '../utils': 32,
            },
          ],
          9: [
            function (t, r, o) {
              var i = t('../compressions'),
                a = t('./ZipFileWorker');
              o.generateWorker = function (s, l, g) {
                var c = new a(l.streamFiles, g, l.platform, l.encodeFileName),
                  w = 0;
                try {
                  s.forEach(function (b, h) {
                    w++;
                    var _ = (function (k, E) {
                        var I = k || E,
                          A = i[I];
                        if (!A)
                          throw new Error(
                            I + ' is not a valid compression method !'
                          );
                        return A;
                      })(h.options.compression, l.compression),
                      d =
                        h.options.compressionOptions ||
                        l.compressionOptions ||
                        {},
                      v = h.dir,
                      m = h.date;
                    h._compressWorker(_, d)
                      .withStreamInfo('file', {
                        name: b,
                        dir: v,
                        date: m,
                        comment: h.comment || '',
                        unixPermissions: h.unixPermissions,
                        dosPermissions: h.dosPermissions,
                      })
                      .pipe(c);
                  }),
                    (c.entriesCount = w);
                } catch (b) {
                  c.error(b);
                }
                return c;
              };
            },
            { '../compressions': 3, './ZipFileWorker': 8 },
          ],
          10: [
            function (t, r, o) {
              function i() {
                if (!(this instanceof i)) return new i();
                if (arguments.length)
                  throw new Error(
                    'The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.'
                  );
                (this.files = Object.create(null)),
                  (this.comment = null),
                  (this.root = ''),
                  (this.clone = function () {
                    var a = new i();
                    for (var s in this)
                      typeof this[s] != 'function' && (a[s] = this[s]);
                    return a;
                  });
              }
              ((i.prototype = t('./object')).loadAsync = t('./load')),
                (i.support = t('./support')),
                (i.defaults = t('./defaults')),
                (i.version = '3.10.1'),
                (i.loadAsync = function (a, s) {
                  return new i().loadAsync(a, s);
                }),
                (i.external = t('./external')),
                (r.exports = i);
            },
            {
              './defaults': 5,
              './external': 6,
              './load': 11,
              './object': 15,
              './support': 30,
            },
          ],
          11: [
            function (t, r, o) {
              var i = t('./utils'),
                a = t('./external'),
                s = t('./utf8'),
                l = t('./zipEntries'),
                g = t('./stream/Crc32Probe'),
                c = t('./nodejsUtils');
              function w(b) {
                return new a.Promise(function (h, _) {
                  var d = b.decompressed.getContentWorker().pipe(new g());
                  d.on('error', function (v) {
                    _(v);
                  })
                    .on('end', function () {
                      d.streamInfo.crc32 !== b.decompressed.crc32
                        ? _(new Error('Corrupted zip : CRC32 mismatch'))
                        : h();
                    })
                    .resume();
                });
              }
              r.exports = function (b, h) {
                var _ = this;
                return (
                  (h = i.extend(h || {}, {
                    base64: !1,
                    checkCRC32: !1,
                    optimizedBinaryString: !1,
                    createFolders: !1,
                    decodeFileName: s.utf8decode,
                  })),
                  c.isNode && c.isStream(b)
                    ? a.Promise.reject(
                        new Error(
                          "JSZip can't accept a stream when loading a zip file."
                        )
                      )
                    : i
                        .prepareContent(
                          'the loaded zip file',
                          b,
                          !0,
                          h.optimizedBinaryString,
                          h.base64
                        )
                        .then(function (d) {
                          var v = new l(h);
                          return v.load(d), v;
                        })
                        .then(function (d) {
                          var v = [a.Promise.resolve(d)],
                            m = d.files;
                          if (h.checkCRC32)
                            for (var k = 0; k < m.length; k++) v.push(w(m[k]));
                          return a.Promise.all(v);
                        })
                        .then(function (d) {
                          for (
                            var v = d.shift(), m = v.files, k = 0;
                            k < m.length;
                            k++
                          ) {
                            var E = m[k],
                              I = E.fileNameStr,
                              A = i.resolve(E.fileNameStr);
                            _.file(A, E.decompressed, {
                              binary: !0,
                              optimizedBinaryString: !0,
                              date: E.date,
                              dir: E.dir,
                              comment: E.fileCommentStr.length
                                ? E.fileCommentStr
                                : null,
                              unixPermissions: E.unixPermissions,
                              dosPermissions: E.dosPermissions,
                              createFolders: h.createFolders,
                            }),
                              E.dir || (_.file(A).unsafeOriginalName = I);
                          }
                          return (
                            v.zipComment.length && (_.comment = v.zipComment), _
                          );
                        })
                );
              };
            },
            {
              './external': 6,
              './nodejsUtils': 14,
              './stream/Crc32Probe': 25,
              './utf8': 31,
              './utils': 32,
              './zipEntries': 33,
            },
          ],
          12: [
            function (t, r, o) {
              var i = t('../utils'),
                a = t('../stream/GenericWorker');
              function s(l, g) {
                a.call(this, 'Nodejs stream input adapter for ' + l),
                  (this._upstreamEnded = !1),
                  this._bindStream(g);
              }
              i.inherits(s, a),
                (s.prototype._bindStream = function (l) {
                  var g = this;
                  (this._stream = l).pause(),
                    l
                      .on('data', function (c) {
                        g.push({ data: c, meta: { percent: 0 } });
                      })
                      .on('error', function (c) {
                        g.isPaused ? (this.generatedError = c) : g.error(c);
                      })
                      .on('end', function () {
                        g.isPaused ? (g._upstreamEnded = !0) : g.end();
                      });
                }),
                (s.prototype.pause = function () {
                  return (
                    !!a.prototype.pause.call(this) && (this._stream.pause(), !0)
                  );
                }),
                (s.prototype.resume = function () {
                  return (
                    !!a.prototype.resume.call(this) &&
                    (this._upstreamEnded ? this.end() : this._stream.resume(),
                    !0)
                  );
                }),
                (r.exports = s);
            },
            { '../stream/GenericWorker': 28, '../utils': 32 },
          ],
          13: [
            function (t, r, o) {
              var i = t('readable-stream').Readable;
              function a(s, l, g) {
                i.call(this, l), (this._helper = s);
                var c = this;
                s.on('data', function (w, b) {
                  c.push(w) || c._helper.pause(), g && g(b);
                })
                  .on('error', function (w) {
                    c.emit('error', w);
                  })
                  .on('end', function () {
                    c.push(null);
                  });
              }
              t('../utils').inherits(a, i),
                (a.prototype._read = function () {
                  this._helper.resume();
                }),
                (r.exports = a);
            },
            { '../utils': 32, 'readable-stream': 16 },
          ],
          14: [
            function (t, r, o) {
              r.exports = {
                isNode: typeof Buffer < 'u',
                newBufferFrom: function (i, a) {
                  if (Buffer.from && Buffer.from !== Uint8Array.from)
                    return Buffer.from(i, a);
                  if (typeof i == 'number')
                    throw new Error('The "data" argument must not be a number');
                  return new Buffer(i, a);
                },
                allocBuffer: function (i) {
                  if (Buffer.alloc) return Buffer.alloc(i);
                  var a = new Buffer(i);
                  return a.fill(0), a;
                },
                isBuffer: function (i) {
                  return Buffer.isBuffer(i);
                },
                isStream: function (i) {
                  return (
                    i &&
                    typeof i.on == 'function' &&
                    typeof i.pause == 'function' &&
                    typeof i.resume == 'function'
                  );
                },
              };
            },
            {},
          ],
          15: [
            function (t, r, o) {
              function i(A, U, W) {
                var it,
                  j = s.getTypeOf(U),
                  at = s.extend(W || {}, c);
                (at.date = at.date || new Date()),
                  at.compression !== null &&
                    (at.compression = at.compression.toUpperCase()),
                  typeof at.unixPermissions == 'string' &&
                    (at.unixPermissions = parseInt(at.unixPermissions, 8)),
                  at.unixPermissions &&
                    16384 & at.unixPermissions &&
                    (at.dir = !0),
                  at.dosPermissions && 16 & at.dosPermissions && (at.dir = !0),
                  at.dir && (A = m(A)),
                  at.createFolders && (it = v(A)) && k.call(this, it, !0);
                var lt = j === 'string' && at.binary === !1 && at.base64 === !1;
                (W && W.binary !== void 0) || (at.binary = !lt),
                  ((U instanceof w && U.uncompressedSize === 0) ||
                    at.dir ||
                    !U ||
                    U.length === 0) &&
                    ((at.base64 = !1),
                    (at.binary = !0),
                    (U = ''),
                    (at.compression = 'STORE'),
                    (j = 'string'));
                var L = null;
                L =
                  U instanceof w || U instanceof l
                    ? U
                    : _.isNode && _.isStream(U)
                    ? new d(A, U)
                    : s.prepareContent(
                        A,
                        U,
                        at.binary,
                        at.optimizedBinaryString,
                        at.base64
                      );
                var V = new b(A, L, at);
                this.files[A] = V;
              }
              var a = t('./utf8'),
                s = t('./utils'),
                l = t('./stream/GenericWorker'),
                g = t('./stream/StreamHelper'),
                c = t('./defaults'),
                w = t('./compressedObject'),
                b = t('./zipObject'),
                h = t('./generate'),
                _ = t('./nodejsUtils'),
                d = t('./nodejs/NodejsStreamInputAdapter'),
                v = function (A) {
                  A.slice(-1) === '/' && (A = A.substring(0, A.length - 1));
                  var U = A.lastIndexOf('/');
                  return 0 < U ? A.substring(0, U) : '';
                },
                m = function (A) {
                  return A.slice(-1) !== '/' && (A += '/'), A;
                },
                k = function (A, U) {
                  return (
                    (U = U !== void 0 ? U : c.createFolders),
                    (A = m(A)),
                    this.files[A] ||
                      i.call(this, A, null, { dir: !0, createFolders: U }),
                    this.files[A]
                  );
                };
              function E(A) {
                return Object.prototype.toString.call(A) === '[object RegExp]';
              }
              var I = {
                load: function () {
                  throw new Error(
                    'This method has been removed in JSZip 3.0, please check the upgrade guide.'
                  );
                },
                forEach: function (A) {
                  var U, W, it;
                  for (U in this.files)
                    (it = this.files[U]),
                      (W = U.slice(this.root.length, U.length)) &&
                        U.slice(0, this.root.length) === this.root &&
                        A(W, it);
                },
                filter: function (A) {
                  var U = [];
                  return (
                    this.forEach(function (W, it) {
                      A(W, it) && U.push(it);
                    }),
                    U
                  );
                },
                file: function (A, U, W) {
                  if (arguments.length !== 1)
                    return (A = this.root + A), i.call(this, A, U, W), this;
                  if (E(A)) {
                    var it = A;
                    return this.filter(function (at, lt) {
                      return !lt.dir && it.test(at);
                    });
                  }
                  var j = this.files[this.root + A];
                  return j && !j.dir ? j : null;
                },
                folder: function (A) {
                  if (!A) return this;
                  if (E(A))
                    return this.filter(function (j, at) {
                      return at.dir && A.test(j);
                    });
                  var U = this.root + A,
                    W = k.call(this, U),
                    it = this.clone();
                  return (it.root = W.name), it;
                },
                remove: function (A) {
                  A = this.root + A;
                  var U = this.files[A];
                  if (
                    (U ||
                      (A.slice(-1) !== '/' && (A += '/'), (U = this.files[A])),
                    U && !U.dir)
                  )
                    delete this.files[A];
                  else
                    for (
                      var W = this.filter(function (j, at) {
                          return at.name.slice(0, A.length) === A;
                        }),
                        it = 0;
                      it < W.length;
                      it++
                    )
                      delete this.files[W[it].name];
                  return this;
                },
                generate: function () {
                  throw new Error(
                    'This method has been removed in JSZip 3.0, please check the upgrade guide.'
                  );
                },
                generateInternalStream: function (A) {
                  var U,
                    W = {};
                  try {
                    if (
                      (((W = s.extend(A || {}, {
                        streamFiles: !1,
                        compression: 'STORE',
                        compressionOptions: null,
                        type: '',
                        platform: 'DOS',
                        comment: null,
                        mimeType: 'application/zip',
                        encodeFileName: a.utf8encode,
                      })).type = W.type.toLowerCase()),
                      (W.compression = W.compression.toUpperCase()),
                      W.type === 'binarystring' && (W.type = 'string'),
                      !W.type)
                    )
                      throw new Error('No output type specified.');
                    s.checkSupport(W.type),
                      (W.platform !== 'darwin' &&
                        W.platform !== 'freebsd' &&
                        W.platform !== 'linux' &&
                        W.platform !== 'sunos') ||
                        (W.platform = 'UNIX'),
                      W.platform === 'win32' && (W.platform = 'DOS');
                    var it = W.comment || this.comment || '';
                    U = h.generateWorker(this, W, it);
                  } catch (j) {
                    (U = new l('error')).error(j);
                  }
                  return new g(U, W.type || 'string', W.mimeType);
                },
                generateAsync: function (A, U) {
                  return this.generateInternalStream(A).accumulate(U);
                },
                generateNodeStream: function (A, U) {
                  return (
                    (A = A || {}).type || (A.type = 'nodebuffer'),
                    this.generateInternalStream(A).toNodejsStream(U)
                  );
                },
              };
              r.exports = I;
            },
            {
              './compressedObject': 2,
              './defaults': 5,
              './generate': 9,
              './nodejs/NodejsStreamInputAdapter': 12,
              './nodejsUtils': 14,
              './stream/GenericWorker': 28,
              './stream/StreamHelper': 29,
              './utf8': 31,
              './utils': 32,
              './zipObject': 35,
            },
          ],
          16: [
            function (t, r, o) {
              r.exports = t('stream');
            },
            { stream: void 0 },
          ],
          17: [
            function (t, r, o) {
              var i = t('./DataReader');
              function a(s) {
                i.call(this, s);
                for (var l = 0; l < this.data.length; l++) s[l] = 255 & s[l];
              }
              t('../utils').inherits(a, i),
                (a.prototype.byteAt = function (s) {
                  return this.data[this.zero + s];
                }),
                (a.prototype.lastIndexOfSignature = function (s) {
                  for (
                    var l = s.charCodeAt(0),
                      g = s.charCodeAt(1),
                      c = s.charCodeAt(2),
                      w = s.charCodeAt(3),
                      b = this.length - 4;
                    0 <= b;
                    --b
                  )
                    if (
                      this.data[b] === l &&
                      this.data[b + 1] === g &&
                      this.data[b + 2] === c &&
                      this.data[b + 3] === w
                    )
                      return b - this.zero;
                  return -1;
                }),
                (a.prototype.readAndCheckSignature = function (s) {
                  var l = s.charCodeAt(0),
                    g = s.charCodeAt(1),
                    c = s.charCodeAt(2),
                    w = s.charCodeAt(3),
                    b = this.readData(4);
                  return l === b[0] && g === b[1] && c === b[2] && w === b[3];
                }),
                (a.prototype.readData = function (s) {
                  if ((this.checkOffset(s), s === 0)) return [];
                  var l = this.data.slice(
                    this.zero + this.index,
                    this.zero + this.index + s
                  );
                  return (this.index += s), l;
                }),
                (r.exports = a);
            },
            { '../utils': 32, './DataReader': 18 },
          ],
          18: [
            function (t, r, o) {
              var i = t('../utils');
              function a(s) {
                (this.data = s),
                  (this.length = s.length),
                  (this.index = 0),
                  (this.zero = 0);
              }
              (a.prototype = {
                checkOffset: function (s) {
                  this.checkIndex(this.index + s);
                },
                checkIndex: function (s) {
                  if (this.length < this.zero + s || s < 0)
                    throw new Error(
                      'End of data reached (data length = ' +
                        this.length +
                        ', asked index = ' +
                        s +
                        '). Corrupted zip ?'
                    );
                },
                setIndex: function (s) {
                  this.checkIndex(s), (this.index = s);
                },
                skip: function (s) {
                  this.setIndex(this.index + s);
                },
                byteAt: function () {},
                readInt: function (s) {
                  var l,
                    g = 0;
                  for (
                    this.checkOffset(s), l = this.index + s - 1;
                    l >= this.index;
                    l--
                  )
                    g = (g << 8) + this.byteAt(l);
                  return (this.index += s), g;
                },
                readString: function (s) {
                  return i.transformTo('string', this.readData(s));
                },
                readData: function () {},
                lastIndexOfSignature: function () {},
                readAndCheckSignature: function () {},
                readDate: function () {
                  var s = this.readInt(4);
                  return new Date(
                    Date.UTC(
                      1980 + ((s >> 25) & 127),
                      ((s >> 21) & 15) - 1,
                      (s >> 16) & 31,
                      (s >> 11) & 31,
                      (s >> 5) & 63,
                      (31 & s) << 1
                    )
                  );
                },
              }),
                (r.exports = a);
            },
            { '../utils': 32 },
          ],
          19: [
            function (t, r, o) {
              var i = t('./Uint8ArrayReader');
              function a(s) {
                i.call(this, s);
              }
              t('../utils').inherits(a, i),
                (a.prototype.readData = function (s) {
                  this.checkOffset(s);
                  var l = this.data.slice(
                    this.zero + this.index,
                    this.zero + this.index + s
                  );
                  return (this.index += s), l;
                }),
                (r.exports = a);
            },
            { '../utils': 32, './Uint8ArrayReader': 21 },
          ],
          20: [
            function (t, r, o) {
              var i = t('./DataReader');
              function a(s) {
                i.call(this, s);
              }
              t('../utils').inherits(a, i),
                (a.prototype.byteAt = function (s) {
                  return this.data.charCodeAt(this.zero + s);
                }),
                (a.prototype.lastIndexOfSignature = function (s) {
                  return this.data.lastIndexOf(s) - this.zero;
                }),
                (a.prototype.readAndCheckSignature = function (s) {
                  return s === this.readData(4);
                }),
                (a.prototype.readData = function (s) {
                  this.checkOffset(s);
                  var l = this.data.slice(
                    this.zero + this.index,
                    this.zero + this.index + s
                  );
                  return (this.index += s), l;
                }),
                (r.exports = a);
            },
            { '../utils': 32, './DataReader': 18 },
          ],
          21: [
            function (t, r, o) {
              var i = t('./ArrayReader');
              function a(s) {
                i.call(this, s);
              }
              t('../utils').inherits(a, i),
                (a.prototype.readData = function (s) {
                  if ((this.checkOffset(s), s === 0)) return new Uint8Array(0);
                  var l = this.data.subarray(
                    this.zero + this.index,
                    this.zero + this.index + s
                  );
                  return (this.index += s), l;
                }),
                (r.exports = a);
            },
            { '../utils': 32, './ArrayReader': 17 },
          ],
          22: [
            function (t, r, o) {
              var i = t('../utils'),
                a = t('../support'),
                s = t('./ArrayReader'),
                l = t('./StringReader'),
                g = t('./NodeBufferReader'),
                c = t('./Uint8ArrayReader');
              r.exports = function (w) {
                var b = i.getTypeOf(w);
                return (
                  i.checkSupport(b),
                  b !== 'string' || a.uint8array
                    ? b === 'nodebuffer'
                      ? new g(w)
                      : a.uint8array
                      ? new c(i.transformTo('uint8array', w))
                      : new s(i.transformTo('array', w))
                    : new l(w)
                );
              };
            },
            {
              '../support': 30,
              '../utils': 32,
              './ArrayReader': 17,
              './NodeBufferReader': 19,
              './StringReader': 20,
              './Uint8ArrayReader': 21,
            },
          ],
          23: [
            function (t, r, o) {
              (o.LOCAL_FILE_HEADER = 'PK'),
                (o.CENTRAL_FILE_HEADER = 'PK'),
                (o.CENTRAL_DIRECTORY_END = 'PK'),
                (o.ZIP64_CENTRAL_DIRECTORY_LOCATOR = 'PK\x07'),
                (o.ZIP64_CENTRAL_DIRECTORY_END = 'PK'),
                (o.DATA_DESCRIPTOR = 'PK\x07\b');
            },
            {},
          ],
          24: [
            function (t, r, o) {
              var i = t('./GenericWorker'),
                a = t('../utils');
              function s(l) {
                i.call(this, 'ConvertWorker to ' + l), (this.destType = l);
              }
              a.inherits(s, i),
                (s.prototype.processChunk = function (l) {
                  this.push({
                    data: a.transformTo(this.destType, l.data),
                    meta: l.meta,
                  });
                }),
                (r.exports = s);
            },
            { '../utils': 32, './GenericWorker': 28 },
          ],
          25: [
            function (t, r, o) {
              var i = t('./GenericWorker'),
                a = t('../crc32');
              function s() {
                i.call(this, 'Crc32Probe'), this.withStreamInfo('crc32', 0);
              }
              t('../utils').inherits(s, i),
                (s.prototype.processChunk = function (l) {
                  (this.streamInfo.crc32 = a(
                    l.data,
                    this.streamInfo.crc32 || 0
                  )),
                    this.push(l);
                }),
                (r.exports = s);
            },
            { '../crc32': 4, '../utils': 32, './GenericWorker': 28 },
          ],
          26: [
            function (t, r, o) {
              var i = t('../utils'),
                a = t('./GenericWorker');
              function s(l) {
                a.call(this, 'DataLengthProbe for ' + l),
                  (this.propName = l),
                  this.withStreamInfo(l, 0);
              }
              i.inherits(s, a),
                (s.prototype.processChunk = function (l) {
                  if (l) {
                    var g = this.streamInfo[this.propName] || 0;
                    this.streamInfo[this.propName] = g + l.data.length;
                  }
                  a.prototype.processChunk.call(this, l);
                }),
                (r.exports = s);
            },
            { '../utils': 32, './GenericWorker': 28 },
          ],
          27: [
            function (t, r, o) {
              var i = t('../utils'),
                a = t('./GenericWorker');
              function s(l) {
                a.call(this, 'DataWorker');
                var g = this;
                (this.dataIsReady = !1),
                  (this.index = 0),
                  (this.max = 0),
                  (this.data = null),
                  (this.type = ''),
                  (this._tickScheduled = !1),
                  l.then(
                    function (c) {
                      (g.dataIsReady = !0),
                        (g.data = c),
                        (g.max = (c && c.length) || 0),
                        (g.type = i.getTypeOf(c)),
                        g.isPaused || g._tickAndRepeat();
                    },
                    function (c) {
                      g.error(c);
                    }
                  );
              }
              i.inherits(s, a),
                (s.prototype.cleanUp = function () {
                  a.prototype.cleanUp.call(this), (this.data = null);
                }),
                (s.prototype.resume = function () {
                  return (
                    !!a.prototype.resume.call(this) &&
                    (!this._tickScheduled &&
                      this.dataIsReady &&
                      ((this._tickScheduled = !0),
                      i.delay(this._tickAndRepeat, [], this)),
                    !0)
                  );
                }),
                (s.prototype._tickAndRepeat = function () {
                  (this._tickScheduled = !1),
                    this.isPaused ||
                      this.isFinished ||
                      (this._tick(),
                      this.isFinished ||
                        (i.delay(this._tickAndRepeat, [], this),
                        (this._tickScheduled = !0)));
                }),
                (s.prototype._tick = function () {
                  if (this.isPaused || this.isFinished) return !1;
                  var l = null,
                    g = Math.min(this.max, this.index + 16384);
                  if (this.index >= this.max) return this.end();
                  switch (this.type) {
                    case 'string':
                      l = this.data.substring(this.index, g);
                      break;
                    case 'uint8array':
                      l = this.data.subarray(this.index, g);
                      break;
                    case 'array':
                    case 'nodebuffer':
                      l = this.data.slice(this.index, g);
                  }
                  return (
                    (this.index = g),
                    this.push({
                      data: l,
                      meta: {
                        percent: this.max ? (this.index / this.max) * 100 : 0,
                      },
                    })
                  );
                }),
                (r.exports = s);
            },
            { '../utils': 32, './GenericWorker': 28 },
          ],
          28: [
            function (t, r, o) {
              function i(a) {
                (this.name = a || 'default'),
                  (this.streamInfo = {}),
                  (this.generatedError = null),
                  (this.extraStreamInfo = {}),
                  (this.isPaused = !0),
                  (this.isFinished = !1),
                  (this.isLocked = !1),
                  (this._listeners = { data: [], end: [], error: [] }),
                  (this.previous = null);
              }
              (i.prototype = {
                push: function (a) {
                  this.emit('data', a);
                },
                end: function () {
                  if (this.isFinished) return !1;
                  this.flush();
                  try {
                    this.emit('end'), this.cleanUp(), (this.isFinished = !0);
                  } catch (a) {
                    this.emit('error', a);
                  }
                  return !0;
                },
                error: function (a) {
                  return (
                    !this.isFinished &&
                    (this.isPaused
                      ? (this.generatedError = a)
                      : ((this.isFinished = !0),
                        this.emit('error', a),
                        this.previous && this.previous.error(a),
                        this.cleanUp()),
                    !0)
                  );
                },
                on: function (a, s) {
                  return this._listeners[a].push(s), this;
                },
                cleanUp: function () {
                  (this.streamInfo =
                    this.generatedError =
                    this.extraStreamInfo =
                      null),
                    (this._listeners = []);
                },
                emit: function (a, s) {
                  if (this._listeners[a])
                    for (var l = 0; l < this._listeners[a].length; l++)
                      this._listeners[a][l].call(this, s);
                },
                pipe: function (a) {
                  return a.registerPrevious(this);
                },
                registerPrevious: function (a) {
                  if (this.isLocked)
                    throw new Error(
                      "The stream '" + this + "' has already been used."
                    );
                  (this.streamInfo = a.streamInfo),
                    this.mergeStreamInfo(),
                    (this.previous = a);
                  var s = this;
                  return (
                    a.on('data', function (l) {
                      s.processChunk(l);
                    }),
                    a.on('end', function () {
                      s.end();
                    }),
                    a.on('error', function (l) {
                      s.error(l);
                    }),
                    this
                  );
                },
                pause: function () {
                  return (
                    !this.isPaused &&
                    !this.isFinished &&
                    ((this.isPaused = !0),
                    this.previous && this.previous.pause(),
                    !0)
                  );
                },
                resume: function () {
                  if (!this.isPaused || this.isFinished) return !1;
                  var a = (this.isPaused = !1);
                  return (
                    this.generatedError &&
                      (this.error(this.generatedError), (a = !0)),
                    this.previous && this.previous.resume(),
                    !a
                  );
                },
                flush: function () {},
                processChunk: function (a) {
                  this.push(a);
                },
                withStreamInfo: function (a, s) {
                  return (
                    (this.extraStreamInfo[a] = s), this.mergeStreamInfo(), this
                  );
                },
                mergeStreamInfo: function () {
                  for (var a in this.extraStreamInfo)
                    Object.prototype.hasOwnProperty.call(
                      this.extraStreamInfo,
                      a
                    ) && (this.streamInfo[a] = this.extraStreamInfo[a]);
                },
                lock: function () {
                  if (this.isLocked)
                    throw new Error(
                      "The stream '" + this + "' has already been used."
                    );
                  (this.isLocked = !0), this.previous && this.previous.lock();
                },
                toString: function () {
                  var a = 'Worker ' + this.name;
                  return this.previous ? this.previous + ' -> ' + a : a;
                },
              }),
                (r.exports = i);
            },
            {},
          ],
          29: [
            function (t, r, o) {
              var i = t('../utils'),
                a = t('./ConvertWorker'),
                s = t('./GenericWorker'),
                l = t('../base64'),
                g = t('../support'),
                c = t('../external'),
                w = null;
              if (g.nodestream)
                try {
                  w = t('../nodejs/NodejsStreamOutputAdapter');
                } catch {}
              function b(_, d) {
                return new c.Promise(function (v, m) {
                  var k = [],
                    E = _._internalType,
                    I = _._outputType,
                    A = _._mimeType;
                  _.on('data', function (U, W) {
                    k.push(U), d && d(W);
                  })
                    .on('error', function (U) {
                      (k = []), m(U);
                    })
                    .on('end', function () {
                      try {
                        var U = (function (W, it, j) {
                          switch (W) {
                            case 'blob':
                              return i.newBlob(
                                i.transformTo('arraybuffer', it),
                                j
                              );
                            case 'base64':
                              return l.encode(it);
                            default:
                              return i.transformTo(W, it);
                          }
                        })(
                          I,
                          (function (W, it) {
                            var j,
                              at = 0,
                              lt = null,
                              L = 0;
                            for (j = 0; j < it.length; j++) L += it[j].length;
                            switch (W) {
                              case 'string':
                                return it.join('');
                              case 'array':
                                return Array.prototype.concat.apply([], it);
                              case 'uint8array':
                                for (
                                  lt = new Uint8Array(L), j = 0;
                                  j < it.length;
                                  j++
                                )
                                  lt.set(it[j], at), (at += it[j].length);
                                return lt;
                              case 'nodebuffer':
                                return Buffer.concat(it);
                              default:
                                throw new Error(
                                  "concat : unsupported type '" + W + "'"
                                );
                            }
                          })(E, k),
                          A
                        );
                        v(U);
                      } catch (W) {
                        m(W);
                      }
                      k = [];
                    })
                    .resume();
                });
              }
              function h(_, d, v) {
                var m = d;
                switch (d) {
                  case 'blob':
                  case 'arraybuffer':
                    m = 'uint8array';
                    break;
                  case 'base64':
                    m = 'string';
                }
                try {
                  (this._internalType = m),
                    (this._outputType = d),
                    (this._mimeType = v),
                    i.checkSupport(m),
                    (this._worker = _.pipe(new a(m))),
                    _.lock();
                } catch (k) {
                  (this._worker = new s('error')), this._worker.error(k);
                }
              }
              (h.prototype = {
                accumulate: function (_) {
                  return b(this, _);
                },
                on: function (_, d) {
                  var v = this;
                  return (
                    _ === 'data'
                      ? this._worker.on(_, function (m) {
                          d.call(v, m.data, m.meta);
                        })
                      : this._worker.on(_, function () {
                          i.delay(d, arguments, v);
                        }),
                    this
                  );
                },
                resume: function () {
                  return i.delay(this._worker.resume, [], this._worker), this;
                },
                pause: function () {
                  return this._worker.pause(), this;
                },
                toNodejsStream: function (_) {
                  if (
                    (i.checkSupport('nodestream'),
                    this._outputType !== 'nodebuffer')
                  )
                    throw new Error(
                      this._outputType + ' is not supported by this method'
                    );
                  return new w(
                    this,
                    { objectMode: this._outputType !== 'nodebuffer' },
                    _
                  );
                },
              }),
                (r.exports = h);
            },
            {
              '../base64': 1,
              '../external': 6,
              '../nodejs/NodejsStreamOutputAdapter': 13,
              '../support': 30,
              '../utils': 32,
              './ConvertWorker': 24,
              './GenericWorker': 28,
            },
          ],
          30: [
            function (t, r, o) {
              if (
                ((o.base64 = !0),
                (o.array = !0),
                (o.string = !0),
                (o.arraybuffer =
                  typeof ArrayBuffer < 'u' && typeof Uint8Array < 'u'),
                (o.nodebuffer = typeof Buffer < 'u'),
                (o.uint8array = typeof Uint8Array < 'u'),
                typeof ArrayBuffer > 'u')
              )
                o.blob = !1;
              else {
                var i = new ArrayBuffer(0);
                try {
                  o.blob =
                    new Blob([i], { type: 'application/zip' }).size === 0;
                } catch {
                  try {
                    var a = new (self.BlobBuilder ||
                      self.WebKitBlobBuilder ||
                      self.MozBlobBuilder ||
                      self.MSBlobBuilder)();
                    a.append(i),
                      (o.blob = a.getBlob('application/zip').size === 0);
                  } catch {
                    o.blob = !1;
                  }
                }
              }
              try {
                o.nodestream = !!t('readable-stream').Readable;
              } catch {
                o.nodestream = !1;
              }
            },
            { 'readable-stream': 16 },
          ],
          31: [
            function (t, r, o) {
              for (
                var i = t('./utils'),
                  a = t('./support'),
                  s = t('./nodejsUtils'),
                  l = t('./stream/GenericWorker'),
                  g = new Array(256),
                  c = 0;
                c < 256;
                c++
              )
                g[c] =
                  252 <= c
                    ? 6
                    : 248 <= c
                    ? 5
                    : 240 <= c
                    ? 4
                    : 224 <= c
                    ? 3
                    : 192 <= c
                    ? 2
                    : 1;
              g[254] = g[254] = 1;
              function w() {
                l.call(this, 'utf-8 decode'), (this.leftOver = null);
              }
              function b() {
                l.call(this, 'utf-8 encode');
              }
              (o.utf8encode = function (h) {
                return a.nodebuffer
                  ? s.newBufferFrom(h, 'utf-8')
                  : (function (_) {
                      var d,
                        v,
                        m,
                        k,
                        E,
                        I = _.length,
                        A = 0;
                      for (k = 0; k < I; k++)
                        (64512 & (v = _.charCodeAt(k))) == 55296 &&
                          k + 1 < I &&
                          (64512 & (m = _.charCodeAt(k + 1))) == 56320 &&
                          ((v = 65536 + ((v - 55296) << 10) + (m - 56320)),
                          k++),
                          (A += v < 128 ? 1 : v < 2048 ? 2 : v < 65536 ? 3 : 4);
                      for (
                        d = a.uint8array ? new Uint8Array(A) : new Array(A),
                          k = E = 0;
                        E < A;
                        k++
                      )
                        (64512 & (v = _.charCodeAt(k))) == 55296 &&
                          k + 1 < I &&
                          (64512 & (m = _.charCodeAt(k + 1))) == 56320 &&
                          ((v = 65536 + ((v - 55296) << 10) + (m - 56320)),
                          k++),
                          v < 128
                            ? (d[E++] = v)
                            : (v < 2048
                                ? (d[E++] = 192 | (v >>> 6))
                                : (v < 65536
                                    ? (d[E++] = 224 | (v >>> 12))
                                    : ((d[E++] = 240 | (v >>> 18)),
                                      (d[E++] = 128 | ((v >>> 12) & 63))),
                                  (d[E++] = 128 | ((v >>> 6) & 63))),
                              (d[E++] = 128 | (63 & v)));
                      return d;
                    })(h);
              }),
                (o.utf8decode = function (h) {
                  return a.nodebuffer
                    ? i.transformTo('nodebuffer', h).toString('utf-8')
                    : (function (_) {
                        var d,
                          v,
                          m,
                          k,
                          E = _.length,
                          I = new Array(2 * E);
                        for (d = v = 0; d < E; )
                          if ((m = _[d++]) < 128) I[v++] = m;
                          else if (4 < (k = g[m]))
                            (I[v++] = 65533), (d += k - 1);
                          else {
                            for (
                              m &= k === 2 ? 31 : k === 3 ? 15 : 7;
                              1 < k && d < E;

                            )
                              (m = (m << 6) | (63 & _[d++])), k--;
                            1 < k
                              ? (I[v++] = 65533)
                              : m < 65536
                              ? (I[v++] = m)
                              : ((m -= 65536),
                                (I[v++] = 55296 | ((m >> 10) & 1023)),
                                (I[v++] = 56320 | (1023 & m)));
                          }
                        return (
                          I.length !== v &&
                            (I.subarray
                              ? (I = I.subarray(0, v))
                              : (I.length = v)),
                          i.applyFromCharCode(I)
                        );
                      })(
                        (h = i.transformTo(
                          a.uint8array ? 'uint8array' : 'array',
                          h
                        ))
                      );
                }),
                i.inherits(w, l),
                (w.prototype.processChunk = function (h) {
                  var _ = i.transformTo(
                    a.uint8array ? 'uint8array' : 'array',
                    h.data
                  );
                  if (this.leftOver && this.leftOver.length) {
                    if (a.uint8array) {
                      var d = _;
                      (_ = new Uint8Array(d.length + this.leftOver.length)).set(
                        this.leftOver,
                        0
                      ),
                        _.set(d, this.leftOver.length);
                    } else _ = this.leftOver.concat(_);
                    this.leftOver = null;
                  }
                  var v = (function (k, E) {
                      var I;
                      for (
                        (E = E || k.length) > k.length && (E = k.length),
                          I = E - 1;
                        0 <= I && (192 & k[I]) == 128;

                      )
                        I--;
                      return I < 0 || I === 0 ? E : I + g[k[I]] > E ? I : E;
                    })(_),
                    m = _;
                  v !== _.length &&
                    (a.uint8array
                      ? ((m = _.subarray(0, v)),
                        (this.leftOver = _.subarray(v, _.length)))
                      : ((m = _.slice(0, v)),
                        (this.leftOver = _.slice(v, _.length)))),
                    this.push({ data: o.utf8decode(m), meta: h.meta });
                }),
                (w.prototype.flush = function () {
                  this.leftOver &&
                    this.leftOver.length &&
                    (this.push({ data: o.utf8decode(this.leftOver), meta: {} }),
                    (this.leftOver = null));
                }),
                (o.Utf8DecodeWorker = w),
                i.inherits(b, l),
                (b.prototype.processChunk = function (h) {
                  this.push({ data: o.utf8encode(h.data), meta: h.meta });
                }),
                (o.Utf8EncodeWorker = b);
            },
            {
              './nodejsUtils': 14,
              './stream/GenericWorker': 28,
              './support': 30,
              './utils': 32,
            },
          ],
          32: [
            function (t, r, o) {
              var i = t('./support'),
                a = t('./base64'),
                s = t('./nodejsUtils'),
                l = t('./external');
              function g(d) {
                return d;
              }
              function c(d, v) {
                for (var m = 0; m < d.length; ++m) v[m] = 255 & d.charCodeAt(m);
                return v;
              }
              t('setimmediate'),
                (o.newBlob = function (d, v) {
                  o.checkSupport('blob');
                  try {
                    return new Blob([d], { type: v });
                  } catch {
                    try {
                      var m = new (self.BlobBuilder ||
                        self.WebKitBlobBuilder ||
                        self.MozBlobBuilder ||
                        self.MSBlobBuilder)();
                      return m.append(d), m.getBlob(v);
                    } catch {
                      throw new Error("Bug : can't construct the Blob.");
                    }
                  }
                });
              var w = {
                stringifyByChunk: function (d, v, m) {
                  var k = [],
                    E = 0,
                    I = d.length;
                  if (I <= m) return String.fromCharCode.apply(null, d);
                  for (; E < I; )
                    v === 'array' || v === 'nodebuffer'
                      ? k.push(
                          String.fromCharCode.apply(
                            null,
                            d.slice(E, Math.min(E + m, I))
                          )
                        )
                      : k.push(
                          String.fromCharCode.apply(
                            null,
                            d.subarray(E, Math.min(E + m, I))
                          )
                        ),
                      (E += m);
                  return k.join('');
                },
                stringifyByChar: function (d) {
                  for (var v = '', m = 0; m < d.length; m++)
                    v += String.fromCharCode(d[m]);
                  return v;
                },
                applyCanBeUsed: {
                  uint8array: (function () {
                    try {
                      return (
                        i.uint8array &&
                        String.fromCharCode.apply(null, new Uint8Array(1))
                          .length === 1
                      );
                    } catch {
                      return !1;
                    }
                  })(),
                  nodebuffer: (function () {
                    try {
                      return (
                        i.nodebuffer &&
                        String.fromCharCode.apply(null, s.allocBuffer(1))
                          .length === 1
                      );
                    } catch {
                      return !1;
                    }
                  })(),
                },
              };
              function b(d) {
                var v = 65536,
                  m = o.getTypeOf(d),
                  k = !0;
                if (
                  (m === 'uint8array'
                    ? (k = w.applyCanBeUsed.uint8array)
                    : m === 'nodebuffer' && (k = w.applyCanBeUsed.nodebuffer),
                  k)
                )
                  for (; 1 < v; )
                    try {
                      return w.stringifyByChunk(d, m, v);
                    } catch {
                      v = Math.floor(v / 2);
                    }
                return w.stringifyByChar(d);
              }
              function h(d, v) {
                for (var m = 0; m < d.length; m++) v[m] = d[m];
                return v;
              }
              o.applyFromCharCode = b;
              var _ = {};
              (_.string = {
                string: g,
                array: function (d) {
                  return c(d, new Array(d.length));
                },
                arraybuffer: function (d) {
                  return _.string.uint8array(d).buffer;
                },
                uint8array: function (d) {
                  return c(d, new Uint8Array(d.length));
                },
                nodebuffer: function (d) {
                  return c(d, s.allocBuffer(d.length));
                },
              }),
                (_.array = {
                  string: b,
                  array: g,
                  arraybuffer: function (d) {
                    return new Uint8Array(d).buffer;
                  },
                  uint8array: function (d) {
                    return new Uint8Array(d);
                  },
                  nodebuffer: function (d) {
                    return s.newBufferFrom(d);
                  },
                }),
                (_.arraybuffer = {
                  string: function (d) {
                    return b(new Uint8Array(d));
                  },
                  array: function (d) {
                    return h(new Uint8Array(d), new Array(d.byteLength));
                  },
                  arraybuffer: g,
                  uint8array: function (d) {
                    return new Uint8Array(d);
                  },
                  nodebuffer: function (d) {
                    return s.newBufferFrom(new Uint8Array(d));
                  },
                }),
                (_.uint8array = {
                  string: b,
                  array: function (d) {
                    return h(d, new Array(d.length));
                  },
                  arraybuffer: function (d) {
                    return d.buffer;
                  },
                  uint8array: g,
                  nodebuffer: function (d) {
                    return s.newBufferFrom(d);
                  },
                }),
                (_.nodebuffer = {
                  string: b,
                  array: function (d) {
                    return h(d, new Array(d.length));
                  },
                  arraybuffer: function (d) {
                    return _.nodebuffer.uint8array(d).buffer;
                  },
                  uint8array: function (d) {
                    return h(d, new Uint8Array(d.length));
                  },
                  nodebuffer: g,
                }),
                (o.transformTo = function (d, v) {
                  if (((v = v || ''), !d)) return v;
                  o.checkSupport(d);
                  var m = o.getTypeOf(v);
                  return _[m][d](v);
                }),
                (o.resolve = function (d) {
                  for (var v = d.split('/'), m = [], k = 0; k < v.length; k++) {
                    var E = v[k];
                    E === '.' ||
                      (E === '' && k !== 0 && k !== v.length - 1) ||
                      (E === '..' ? m.pop() : m.push(E));
                  }
                  return m.join('/');
                }),
                (o.getTypeOf = function (d) {
                  return typeof d == 'string'
                    ? 'string'
                    : Object.prototype.toString.call(d) === '[object Array]'
                    ? 'array'
                    : i.nodebuffer && s.isBuffer(d)
                    ? 'nodebuffer'
                    : i.uint8array && d instanceof Uint8Array
                    ? 'uint8array'
                    : i.arraybuffer && d instanceof ArrayBuffer
                    ? 'arraybuffer'
                    : void 0;
                }),
                (o.checkSupport = function (d) {
                  if (!i[d.toLowerCase()])
                    throw new Error(d + ' is not supported by this platform');
                }),
                (o.MAX_VALUE_16BITS = 65535),
                (o.MAX_VALUE_32BITS = -1),
                (o.pretty = function (d) {
                  var v,
                    m,
                    k = '';
                  for (m = 0; m < (d || '').length; m++)
                    k +=
                      '\\x' +
                      ((v = d.charCodeAt(m)) < 16 ? '0' : '') +
                      v.toString(16).toUpperCase();
                  return k;
                }),
                (o.delay = function (d, v, m) {
                  setImmediate(function () {
                    d.apply(m || null, v || []);
                  });
                }),
                (o.inherits = function (d, v) {
                  function m() {}
                  (m.prototype = v.prototype), (d.prototype = new m());
                }),
                (o.extend = function () {
                  var d,
                    v,
                    m = {};
                  for (d = 0; d < arguments.length; d++)
                    for (v in arguments[d])
                      Object.prototype.hasOwnProperty.call(arguments[d], v) &&
                        m[v] === void 0 &&
                        (m[v] = arguments[d][v]);
                  return m;
                }),
                (o.prepareContent = function (d, v, m, k, E) {
                  return l.Promise.resolve(v)
                    .then(function (I) {
                      return i.blob &&
                        (I instanceof Blob ||
                          ['[object File]', '[object Blob]'].indexOf(
                            Object.prototype.toString.call(I)
                          ) !== -1) &&
                        typeof FileReader < 'u'
                        ? new l.Promise(function (A, U) {
                            var W = new FileReader();
                            (W.onload = function (it) {
                              A(it.target.result);
                            }),
                              (W.onerror = function (it) {
                                U(it.target.error);
                              }),
                              W.readAsArrayBuffer(I);
                          })
                        : I;
                    })
                    .then(function (I) {
                      var A = o.getTypeOf(I);
                      return A
                        ? (A === 'arraybuffer'
                            ? (I = o.transformTo('uint8array', I))
                            : A === 'string' &&
                              (E
                                ? (I = a.decode(I))
                                : m &&
                                  k !== !0 &&
                                  (I = (function (U) {
                                    return c(
                                      U,
                                      i.uint8array
                                        ? new Uint8Array(U.length)
                                        : new Array(U.length)
                                    );
                                  })(I))),
                          I)
                        : l.Promise.reject(
                            new Error(
                              "Can't read the data of '" +
                                d +
                                "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"
                            )
                          );
                    });
                });
            },
            {
              './base64': 1,
              './external': 6,
              './nodejsUtils': 14,
              './support': 30,
              setimmediate: 54,
            },
          ],
          33: [
            function (t, r, o) {
              var i = t('./reader/readerFor'),
                a = t('./utils'),
                s = t('./signature'),
                l = t('./zipEntry'),
                g = t('./support');
              function c(w) {
                (this.files = []), (this.loadOptions = w);
              }
              (c.prototype = {
                checkSignature: function (w) {
                  if (!this.reader.readAndCheckSignature(w)) {
                    this.reader.index -= 4;
                    var b = this.reader.readString(4);
                    throw new Error(
                      'Corrupted zip or bug: unexpected signature (' +
                        a.pretty(b) +
                        ', expected ' +
                        a.pretty(w) +
                        ')'
                    );
                  }
                },
                isSignature: function (w, b) {
                  var h = this.reader.index;
                  this.reader.setIndex(w);
                  var _ = this.reader.readString(4) === b;
                  return this.reader.setIndex(h), _;
                },
                readBlockEndOfCentral: function () {
                  (this.diskNumber = this.reader.readInt(2)),
                    (this.diskWithCentralDirStart = this.reader.readInt(2)),
                    (this.centralDirRecordsOnThisDisk = this.reader.readInt(2)),
                    (this.centralDirRecords = this.reader.readInt(2)),
                    (this.centralDirSize = this.reader.readInt(4)),
                    (this.centralDirOffset = this.reader.readInt(4)),
                    (this.zipCommentLength = this.reader.readInt(2));
                  var w = this.reader.readData(this.zipCommentLength),
                    b = g.uint8array ? 'uint8array' : 'array',
                    h = a.transformTo(b, w);
                  this.zipComment = this.loadOptions.decodeFileName(h);
                },
                readBlockZip64EndOfCentral: function () {
                  (this.zip64EndOfCentralSize = this.reader.readInt(8)),
                    this.reader.skip(4),
                    (this.diskNumber = this.reader.readInt(4)),
                    (this.diskWithCentralDirStart = this.reader.readInt(4)),
                    (this.centralDirRecordsOnThisDisk = this.reader.readInt(8)),
                    (this.centralDirRecords = this.reader.readInt(8)),
                    (this.centralDirSize = this.reader.readInt(8)),
                    (this.centralDirOffset = this.reader.readInt(8)),
                    (this.zip64ExtensibleData = {});
                  for (
                    var w, b, h, _ = this.zip64EndOfCentralSize - 44;
                    0 < _;

                  )
                    (w = this.reader.readInt(2)),
                      (b = this.reader.readInt(4)),
                      (h = this.reader.readData(b)),
                      (this.zip64ExtensibleData[w] = {
                        id: w,
                        length: b,
                        value: h,
                      });
                },
                readBlockZip64EndOfCentralLocator: function () {
                  if (
                    ((this.diskWithZip64CentralDirStart =
                      this.reader.readInt(4)),
                    (this.relativeOffsetEndOfZip64CentralDir =
                      this.reader.readInt(8)),
                    (this.disksCount = this.reader.readInt(4)),
                    1 < this.disksCount)
                  )
                    throw new Error('Multi-volumes zip are not supported');
                },
                readLocalFiles: function () {
                  var w, b;
                  for (w = 0; w < this.files.length; w++)
                    (b = this.files[w]),
                      this.reader.setIndex(b.localHeaderOffset),
                      this.checkSignature(s.LOCAL_FILE_HEADER),
                      b.readLocalPart(this.reader),
                      b.handleUTF8(),
                      b.processAttributes();
                },
                readCentralDir: function () {
                  var w;
                  for (
                    this.reader.setIndex(this.centralDirOffset);
                    this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);

                  )
                    (w = new l(
                      { zip64: this.zip64 },
                      this.loadOptions
                    )).readCentralPart(this.reader),
                      this.files.push(w);
                  if (
                    this.centralDirRecords !== this.files.length &&
                    this.centralDirRecords !== 0 &&
                    this.files.length === 0
                  )
                    throw new Error(
                      'Corrupted zip or bug: expected ' +
                        this.centralDirRecords +
                        ' records in central dir, got ' +
                        this.files.length
                    );
                },
                readEndOfCentral: function () {
                  var w = this.reader.lastIndexOfSignature(
                    s.CENTRAL_DIRECTORY_END
                  );
                  if (w < 0)
                    throw this.isSignature(0, s.LOCAL_FILE_HEADER)
                      ? new Error(
                          "Corrupted zip: can't find end of central directory"
                        )
                      : new Error(
                          "Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"
                        );
                  this.reader.setIndex(w);
                  var b = w;
                  if (
                    (this.checkSignature(s.CENTRAL_DIRECTORY_END),
                    this.readBlockEndOfCentral(),
                    this.diskNumber === a.MAX_VALUE_16BITS ||
                      this.diskWithCentralDirStart === a.MAX_VALUE_16BITS ||
                      this.centralDirRecordsOnThisDisk === a.MAX_VALUE_16BITS ||
                      this.centralDirRecords === a.MAX_VALUE_16BITS ||
                      this.centralDirSize === a.MAX_VALUE_32BITS ||
                      this.centralDirOffset === a.MAX_VALUE_32BITS)
                  ) {
                    if (
                      ((this.zip64 = !0),
                      (w = this.reader.lastIndexOfSignature(
                        s.ZIP64_CENTRAL_DIRECTORY_LOCATOR
                      )) < 0)
                    )
                      throw new Error(
                        "Corrupted zip: can't find the ZIP64 end of central directory locator"
                      );
                    if (
                      (this.reader.setIndex(w),
                      this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),
                      this.readBlockZip64EndOfCentralLocator(),
                      !this.isSignature(
                        this.relativeOffsetEndOfZip64CentralDir,
                        s.ZIP64_CENTRAL_DIRECTORY_END
                      ) &&
                        ((this.relativeOffsetEndOfZip64CentralDir =
                          this.reader.lastIndexOfSignature(
                            s.ZIP64_CENTRAL_DIRECTORY_END
                          )),
                        this.relativeOffsetEndOfZip64CentralDir < 0))
                    )
                      throw new Error(
                        "Corrupted zip: can't find the ZIP64 end of central directory"
                      );
                    this.reader.setIndex(
                      this.relativeOffsetEndOfZip64CentralDir
                    ),
                      this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),
                      this.readBlockZip64EndOfCentral();
                  }
                  var h = this.centralDirOffset + this.centralDirSize;
                  this.zip64 &&
                    ((h += 20), (h += 12 + this.zip64EndOfCentralSize));
                  var _ = b - h;
                  if (0 < _)
                    this.isSignature(b, s.CENTRAL_FILE_HEADER) ||
                      (this.reader.zero = _);
                  else if (_ < 0)
                    throw new Error(
                      'Corrupted zip: missing ' + Math.abs(_) + ' bytes.'
                    );
                },
                prepareReader: function (w) {
                  this.reader = i(w);
                },
                load: function (w) {
                  this.prepareReader(w),
                    this.readEndOfCentral(),
                    this.readCentralDir(),
                    this.readLocalFiles();
                },
              }),
                (r.exports = c);
            },
            {
              './reader/readerFor': 22,
              './signature': 23,
              './support': 30,
              './utils': 32,
              './zipEntry': 34,
            },
          ],
          34: [
            function (t, r, o) {
              var i = t('./reader/readerFor'),
                a = t('./utils'),
                s = t('./compressedObject'),
                l = t('./crc32'),
                g = t('./utf8'),
                c = t('./compressions'),
                w = t('./support');
              function b(h, _) {
                (this.options = h), (this.loadOptions = _);
              }
              (b.prototype = {
                isEncrypted: function () {
                  return (1 & this.bitFlag) == 1;
                },
                useUTF8: function () {
                  return (2048 & this.bitFlag) == 2048;
                },
                readLocalPart: function (h) {
                  var _, d;
                  if (
                    (h.skip(22),
                    (this.fileNameLength = h.readInt(2)),
                    (d = h.readInt(2)),
                    (this.fileName = h.readData(this.fileNameLength)),
                    h.skip(d),
                    this.compressedSize === -1 || this.uncompressedSize === -1)
                  )
                    throw new Error(
                      "Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)"
                    );
                  if (
                    (_ = (function (v) {
                      for (var m in c)
                        if (
                          Object.prototype.hasOwnProperty.call(c, m) &&
                          c[m].magic === v
                        )
                          return c[m];
                      return null;
                    })(this.compressionMethod)) === null
                  )
                    throw new Error(
                      'Corrupted zip : compression ' +
                        a.pretty(this.compressionMethod) +
                        ' unknown (inner file : ' +
                        a.transformTo('string', this.fileName) +
                        ')'
                    );
                  this.decompressed = new s(
                    this.compressedSize,
                    this.uncompressedSize,
                    this.crc32,
                    _,
                    h.readData(this.compressedSize)
                  );
                },
                readCentralPart: function (h) {
                  (this.versionMadeBy = h.readInt(2)),
                    h.skip(2),
                    (this.bitFlag = h.readInt(2)),
                    (this.compressionMethod = h.readString(2)),
                    (this.date = h.readDate()),
                    (this.crc32 = h.readInt(4)),
                    (this.compressedSize = h.readInt(4)),
                    (this.uncompressedSize = h.readInt(4));
                  var _ = h.readInt(2);
                  if (
                    ((this.extraFieldsLength = h.readInt(2)),
                    (this.fileCommentLength = h.readInt(2)),
                    (this.diskNumberStart = h.readInt(2)),
                    (this.internalFileAttributes = h.readInt(2)),
                    (this.externalFileAttributes = h.readInt(4)),
                    (this.localHeaderOffset = h.readInt(4)),
                    this.isEncrypted())
                  )
                    throw new Error('Encrypted zip are not supported');
                  h.skip(_),
                    this.readExtraFields(h),
                    this.parseZIP64ExtraField(h),
                    (this.fileComment = h.readData(this.fileCommentLength));
                },
                processAttributes: function () {
                  (this.unixPermissions = null), (this.dosPermissions = null);
                  var h = this.versionMadeBy >> 8;
                  (this.dir = !!(16 & this.externalFileAttributes)),
                    h == 0 &&
                      (this.dosPermissions = 63 & this.externalFileAttributes),
                    h == 3 &&
                      (this.unixPermissions =
                        (this.externalFileAttributes >> 16) & 65535),
                    this.dir ||
                      this.fileNameStr.slice(-1) !== '/' ||
                      (this.dir = !0);
                },
                parseZIP64ExtraField: function () {
                  if (this.extraFields[1]) {
                    var h = i(this.extraFields[1].value);
                    this.uncompressedSize === a.MAX_VALUE_32BITS &&
                      (this.uncompressedSize = h.readInt(8)),
                      this.compressedSize === a.MAX_VALUE_32BITS &&
                        (this.compressedSize = h.readInt(8)),
                      this.localHeaderOffset === a.MAX_VALUE_32BITS &&
                        (this.localHeaderOffset = h.readInt(8)),
                      this.diskNumberStart === a.MAX_VALUE_32BITS &&
                        (this.diskNumberStart = h.readInt(4));
                  }
                },
                readExtraFields: function (h) {
                  var _,
                    d,
                    v,
                    m = h.index + this.extraFieldsLength;
                  for (
                    this.extraFields || (this.extraFields = {});
                    h.index + 4 < m;

                  )
                    (_ = h.readInt(2)),
                      (d = h.readInt(2)),
                      (v = h.readData(d)),
                      (this.extraFields[_] = { id: _, length: d, value: v });
                  h.setIndex(m);
                },
                handleUTF8: function () {
                  var h = w.uint8array ? 'uint8array' : 'array';
                  if (this.useUTF8())
                    (this.fileNameStr = g.utf8decode(this.fileName)),
                      (this.fileCommentStr = g.utf8decode(this.fileComment));
                  else {
                    var _ = this.findExtraFieldUnicodePath();
                    if (_ !== null) this.fileNameStr = _;
                    else {
                      var d = a.transformTo(h, this.fileName);
                      this.fileNameStr = this.loadOptions.decodeFileName(d);
                    }
                    var v = this.findExtraFieldUnicodeComment();
                    if (v !== null) this.fileCommentStr = v;
                    else {
                      var m = a.transformTo(h, this.fileComment);
                      this.fileCommentStr = this.loadOptions.decodeFileName(m);
                    }
                  }
                },
                findExtraFieldUnicodePath: function () {
                  var h = this.extraFields[28789];
                  if (h) {
                    var _ = i(h.value);
                    return _.readInt(1) !== 1 ||
                      l(this.fileName) !== _.readInt(4)
                      ? null
                      : g.utf8decode(_.readData(h.length - 5));
                  }
                  return null;
                },
                findExtraFieldUnicodeComment: function () {
                  var h = this.extraFields[25461];
                  if (h) {
                    var _ = i(h.value);
                    return _.readInt(1) !== 1 ||
                      l(this.fileComment) !== _.readInt(4)
                      ? null
                      : g.utf8decode(_.readData(h.length - 5));
                  }
                  return null;
                },
              }),
                (r.exports = b);
            },
            {
              './compressedObject': 2,
              './compressions': 3,
              './crc32': 4,
              './reader/readerFor': 22,
              './support': 30,
              './utf8': 31,
              './utils': 32,
            },
          ],
          35: [
            function (t, r, o) {
              function i(_, d, v) {
                (this.name = _),
                  (this.dir = v.dir),
                  (this.date = v.date),
                  (this.comment = v.comment),
                  (this.unixPermissions = v.unixPermissions),
                  (this.dosPermissions = v.dosPermissions),
                  (this._data = d),
                  (this._dataBinary = v.binary),
                  (this.options = {
                    compression: v.compression,
                    compressionOptions: v.compressionOptions,
                  });
              }
              var a = t('./stream/StreamHelper'),
                s = t('./stream/DataWorker'),
                l = t('./utf8'),
                g = t('./compressedObject'),
                c = t('./stream/GenericWorker');
              i.prototype = {
                internalStream: function (_) {
                  var d = null,
                    v = 'string';
                  try {
                    if (!_) throw new Error('No output type specified.');
                    var m = (v = _.toLowerCase()) === 'string' || v === 'text';
                    (v !== 'binarystring' && v !== 'text') || (v = 'string'),
                      (d = this._decompressWorker());
                    var k = !this._dataBinary;
                    k && !m && (d = d.pipe(new l.Utf8EncodeWorker())),
                      !k && m && (d = d.pipe(new l.Utf8DecodeWorker()));
                  } catch (E) {
                    (d = new c('error')).error(E);
                  }
                  return new a(d, v, '');
                },
                async: function (_, d) {
                  return this.internalStream(_).accumulate(d);
                },
                nodeStream: function (_, d) {
                  return this.internalStream(_ || 'nodebuffer').toNodejsStream(
                    d
                  );
                },
                _compressWorker: function (_, d) {
                  if (
                    this._data instanceof g &&
                    this._data.compression.magic === _.magic
                  )
                    return this._data.getCompressedWorker();
                  var v = this._decompressWorker();
                  return (
                    this._dataBinary || (v = v.pipe(new l.Utf8EncodeWorker())),
                    g.createWorkerFrom(v, _, d)
                  );
                },
                _decompressWorker: function () {
                  return this._data instanceof g
                    ? this._data.getContentWorker()
                    : this._data instanceof c
                    ? this._data
                    : new s(this._data);
                },
              };
              for (
                var w = [
                    'asText',
                    'asBinary',
                    'asNodeBuffer',
                    'asUint8Array',
                    'asArrayBuffer',
                  ],
                  b = function () {
                    throw new Error(
                      'This method has been removed in JSZip 3.0, please check the upgrade guide.'
                    );
                  },
                  h = 0;
                h < w.length;
                h++
              )
                i.prototype[w[h]] = b;
              r.exports = i;
            },
            {
              './compressedObject': 2,
              './stream/DataWorker': 27,
              './stream/GenericWorker': 28,
              './stream/StreamHelper': 29,
              './utf8': 31,
            },
          ],
          36: [
            function (t, r, o) {
              (function (i) {
                var a,
                  s,
                  l = i.MutationObserver || i.WebKitMutationObserver;
                if (l) {
                  var g = 0,
                    c = new l(_),
                    w = i.document.createTextNode('');
                  c.observe(w, { characterData: !0 }),
                    (a = function () {
                      w.data = g = ++g % 2;
                    });
                } else if (i.setImmediate || i.MessageChannel === void 0)
                  a =
                    'document' in i &&
                    'onreadystatechange' in i.document.createElement('script')
                      ? function () {
                          var d = i.document.createElement('script');
                          (d.onreadystatechange = function () {
                            _(),
                              (d.onreadystatechange = null),
                              d.parentNode.removeChild(d),
                              (d = null);
                          }),
                            i.document.documentElement.appendChild(d);
                        }
                      : function () {
                          setTimeout(_, 0);
                        };
                else {
                  var b = new i.MessageChannel();
                  (b.port1.onmessage = _),
                    (a = function () {
                      b.port2.postMessage(0);
                    });
                }
                var h = [];
                function _() {
                  var d, v;
                  s = !0;
                  for (var m = h.length; m; ) {
                    for (v = h, h = [], d = -1; ++d < m; ) v[d]();
                    m = h.length;
                  }
                  s = !1;
                }
                r.exports = function (d) {
                  h.push(d) !== 1 || s || a();
                };
              }.call(
                this,
                typeof rn < 'u'
                  ? rn
                  : typeof self < 'u'
                  ? self
                  : typeof window < 'u'
                  ? window
                  : {}
              ));
            },
            {},
          ],
          37: [
            function (t, r, o) {
              var i = t('immediate');
              function a() {}
              var s = {},
                l = ['REJECTED'],
                g = ['FULFILLED'],
                c = ['PENDING'];
              function w(m) {
                if (typeof m != 'function')
                  throw new TypeError('resolver must be a function');
                (this.state = c),
                  (this.queue = []),
                  (this.outcome = void 0),
                  m !== a && d(this, m);
              }
              function b(m, k, E) {
                (this.promise = m),
                  typeof k == 'function' &&
                    ((this.onFulfilled = k),
                    (this.callFulfilled = this.otherCallFulfilled)),
                  typeof E == 'function' &&
                    ((this.onRejected = E),
                    (this.callRejected = this.otherCallRejected));
              }
              function h(m, k, E) {
                i(function () {
                  var I;
                  try {
                    I = k(E);
                  } catch (A) {
                    return s.reject(m, A);
                  }
                  I === m
                    ? s.reject(
                        m,
                        new TypeError('Cannot resolve promise with itself')
                      )
                    : s.resolve(m, I);
                });
              }
              function _(m) {
                var k = m && m.then;
                if (
                  m &&
                  (typeof m == 'object' || typeof m == 'function') &&
                  typeof k == 'function'
                )
                  return function () {
                    k.apply(m, arguments);
                  };
              }
              function d(m, k) {
                var E = !1;
                function I(W) {
                  E || ((E = !0), s.reject(m, W));
                }
                function A(W) {
                  E || ((E = !0), s.resolve(m, W));
                }
                var U = v(function () {
                  k(A, I);
                });
                U.status === 'error' && I(U.value);
              }
              function v(m, k) {
                var E = {};
                try {
                  (E.value = m(k)), (E.status = 'success');
                } catch (I) {
                  (E.status = 'error'), (E.value = I);
                }
                return E;
              }
              ((r.exports = w).prototype.finally = function (m) {
                if (typeof m != 'function') return this;
                var k = this.constructor;
                return this.then(
                  function (E) {
                    return k.resolve(m()).then(function () {
                      return E;
                    });
                  },
                  function (E) {
                    return k.resolve(m()).then(function () {
                      throw E;
                    });
                  }
                );
              }),
                (w.prototype.catch = function (m) {
                  return this.then(null, m);
                }),
                (w.prototype.then = function (m, k) {
                  if (
                    (typeof m != 'function' && this.state === g) ||
                    (typeof k != 'function' && this.state === l)
                  )
                    return this;
                  var E = new this.constructor(a);
                  return (
                    this.state !== c
                      ? h(E, this.state === g ? m : k, this.outcome)
                      : this.queue.push(new b(E, m, k)),
                    E
                  );
                }),
                (b.prototype.callFulfilled = function (m) {
                  s.resolve(this.promise, m);
                }),
                (b.prototype.otherCallFulfilled = function (m) {
                  h(this.promise, this.onFulfilled, m);
                }),
                (b.prototype.callRejected = function (m) {
                  s.reject(this.promise, m);
                }),
                (b.prototype.otherCallRejected = function (m) {
                  h(this.promise, this.onRejected, m);
                }),
                (s.resolve = function (m, k) {
                  var E = v(_, k);
                  if (E.status === 'error') return s.reject(m, E.value);
                  var I = E.value;
                  if (I) d(m, I);
                  else {
                    (m.state = g), (m.outcome = k);
                    for (var A = -1, U = m.queue.length; ++A < U; )
                      m.queue[A].callFulfilled(k);
                  }
                  return m;
                }),
                (s.reject = function (m, k) {
                  (m.state = l), (m.outcome = k);
                  for (var E = -1, I = m.queue.length; ++E < I; )
                    m.queue[E].callRejected(k);
                  return m;
                }),
                (w.resolve = function (m) {
                  return m instanceof this ? m : s.resolve(new this(a), m);
                }),
                (w.reject = function (m) {
                  var k = new this(a);
                  return s.reject(k, m);
                }),
                (w.all = function (m) {
                  var k = this;
                  if (Object.prototype.toString.call(m) !== '[object Array]')
                    return this.reject(new TypeError('must be an array'));
                  var E = m.length,
                    I = !1;
                  if (!E) return this.resolve([]);
                  for (
                    var A = new Array(E), U = 0, W = -1, it = new this(a);
                    ++W < E;

                  )
                    j(m[W], W);
                  return it;
                  function j(at, lt) {
                    k.resolve(at).then(
                      function (L) {
                        (A[lt] = L),
                          ++U !== E || I || ((I = !0), s.resolve(it, A));
                      },
                      function (L) {
                        I || ((I = !0), s.reject(it, L));
                      }
                    );
                  }
                }),
                (w.race = function (m) {
                  var k = this;
                  if (Object.prototype.toString.call(m) !== '[object Array]')
                    return this.reject(new TypeError('must be an array'));
                  var E = m.length,
                    I = !1;
                  if (!E) return this.resolve([]);
                  for (var A = -1, U = new this(a); ++A < E; )
                    (W = m[A]),
                      k.resolve(W).then(
                        function (it) {
                          I || ((I = !0), s.resolve(U, it));
                        },
                        function (it) {
                          I || ((I = !0), s.reject(U, it));
                        }
                      );
                  var W;
                  return U;
                });
            },
            { immediate: 36 },
          ],
          38: [
            function (t, r, o) {
              var i = {};
              (0, t('./lib/utils/common').assign)(
                i,
                t('./lib/deflate'),
                t('./lib/inflate'),
                t('./lib/zlib/constants')
              ),
                (r.exports = i);
            },
            {
              './lib/deflate': 39,
              './lib/inflate': 40,
              './lib/utils/common': 41,
              './lib/zlib/constants': 44,
            },
          ],
          39: [
            function (t, r, o) {
              var i = t('./zlib/deflate'),
                a = t('./utils/common'),
                s = t('./utils/strings'),
                l = t('./zlib/messages'),
                g = t('./zlib/zstream'),
                c = Object.prototype.toString,
                w = 0,
                b = -1,
                h = 0,
                _ = 8;
              function d(m) {
                if (!(this instanceof d)) return new d(m);
                this.options = a.assign(
                  {
                    level: b,
                    method: _,
                    chunkSize: 16384,
                    windowBits: 15,
                    memLevel: 8,
                    strategy: h,
                    to: '',
                  },
                  m || {}
                );
                var k = this.options;
                k.raw && 0 < k.windowBits
                  ? (k.windowBits = -k.windowBits)
                  : k.gzip &&
                    0 < k.windowBits &&
                    k.windowBits < 16 &&
                    (k.windowBits += 16),
                  (this.err = 0),
                  (this.msg = ''),
                  (this.ended = !1),
                  (this.chunks = []),
                  (this.strm = new g()),
                  (this.strm.avail_out = 0);
                var E = i.deflateInit2(
                  this.strm,
                  k.level,
                  k.method,
                  k.windowBits,
                  k.memLevel,
                  k.strategy
                );
                if (E !== w) throw new Error(l[E]);
                if (
                  (k.header && i.deflateSetHeader(this.strm, k.header),
                  k.dictionary)
                ) {
                  var I;
                  if (
                    ((I =
                      typeof k.dictionary == 'string'
                        ? s.string2buf(k.dictionary)
                        : c.call(k.dictionary) === '[object ArrayBuffer]'
                        ? new Uint8Array(k.dictionary)
                        : k.dictionary),
                    (E = i.deflateSetDictionary(this.strm, I)) !== w)
                  )
                    throw new Error(l[E]);
                  this._dict_set = !0;
                }
              }
              function v(m, k) {
                var E = new d(k);
                if ((E.push(m, !0), E.err)) throw E.msg || l[E.err];
                return E.result;
              }
              (d.prototype.push = function (m, k) {
                var E,
                  I,
                  A = this.strm,
                  U = this.options.chunkSize;
                if (this.ended) return !1;
                (I = k === ~~k ? k : k === !0 ? 4 : 0),
                  typeof m == 'string'
                    ? (A.input = s.string2buf(m))
                    : c.call(m) === '[object ArrayBuffer]'
                    ? (A.input = new Uint8Array(m))
                    : (A.input = m),
                  (A.next_in = 0),
                  (A.avail_in = A.input.length);
                do {
                  if (
                    (A.avail_out === 0 &&
                      ((A.output = new a.Buf8(U)),
                      (A.next_out = 0),
                      (A.avail_out = U)),
                    (E = i.deflate(A, I)) !== 1 && E !== w)
                  )
                    return this.onEnd(E), !(this.ended = !0);
                  (A.avail_out !== 0 &&
                    (A.avail_in !== 0 || (I !== 4 && I !== 2))) ||
                    (this.options.to === 'string'
                      ? this.onData(
                          s.buf2binstring(a.shrinkBuf(A.output, A.next_out))
                        )
                      : this.onData(a.shrinkBuf(A.output, A.next_out)));
                } while ((0 < A.avail_in || A.avail_out === 0) && E !== 1);
                return I === 4
                  ? ((E = i.deflateEnd(this.strm)),
                    this.onEnd(E),
                    (this.ended = !0),
                    E === w)
                  : I !== 2 || (this.onEnd(w), !(A.avail_out = 0));
              }),
                (d.prototype.onData = function (m) {
                  this.chunks.push(m);
                }),
                (d.prototype.onEnd = function (m) {
                  m === w &&
                    (this.options.to === 'string'
                      ? (this.result = this.chunks.join(''))
                      : (this.result = a.flattenChunks(this.chunks))),
                    (this.chunks = []),
                    (this.err = m),
                    (this.msg = this.strm.msg);
                }),
                (o.Deflate = d),
                (o.deflate = v),
                (o.deflateRaw = function (m, k) {
                  return ((k = k || {}).raw = !0), v(m, k);
                }),
                (o.gzip = function (m, k) {
                  return ((k = k || {}).gzip = !0), v(m, k);
                });
            },
            {
              './utils/common': 41,
              './utils/strings': 42,
              './zlib/deflate': 46,
              './zlib/messages': 51,
              './zlib/zstream': 53,
            },
          ],
          40: [
            function (t, r, o) {
              var i = t('./zlib/inflate'),
                a = t('./utils/common'),
                s = t('./utils/strings'),
                l = t('./zlib/constants'),
                g = t('./zlib/messages'),
                c = t('./zlib/zstream'),
                w = t('./zlib/gzheader'),
                b = Object.prototype.toString;
              function h(d) {
                if (!(this instanceof h)) return new h(d);
                this.options = a.assign(
                  { chunkSize: 16384, windowBits: 0, to: '' },
                  d || {}
                );
                var v = this.options;
                v.raw &&
                  0 <= v.windowBits &&
                  v.windowBits < 16 &&
                  ((v.windowBits = -v.windowBits),
                  v.windowBits === 0 && (v.windowBits = -15)),
                  !(0 <= v.windowBits && v.windowBits < 16) ||
                    (d && d.windowBits) ||
                    (v.windowBits += 32),
                  15 < v.windowBits &&
                    v.windowBits < 48 &&
                    (15 & v.windowBits) == 0 &&
                    (v.windowBits |= 15),
                  (this.err = 0),
                  (this.msg = ''),
                  (this.ended = !1),
                  (this.chunks = []),
                  (this.strm = new c()),
                  (this.strm.avail_out = 0);
                var m = i.inflateInit2(this.strm, v.windowBits);
                if (m !== l.Z_OK) throw new Error(g[m]);
                (this.header = new w()),
                  i.inflateGetHeader(this.strm, this.header);
              }
              function _(d, v) {
                var m = new h(v);
                if ((m.push(d, !0), m.err)) throw m.msg || g[m.err];
                return m.result;
              }
              (h.prototype.push = function (d, v) {
                var m,
                  k,
                  E,
                  I,
                  A,
                  U,
                  W = this.strm,
                  it = this.options.chunkSize,
                  j = this.options.dictionary,
                  at = !1;
                if (this.ended) return !1;
                (k = v === ~~v ? v : v === !0 ? l.Z_FINISH : l.Z_NO_FLUSH),
                  typeof d == 'string'
                    ? (W.input = s.binstring2buf(d))
                    : b.call(d) === '[object ArrayBuffer]'
                    ? (W.input = new Uint8Array(d))
                    : (W.input = d),
                  (W.next_in = 0),
                  (W.avail_in = W.input.length);
                do {
                  if (
                    (W.avail_out === 0 &&
                      ((W.output = new a.Buf8(it)),
                      (W.next_out = 0),
                      (W.avail_out = it)),
                    (m = i.inflate(W, l.Z_NO_FLUSH)) === l.Z_NEED_DICT &&
                      j &&
                      ((U =
                        typeof j == 'string'
                          ? s.string2buf(j)
                          : b.call(j) === '[object ArrayBuffer]'
                          ? new Uint8Array(j)
                          : j),
                      (m = i.inflateSetDictionary(this.strm, U))),
                    m === l.Z_BUF_ERROR &&
                      at === !0 &&
                      ((m = l.Z_OK), (at = !1)),
                    m !== l.Z_STREAM_END && m !== l.Z_OK)
                  )
                    return this.onEnd(m), !(this.ended = !0);
                  W.next_out &&
                    ((W.avail_out !== 0 &&
                      m !== l.Z_STREAM_END &&
                      (W.avail_in !== 0 ||
                        (k !== l.Z_FINISH && k !== l.Z_SYNC_FLUSH))) ||
                      (this.options.to === 'string'
                        ? ((E = s.utf8border(W.output, W.next_out)),
                          (I = W.next_out - E),
                          (A = s.buf2string(W.output, E)),
                          (W.next_out = I),
                          (W.avail_out = it - I),
                          I && a.arraySet(W.output, W.output, E, I, 0),
                          this.onData(A))
                        : this.onData(a.shrinkBuf(W.output, W.next_out)))),
                    W.avail_in === 0 && W.avail_out === 0 && (at = !0);
                } while (
                  (0 < W.avail_in || W.avail_out === 0) &&
                  m !== l.Z_STREAM_END
                );
                return (
                  m === l.Z_STREAM_END && (k = l.Z_FINISH),
                  k === l.Z_FINISH
                    ? ((m = i.inflateEnd(this.strm)),
                      this.onEnd(m),
                      (this.ended = !0),
                      m === l.Z_OK)
                    : k !== l.Z_SYNC_FLUSH ||
                      (this.onEnd(l.Z_OK), !(W.avail_out = 0))
                );
              }),
                (h.prototype.onData = function (d) {
                  this.chunks.push(d);
                }),
                (h.prototype.onEnd = function (d) {
                  d === l.Z_OK &&
                    (this.options.to === 'string'
                      ? (this.result = this.chunks.join(''))
                      : (this.result = a.flattenChunks(this.chunks))),
                    (this.chunks = []),
                    (this.err = d),
                    (this.msg = this.strm.msg);
                }),
                (o.Inflate = h),
                (o.inflate = _),
                (o.inflateRaw = function (d, v) {
                  return ((v = v || {}).raw = !0), _(d, v);
                }),
                (o.ungzip = _);
            },
            {
              './utils/common': 41,
              './utils/strings': 42,
              './zlib/constants': 44,
              './zlib/gzheader': 47,
              './zlib/inflate': 49,
              './zlib/messages': 51,
              './zlib/zstream': 53,
            },
          ],
          41: [
            function (t, r, o) {
              var i =
                typeof Uint8Array < 'u' &&
                typeof Uint16Array < 'u' &&
                typeof Int32Array < 'u';
              (o.assign = function (l) {
                for (
                  var g = Array.prototype.slice.call(arguments, 1);
                  g.length;

                ) {
                  var c = g.shift();
                  if (c) {
                    if (typeof c != 'object')
                      throw new TypeError(c + 'must be non-object');
                    for (var w in c) c.hasOwnProperty(w) && (l[w] = c[w]);
                  }
                }
                return l;
              }),
                (o.shrinkBuf = function (l, g) {
                  return l.length === g
                    ? l
                    : l.subarray
                    ? l.subarray(0, g)
                    : ((l.length = g), l);
                });
              var a = {
                  arraySet: function (l, g, c, w, b) {
                    if (g.subarray && l.subarray)
                      l.set(g.subarray(c, c + w), b);
                    else for (var h = 0; h < w; h++) l[b + h] = g[c + h];
                  },
                  flattenChunks: function (l) {
                    var g, c, w, b, h, _;
                    for (g = w = 0, c = l.length; g < c; g++) w += l[g].length;
                    for (
                      _ = new Uint8Array(w), g = b = 0, c = l.length;
                      g < c;
                      g++
                    )
                      (h = l[g]), _.set(h, b), (b += h.length);
                    return _;
                  },
                },
                s = {
                  arraySet: function (l, g, c, w, b) {
                    for (var h = 0; h < w; h++) l[b + h] = g[c + h];
                  },
                  flattenChunks: function (l) {
                    return [].concat.apply([], l);
                  },
                };
              (o.setTyped = function (l) {
                l
                  ? ((o.Buf8 = Uint8Array),
                    (o.Buf16 = Uint16Array),
                    (o.Buf32 = Int32Array),
                    o.assign(o, a))
                  : ((o.Buf8 = Array),
                    (o.Buf16 = Array),
                    (o.Buf32 = Array),
                    o.assign(o, s));
              }),
                o.setTyped(i);
            },
            {},
          ],
          42: [
            function (t, r, o) {
              var i = t('./common'),
                a = !0,
                s = !0;
              try {
                String.fromCharCode.apply(null, [0]);
              } catch {
                a = !1;
              }
              try {
                String.fromCharCode.apply(null, new Uint8Array(1));
              } catch {
                s = !1;
              }
              for (var l = new i.Buf8(256), g = 0; g < 256; g++)
                l[g] =
                  252 <= g
                    ? 6
                    : 248 <= g
                    ? 5
                    : 240 <= g
                    ? 4
                    : 224 <= g
                    ? 3
                    : 192 <= g
                    ? 2
                    : 1;
              function c(w, b) {
                if (b < 65537 && ((w.subarray && s) || (!w.subarray && a)))
                  return String.fromCharCode.apply(null, i.shrinkBuf(w, b));
                for (var h = '', _ = 0; _ < b; _++)
                  h += String.fromCharCode(w[_]);
                return h;
              }
              (l[254] = l[254] = 1),
                (o.string2buf = function (w) {
                  var b,
                    h,
                    _,
                    d,
                    v,
                    m = w.length,
                    k = 0;
                  for (d = 0; d < m; d++)
                    (64512 & (h = w.charCodeAt(d))) == 55296 &&
                      d + 1 < m &&
                      (64512 & (_ = w.charCodeAt(d + 1))) == 56320 &&
                      ((h = 65536 + ((h - 55296) << 10) + (_ - 56320)), d++),
                      (k += h < 128 ? 1 : h < 2048 ? 2 : h < 65536 ? 3 : 4);
                  for (b = new i.Buf8(k), d = v = 0; v < k; d++)
                    (64512 & (h = w.charCodeAt(d))) == 55296 &&
                      d + 1 < m &&
                      (64512 & (_ = w.charCodeAt(d + 1))) == 56320 &&
                      ((h = 65536 + ((h - 55296) << 10) + (_ - 56320)), d++),
                      h < 128
                        ? (b[v++] = h)
                        : (h < 2048
                            ? (b[v++] = 192 | (h >>> 6))
                            : (h < 65536
                                ? (b[v++] = 224 | (h >>> 12))
                                : ((b[v++] = 240 | (h >>> 18)),
                                  (b[v++] = 128 | ((h >>> 12) & 63))),
                              (b[v++] = 128 | ((h >>> 6) & 63))),
                          (b[v++] = 128 | (63 & h)));
                  return b;
                }),
                (o.buf2binstring = function (w) {
                  return c(w, w.length);
                }),
                (o.binstring2buf = function (w) {
                  for (
                    var b = new i.Buf8(w.length), h = 0, _ = b.length;
                    h < _;
                    h++
                  )
                    b[h] = w.charCodeAt(h);
                  return b;
                }),
                (o.buf2string = function (w, b) {
                  var h,
                    _,
                    d,
                    v,
                    m = b || w.length,
                    k = new Array(2 * m);
                  for (h = _ = 0; h < m; )
                    if ((d = w[h++]) < 128) k[_++] = d;
                    else if (4 < (v = l[d])) (k[_++] = 65533), (h += v - 1);
                    else {
                      for (
                        d &= v === 2 ? 31 : v === 3 ? 15 : 7;
                        1 < v && h < m;

                      )
                        (d = (d << 6) | (63 & w[h++])), v--;
                      1 < v
                        ? (k[_++] = 65533)
                        : d < 65536
                        ? (k[_++] = d)
                        : ((d -= 65536),
                          (k[_++] = 55296 | ((d >> 10) & 1023)),
                          (k[_++] = 56320 | (1023 & d)));
                    }
                  return c(k, _);
                }),
                (o.utf8border = function (w, b) {
                  var h;
                  for (
                    (b = b || w.length) > w.length && (b = w.length), h = b - 1;
                    0 <= h && (192 & w[h]) == 128;

                  )
                    h--;
                  return h < 0 || h === 0 ? b : h + l[w[h]] > b ? h : b;
                });
            },
            { './common': 41 },
          ],
          43: [
            function (t, r, o) {
              r.exports = function (i, a, s, l) {
                for (
                  var g = (65535 & i) | 0, c = ((i >>> 16) & 65535) | 0, w = 0;
                  s !== 0;

                ) {
                  for (
                    s -= w = 2e3 < s ? 2e3 : s;
                    (c = (c + (g = (g + a[l++]) | 0)) | 0), --w;

                  );
                  (g %= 65521), (c %= 65521);
                }
                return g | (c << 16) | 0;
              };
            },
            {},
          ],
          44: [
            function (t, r, o) {
              r.exports = {
                Z_NO_FLUSH: 0,
                Z_PARTIAL_FLUSH: 1,
                Z_SYNC_FLUSH: 2,
                Z_FULL_FLUSH: 3,
                Z_FINISH: 4,
                Z_BLOCK: 5,
                Z_TREES: 6,
                Z_OK: 0,
                Z_STREAM_END: 1,
                Z_NEED_DICT: 2,
                Z_ERRNO: -1,
                Z_STREAM_ERROR: -2,
                Z_DATA_ERROR: -3,
                Z_BUF_ERROR: -5,
                Z_NO_COMPRESSION: 0,
                Z_BEST_SPEED: 1,
                Z_BEST_COMPRESSION: 9,
                Z_DEFAULT_COMPRESSION: -1,
                Z_FILTERED: 1,
                Z_HUFFMAN_ONLY: 2,
                Z_RLE: 3,
                Z_FIXED: 4,
                Z_DEFAULT_STRATEGY: 0,
                Z_BINARY: 0,
                Z_TEXT: 1,
                Z_UNKNOWN: 2,
                Z_DEFLATED: 8,
              };
            },
            {},
          ],
          45: [
            function (t, r, o) {
              var i = (function () {
                for (var a, s = [], l = 0; l < 256; l++) {
                  a = l;
                  for (var g = 0; g < 8; g++)
                    a = 1 & a ? 3988292384 ^ (a >>> 1) : a >>> 1;
                  s[l] = a;
                }
                return s;
              })();
              r.exports = function (a, s, l, g) {
                var c = i,
                  w = g + l;
                a ^= -1;
                for (var b = g; b < w; b++) a = (a >>> 8) ^ c[255 & (a ^ s[b])];
                return -1 ^ a;
              };
            },
            {},
          ],
          46: [
            function (t, r, o) {
              var i,
                a = t('../utils/common'),
                s = t('./trees'),
                l = t('./adler32'),
                g = t('./crc32'),
                c = t('./messages'),
                w = 0,
                b = 4,
                h = 0,
                _ = -2,
                d = -1,
                v = 4,
                m = 2,
                k = 8,
                E = 9,
                I = 286,
                A = 30,
                U = 19,
                W = 2 * I + 1,
                it = 15,
                j = 3,
                at = 258,
                lt = at + j + 1,
                L = 42,
                V = 113,
                f = 1,
                M = 2,
                gt = 3,
                Y = 4;
              function st(u, N) {
                return (u.msg = c[N]), N;
              }
              function nt(u) {
                return (u << 1) - (4 < u ? 9 : 0);
              }
              function mt(u) {
                for (var N = u.length; 0 <= --N; ) u[N] = 0;
              }
              function B(u) {
                var N = u.state,
                  F = N.pending;
                F > u.avail_out && (F = u.avail_out),
                  F !== 0 &&
                    (a.arraySet(
                      u.output,
                      N.pending_buf,
                      N.pending_out,
                      F,
                      u.next_out
                    ),
                    (u.next_out += F),
                    (N.pending_out += F),
                    (u.total_out += F),
                    (u.avail_out -= F),
                    (N.pending -= F),
                    N.pending === 0 && (N.pending_out = 0));
              }
              function T(u, N) {
                s._tr_flush_block(
                  u,
                  0 <= u.block_start ? u.block_start : -1,
                  u.strstart - u.block_start,
                  N
                ),
                  (u.block_start = u.strstart),
                  B(u.strm);
              }
              function K(u, N) {
                u.pending_buf[u.pending++] = N;
              }
              function H(u, N) {
                (u.pending_buf[u.pending++] = (N >>> 8) & 255),
                  (u.pending_buf[u.pending++] = 255 & N);
              }
              function $(u, N) {
                var F,
                  x,
                  C = u.max_chain_length,
                  D = u.strstart,
                  G = u.prev_length,
                  tt = u.nice_match,
                  z =
                    u.strstart > u.w_size - lt
                      ? u.strstart - (u.w_size - lt)
                      : 0,
                  ot = u.window,
                  X = u.w_mask,
                  rt = u.prev,
                  _t = u.strstart + at,
                  At = ot[D + G - 1],
                  kt = ot[D + G];
                u.prev_length >= u.good_match && (C >>= 2),
                  tt > u.lookahead && (tt = u.lookahead);
                do
                  if (
                    ot[(F = N) + G] === kt &&
                    ot[F + G - 1] === At &&
                    ot[F] === ot[D] &&
                    ot[++F] === ot[D + 1]
                  ) {
                    (D += 2), F++;
                    do;
                    while (
                      ot[++D] === ot[++F] &&
                      ot[++D] === ot[++F] &&
                      ot[++D] === ot[++F] &&
                      ot[++D] === ot[++F] &&
                      ot[++D] === ot[++F] &&
                      ot[++D] === ot[++F] &&
                      ot[++D] === ot[++F] &&
                      ot[++D] === ot[++F] &&
                      D < _t
                    );
                    if (((x = at - (_t - D)), (D = _t - at), G < x)) {
                      if (((u.match_start = N), tt <= (G = x))) break;
                      (At = ot[D + G - 1]), (kt = ot[D + G]);
                    }
                  }
                while ((N = rt[N & X]) > z && --C != 0);
                return G <= u.lookahead ? G : u.lookahead;
              }
              function P(u) {
                var N,
                  F,
                  x,
                  C,
                  D,
                  G,
                  tt,
                  z,
                  ot,
                  X,
                  rt = u.w_size;
                do {
                  if (
                    ((C = u.window_size - u.lookahead - u.strstart),
                    u.strstart >= rt + (rt - lt))
                  ) {
                    for (
                      a.arraySet(u.window, u.window, rt, rt, 0),
                        u.match_start -= rt,
                        u.strstart -= rt,
                        u.block_start -= rt,
                        N = F = u.hash_size;
                      (x = u.head[--N]),
                        (u.head[N] = rt <= x ? x - rt : 0),
                        --F;

                    );
                    for (
                      N = F = rt;
                      (x = u.prev[--N]),
                        (u.prev[N] = rt <= x ? x - rt : 0),
                        --F;

                    );
                    C += rt;
                  }
                  if (u.strm.avail_in === 0) break;
                  if (
                    ((G = u.strm),
                    (tt = u.window),
                    (z = u.strstart + u.lookahead),
                    (ot = C),
                    (X = void 0),
                    (X = G.avail_in),
                    ot < X && (X = ot),
                    (F =
                      X === 0
                        ? 0
                        : ((G.avail_in -= X),
                          a.arraySet(tt, G.input, G.next_in, X, z),
                          G.state.wrap === 1
                            ? (G.adler = l(G.adler, tt, X, z))
                            : G.state.wrap === 2 &&
                              (G.adler = g(G.adler, tt, X, z)),
                          (G.next_in += X),
                          (G.total_in += X),
                          X)),
                    (u.lookahead += F),
                    u.lookahead + u.insert >= j)
                  )
                    for (
                      D = u.strstart - u.insert,
                        u.ins_h = u.window[D],
                        u.ins_h =
                          ((u.ins_h << u.hash_shift) ^ u.window[D + 1]) &
                          u.hash_mask;
                      u.insert &&
                      ((u.ins_h =
                        ((u.ins_h << u.hash_shift) ^ u.window[D + j - 1]) &
                        u.hash_mask),
                      (u.prev[D & u.w_mask] = u.head[u.ins_h]),
                      (u.head[u.ins_h] = D),
                      D++,
                      u.insert--,
                      !(u.lookahead + u.insert < j));

                    );
                } while (u.lookahead < lt && u.strm.avail_in !== 0);
              }
              function vt(u, N) {
                for (var F, x; ; ) {
                  if (u.lookahead < lt) {
                    if ((P(u), u.lookahead < lt && N === w)) return f;
                    if (u.lookahead === 0) break;
                  }
                  if (
                    ((F = 0),
                    u.lookahead >= j &&
                      ((u.ins_h =
                        ((u.ins_h << u.hash_shift) ^
                          u.window[u.strstart + j - 1]) &
                        u.hash_mask),
                      (F = u.prev[u.strstart & u.w_mask] = u.head[u.ins_h]),
                      (u.head[u.ins_h] = u.strstart)),
                    F !== 0 &&
                      u.strstart - F <= u.w_size - lt &&
                      (u.match_length = $(u, F)),
                    u.match_length >= j)
                  )
                    if (
                      ((x = s._tr_tally(
                        u,
                        u.strstart - u.match_start,
                        u.match_length - j
                      )),
                      (u.lookahead -= u.match_length),
                      u.match_length <= u.max_lazy_match && u.lookahead >= j)
                    ) {
                      for (
                        u.match_length--;
                        u.strstart++,
                          (u.ins_h =
                            ((u.ins_h << u.hash_shift) ^
                              u.window[u.strstart + j - 1]) &
                            u.hash_mask),
                          (F = u.prev[u.strstart & u.w_mask] = u.head[u.ins_h]),
                          (u.head[u.ins_h] = u.strstart),
                          --u.match_length != 0;

                      );
                      u.strstart++;
                    } else
                      (u.strstart += u.match_length),
                        (u.match_length = 0),
                        (u.ins_h = u.window[u.strstart]),
                        (u.ins_h =
                          ((u.ins_h << u.hash_shift) ^
                            u.window[u.strstart + 1]) &
                          u.hash_mask);
                  else
                    (x = s._tr_tally(u, 0, u.window[u.strstart])),
                      u.lookahead--,
                      u.strstart++;
                  if (x && (T(u, !1), u.strm.avail_out === 0)) return f;
                }
                return (
                  (u.insert = u.strstart < j - 1 ? u.strstart : j - 1),
                  N === b
                    ? (T(u, !0), u.strm.avail_out === 0 ? gt : Y)
                    : u.last_lit && (T(u, !1), u.strm.avail_out === 0)
                    ? f
                    : M
                );
              }
              function Q(u, N) {
                for (var F, x, C; ; ) {
                  if (u.lookahead < lt) {
                    if ((P(u), u.lookahead < lt && N === w)) return f;
                    if (u.lookahead === 0) break;
                  }
                  if (
                    ((F = 0),
                    u.lookahead >= j &&
                      ((u.ins_h =
                        ((u.ins_h << u.hash_shift) ^
                          u.window[u.strstart + j - 1]) &
                        u.hash_mask),
                      (F = u.prev[u.strstart & u.w_mask] = u.head[u.ins_h]),
                      (u.head[u.ins_h] = u.strstart)),
                    (u.prev_length = u.match_length),
                    (u.prev_match = u.match_start),
                    (u.match_length = j - 1),
                    F !== 0 &&
                      u.prev_length < u.max_lazy_match &&
                      u.strstart - F <= u.w_size - lt &&
                      ((u.match_length = $(u, F)),
                      u.match_length <= 5 &&
                        (u.strategy === 1 ||
                          (u.match_length === j &&
                            4096 < u.strstart - u.match_start)) &&
                        (u.match_length = j - 1)),
                    u.prev_length >= j && u.match_length <= u.prev_length)
                  ) {
                    for (
                      C = u.strstart + u.lookahead - j,
                        x = s._tr_tally(
                          u,
                          u.strstart - 1 - u.prev_match,
                          u.prev_length - j
                        ),
                        u.lookahead -= u.prev_length - 1,
                        u.prev_length -= 2;
                      ++u.strstart <= C &&
                        ((u.ins_h =
                          ((u.ins_h << u.hash_shift) ^
                            u.window[u.strstart + j - 1]) &
                          u.hash_mask),
                        (F = u.prev[u.strstart & u.w_mask] = u.head[u.ins_h]),
                        (u.head[u.ins_h] = u.strstart)),
                        --u.prev_length != 0;

                    );
                    if (
                      ((u.match_available = 0),
                      (u.match_length = j - 1),
                      u.strstart++,
                      x && (T(u, !1), u.strm.avail_out === 0))
                    )
                      return f;
                  } else if (u.match_available) {
                    if (
                      ((x = s._tr_tally(u, 0, u.window[u.strstart - 1])) &&
                        T(u, !1),
                      u.strstart++,
                      u.lookahead--,
                      u.strm.avail_out === 0)
                    )
                      return f;
                  } else (u.match_available = 1), u.strstart++, u.lookahead--;
                }
                return (
                  u.match_available &&
                    ((x = s._tr_tally(u, 0, u.window[u.strstart - 1])),
                    (u.match_available = 0)),
                  (u.insert = u.strstart < j - 1 ? u.strstart : j - 1),
                  N === b
                    ? (T(u, !0), u.strm.avail_out === 0 ? gt : Y)
                    : u.last_lit && (T(u, !1), u.strm.avail_out === 0)
                    ? f
                    : M
                );
              }
              function dt(u, N, F, x, C) {
                (this.good_length = u),
                  (this.max_lazy = N),
                  (this.nice_length = F),
                  (this.max_chain = x),
                  (this.func = C);
              }
              function yt() {
                (this.strm = null),
                  (this.status = 0),
                  (this.pending_buf = null),
                  (this.pending_buf_size = 0),
                  (this.pending_out = 0),
                  (this.pending = 0),
                  (this.wrap = 0),
                  (this.gzhead = null),
                  (this.gzindex = 0),
                  (this.method = k),
                  (this.last_flush = -1),
                  (this.w_size = 0),
                  (this.w_bits = 0),
                  (this.w_mask = 0),
                  (this.window = null),
                  (this.window_size = 0),
                  (this.prev = null),
                  (this.head = null),
                  (this.ins_h = 0),
                  (this.hash_size = 0),
                  (this.hash_bits = 0),
                  (this.hash_mask = 0),
                  (this.hash_shift = 0),
                  (this.block_start = 0),
                  (this.match_length = 0),
                  (this.prev_match = 0),
                  (this.match_available = 0),
                  (this.strstart = 0),
                  (this.match_start = 0),
                  (this.lookahead = 0),
                  (this.prev_length = 0),
                  (this.max_chain_length = 0),
                  (this.max_lazy_match = 0),
                  (this.level = 0),
                  (this.strategy = 0),
                  (this.good_match = 0),
                  (this.nice_match = 0),
                  (this.dyn_ltree = new a.Buf16(2 * W)),
                  (this.dyn_dtree = new a.Buf16(2 * (2 * A + 1))),
                  (this.bl_tree = new a.Buf16(2 * (2 * U + 1))),
                  mt(this.dyn_ltree),
                  mt(this.dyn_dtree),
                  mt(this.bl_tree),
                  (this.l_desc = null),
                  (this.d_desc = null),
                  (this.bl_desc = null),
                  (this.bl_count = new a.Buf16(it + 1)),
                  (this.heap = new a.Buf16(2 * I + 1)),
                  mt(this.heap),
                  (this.heap_len = 0),
                  (this.heap_max = 0),
                  (this.depth = new a.Buf16(2 * I + 1)),
                  mt(this.depth),
                  (this.l_buf = 0),
                  (this.lit_bufsize = 0),
                  (this.last_lit = 0),
                  (this.d_buf = 0),
                  (this.opt_len = 0),
                  (this.static_len = 0),
                  (this.matches = 0),
                  (this.insert = 0),
                  (this.bi_buf = 0),
                  (this.bi_valid = 0);
              }
              function ft(u) {
                var N;
                return u && u.state
                  ? ((u.total_in = u.total_out = 0),
                    (u.data_type = m),
                    ((N = u.state).pending = 0),
                    (N.pending_out = 0),
                    N.wrap < 0 && (N.wrap = -N.wrap),
                    (N.status = N.wrap ? L : V),
                    (u.adler = N.wrap === 2 ? 0 : 1),
                    (N.last_flush = w),
                    s._tr_init(N),
                    h)
                  : st(u, _);
              }
              function et(u) {
                var N = ft(u);
                return (
                  N === h &&
                    (function (F) {
                      (F.window_size = 2 * F.w_size),
                        mt(F.head),
                        (F.max_lazy_match = i[F.level].max_lazy),
                        (F.good_match = i[F.level].good_length),
                        (F.nice_match = i[F.level].nice_length),
                        (F.max_chain_length = i[F.level].max_chain),
                        (F.strstart = 0),
                        (F.block_start = 0),
                        (F.lookahead = 0),
                        (F.insert = 0),
                        (F.match_length = F.prev_length = j - 1),
                        (F.match_available = 0),
                        (F.ins_h = 0);
                    })(u.state),
                  N
                );
              }
              function xt(u, N, F, x, C, D) {
                if (!u) return _;
                var G = 1;
                if (
                  (N === d && (N = 6),
                  x < 0 ? ((G = 0), (x = -x)) : 15 < x && ((G = 2), (x -= 16)),
                  C < 1 ||
                    E < C ||
                    F !== k ||
                    x < 8 ||
                    15 < x ||
                    N < 0 ||
                    9 < N ||
                    D < 0 ||
                    v < D)
                )
                  return st(u, _);
                x === 8 && (x = 9);
                var tt = new yt();
                return (
                  ((u.state = tt).strm = u),
                  (tt.wrap = G),
                  (tt.gzhead = null),
                  (tt.w_bits = x),
                  (tt.w_size = 1 << tt.w_bits),
                  (tt.w_mask = tt.w_size - 1),
                  (tt.hash_bits = C + 7),
                  (tt.hash_size = 1 << tt.hash_bits),
                  (tt.hash_mask = tt.hash_size - 1),
                  (tt.hash_shift = ~~((tt.hash_bits + j - 1) / j)),
                  (tt.window = new a.Buf8(2 * tt.w_size)),
                  (tt.head = new a.Buf16(tt.hash_size)),
                  (tt.prev = new a.Buf16(tt.w_size)),
                  (tt.lit_bufsize = 1 << (C + 6)),
                  (tt.pending_buf_size = 4 * tt.lit_bufsize),
                  (tt.pending_buf = new a.Buf8(tt.pending_buf_size)),
                  (tt.d_buf = 1 * tt.lit_bufsize),
                  (tt.l_buf = 3 * tt.lit_bufsize),
                  (tt.level = N),
                  (tt.strategy = D),
                  (tt.method = F),
                  et(u)
                );
              }
              (i = [
                new dt(0, 0, 0, 0, function (u, N) {
                  var F = 65535;
                  for (
                    F > u.pending_buf_size - 5 && (F = u.pending_buf_size - 5);
                    ;

                  ) {
                    if (u.lookahead <= 1) {
                      if ((P(u), u.lookahead === 0 && N === w)) return f;
                      if (u.lookahead === 0) break;
                    }
                    (u.strstart += u.lookahead), (u.lookahead = 0);
                    var x = u.block_start + F;
                    if (
                      ((u.strstart === 0 || u.strstart >= x) &&
                        ((u.lookahead = u.strstart - x),
                        (u.strstart = x),
                        T(u, !1),
                        u.strm.avail_out === 0)) ||
                      (u.strstart - u.block_start >= u.w_size - lt &&
                        (T(u, !1), u.strm.avail_out === 0))
                    )
                      return f;
                  }
                  return (
                    (u.insert = 0),
                    N === b
                      ? (T(u, !0), u.strm.avail_out === 0 ? gt : Y)
                      : (u.strstart > u.block_start &&
                          (T(u, !1), u.strm.avail_out),
                        f)
                  );
                }),
                new dt(4, 4, 8, 4, vt),
                new dt(4, 5, 16, 8, vt),
                new dt(4, 6, 32, 32, vt),
                new dt(4, 4, 16, 16, Q),
                new dt(8, 16, 32, 32, Q),
                new dt(8, 16, 128, 128, Q),
                new dt(8, 32, 128, 256, Q),
                new dt(32, 128, 258, 1024, Q),
                new dt(32, 258, 258, 4096, Q),
              ]),
                (o.deflateInit = function (u, N) {
                  return xt(u, N, k, 15, 8, 0);
                }),
                (o.deflateInit2 = xt),
                (o.deflateReset = et),
                (o.deflateResetKeep = ft),
                (o.deflateSetHeader = function (u, N) {
                  return u && u.state
                    ? u.state.wrap !== 2
                      ? _
                      : ((u.state.gzhead = N), h)
                    : _;
                }),
                (o.deflate = function (u, N) {
                  var F, x, C, D;
                  if (!u || !u.state || 5 < N || N < 0) return u ? st(u, _) : _;
                  if (
                    ((x = u.state),
                    !u.output ||
                      (!u.input && u.avail_in !== 0) ||
                      (x.status === 666 && N !== b))
                  )
                    return st(u, u.avail_out === 0 ? -5 : _);
                  if (
                    ((x.strm = u),
                    (F = x.last_flush),
                    (x.last_flush = N),
                    x.status === L)
                  )
                    if (x.wrap === 2)
                      (u.adler = 0),
                        K(x, 31),
                        K(x, 139),
                        K(x, 8),
                        x.gzhead
                          ? (K(
                              x,
                              (x.gzhead.text ? 1 : 0) +
                                (x.gzhead.hcrc ? 2 : 0) +
                                (x.gzhead.extra ? 4 : 0) +
                                (x.gzhead.name ? 8 : 0) +
                                (x.gzhead.comment ? 16 : 0)
                            ),
                            K(x, 255 & x.gzhead.time),
                            K(x, (x.gzhead.time >> 8) & 255),
                            K(x, (x.gzhead.time >> 16) & 255),
                            K(x, (x.gzhead.time >> 24) & 255),
                            K(
                              x,
                              x.level === 9
                                ? 2
                                : 2 <= x.strategy || x.level < 2
                                ? 4
                                : 0
                            ),
                            K(x, 255 & x.gzhead.os),
                            x.gzhead.extra &&
                              x.gzhead.extra.length &&
                              (K(x, 255 & x.gzhead.extra.length),
                              K(x, (x.gzhead.extra.length >> 8) & 255)),
                            x.gzhead.hcrc &&
                              (u.adler = g(
                                u.adler,
                                x.pending_buf,
                                x.pending,
                                0
                              )),
                            (x.gzindex = 0),
                            (x.status = 69))
                          : (K(x, 0),
                            K(x, 0),
                            K(x, 0),
                            K(x, 0),
                            K(x, 0),
                            K(
                              x,
                              x.level === 9
                                ? 2
                                : 2 <= x.strategy || x.level < 2
                                ? 4
                                : 0
                            ),
                            K(x, 3),
                            (x.status = V));
                    else {
                      var G = (k + ((x.w_bits - 8) << 4)) << 8;
                      (G |=
                        (2 <= x.strategy || x.level < 2
                          ? 0
                          : x.level < 6
                          ? 1
                          : x.level === 6
                          ? 2
                          : 3) << 6),
                        x.strstart !== 0 && (G |= 32),
                        (G += 31 - (G % 31)),
                        (x.status = V),
                        H(x, G),
                        x.strstart !== 0 &&
                          (H(x, u.adler >>> 16), H(x, 65535 & u.adler)),
                        (u.adler = 1);
                    }
                  if (x.status === 69)
                    if (x.gzhead.extra) {
                      for (
                        C = x.pending;
                        x.gzindex < (65535 & x.gzhead.extra.length) &&
                        (x.pending !== x.pending_buf_size ||
                          (x.gzhead.hcrc &&
                            x.pending > C &&
                            (u.adler = g(
                              u.adler,
                              x.pending_buf,
                              x.pending - C,
                              C
                            )),
                          B(u),
                          (C = x.pending),
                          x.pending !== x.pending_buf_size));

                      )
                        K(x, 255 & x.gzhead.extra[x.gzindex]), x.gzindex++;
                      x.gzhead.hcrc &&
                        x.pending > C &&
                        (u.adler = g(u.adler, x.pending_buf, x.pending - C, C)),
                        x.gzindex === x.gzhead.extra.length &&
                          ((x.gzindex = 0), (x.status = 73));
                    } else x.status = 73;
                  if (x.status === 73)
                    if (x.gzhead.name) {
                      C = x.pending;
                      do {
                        if (
                          x.pending === x.pending_buf_size &&
                          (x.gzhead.hcrc &&
                            x.pending > C &&
                            (u.adler = g(
                              u.adler,
                              x.pending_buf,
                              x.pending - C,
                              C
                            )),
                          B(u),
                          (C = x.pending),
                          x.pending === x.pending_buf_size)
                        ) {
                          D = 1;
                          break;
                        }
                        (D =
                          x.gzindex < x.gzhead.name.length
                            ? 255 & x.gzhead.name.charCodeAt(x.gzindex++)
                            : 0),
                          K(x, D);
                      } while (D !== 0);
                      x.gzhead.hcrc &&
                        x.pending > C &&
                        (u.adler = g(u.adler, x.pending_buf, x.pending - C, C)),
                        D === 0 && ((x.gzindex = 0), (x.status = 91));
                    } else x.status = 91;
                  if (x.status === 91)
                    if (x.gzhead.comment) {
                      C = x.pending;
                      do {
                        if (
                          x.pending === x.pending_buf_size &&
                          (x.gzhead.hcrc &&
                            x.pending > C &&
                            (u.adler = g(
                              u.adler,
                              x.pending_buf,
                              x.pending - C,
                              C
                            )),
                          B(u),
                          (C = x.pending),
                          x.pending === x.pending_buf_size)
                        ) {
                          D = 1;
                          break;
                        }
                        (D =
                          x.gzindex < x.gzhead.comment.length
                            ? 255 & x.gzhead.comment.charCodeAt(x.gzindex++)
                            : 0),
                          K(x, D);
                      } while (D !== 0);
                      x.gzhead.hcrc &&
                        x.pending > C &&
                        (u.adler = g(u.adler, x.pending_buf, x.pending - C, C)),
                        D === 0 && (x.status = 103);
                    } else x.status = 103;
                  if (
                    (x.status === 103 &&
                      (x.gzhead.hcrc
                        ? (x.pending + 2 > x.pending_buf_size && B(u),
                          x.pending + 2 <= x.pending_buf_size &&
                            (K(x, 255 & u.adler),
                            K(x, (u.adler >> 8) & 255),
                            (u.adler = 0),
                            (x.status = V)))
                        : (x.status = V)),
                    x.pending !== 0)
                  ) {
                    if ((B(u), u.avail_out === 0))
                      return (x.last_flush = -1), h;
                  } else if (u.avail_in === 0 && nt(N) <= nt(F) && N !== b)
                    return st(u, -5);
                  if (x.status === 666 && u.avail_in !== 0) return st(u, -5);
                  if (
                    u.avail_in !== 0 ||
                    x.lookahead !== 0 ||
                    (N !== w && x.status !== 666)
                  ) {
                    var tt =
                      x.strategy === 2
                        ? (function (z, ot) {
                            for (var X; ; ) {
                              if (
                                z.lookahead === 0 &&
                                (P(z), z.lookahead === 0)
                              ) {
                                if (ot === w) return f;
                                break;
                              }
                              if (
                                ((z.match_length = 0),
                                (X = s._tr_tally(z, 0, z.window[z.strstart])),
                                z.lookahead--,
                                z.strstart++,
                                X && (T(z, !1), z.strm.avail_out === 0))
                              )
                                return f;
                            }
                            return (
                              (z.insert = 0),
                              ot === b
                                ? (T(z, !0), z.strm.avail_out === 0 ? gt : Y)
                                : z.last_lit &&
                                  (T(z, !1), z.strm.avail_out === 0)
                                ? f
                                : M
                            );
                          })(x, N)
                        : x.strategy === 3
                        ? (function (z, ot) {
                            for (var X, rt, _t, At, kt = z.window; ; ) {
                              if (z.lookahead <= at) {
                                if ((P(z), z.lookahead <= at && ot === w))
                                  return f;
                                if (z.lookahead === 0) break;
                              }
                              if (
                                ((z.match_length = 0),
                                z.lookahead >= j &&
                                  0 < z.strstart &&
                                  (rt = kt[(_t = z.strstart - 1)]) ===
                                    kt[++_t] &&
                                  rt === kt[++_t] &&
                                  rt === kt[++_t])
                              ) {
                                At = z.strstart + at;
                                do;
                                while (
                                  rt === kt[++_t] &&
                                  rt === kt[++_t] &&
                                  rt === kt[++_t] &&
                                  rt === kt[++_t] &&
                                  rt === kt[++_t] &&
                                  rt === kt[++_t] &&
                                  rt === kt[++_t] &&
                                  rt === kt[++_t] &&
                                  _t < At
                                );
                                (z.match_length = at - (At - _t)),
                                  z.match_length > z.lookahead &&
                                    (z.match_length = z.lookahead);
                              }
                              if (
                                (z.match_length >= j
                                  ? ((X = s._tr_tally(
                                      z,
                                      1,
                                      z.match_length - j
                                    )),
                                    (z.lookahead -= z.match_length),
                                    (z.strstart += z.match_length),
                                    (z.match_length = 0))
                                  : ((X = s._tr_tally(
                                      z,
                                      0,
                                      z.window[z.strstart]
                                    )),
                                    z.lookahead--,
                                    z.strstart++),
                                X && (T(z, !1), z.strm.avail_out === 0))
                              )
                                return f;
                            }
                            return (
                              (z.insert = 0),
                              ot === b
                                ? (T(z, !0), z.strm.avail_out === 0 ? gt : Y)
                                : z.last_lit &&
                                  (T(z, !1), z.strm.avail_out === 0)
                                ? f
                                : M
                            );
                          })(x, N)
                        : i[x.level].func(x, N);
                    if (
                      ((tt !== gt && tt !== Y) || (x.status = 666),
                      tt === f || tt === gt)
                    )
                      return u.avail_out === 0 && (x.last_flush = -1), h;
                    if (
                      tt === M &&
                      (N === 1
                        ? s._tr_align(x)
                        : N !== 5 &&
                          (s._tr_stored_block(x, 0, 0, !1),
                          N === 3 &&
                            (mt(x.head),
                            x.lookahead === 0 &&
                              ((x.strstart = 0),
                              (x.block_start = 0),
                              (x.insert = 0)))),
                      B(u),
                      u.avail_out === 0)
                    )
                      return (x.last_flush = -1), h;
                  }
                  return N !== b
                    ? h
                    : x.wrap <= 0
                    ? 1
                    : (x.wrap === 2
                        ? (K(x, 255 & u.adler),
                          K(x, (u.adler >> 8) & 255),
                          K(x, (u.adler >> 16) & 255),
                          K(x, (u.adler >> 24) & 255),
                          K(x, 255 & u.total_in),
                          K(x, (u.total_in >> 8) & 255),
                          K(x, (u.total_in >> 16) & 255),
                          K(x, (u.total_in >> 24) & 255))
                        : (H(x, u.adler >>> 16), H(x, 65535 & u.adler)),
                      B(u),
                      0 < x.wrap && (x.wrap = -x.wrap),
                      x.pending !== 0 ? h : 1);
                }),
                (o.deflateEnd = function (u) {
                  var N;
                  return u && u.state
                    ? (N = u.state.status) !== L &&
                      N !== 69 &&
                      N !== 73 &&
                      N !== 91 &&
                      N !== 103 &&
                      N !== V &&
                      N !== 666
                      ? st(u, _)
                      : ((u.state = null), N === V ? st(u, -3) : h)
                    : _;
                }),
                (o.deflateSetDictionary = function (u, N) {
                  var F,
                    x,
                    C,
                    D,
                    G,
                    tt,
                    z,
                    ot,
                    X = N.length;
                  if (
                    !u ||
                    !u.state ||
                    (D = (F = u.state).wrap) === 2 ||
                    (D === 1 && F.status !== L) ||
                    F.lookahead
                  )
                    return _;
                  for (
                    D === 1 && (u.adler = l(u.adler, N, X, 0)),
                      F.wrap = 0,
                      X >= F.w_size &&
                        (D === 0 &&
                          (mt(F.head),
                          (F.strstart = 0),
                          (F.block_start = 0),
                          (F.insert = 0)),
                        (ot = new a.Buf8(F.w_size)),
                        a.arraySet(ot, N, X - F.w_size, F.w_size, 0),
                        (N = ot),
                        (X = F.w_size)),
                      G = u.avail_in,
                      tt = u.next_in,
                      z = u.input,
                      u.avail_in = X,
                      u.next_in = 0,
                      u.input = N,
                      P(F);
                    F.lookahead >= j;

                  ) {
                    for (
                      x = F.strstart, C = F.lookahead - (j - 1);
                      (F.ins_h =
                        ((F.ins_h << F.hash_shift) ^ F.window[x + j - 1]) &
                        F.hash_mask),
                        (F.prev[x & F.w_mask] = F.head[F.ins_h]),
                        (F.head[F.ins_h] = x),
                        x++,
                        --C;

                    );
                    (F.strstart = x), (F.lookahead = j - 1), P(F);
                  }
                  return (
                    (F.strstart += F.lookahead),
                    (F.block_start = F.strstart),
                    (F.insert = F.lookahead),
                    (F.lookahead = 0),
                    (F.match_length = F.prev_length = j - 1),
                    (F.match_available = 0),
                    (u.next_in = tt),
                    (u.input = z),
                    (u.avail_in = G),
                    (F.wrap = D),
                    h
                  );
                }),
                (o.deflateInfo = 'pako deflate (from Nodeca project)');
            },
            {
              '../utils/common': 41,
              './adler32': 43,
              './crc32': 45,
              './messages': 51,
              './trees': 52,
            },
          ],
          47: [
            function (t, r, o) {
              r.exports = function () {
                (this.text = 0),
                  (this.time = 0),
                  (this.xflags = 0),
                  (this.os = 0),
                  (this.extra = null),
                  (this.extra_len = 0),
                  (this.name = ''),
                  (this.comment = ''),
                  (this.hcrc = 0),
                  (this.done = !1);
              };
            },
            {},
          ],
          48: [
            function (t, r, o) {
              r.exports = function (i, a) {
                var s,
                  l,
                  g,
                  c,
                  w,
                  b,
                  h,
                  _,
                  d,
                  v,
                  m,
                  k,
                  E,
                  I,
                  A,
                  U,
                  W,
                  it,
                  j,
                  at,
                  lt,
                  L,
                  V,
                  f,
                  M;
                (s = i.state),
                  (l = i.next_in),
                  (f = i.input),
                  (g = l + (i.avail_in - 5)),
                  (c = i.next_out),
                  (M = i.output),
                  (w = c - (a - i.avail_out)),
                  (b = c + (i.avail_out - 257)),
                  (h = s.dmax),
                  (_ = s.wsize),
                  (d = s.whave),
                  (v = s.wnext),
                  (m = s.window),
                  (k = s.hold),
                  (E = s.bits),
                  (I = s.lencode),
                  (A = s.distcode),
                  (U = (1 << s.lenbits) - 1),
                  (W = (1 << s.distbits) - 1);
                t: do {
                  E < 15 &&
                    ((k += f[l++] << E),
                    (E += 8),
                    (k += f[l++] << E),
                    (E += 8)),
                    (it = I[k & U]);
                  e: for (;;) {
                    if (
                      ((k >>>= j = it >>> 24),
                      (E -= j),
                      (j = (it >>> 16) & 255) === 0)
                    )
                      M[c++] = 65535 & it;
                    else {
                      if (!(16 & j)) {
                        if ((64 & j) == 0) {
                          it = I[(65535 & it) + (k & ((1 << j) - 1))];
                          continue e;
                        }
                        if (32 & j) {
                          s.mode = 12;
                          break t;
                        }
                        (i.msg = 'invalid literal/length code'), (s.mode = 30);
                        break t;
                      }
                      (at = 65535 & it),
                        (j &= 15) &&
                          (E < j && ((k += f[l++] << E), (E += 8)),
                          (at += k & ((1 << j) - 1)),
                          (k >>>= j),
                          (E -= j)),
                        E < 15 &&
                          ((k += f[l++] << E),
                          (E += 8),
                          (k += f[l++] << E),
                          (E += 8)),
                        (it = A[k & W]);
                      n: for (;;) {
                        if (
                          ((k >>>= j = it >>> 24),
                          (E -= j),
                          !(16 & (j = (it >>> 16) & 255)))
                        ) {
                          if ((64 & j) == 0) {
                            it = A[(65535 & it) + (k & ((1 << j) - 1))];
                            continue n;
                          }
                          (i.msg = 'invalid distance code'), (s.mode = 30);
                          break t;
                        }
                        if (
                          ((lt = 65535 & it),
                          E < (j &= 15) &&
                            ((k += f[l++] << E),
                            (E += 8) < j && ((k += f[l++] << E), (E += 8))),
                          h < (lt += k & ((1 << j) - 1)))
                        ) {
                          (i.msg = 'invalid distance too far back'),
                            (s.mode = 30);
                          break t;
                        }
                        if (((k >>>= j), (E -= j), (j = c - w) < lt)) {
                          if (d < (j = lt - j) && s.sane) {
                            (i.msg = 'invalid distance too far back'),
                              (s.mode = 30);
                            break t;
                          }
                          if (((V = m), (L = 0) === v)) {
                            if (((L += _ - j), j < at)) {
                              for (at -= j; (M[c++] = m[L++]), --j; );
                              (L = c - lt), (V = M);
                            }
                          } else if (v < j) {
                            if (((L += _ + v - j), (j -= v) < at)) {
                              for (at -= j; (M[c++] = m[L++]), --j; );
                              if (((L = 0), v < at)) {
                                for (at -= j = v; (M[c++] = m[L++]), --j; );
                                (L = c - lt), (V = M);
                              }
                            }
                          } else if (((L += v - j), j < at)) {
                            for (at -= j; (M[c++] = m[L++]), --j; );
                            (L = c - lt), (V = M);
                          }
                          for (; 2 < at; )
                            (M[c++] = V[L++]),
                              (M[c++] = V[L++]),
                              (M[c++] = V[L++]),
                              (at -= 3);
                          at &&
                            ((M[c++] = V[L++]), 1 < at && (M[c++] = V[L++]));
                        } else {
                          for (
                            L = c - lt;
                            (M[c++] = M[L++]),
                              (M[c++] = M[L++]),
                              (M[c++] = M[L++]),
                              2 < (at -= 3);

                          );
                          at &&
                            ((M[c++] = M[L++]), 1 < at && (M[c++] = M[L++]));
                        }
                        break;
                      }
                    }
                    break;
                  }
                } while (l < g && c < b);
                (l -= at = E >> 3),
                  (k &= (1 << (E -= at << 3)) - 1),
                  (i.next_in = l),
                  (i.next_out = c),
                  (i.avail_in = l < g ? g - l + 5 : 5 - (l - g)),
                  (i.avail_out = c < b ? b - c + 257 : 257 - (c - b)),
                  (s.hold = k),
                  (s.bits = E);
              };
            },
            {},
          ],
          49: [
            function (t, r, o) {
              var i = t('../utils/common'),
                a = t('./adler32'),
                s = t('./crc32'),
                l = t('./inffast'),
                g = t('./inftrees'),
                c = 1,
                w = 2,
                b = 0,
                h = -2,
                _ = 1,
                d = 852,
                v = 592;
              function m(L) {
                return (
                  ((L >>> 24) & 255) +
                  ((L >>> 8) & 65280) +
                  ((65280 & L) << 8) +
                  ((255 & L) << 24)
                );
              }
              function k() {
                (this.mode = 0),
                  (this.last = !1),
                  (this.wrap = 0),
                  (this.havedict = !1),
                  (this.flags = 0),
                  (this.dmax = 0),
                  (this.check = 0),
                  (this.total = 0),
                  (this.head = null),
                  (this.wbits = 0),
                  (this.wsize = 0),
                  (this.whave = 0),
                  (this.wnext = 0),
                  (this.window = null),
                  (this.hold = 0),
                  (this.bits = 0),
                  (this.length = 0),
                  (this.offset = 0),
                  (this.extra = 0),
                  (this.lencode = null),
                  (this.distcode = null),
                  (this.lenbits = 0),
                  (this.distbits = 0),
                  (this.ncode = 0),
                  (this.nlen = 0),
                  (this.ndist = 0),
                  (this.have = 0),
                  (this.next = null),
                  (this.lens = new i.Buf16(320)),
                  (this.work = new i.Buf16(288)),
                  (this.lendyn = null),
                  (this.distdyn = null),
                  (this.sane = 0),
                  (this.back = 0),
                  (this.was = 0);
              }
              function E(L) {
                var V;
                return L && L.state
                  ? ((V = L.state),
                    (L.total_in = L.total_out = V.total = 0),
                    (L.msg = ''),
                    V.wrap && (L.adler = 1 & V.wrap),
                    (V.mode = _),
                    (V.last = 0),
                    (V.havedict = 0),
                    (V.dmax = 32768),
                    (V.head = null),
                    (V.hold = 0),
                    (V.bits = 0),
                    (V.lencode = V.lendyn = new i.Buf32(d)),
                    (V.distcode = V.distdyn = new i.Buf32(v)),
                    (V.sane = 1),
                    (V.back = -1),
                    b)
                  : h;
              }
              function I(L) {
                var V;
                return L && L.state
                  ? (((V = L.state).wsize = 0),
                    (V.whave = 0),
                    (V.wnext = 0),
                    E(L))
                  : h;
              }
              function A(L, V) {
                var f, M;
                return L && L.state
                  ? ((M = L.state),
                    V < 0
                      ? ((f = 0), (V = -V))
                      : ((f = 1 + (V >> 4)), V < 48 && (V &= 15)),
                    V && (V < 8 || 15 < V)
                      ? h
                      : (M.window !== null &&
                          M.wbits !== V &&
                          (M.window = null),
                        (M.wrap = f),
                        (M.wbits = V),
                        I(L)))
                  : h;
              }
              function U(L, V) {
                var f, M;
                return L
                  ? ((M = new k()),
                    ((L.state = M).window = null),
                    (f = A(L, V)) !== b && (L.state = null),
                    f)
                  : h;
              }
              var W,
                it,
                j = !0;
              function at(L) {
                if (j) {
                  var V;
                  for (
                    W = new i.Buf32(512), it = new i.Buf32(32), V = 0;
                    V < 144;

                  )
                    L.lens[V++] = 8;
                  for (; V < 256; ) L.lens[V++] = 9;
                  for (; V < 280; ) L.lens[V++] = 7;
                  for (; V < 288; ) L.lens[V++] = 8;
                  for (
                    g(c, L.lens, 0, 288, W, 0, L.work, { bits: 9 }), V = 0;
                    V < 32;

                  )
                    L.lens[V++] = 5;
                  g(w, L.lens, 0, 32, it, 0, L.work, { bits: 5 }), (j = !1);
                }
                (L.lencode = W),
                  (L.lenbits = 9),
                  (L.distcode = it),
                  (L.distbits = 5);
              }
              function lt(L, V, f, M) {
                var gt,
                  Y = L.state;
                return (
                  Y.window === null &&
                    ((Y.wsize = 1 << Y.wbits),
                    (Y.wnext = 0),
                    (Y.whave = 0),
                    (Y.window = new i.Buf8(Y.wsize))),
                  M >= Y.wsize
                    ? (i.arraySet(Y.window, V, f - Y.wsize, Y.wsize, 0),
                      (Y.wnext = 0),
                      (Y.whave = Y.wsize))
                    : (M < (gt = Y.wsize - Y.wnext) && (gt = M),
                      i.arraySet(Y.window, V, f - M, gt, Y.wnext),
                      (M -= gt)
                        ? (i.arraySet(Y.window, V, f - M, M, 0),
                          (Y.wnext = M),
                          (Y.whave = Y.wsize))
                        : ((Y.wnext += gt),
                          Y.wnext === Y.wsize && (Y.wnext = 0),
                          Y.whave < Y.wsize && (Y.whave += gt))),
                  0
                );
              }
              (o.inflateReset = I),
                (o.inflateReset2 = A),
                (o.inflateResetKeep = E),
                (o.inflateInit = function (L) {
                  return U(L, 15);
                }),
                (o.inflateInit2 = U),
                (o.inflate = function (L, V) {
                  var f,
                    M,
                    gt,
                    Y,
                    st,
                    nt,
                    mt,
                    B,
                    T,
                    K,
                    H,
                    $,
                    P,
                    vt,
                    Q,
                    dt,
                    yt,
                    ft,
                    et,
                    xt,
                    u,
                    N,
                    F,
                    x,
                    C = 0,
                    D = new i.Buf8(4),
                    G = [
                      16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14,
                      1, 15,
                    ];
                  if (
                    !L ||
                    !L.state ||
                    !L.output ||
                    (!L.input && L.avail_in !== 0)
                  )
                    return h;
                  (f = L.state).mode === 12 && (f.mode = 13),
                    (st = L.next_out),
                    (gt = L.output),
                    (mt = L.avail_out),
                    (Y = L.next_in),
                    (M = L.input),
                    (nt = L.avail_in),
                    (B = f.hold),
                    (T = f.bits),
                    (K = nt),
                    (H = mt),
                    (N = b);
                  t: for (;;)
                    switch (f.mode) {
                      case _:
                        if (f.wrap === 0) {
                          f.mode = 13;
                          break;
                        }
                        for (; T < 16; ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        if (2 & f.wrap && B === 35615) {
                          (D[(f.check = 0)] = 255 & B),
                            (D[1] = (B >>> 8) & 255),
                            (f.check = s(f.check, D, 2, 0)),
                            (T = B = 0),
                            (f.mode = 2);
                          break;
                        }
                        if (
                          ((f.flags = 0),
                          f.head && (f.head.done = !1),
                          !(1 & f.wrap) || (((255 & B) << 8) + (B >> 8)) % 31)
                        ) {
                          (L.msg = 'incorrect header check'), (f.mode = 30);
                          break;
                        }
                        if ((15 & B) != 8) {
                          (L.msg = 'unknown compression method'), (f.mode = 30);
                          break;
                        }
                        if (
                          ((T -= 4), (u = 8 + (15 & (B >>>= 4))), f.wbits === 0)
                        )
                          f.wbits = u;
                        else if (u > f.wbits) {
                          (L.msg = 'invalid window size'), (f.mode = 30);
                          break;
                        }
                        (f.dmax = 1 << u),
                          (L.adler = f.check = 1),
                          (f.mode = 512 & B ? 10 : 12),
                          (T = B = 0);
                        break;
                      case 2:
                        for (; T < 16; ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        if (((f.flags = B), (255 & f.flags) != 8)) {
                          (L.msg = 'unknown compression method'), (f.mode = 30);
                          break;
                        }
                        if (57344 & f.flags) {
                          (L.msg = 'unknown header flags set'), (f.mode = 30);
                          break;
                        }
                        f.head && (f.head.text = (B >> 8) & 1),
                          512 & f.flags &&
                            ((D[0] = 255 & B),
                            (D[1] = (B >>> 8) & 255),
                            (f.check = s(f.check, D, 2, 0))),
                          (T = B = 0),
                          (f.mode = 3);
                      case 3:
                        for (; T < 32; ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        f.head && (f.head.time = B),
                          512 & f.flags &&
                            ((D[0] = 255 & B),
                            (D[1] = (B >>> 8) & 255),
                            (D[2] = (B >>> 16) & 255),
                            (D[3] = (B >>> 24) & 255),
                            (f.check = s(f.check, D, 4, 0))),
                          (T = B = 0),
                          (f.mode = 4);
                      case 4:
                        for (; T < 16; ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        f.head &&
                          ((f.head.xflags = 255 & B), (f.head.os = B >> 8)),
                          512 & f.flags &&
                            ((D[0] = 255 & B),
                            (D[1] = (B >>> 8) & 255),
                            (f.check = s(f.check, D, 2, 0))),
                          (T = B = 0),
                          (f.mode = 5);
                      case 5:
                        if (1024 & f.flags) {
                          for (; T < 16; ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          (f.length = B),
                            f.head && (f.head.extra_len = B),
                            512 & f.flags &&
                              ((D[0] = 255 & B),
                              (D[1] = (B >>> 8) & 255),
                              (f.check = s(f.check, D, 2, 0))),
                            (T = B = 0);
                        } else f.head && (f.head.extra = null);
                        f.mode = 6;
                      case 6:
                        if (
                          1024 & f.flags &&
                          (nt < ($ = f.length) && ($ = nt),
                          $ &&
                            (f.head &&
                              ((u = f.head.extra_len - f.length),
                              f.head.extra ||
                                (f.head.extra = new Array(f.head.extra_len)),
                              i.arraySet(f.head.extra, M, Y, $, u)),
                            512 & f.flags && (f.check = s(f.check, M, $, Y)),
                            (nt -= $),
                            (Y += $),
                            (f.length -= $)),
                          f.length)
                        )
                          break t;
                        (f.length = 0), (f.mode = 7);
                      case 7:
                        if (2048 & f.flags) {
                          if (nt === 0) break t;
                          for (
                            $ = 0;
                            (u = M[Y + $++]),
                              f.head &&
                                u &&
                                f.length < 65536 &&
                                (f.head.name += String.fromCharCode(u)),
                              u && $ < nt;

                          );
                          if (
                            (512 & f.flags && (f.check = s(f.check, M, $, Y)),
                            (nt -= $),
                            (Y += $),
                            u)
                          )
                            break t;
                        } else f.head && (f.head.name = null);
                        (f.length = 0), (f.mode = 8);
                      case 8:
                        if (4096 & f.flags) {
                          if (nt === 0) break t;
                          for (
                            $ = 0;
                            (u = M[Y + $++]),
                              f.head &&
                                u &&
                                f.length < 65536 &&
                                (f.head.comment += String.fromCharCode(u)),
                              u && $ < nt;

                          );
                          if (
                            (512 & f.flags && (f.check = s(f.check, M, $, Y)),
                            (nt -= $),
                            (Y += $),
                            u)
                          )
                            break t;
                        } else f.head && (f.head.comment = null);
                        f.mode = 9;
                      case 9:
                        if (512 & f.flags) {
                          for (; T < 16; ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          if (B !== (65535 & f.check)) {
                            (L.msg = 'header crc mismatch'), (f.mode = 30);
                            break;
                          }
                          T = B = 0;
                        }
                        f.head &&
                          ((f.head.hcrc = (f.flags >> 9) & 1),
                          (f.head.done = !0)),
                          (L.adler = f.check = 0),
                          (f.mode = 12);
                        break;
                      case 10:
                        for (; T < 32; ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        (L.adler = f.check = m(B)), (T = B = 0), (f.mode = 11);
                      case 11:
                        if (f.havedict === 0)
                          return (
                            (L.next_out = st),
                            (L.avail_out = mt),
                            (L.next_in = Y),
                            (L.avail_in = nt),
                            (f.hold = B),
                            (f.bits = T),
                            2
                          );
                        (L.adler = f.check = 1), (f.mode = 12);
                      case 12:
                        if (V === 5 || V === 6) break t;
                      case 13:
                        if (f.last) {
                          (B >>>= 7 & T), (T -= 7 & T), (f.mode = 27);
                          break;
                        }
                        for (; T < 3; ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        switch (((f.last = 1 & B), (T -= 1), 3 & (B >>>= 1))) {
                          case 0:
                            f.mode = 14;
                            break;
                          case 1:
                            if ((at(f), (f.mode = 20), V !== 6)) break;
                            (B >>>= 2), (T -= 2);
                            break t;
                          case 2:
                            f.mode = 17;
                            break;
                          case 3:
                            (L.msg = 'invalid block type'), (f.mode = 30);
                        }
                        (B >>>= 2), (T -= 2);
                        break;
                      case 14:
                        for (B >>>= 7 & T, T -= 7 & T; T < 32; ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        if ((65535 & B) != ((B >>> 16) ^ 65535)) {
                          (L.msg = 'invalid stored block lengths'),
                            (f.mode = 30);
                          break;
                        }
                        if (
                          ((f.length = 65535 & B),
                          (T = B = 0),
                          (f.mode = 15),
                          V === 6)
                        )
                          break t;
                      case 15:
                        f.mode = 16;
                      case 16:
                        if (($ = f.length)) {
                          if ((nt < $ && ($ = nt), mt < $ && ($ = mt), $ === 0))
                            break t;
                          i.arraySet(gt, M, Y, $, st),
                            (nt -= $),
                            (Y += $),
                            (mt -= $),
                            (st += $),
                            (f.length -= $);
                          break;
                        }
                        f.mode = 12;
                        break;
                      case 17:
                        for (; T < 14; ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        if (
                          ((f.nlen = 257 + (31 & B)),
                          (B >>>= 5),
                          (T -= 5),
                          (f.ndist = 1 + (31 & B)),
                          (B >>>= 5),
                          (T -= 5),
                          (f.ncode = 4 + (15 & B)),
                          (B >>>= 4),
                          (T -= 4),
                          286 < f.nlen || 30 < f.ndist)
                        ) {
                          (L.msg = 'too many length or distance symbols'),
                            (f.mode = 30);
                          break;
                        }
                        (f.have = 0), (f.mode = 18);
                      case 18:
                        for (; f.have < f.ncode; ) {
                          for (; T < 3; ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          (f.lens[G[f.have++]] = 7 & B), (B >>>= 3), (T -= 3);
                        }
                        for (; f.have < 19; ) f.lens[G[f.have++]] = 0;
                        if (
                          ((f.lencode = f.lendyn),
                          (f.lenbits = 7),
                          (F = { bits: f.lenbits }),
                          (N = g(0, f.lens, 0, 19, f.lencode, 0, f.work, F)),
                          (f.lenbits = F.bits),
                          N)
                        ) {
                          (L.msg = 'invalid code lengths set'), (f.mode = 30);
                          break;
                        }
                        (f.have = 0), (f.mode = 19);
                      case 19:
                        for (; f.have < f.nlen + f.ndist; ) {
                          for (
                            ;
                            (dt =
                              ((C = f.lencode[B & ((1 << f.lenbits) - 1)]) >>>
                                16) &
                              255),
                              (yt = 65535 & C),
                              !((Q = C >>> 24) <= T);

                          ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          if (yt < 16)
                            (B >>>= Q), (T -= Q), (f.lens[f.have++] = yt);
                          else {
                            if (yt === 16) {
                              for (x = Q + 2; T < x; ) {
                                if (nt === 0) break t;
                                nt--, (B += M[Y++] << T), (T += 8);
                              }
                              if (((B >>>= Q), (T -= Q), f.have === 0)) {
                                (L.msg = 'invalid bit length repeat'),
                                  (f.mode = 30);
                                break;
                              }
                              (u = f.lens[f.have - 1]),
                                ($ = 3 + (3 & B)),
                                (B >>>= 2),
                                (T -= 2);
                            } else if (yt === 17) {
                              for (x = Q + 3; T < x; ) {
                                if (nt === 0) break t;
                                nt--, (B += M[Y++] << T), (T += 8);
                              }
                              (T -= Q),
                                (u = 0),
                                ($ = 3 + (7 & (B >>>= Q))),
                                (B >>>= 3),
                                (T -= 3);
                            } else {
                              for (x = Q + 7; T < x; ) {
                                if (nt === 0) break t;
                                nt--, (B += M[Y++] << T), (T += 8);
                              }
                              (T -= Q),
                                (u = 0),
                                ($ = 11 + (127 & (B >>>= Q))),
                                (B >>>= 7),
                                (T -= 7);
                            }
                            if (f.have + $ > f.nlen + f.ndist) {
                              (L.msg = 'invalid bit length repeat'),
                                (f.mode = 30);
                              break;
                            }
                            for (; $--; ) f.lens[f.have++] = u;
                          }
                        }
                        if (f.mode === 30) break;
                        if (f.lens[256] === 0) {
                          (L.msg = 'invalid code -- missing end-of-block'),
                            (f.mode = 30);
                          break;
                        }
                        if (
                          ((f.lenbits = 9),
                          (F = { bits: f.lenbits }),
                          (N = g(
                            c,
                            f.lens,
                            0,
                            f.nlen,
                            f.lencode,
                            0,
                            f.work,
                            F
                          )),
                          (f.lenbits = F.bits),
                          N)
                        ) {
                          (L.msg = 'invalid literal/lengths set'),
                            (f.mode = 30);
                          break;
                        }
                        if (
                          ((f.distbits = 6),
                          (f.distcode = f.distdyn),
                          (F = { bits: f.distbits }),
                          (N = g(
                            w,
                            f.lens,
                            f.nlen,
                            f.ndist,
                            f.distcode,
                            0,
                            f.work,
                            F
                          )),
                          (f.distbits = F.bits),
                          N)
                        ) {
                          (L.msg = 'invalid distances set'), (f.mode = 30);
                          break;
                        }
                        if (((f.mode = 20), V === 6)) break t;
                      case 20:
                        f.mode = 21;
                      case 21:
                        if (6 <= nt && 258 <= mt) {
                          (L.next_out = st),
                            (L.avail_out = mt),
                            (L.next_in = Y),
                            (L.avail_in = nt),
                            (f.hold = B),
                            (f.bits = T),
                            l(L, H),
                            (st = L.next_out),
                            (gt = L.output),
                            (mt = L.avail_out),
                            (Y = L.next_in),
                            (M = L.input),
                            (nt = L.avail_in),
                            (B = f.hold),
                            (T = f.bits),
                            f.mode === 12 && (f.back = -1);
                          break;
                        }
                        for (
                          f.back = 0;
                          (dt =
                            ((C = f.lencode[B & ((1 << f.lenbits) - 1)]) >>>
                              16) &
                            255),
                            (yt = 65535 & C),
                            !((Q = C >>> 24) <= T);

                        ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        if (dt && (240 & dt) == 0) {
                          for (
                            ft = Q, et = dt, xt = yt;
                            (dt =
                              ((C =
                                f.lencode[
                                  xt + ((B & ((1 << (ft + et)) - 1)) >> ft)
                                ]) >>>
                                16) &
                              255),
                              (yt = 65535 & C),
                              !(ft + (Q = C >>> 24) <= T);

                          ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          (B >>>= ft), (T -= ft), (f.back += ft);
                        }
                        if (
                          ((B >>>= Q),
                          (T -= Q),
                          (f.back += Q),
                          (f.length = yt),
                          dt === 0)
                        ) {
                          f.mode = 26;
                          break;
                        }
                        if (32 & dt) {
                          (f.back = -1), (f.mode = 12);
                          break;
                        }
                        if (64 & dt) {
                          (L.msg = 'invalid literal/length code'),
                            (f.mode = 30);
                          break;
                        }
                        (f.extra = 15 & dt), (f.mode = 22);
                      case 22:
                        if (f.extra) {
                          for (x = f.extra; T < x; ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          (f.length += B & ((1 << f.extra) - 1)),
                            (B >>>= f.extra),
                            (T -= f.extra),
                            (f.back += f.extra);
                        }
                        (f.was = f.length), (f.mode = 23);
                      case 23:
                        for (
                          ;
                          (dt =
                            ((C = f.distcode[B & ((1 << f.distbits) - 1)]) >>>
                              16) &
                            255),
                            (yt = 65535 & C),
                            !((Q = C >>> 24) <= T);

                        ) {
                          if (nt === 0) break t;
                          nt--, (B += M[Y++] << T), (T += 8);
                        }
                        if ((240 & dt) == 0) {
                          for (
                            ft = Q, et = dt, xt = yt;
                            (dt =
                              ((C =
                                f.distcode[
                                  xt + ((B & ((1 << (ft + et)) - 1)) >> ft)
                                ]) >>>
                                16) &
                              255),
                              (yt = 65535 & C),
                              !(ft + (Q = C >>> 24) <= T);

                          ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          (B >>>= ft), (T -= ft), (f.back += ft);
                        }
                        if (((B >>>= Q), (T -= Q), (f.back += Q), 64 & dt)) {
                          (L.msg = 'invalid distance code'), (f.mode = 30);
                          break;
                        }
                        (f.offset = yt), (f.extra = 15 & dt), (f.mode = 24);
                      case 24:
                        if (f.extra) {
                          for (x = f.extra; T < x; ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          (f.offset += B & ((1 << f.extra) - 1)),
                            (B >>>= f.extra),
                            (T -= f.extra),
                            (f.back += f.extra);
                        }
                        if (f.offset > f.dmax) {
                          (L.msg = 'invalid distance too far back'),
                            (f.mode = 30);
                          break;
                        }
                        f.mode = 25;
                      case 25:
                        if (mt === 0) break t;
                        if ((($ = H - mt), f.offset > $)) {
                          if (($ = f.offset - $) > f.whave && f.sane) {
                            (L.msg = 'invalid distance too far back'),
                              (f.mode = 30);
                            break;
                          }
                          (P =
                            $ > f.wnext
                              ? (($ -= f.wnext), f.wsize - $)
                              : f.wnext - $),
                            $ > f.length && ($ = f.length),
                            (vt = f.window);
                        } else (vt = gt), (P = st - f.offset), ($ = f.length);
                        for (
                          mt < $ && ($ = mt), mt -= $, f.length -= $;
                          (gt[st++] = vt[P++]), --$;

                        );
                        f.length === 0 && (f.mode = 21);
                        break;
                      case 26:
                        if (mt === 0) break t;
                        (gt[st++] = f.length), mt--, (f.mode = 21);
                        break;
                      case 27:
                        if (f.wrap) {
                          for (; T < 32; ) {
                            if (nt === 0) break t;
                            nt--, (B |= M[Y++] << T), (T += 8);
                          }
                          if (
                            ((H -= mt),
                            (L.total_out += H),
                            (f.total += H),
                            H &&
                              (L.adler = f.check =
                                f.flags
                                  ? s(f.check, gt, H, st - H)
                                  : a(f.check, gt, H, st - H)),
                            (H = mt),
                            (f.flags ? B : m(B)) !== f.check)
                          ) {
                            (L.msg = 'incorrect data check'), (f.mode = 30);
                            break;
                          }
                          T = B = 0;
                        }
                        f.mode = 28;
                      case 28:
                        if (f.wrap && f.flags) {
                          for (; T < 32; ) {
                            if (nt === 0) break t;
                            nt--, (B += M[Y++] << T), (T += 8);
                          }
                          if (B !== (4294967295 & f.total)) {
                            (L.msg = 'incorrect length check'), (f.mode = 30);
                            break;
                          }
                          T = B = 0;
                        }
                        f.mode = 29;
                      case 29:
                        N = 1;
                        break t;
                      case 30:
                        N = -3;
                        break t;
                      case 31:
                        return -4;
                      case 32:
                      default:
                        return h;
                    }
                  return (
                    (L.next_out = st),
                    (L.avail_out = mt),
                    (L.next_in = Y),
                    (L.avail_in = nt),
                    (f.hold = B),
                    (f.bits = T),
                    (f.wsize ||
                      (H !== L.avail_out &&
                        f.mode < 30 &&
                        (f.mode < 27 || V !== 4))) &&
                    lt(L, L.output, L.next_out, H - L.avail_out)
                      ? ((f.mode = 31), -4)
                      : ((K -= L.avail_in),
                        (H -= L.avail_out),
                        (L.total_in += K),
                        (L.total_out += H),
                        (f.total += H),
                        f.wrap &&
                          H &&
                          (L.adler = f.check =
                            f.flags
                              ? s(f.check, gt, H, L.next_out - H)
                              : a(f.check, gt, H, L.next_out - H)),
                        (L.data_type =
                          f.bits +
                          (f.last ? 64 : 0) +
                          (f.mode === 12 ? 128 : 0) +
                          (f.mode === 20 || f.mode === 15 ? 256 : 0)),
                        ((K == 0 && H === 0) || V === 4) && N === b && (N = -5),
                        N)
                  );
                }),
                (o.inflateEnd = function (L) {
                  if (!L || !L.state) return h;
                  var V = L.state;
                  return V.window && (V.window = null), (L.state = null), b;
                }),
                (o.inflateGetHeader = function (L, V) {
                  var f;
                  return L && L.state
                    ? (2 & (f = L.state).wrap) == 0
                      ? h
                      : (((f.head = V).done = !1), b)
                    : h;
                }),
                (o.inflateSetDictionary = function (L, V) {
                  var f,
                    M = V.length;
                  return L && L.state
                    ? (f = L.state).wrap !== 0 && f.mode !== 11
                      ? h
                      : f.mode === 11 && a(1, V, M, 0) !== f.check
                      ? -3
                      : lt(L, V, M, M)
                      ? ((f.mode = 31), -4)
                      : ((f.havedict = 1), b)
                    : h;
                }),
                (o.inflateInfo = 'pako inflate (from Nodeca project)');
            },
            {
              '../utils/common': 41,
              './adler32': 43,
              './crc32': 45,
              './inffast': 48,
              './inftrees': 50,
            },
          ],
          50: [
            function (t, r, o) {
              var i = t('../utils/common'),
                a = [
                  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35,
                  43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0,
                ],
                s = [
                  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18,
                  18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72,
                  78,
                ],
                l = [
                  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
                  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193,
                  12289, 16385, 24577, 0, 0,
                ],
                g = [
                  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22,
                  22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29,
                  64, 64,
                ];
              r.exports = function (c, w, b, h, _, d, v, m) {
                var k,
                  E,
                  I,
                  A,
                  U,
                  W,
                  it,
                  j,
                  at,
                  lt = m.bits,
                  L = 0,
                  V = 0,
                  f = 0,
                  M = 0,
                  gt = 0,
                  Y = 0,
                  st = 0,
                  nt = 0,
                  mt = 0,
                  B = 0,
                  T = null,
                  K = 0,
                  H = new i.Buf16(16),
                  $ = new i.Buf16(16),
                  P = null,
                  vt = 0;
                for (L = 0; L <= 15; L++) H[L] = 0;
                for (V = 0; V < h; V++) H[w[b + V]]++;
                for (gt = lt, M = 15; 1 <= M && H[M] === 0; M--);
                if ((M < gt && (gt = M), M === 0))
                  return (
                    (_[d++] = 20971520), (_[d++] = 20971520), (m.bits = 1), 0
                  );
                for (f = 1; f < M && H[f] === 0; f++);
                for (gt < f && (gt = f), L = nt = 1; L <= 15; L++)
                  if (((nt <<= 1), (nt -= H[L]) < 0)) return -1;
                if (0 < nt && (c === 0 || M !== 1)) return -1;
                for ($[1] = 0, L = 1; L < 15; L++) $[L + 1] = $[L] + H[L];
                for (V = 0; V < h; V++)
                  w[b + V] !== 0 && (v[$[w[b + V]]++] = V);
                if (
                  ((W =
                    c === 0
                      ? ((T = P = v), 19)
                      : c === 1
                      ? ((T = a), (K -= 257), (P = s), (vt -= 257), 256)
                      : ((T = l), (P = g), -1)),
                  (L = f),
                  (U = d),
                  (st = V = B = 0),
                  (I = -1),
                  (A = (mt = 1 << (Y = gt)) - 1),
                  (c === 1 && 852 < mt) || (c === 2 && 592 < mt))
                )
                  return 1;
                for (;;) {
                  for (
                    it = L - st,
                      at =
                        v[V] < W
                          ? ((j = 0), v[V])
                          : v[V] > W
                          ? ((j = P[vt + v[V]]), T[K + v[V]])
                          : ((j = 96), 0),
                      k = 1 << (L - st),
                      f = E = 1 << Y;
                    (_[U + (B >> st) + (E -= k)] =
                      (it << 24) | (j << 16) | at | 0),
                      E !== 0;

                  );
                  for (k = 1 << (L - 1); B & k; ) k >>= 1;
                  if (
                    (k !== 0 ? ((B &= k - 1), (B += k)) : (B = 0),
                    V++,
                    --H[L] == 0)
                  ) {
                    if (L === M) break;
                    L = w[b + v[V]];
                  }
                  if (gt < L && (B & A) !== I) {
                    for (
                      st === 0 && (st = gt), U += f, nt = 1 << (Y = L - st);
                      Y + st < M && !((nt -= H[Y + st]) <= 0);

                    )
                      Y++, (nt <<= 1);
                    if (
                      ((mt += 1 << Y),
                      (c === 1 && 852 < mt) || (c === 2 && 592 < mt))
                    )
                      return 1;
                    _[(I = B & A)] = (gt << 24) | (Y << 16) | (U - d) | 0;
                  }
                }
                return (
                  B !== 0 && (_[U + B] = ((L - st) << 24) | (64 << 16) | 0),
                  (m.bits = gt),
                  0
                );
              };
            },
            { '../utils/common': 41 },
          ],
          51: [
            function (t, r, o) {
              r.exports = {
                2: 'need dictionary',
                1: 'stream end',
                0: '',
                '-1': 'file error',
                '-2': 'stream error',
                '-3': 'data error',
                '-4': 'insufficient memory',
                '-5': 'buffer error',
                '-6': 'incompatible version',
              };
            },
            {},
          ],
          52: [
            function (t, r, o) {
              var i = t('../utils/common'),
                a = 0,
                s = 1;
              function l(C) {
                for (var D = C.length; 0 <= --D; ) C[D] = 0;
              }
              var g = 0,
                c = 29,
                w = 256,
                b = w + 1 + c,
                h = 30,
                _ = 19,
                d = 2 * b + 1,
                v = 15,
                m = 16,
                k = 7,
                E = 256,
                I = 16,
                A = 17,
                U = 18,
                W = [
                  0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4,
                  4, 4, 4, 5, 5, 5, 5, 0,
                ],
                it = [
                  0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9,
                  9, 10, 10, 11, 11, 12, 12, 13, 13,
                ],
                j = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
                at = [
                  16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1,
                  15,
                ],
                lt = new Array(2 * (b + 2));
              l(lt);
              var L = new Array(2 * h);
              l(L);
              var V = new Array(512);
              l(V);
              var f = new Array(256);
              l(f);
              var M = new Array(c);
              l(M);
              var gt,
                Y,
                st,
                nt = new Array(h);
              function mt(C, D, G, tt, z) {
                (this.static_tree = C),
                  (this.extra_bits = D),
                  (this.extra_base = G),
                  (this.elems = tt),
                  (this.max_length = z),
                  (this.has_stree = C && C.length);
              }
              function B(C, D) {
                (this.dyn_tree = C), (this.max_code = 0), (this.stat_desc = D);
              }
              function T(C) {
                return C < 256 ? V[C] : V[256 + (C >>> 7)];
              }
              function K(C, D) {
                (C.pending_buf[C.pending++] = 255 & D),
                  (C.pending_buf[C.pending++] = (D >>> 8) & 255);
              }
              function H(C, D, G) {
                C.bi_valid > m - G
                  ? ((C.bi_buf |= (D << C.bi_valid) & 65535),
                    K(C, C.bi_buf),
                    (C.bi_buf = D >> (m - C.bi_valid)),
                    (C.bi_valid += G - m))
                  : ((C.bi_buf |= (D << C.bi_valid) & 65535),
                    (C.bi_valid += G));
              }
              function $(C, D, G) {
                H(C, G[2 * D], G[2 * D + 1]);
              }
              function P(C, D) {
                for (var G = 0; (G |= 1 & C), (C >>>= 1), (G <<= 1), 0 < --D; );
                return G >>> 1;
              }
              function vt(C, D, G) {
                var tt,
                  z,
                  ot = new Array(v + 1),
                  X = 0;
                for (tt = 1; tt <= v; tt++) ot[tt] = X = (X + G[tt - 1]) << 1;
                for (z = 0; z <= D; z++) {
                  var rt = C[2 * z + 1];
                  rt !== 0 && (C[2 * z] = P(ot[rt]++, rt));
                }
              }
              function Q(C) {
                var D;
                for (D = 0; D < b; D++) C.dyn_ltree[2 * D] = 0;
                for (D = 0; D < h; D++) C.dyn_dtree[2 * D] = 0;
                for (D = 0; D < _; D++) C.bl_tree[2 * D] = 0;
                (C.dyn_ltree[2 * E] = 1),
                  (C.opt_len = C.static_len = 0),
                  (C.last_lit = C.matches = 0);
              }
              function dt(C) {
                8 < C.bi_valid
                  ? K(C, C.bi_buf)
                  : 0 < C.bi_valid && (C.pending_buf[C.pending++] = C.bi_buf),
                  (C.bi_buf = 0),
                  (C.bi_valid = 0);
              }
              function yt(C, D, G, tt) {
                var z = 2 * D,
                  ot = 2 * G;
                return C[z] < C[ot] || (C[z] === C[ot] && tt[D] <= tt[G]);
              }
              function ft(C, D, G) {
                for (
                  var tt = C.heap[G], z = G << 1;
                  z <= C.heap_len &&
                  (z < C.heap_len &&
                    yt(D, C.heap[z + 1], C.heap[z], C.depth) &&
                    z++,
                  !yt(D, tt, C.heap[z], C.depth));

                )
                  (C.heap[G] = C.heap[z]), (G = z), (z <<= 1);
                C.heap[G] = tt;
              }
              function et(C, D, G) {
                var tt,
                  z,
                  ot,
                  X,
                  rt = 0;
                if (C.last_lit !== 0)
                  for (
                    ;
                    (tt =
                      (C.pending_buf[C.d_buf + 2 * rt] << 8) |
                      C.pending_buf[C.d_buf + 2 * rt + 1]),
                      (z = C.pending_buf[C.l_buf + rt]),
                      rt++,
                      tt === 0
                        ? $(C, z, D)
                        : ($(C, (ot = f[z]) + w + 1, D),
                          (X = W[ot]) !== 0 && H(C, (z -= M[ot]), X),
                          $(C, (ot = T(--tt)), G),
                          (X = it[ot]) !== 0 && H(C, (tt -= nt[ot]), X)),
                      rt < C.last_lit;

                  );
                $(C, E, D);
              }
              function xt(C, D) {
                var G,
                  tt,
                  z,
                  ot = D.dyn_tree,
                  X = D.stat_desc.static_tree,
                  rt = D.stat_desc.has_stree,
                  _t = D.stat_desc.elems,
                  At = -1;
                for (C.heap_len = 0, C.heap_max = d, G = 0; G < _t; G++)
                  ot[2 * G] !== 0
                    ? ((C.heap[++C.heap_len] = At = G), (C.depth[G] = 0))
                    : (ot[2 * G + 1] = 0);
                for (; C.heap_len < 2; )
                  (ot[2 * (z = C.heap[++C.heap_len] = At < 2 ? ++At : 0)] = 1),
                    (C.depth[z] = 0),
                    C.opt_len--,
                    rt && (C.static_len -= X[2 * z + 1]);
                for (D.max_code = At, G = C.heap_len >> 1; 1 <= G; G--)
                  ft(C, ot, G);
                for (
                  z = _t;
                  (G = C.heap[1]),
                    (C.heap[1] = C.heap[C.heap_len--]),
                    ft(C, ot, 1),
                    (tt = C.heap[1]),
                    (C.heap[--C.heap_max] = G),
                    (C.heap[--C.heap_max] = tt),
                    (ot[2 * z] = ot[2 * G] + ot[2 * tt]),
                    (C.depth[z] =
                      (C.depth[G] >= C.depth[tt] ? C.depth[G] : C.depth[tt]) +
                      1),
                    (ot[2 * G + 1] = ot[2 * tt + 1] = z),
                    (C.heap[1] = z++),
                    ft(C, ot, 1),
                    2 <= C.heap_len;

                );
                (C.heap[--C.heap_max] = C.heap[1]),
                  (function (kt, Ut) {
                    var ae,
                      Vt,
                      St,
                      Ot,
                      se,
                      Qt,
                      Ft = Ut.dyn_tree,
                      kn = Ut.max_code,
                      We = Ut.stat_desc.static_tree,
                      He = Ut.stat_desc.has_stree,
                      xn = Ut.stat_desc.extra_bits,
                      Ze = Ut.stat_desc.extra_base,
                      Gt = Ut.stat_desc.max_length,
                      te = 0;
                    for (Ot = 0; Ot <= v; Ot++) kt.bl_count[Ot] = 0;
                    for (
                      Ft[2 * kt.heap[kt.heap_max] + 1] = 0,
                        ae = kt.heap_max + 1;
                      ae < d;
                      ae++
                    )
                      Gt <
                        (Ot = Ft[2 * Ft[2 * (Vt = kt.heap[ae]) + 1] + 1] + 1) &&
                        ((Ot = Gt), te++),
                        (Ft[2 * Vt + 1] = Ot),
                        kn < Vt ||
                          (kt.bl_count[Ot]++,
                          (se = 0),
                          Ze <= Vt && (se = xn[Vt - Ze]),
                          (Qt = Ft[2 * Vt]),
                          (kt.opt_len += Qt * (Ot + se)),
                          He && (kt.static_len += Qt * (We[2 * Vt + 1] + se)));
                    if (te !== 0) {
                      do {
                        for (Ot = Gt - 1; kt.bl_count[Ot] === 0; ) Ot--;
                        kt.bl_count[Ot]--,
                          (kt.bl_count[Ot + 1] += 2),
                          kt.bl_count[Gt]--,
                          (te -= 2);
                      } while (0 < te);
                      for (Ot = Gt; Ot !== 0; Ot--)
                        for (Vt = kt.bl_count[Ot]; Vt !== 0; )
                          kn < (St = kt.heap[--ae]) ||
                            (Ft[2 * St + 1] !== Ot &&
                              ((kt.opt_len +=
                                (Ot - Ft[2 * St + 1]) * Ft[2 * St]),
                              (Ft[2 * St + 1] = Ot)),
                            Vt--);
                    }
                  })(C, D),
                  vt(ot, At, C.bl_count);
              }
              function u(C, D, G) {
                var tt,
                  z,
                  ot = -1,
                  X = D[1],
                  rt = 0,
                  _t = 7,
                  At = 4;
                for (
                  X === 0 && ((_t = 138), (At = 3)),
                    D[2 * (G + 1) + 1] = 65535,
                    tt = 0;
                  tt <= G;
                  tt++
                )
                  (z = X),
                    (X = D[2 * (tt + 1) + 1]),
                    (++rt < _t && z === X) ||
                      (rt < At
                        ? (C.bl_tree[2 * z] += rt)
                        : z !== 0
                        ? (z !== ot && C.bl_tree[2 * z]++, C.bl_tree[2 * I]++)
                        : rt <= 10
                        ? C.bl_tree[2 * A]++
                        : C.bl_tree[2 * U]++,
                      (ot = z),
                      (At =
                        (rt = 0) === X
                          ? ((_t = 138), 3)
                          : z === X
                          ? ((_t = 6), 3)
                          : ((_t = 7), 4)));
              }
              function N(C, D, G) {
                var tt,
                  z,
                  ot = -1,
                  X = D[1],
                  rt = 0,
                  _t = 7,
                  At = 4;
                for (X === 0 && ((_t = 138), (At = 3)), tt = 0; tt <= G; tt++)
                  if (
                    ((z = X),
                    (X = D[2 * (tt + 1) + 1]),
                    !(++rt < _t && z === X))
                  ) {
                    if (rt < At) for (; $(C, z, C.bl_tree), --rt != 0; );
                    else
                      z !== 0
                        ? (z !== ot && ($(C, z, C.bl_tree), rt--),
                          $(C, I, C.bl_tree),
                          H(C, rt - 3, 2))
                        : rt <= 10
                        ? ($(C, A, C.bl_tree), H(C, rt - 3, 3))
                        : ($(C, U, C.bl_tree), H(C, rt - 11, 7));
                    (ot = z),
                      (At =
                        (rt = 0) === X
                          ? ((_t = 138), 3)
                          : z === X
                          ? ((_t = 6), 3)
                          : ((_t = 7), 4));
                  }
              }
              l(nt);
              var F = !1;
              function x(C, D, G, tt) {
                H(C, (g << 1) + (tt ? 1 : 0), 3),
                  (function (z, ot, X, rt) {
                    dt(z),
                      rt && (K(z, X), K(z, ~X)),
                      i.arraySet(z.pending_buf, z.window, ot, X, z.pending),
                      (z.pending += X);
                  })(C, D, G, !0);
              }
              (o._tr_init = function (C) {
                F ||
                  ((function () {
                    var D,
                      G,
                      tt,
                      z,
                      ot,
                      X = new Array(v + 1);
                    for (z = tt = 0; z < c - 1; z++)
                      for (M[z] = tt, D = 0; D < 1 << W[z]; D++) f[tt++] = z;
                    for (f[tt - 1] = z, z = ot = 0; z < 16; z++)
                      for (nt[z] = ot, D = 0; D < 1 << it[z]; D++) V[ot++] = z;
                    for (ot >>= 7; z < h; z++)
                      for (nt[z] = ot << 7, D = 0; D < 1 << (it[z] - 7); D++)
                        V[256 + ot++] = z;
                    for (G = 0; G <= v; G++) X[G] = 0;
                    for (D = 0; D <= 143; ) (lt[2 * D + 1] = 8), D++, X[8]++;
                    for (; D <= 255; ) (lt[2 * D + 1] = 9), D++, X[9]++;
                    for (; D <= 279; ) (lt[2 * D + 1] = 7), D++, X[7]++;
                    for (; D <= 287; ) (lt[2 * D + 1] = 8), D++, X[8]++;
                    for (vt(lt, b + 1, X), D = 0; D < h; D++)
                      (L[2 * D + 1] = 5), (L[2 * D] = P(D, 5));
                    (gt = new mt(lt, W, w + 1, b, v)),
                      (Y = new mt(L, it, 0, h, v)),
                      (st = new mt(new Array(0), j, 0, _, k));
                  })(),
                  (F = !0)),
                  (C.l_desc = new B(C.dyn_ltree, gt)),
                  (C.d_desc = new B(C.dyn_dtree, Y)),
                  (C.bl_desc = new B(C.bl_tree, st)),
                  (C.bi_buf = 0),
                  (C.bi_valid = 0),
                  Q(C);
              }),
                (o._tr_stored_block = x),
                (o._tr_flush_block = function (C, D, G, tt) {
                  var z,
                    ot,
                    X = 0;
                  0 < C.level
                    ? (C.strm.data_type === 2 &&
                        (C.strm.data_type = (function (rt) {
                          var _t,
                            At = 4093624447;
                          for (_t = 0; _t <= 31; _t++, At >>>= 1)
                            if (1 & At && rt.dyn_ltree[2 * _t] !== 0) return a;
                          if (
                            rt.dyn_ltree[18] !== 0 ||
                            rt.dyn_ltree[20] !== 0 ||
                            rt.dyn_ltree[26] !== 0
                          )
                            return s;
                          for (_t = 32; _t < w; _t++)
                            if (rt.dyn_ltree[2 * _t] !== 0) return s;
                          return a;
                        })(C)),
                      xt(C, C.l_desc),
                      xt(C, C.d_desc),
                      (X = (function (rt) {
                        var _t;
                        for (
                          u(rt, rt.dyn_ltree, rt.l_desc.max_code),
                            u(rt, rt.dyn_dtree, rt.d_desc.max_code),
                            xt(rt, rt.bl_desc),
                            _t = _ - 1;
                          3 <= _t && rt.bl_tree[2 * at[_t] + 1] === 0;
                          _t--
                        );
                        return (rt.opt_len += 3 * (_t + 1) + 5 + 5 + 4), _t;
                      })(C)),
                      (z = (C.opt_len + 3 + 7) >>> 3),
                      (ot = (C.static_len + 3 + 7) >>> 3) <= z && (z = ot))
                    : (z = ot = G + 5),
                    G + 4 <= z && D !== -1
                      ? x(C, D, G, tt)
                      : C.strategy === 4 || ot === z
                      ? (H(C, 2 + (tt ? 1 : 0), 3), et(C, lt, L))
                      : (H(C, 4 + (tt ? 1 : 0), 3),
                        (function (rt, _t, At, kt) {
                          var Ut;
                          for (
                            H(rt, _t - 257, 5),
                              H(rt, At - 1, 5),
                              H(rt, kt - 4, 4),
                              Ut = 0;
                            Ut < kt;
                            Ut++
                          )
                            H(rt, rt.bl_tree[2 * at[Ut] + 1], 3);
                          N(rt, rt.dyn_ltree, _t - 1),
                            N(rt, rt.dyn_dtree, At - 1);
                        })(
                          C,
                          C.l_desc.max_code + 1,
                          C.d_desc.max_code + 1,
                          X + 1
                        ),
                        et(C, C.dyn_ltree, C.dyn_dtree)),
                    Q(C),
                    tt && dt(C);
                }),
                (o._tr_tally = function (C, D, G) {
                  return (
                    (C.pending_buf[C.d_buf + 2 * C.last_lit] = (D >>> 8) & 255),
                    (C.pending_buf[C.d_buf + 2 * C.last_lit + 1] = 255 & D),
                    (C.pending_buf[C.l_buf + C.last_lit] = 255 & G),
                    C.last_lit++,
                    D === 0
                      ? C.dyn_ltree[2 * G]++
                      : (C.matches++,
                        D--,
                        C.dyn_ltree[2 * (f[G] + w + 1)]++,
                        C.dyn_dtree[2 * T(D)]++),
                    C.last_lit === C.lit_bufsize - 1
                  );
                }),
                (o._tr_align = function (C) {
                  H(C, 2, 3),
                    $(C, E, lt),
                    (function (D) {
                      D.bi_valid === 16
                        ? (K(D, D.bi_buf), (D.bi_buf = 0), (D.bi_valid = 0))
                        : 8 <= D.bi_valid &&
                          ((D.pending_buf[D.pending++] = 255 & D.bi_buf),
                          (D.bi_buf >>= 8),
                          (D.bi_valid -= 8));
                    })(C);
                });
            },
            { '../utils/common': 41 },
          ],
          53: [
            function (t, r, o) {
              r.exports = function () {
                (this.input = null),
                  (this.next_in = 0),
                  (this.avail_in = 0),
                  (this.total_in = 0),
                  (this.output = null),
                  (this.next_out = 0),
                  (this.avail_out = 0),
                  (this.total_out = 0),
                  (this.msg = ''),
                  (this.state = null),
                  (this.data_type = 2),
                  (this.adler = 0);
              };
            },
            {},
          ],
          54: [
            function (t, r, o) {
              (function (i) {
                (function (a, s) {
                  if (!a.setImmediate) {
                    var l,
                      g,
                      c,
                      w,
                      b = 1,
                      h = {},
                      _ = !1,
                      d = a.document,
                      v = Object.getPrototypeOf && Object.getPrototypeOf(a);
                    (v = v && v.setTimeout ? v : a),
                      (l =
                        {}.toString.call(a.process) === '[object process]'
                          ? function (I) {
                              process.nextTick(function () {
                                k(I);
                              });
                            }
                          : (function () {
                              if (a.postMessage && !a.importScripts) {
                                var I = !0,
                                  A = a.onmessage;
                                return (
                                  (a.onmessage = function () {
                                    I = !1;
                                  }),
                                  a.postMessage('', '*'),
                                  (a.onmessage = A),
                                  I
                                );
                              }
                            })()
                          ? ((w = 'setImmediate$' + Math.random() + '$'),
                            a.addEventListener
                              ? a.addEventListener('message', E, !1)
                              : a.attachEvent('onmessage', E),
                            function (I) {
                              a.postMessage(w + I, '*');
                            })
                          : a.MessageChannel
                          ? (((c = new MessageChannel()).port1.onmessage =
                              function (I) {
                                k(I.data);
                              }),
                            function (I) {
                              c.port2.postMessage(I);
                            })
                          : d &&
                            'onreadystatechange' in d.createElement('script')
                          ? ((g = d.documentElement),
                            function (I) {
                              var A = d.createElement('script');
                              (A.onreadystatechange = function () {
                                k(I),
                                  (A.onreadystatechange = null),
                                  g.removeChild(A),
                                  (A = null);
                              }),
                                g.appendChild(A);
                            })
                          : function (I) {
                              setTimeout(k, 0, I);
                            }),
                      (v.setImmediate = function (I) {
                        typeof I != 'function' && (I = new Function('' + I));
                        for (
                          var A = new Array(arguments.length - 1), U = 0;
                          U < A.length;
                          U++
                        )
                          A[U] = arguments[U + 1];
                        var W = { callback: I, args: A };
                        return (h[b] = W), l(b), b++;
                      }),
                      (v.clearImmediate = m);
                  }
                  function m(I) {
                    delete h[I];
                  }
                  function k(I) {
                    if (_) setTimeout(k, 0, I);
                    else {
                      var A = h[I];
                      if (A) {
                        _ = !0;
                        try {
                          (function (U) {
                            var W = U.callback,
                              it = U.args;
                            switch (it.length) {
                              case 0:
                                W();
                                break;
                              case 1:
                                W(it[0]);
                                break;
                              case 2:
                                W(it[0], it[1]);
                                break;
                              case 3:
                                W(it[0], it[1], it[2]);
                                break;
                              default:
                                W.apply(s, it);
                            }
                          })(A);
                        } finally {
                          m(I), (_ = !1);
                        }
                      }
                    }
                  }
                  function E(I) {
                    I.source === a &&
                      typeof I.data == 'string' &&
                      I.data.indexOf(w) === 0 &&
                      k(+I.data.slice(w.length));
                  }
                })(typeof self > 'u' ? (i === void 0 ? this : i) : self);
              }.call(
                this,
                typeof rn < 'u'
                  ? rn
                  : typeof self < 'u'
                  ? self
                  : typeof window < 'u'
                  ? window
                  : {}
              ));
            },
            {},
          ],
        },
        {},
        [10]
      )(10);
    });
  })(jo);
  const $o = {
      name: '@innovatrics/dot-common-auto-capture',
      private: !0,
      version: '3.5.1',
      scripts: {
        build: 'tsc && vite build',
        lint: 'eslint "src/**/*.{ts,tsx}" --max-warnings 0',
        test: 'vitest run --coverage',
        tsc: 'tsc',
      },
      dependencies: {
        polished: '^4.2.2',
        preact: '^10.9.0',
        'styled-components': '^5.3.5',
        jszip: '^3.10.0',
      },
      devDependencies: {
        '@preact/preset-vite': '^2.3.0',
        '@types/styled-components': '^5.1.25',
        c8: '^7.12.0',
        typescript: '~4.7.2',
        vite: '^3.0.0',
        vitest: '^0.18.1',
      },
    },
    Uo = 600,
    an = 14,
    Qr = 5,
    ti = 0.027,
    Wo = 1.5,
    Ho = 0.85,
    ei = 1e3,
    ni = 0.24,
    Zo = 24,
    Yo = 2,
    Go = 0.8,
    Xo = 0.035,
    qo = 0.43,
    Ko = 0.03,
    Jo = 500,
    Qo = 250,
    ta = 900,
    ea = 100,
    na = 10,
    sn = 0.5,
    un = 2,
    ra = 16,
    Yn = { minDuration: 1e3, maxDuration: 2500, minFrames: 10 },
    ri = { max: 100, min: 10 },
    ii = { shorterSide: 720, longerSide: 1280 };
  function Gn() {
    return /iPhone|iPad|iPod|Android|Mobi|BlackBerry|Silk|Windows Phone/i.test(
      navigator.userAgent
    );
  }
  function ia() {
    const e = navigator.userAgent.includes('Chrome'),
      n = new RegExp(/Version\/15.* Safari/).test(navigator.userAgent);
    return e && n ? !1 : n;
  }
  function oa(e) {
    return new Promise((n) => {
      setTimeout(n, e);
    });
  }
  function aa(e) {
    if (e == null) {
      const n = e === null ? 'null' : 'undefined';
      throw new Error(`unwrap: value must not be null/undefined, but is: ${n}`);
    }
    return e;
  }
  const oi = (e) => Number.parseFloat(e.toFixed(3)),
    Pe = (e) =>
      JSON.parse(
        JSON.stringify(e, (n, t) => (typeof t == 'number' ? oi(t) : t))
      );
  function sa(e) {
    return e == null
      ? an
      : e.width < e.height
      ? Math.max(an, Qr + e.width * ti)
      : Math.max(an, Qr + e.height * ti);
  }
  const ua = () => $o.version,
    la = (e) => new URL(e).hostname.replace('www.', ''),
    ln = (e) =>
      Object.entries(e)
        .map(([n, t]) => `${encodeURIComponent(n)}=${encodeURIComponent(t)}`)
        .join('&'),
    ca = () =>
      window.crypto.getRandomValues(new Uint32Array(1))[0].toString(16),
    ai = (e) => (Math.round(e / 500) * 500) / 1e3,
    ke = (e) => (e <= 1 ? Math.round(e * 20) / 20 : Math.round(e / 50) * 50),
    ha = (e) => Math.round(e / 10) * 10,
    si = (e) => Math.round(e * 2) / 2,
    fa = (e, n) => {
      const t = e && performance.now() - e;
      return n >= Yn.minFrames ? t > Yn.minDuration : t > Yn.maxDuration;
    },
    da = (e, n) => {
      document.dispatchEvent(new CustomEvent(e, { detail: n }));
    };
  var ui = ((e) => ((e.AUTO_CAPTURE = 'auto-capture'), e))(ui || {});
  const cn = {
      appKey: '',
      deviceId: '',
      async countlyFetch(e) {
        if (true) return;
        const n = { method: 'GET', headers: { Accept: 'application/json' } },
          t = 'https://confia.count.ly/i?',
          r = ln({ app_key: this.appKey, device_id: this.deviceId });
        await fetch(`${t}${r}&${e}`, n);
      },
      async init(e, n) {
        if (!n) return;
        (this.appKey = n), (this.deviceId = e);
        const t = { _app_version: ua() },
          r = { organization: la(window.location.href) },
          o = ln({
            begin_session: '1',
            metrics: JSON.stringify(t),
            user_details: JSON.stringify(r),
          });
        await this.countlyFetch(o);
      },
      async endSession() {
        const e = ln({ end_session: '1' });
        await this.countlyFetch(e);
      },
      async sendAutoCaptureEvent(e) {
        const n = [
            {
              key: ui.AUTO_CAPTURE,
              count: 1,
              dur: e.captureTime,
              segmentation: e,
            },
          ],
          t = ln({ events: JSON.stringify(n) });
        await this.countlyFetch(t);
      },
      async sendDocumentData({ documentDetection: e, deviceName: n, ...t }) {
        if (e) {
          const r = {
            ...t,
            hotspots: ke(e.hotspots),
            brightness: ke(e.brightness),
            confidence: ke(e.confidence),
            sharpness: ke(e.sharpness),
            smallestEdge: ke(e.smallestEdge),
            camera: n,
            imageResolution: `${t.imageResolution.width}x${t.imageResolution.height}`,
            averageFps: si(t.averageFps),
            captureTime: ai(t.captureProcessDurationInMs),
          };
          this.sendAutoCaptureEvent(r);
        }
      },
      async sendFaceData({ faceDetection: e, deviceName: n, ...t }) {
        if (e) {
          const r = {
            ...t,
            faceSize: ha(e.faceSize) / 1e3,
            confidence: ke(e.confidence),
            camera: n,
            imageResolution: `${t.imageResolution.width}x${t.imageResolution.height}`,
            averageFps: si(t.averageFps),
            captureTime: ai(t.captureProcessDurationInMs),
          };
          this.sendAutoCaptureEvent(r);
        }
      },
    },
    pa = () => {
      const e = sessionStorage.getItem('dot-user-id');
      if (e) return e;
      {
        const n = ca();
        return sessionStorage.setItem('dot-user-id', n), n;
      }
    },
    ze = {
      init(e) {
        const n = pa();
        cn.init(n, e);
      },
      endSession() {
        cn.endSession();
      },
      sendDocumentData(e) {
        cn.sendDocumentData(e);
      },
      sendFaceData(e) {
        cn.sendFaceData(e);
      },
    },
    li = Bn(null),
    Ne = () => {
      const e = fe(li);
      if (!e) throw new Error('Missing provider for CameraOptionsContext');
      return e;
    },
    ma = ({ children: e, cameraOptions: n }) => {
      const [t, r] = Mt(null);
      return (
        $t(() => {
          var E,
            I,
            A,
            U,
            W,
            it,
            j,
            at,
            lt,
            L,
            V,
            f,
            M,
            gt,
            Y,
            st,
            nt,
            mt,
            B,
            T,
            K,
            H,
            $,
            P,
            vt,
            Q;
          const {
              imageType: o,
              cameraFacing: i,
              photoTakenCb: a,
              onError: s,
              thresholds: l,
              validationMode: g,
              detectionLayerVisible: c,
              uiCustomisation: w,
              samWasmUrl: b,
            } = n,
            h = Gn() ? 'environment' : 'user',
            _ = w == null ? void 0 : w.placeholder,
            d = w == null ? void 0 : w.instructions,
            v = w == null ? void 0 : w.appStateInstructions,
            m = w == null ? void 0 : w.colors,
            k = {
              imageType: o != null ? o : 'png',
              cameraFacing: i != null ? i : h,
              photoTakenCb: a,
              onError: s,
              thresholds: {
                confidenceThreshold:
                  (E = l == null ? void 0 : l.confidenceThreshold) != null
                    ? E
                    : Go,
                placeholderErrorScoreThreshold:
                  (I = l == null ? void 0 : l.placeholderErrorScoreThreshold) !=
                  null
                    ? I
                    : Xo,
                sharpnessThreshold:
                  (A = l == null ? void 0 : l.sharpnessThreshold) != null
                    ? A
                    : Jo,
                brightnessLowThreshold:
                  (U = l == null ? void 0 : l.brightnessLowThreshold) != null
                    ? U
                    : Qo,
                brightnessHighThreshold:
                  (W = l == null ? void 0 : l.brightnessHighThreshold) != null
                    ? W
                    : ta,
                hotspotsScoreThreshold:
                  (it = l == null ? void 0 : l.hotspotsScoreThreshold) != null
                    ? it
                    : ea,
                sizeSmallThreshold:
                  (j = l == null ? void 0 : l.sizeSmallThreshold) != null
                    ? j
                    : qo,
                outOfBoundsThreshold:
                  (at = l == null ? void 0 : l.outOfBoundsThreshold) != null
                    ? at
                    : Ko,
              },
              validationMode: g != null ? g : 'standard',
              detectionLayerVisible: c != null ? c : !1,
              samWasmUrl: b,
              uiCustomisation: {
                placeholder: {
                  documentPlaceholder:
                    (lt = _ == null ? void 0 : _.documentPlaceholder) != null
                      ? lt
                      : 'id-rounded-rectangle-corners-front',
                  customSVG: _ == null ? void 0 : _.customSVG,
                },
                instructions: {
                  candidate_selection:
                    (L = d == null ? void 0 : d.candidate_selection) != null
                      ? L
                      : 'Hold still\u2026',
                  document_centering:
                    (V = d == null ? void 0 : d.document_centering) != null
                      ? V
                      : 'Center document',
                  document_too_close:
                    (f = d == null ? void 0 : d.document_too_close) != null
                      ? f
                      : 'Move back',
                  document_not_present:
                    (M = d == null ? void 0 : d.document_not_present) != null
                      ? M
                      : 'Scan document',
                  document_too_far:
                    (gt = d == null ? void 0 : d.document_too_far) != null
                      ? gt
                      : 'Move closer',
                  sharpness_too_low:
                    (Y = d == null ? void 0 : d.sharpness_too_low) != null
                      ? Y
                      : 'More light needed',
                  brightness_too_low:
                    (st = d == null ? void 0 : d.brightness_too_low) != null
                      ? st
                      : 'More light needed',
                  brightness_too_high:
                    (nt = d == null ? void 0 : d.brightness_too_high) != null
                      ? nt
                      : 'Less light needed',
                  hotspots_present:
                    (mt = d == null ? void 0 : d.hotspots_present) != null
                      ? mt
                      : 'Avoid reflections',
                },
                appStateInstructions: {
                  loading: {
                    text:
                      (T =
                        (B = v == null ? void 0 : v.loading) == null
                          ? void 0
                          : B.text) != null
                        ? T
                        : 'Loading. Please wait.',
                    visible:
                      (H =
                        (K = v == null ? void 0 : v.loading) == null
                          ? void 0
                          : K.visible) != null
                        ? H
                        : !0,
                  },
                  waiting: {
                    text:
                      (P =
                        ($ = v == null ? void 0 : v.waiting) == null
                          ? void 0
                          : $.text) != null
                        ? P
                        : 'Waiting for input',
                    visible:
                      (Q =
                        (vt = v == null ? void 0 : v.waiting) == null
                          ? void 0
                          : vt.visible) != null
                        ? Q
                        : !0,
                  },
                },
                colors: m,
              },
            };
          r(k);
        }, [n]),
        t
          ? O(li.Provider, { value: { documentCameraOptions: t }, children: e })
          : null
      );
    };
  var Me = { exports: {} },
    Tt = {};
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ci;
  function ga() {
    if (ci) return Tt;
    ci = 1;
    var e = typeof Symbol == 'function' && Symbol.for,
      n = e ? Symbol.for('react.element') : 60103,
      t = e ? Symbol.for('react.portal') : 60106,
      r = e ? Symbol.for('react.fragment') : 60107,
      o = e ? Symbol.for('react.strict_mode') : 60108,
      i = e ? Symbol.for('react.profiler') : 60114,
      a = e ? Symbol.for('react.provider') : 60109,
      s = e ? Symbol.for('react.context') : 60110,
      l = e ? Symbol.for('react.async_mode') : 60111,
      g = e ? Symbol.for('react.concurrent_mode') : 60111,
      c = e ? Symbol.for('react.forward_ref') : 60112,
      w = e ? Symbol.for('react.suspense') : 60113,
      b = e ? Symbol.for('react.suspense_list') : 60120,
      h = e ? Symbol.for('react.memo') : 60115,
      _ = e ? Symbol.for('react.lazy') : 60116,
      d = e ? Symbol.for('react.block') : 60121,
      v = e ? Symbol.for('react.fundamental') : 60117,
      m = e ? Symbol.for('react.responder') : 60118,
      k = e ? Symbol.for('react.scope') : 60119;
    function E(A) {
      if (typeof A == 'object' && A !== null) {
        var U = A.$$typeof;
        switch (U) {
          case n:
            switch (((A = A.type), A)) {
              case l:
              case g:
              case r:
              case i:
              case o:
              case w:
                return A;
              default:
                switch (((A = A && A.$$typeof), A)) {
                  case s:
                  case c:
                  case _:
                  case h:
                  case a:
                    return A;
                  default:
                    return U;
                }
            }
          case t:
            return U;
        }
      }
    }
    function I(A) {
      return E(A) === g;
    }
    return (
      (Tt.AsyncMode = l),
      (Tt.ConcurrentMode = g),
      (Tt.ContextConsumer = s),
      (Tt.ContextProvider = a),
      (Tt.Element = n),
      (Tt.ForwardRef = c),
      (Tt.Fragment = r),
      (Tt.Lazy = _),
      (Tt.Memo = h),
      (Tt.Portal = t),
      (Tt.Profiler = i),
      (Tt.StrictMode = o),
      (Tt.Suspense = w),
      (Tt.isAsyncMode = function (A) {
        return I(A) || E(A) === l;
      }),
      (Tt.isConcurrentMode = I),
      (Tt.isContextConsumer = function (A) {
        return E(A) === s;
      }),
      (Tt.isContextProvider = function (A) {
        return E(A) === a;
      }),
      (Tt.isElement = function (A) {
        return typeof A == 'object' && A !== null && A.$$typeof === n;
      }),
      (Tt.isForwardRef = function (A) {
        return E(A) === c;
      }),
      (Tt.isFragment = function (A) {
        return E(A) === r;
      }),
      (Tt.isLazy = function (A) {
        return E(A) === _;
      }),
      (Tt.isMemo = function (A) {
        return E(A) === h;
      }),
      (Tt.isPortal = function (A) {
        return E(A) === t;
      }),
      (Tt.isProfiler = function (A) {
        return E(A) === i;
      }),
      (Tt.isStrictMode = function (A) {
        return E(A) === o;
      }),
      (Tt.isSuspense = function (A) {
        return E(A) === w;
      }),
      (Tt.isValidElementType = function (A) {
        return (
          typeof A == 'string' ||
          typeof A == 'function' ||
          A === r ||
          A === g ||
          A === i ||
          A === o ||
          A === w ||
          A === b ||
          (typeof A == 'object' &&
            A !== null &&
            (A.$$typeof === _ ||
              A.$$typeof === h ||
              A.$$typeof === a ||
              A.$$typeof === s ||
              A.$$typeof === c ||
              A.$$typeof === v ||
              A.$$typeof === m ||
              A.$$typeof === k ||
              A.$$typeof === d))
        );
      }),
      (Tt.typeOf = E),
      Tt
    );
  }
  var It = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var hi;
  function _a() {
    return (
      hi ||
        ((hi = 1),
        {}.NODE_ENV !== 'production' &&
          (function () {
            var e = typeof Symbol == 'function' && Symbol.for,
              n = e ? Symbol.for('react.element') : 60103,
              t = e ? Symbol.for('react.portal') : 60106,
              r = e ? Symbol.for('react.fragment') : 60107,
              o = e ? Symbol.for('react.strict_mode') : 60108,
              i = e ? Symbol.for('react.profiler') : 60114,
              a = e ? Symbol.for('react.provider') : 60109,
              s = e ? Symbol.for('react.context') : 60110,
              l = e ? Symbol.for('react.async_mode') : 60111,
              g = e ? Symbol.for('react.concurrent_mode') : 60111,
              c = e ? Symbol.for('react.forward_ref') : 60112,
              w = e ? Symbol.for('react.suspense') : 60113,
              b = e ? Symbol.for('react.suspense_list') : 60120,
              h = e ? Symbol.for('react.memo') : 60115,
              _ = e ? Symbol.for('react.lazy') : 60116,
              d = e ? Symbol.for('react.block') : 60121,
              v = e ? Symbol.for('react.fundamental') : 60117,
              m = e ? Symbol.for('react.responder') : 60118,
              k = e ? Symbol.for('react.scope') : 60119;
            function E(et) {
              return (
                typeof et == 'string' ||
                typeof et == 'function' ||
                et === r ||
                et === g ||
                et === i ||
                et === o ||
                et === w ||
                et === b ||
                (typeof et == 'object' &&
                  et !== null &&
                  (et.$$typeof === _ ||
                    et.$$typeof === h ||
                    et.$$typeof === a ||
                    et.$$typeof === s ||
                    et.$$typeof === c ||
                    et.$$typeof === v ||
                    et.$$typeof === m ||
                    et.$$typeof === k ||
                    et.$$typeof === d))
              );
            }
            function I(et) {
              if (typeof et == 'object' && et !== null) {
                var xt = et.$$typeof;
                switch (xt) {
                  case n:
                    var u = et.type;
                    switch (u) {
                      case l:
                      case g:
                      case r:
                      case i:
                      case o:
                      case w:
                        return u;
                      default:
                        var N = u && u.$$typeof;
                        switch (N) {
                          case s:
                          case c:
                          case _:
                          case h:
                          case a:
                            return N;
                          default:
                            return xt;
                        }
                    }
                  case t:
                    return xt;
                }
              }
            }
            var A = l,
              U = g,
              W = s,
              it = a,
              j = n,
              at = c,
              lt = r,
              L = _,
              V = h,
              f = t,
              M = i,
              gt = o,
              Y = w,
              st = !1;
            function nt(et) {
              return (
                st ||
                  ((st = !0),
                  console.warn(
                    'The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.'
                  )),
                mt(et) || I(et) === l
              );
            }
            function mt(et) {
              return I(et) === g;
            }
            function B(et) {
              return I(et) === s;
            }
            function T(et) {
              return I(et) === a;
            }
            function K(et) {
              return typeof et == 'object' && et !== null && et.$$typeof === n;
            }
            function H(et) {
              return I(et) === c;
            }
            function $(et) {
              return I(et) === r;
            }
            function P(et) {
              return I(et) === _;
            }
            function vt(et) {
              return I(et) === h;
            }
            function Q(et) {
              return I(et) === t;
            }
            function dt(et) {
              return I(et) === i;
            }
            function yt(et) {
              return I(et) === o;
            }
            function ft(et) {
              return I(et) === w;
            }
            (It.AsyncMode = A),
              (It.ConcurrentMode = U),
              (It.ContextConsumer = W),
              (It.ContextProvider = it),
              (It.Element = j),
              (It.ForwardRef = at),
              (It.Fragment = lt),
              (It.Lazy = L),
              (It.Memo = V),
              (It.Portal = f),
              (It.Profiler = M),
              (It.StrictMode = gt),
              (It.Suspense = Y),
              (It.isAsyncMode = nt),
              (It.isConcurrentMode = mt),
              (It.isContextConsumer = B),
              (It.isContextProvider = T),
              (It.isElement = K),
              (It.isForwardRef = H),
              (It.isFragment = $),
              (It.isLazy = P),
              (It.isMemo = vt),
              (It.isPortal = Q),
              (It.isProfiler = dt),
              (It.isStrictMode = yt),
              (It.isSuspense = ft),
              (It.isValidElementType = E),
              (It.typeOf = I);
          })()),
      It
    );
  }
  (function (e) {
    ({}.NODE_ENV === 'production' ? (e.exports = ga()) : (e.exports = _a()));
  })(Me);
  function fi(e, n) {
    for (var t in n) e[t] = n[t];
    return e;
  }
  function Xn(e, n) {
    for (var t in e) if (t !== '__source' && !(t in n)) return !0;
    for (var r in n) if (r !== '__source' && e[r] !== n[r]) return !0;
    return !1;
  }
  function qn(e) {
    this.props = e;
  }
  function va(e, n) {
    function t(o) {
      var i = this.props.ref,
        a = i == o.ref;
      return (
        !a && i && (i.call ? i(null) : (i.current = null)),
        n ? !n(this.props, o) || !a : Xn(this.props, o)
      );
    }
    function r(o) {
      return (this.shouldComponentUpdate = t), Wt(e, o);
    }
    return (
      (r.displayName = 'Memo(' + (e.displayName || e.name) + ')'),
      (r.prototype.isReactComponent = !0),
      (r.__f = !0),
      r
    );
  }
  ((qn.prototype = new Yt()).isPureReactComponent = !0),
    (qn.prototype.shouldComponentUpdate = function (e, n) {
      return Xn(this.props, e) || Xn(this.state, n);
    });
  var di = pt.__b;
  pt.__b = function (e) {
    e.type && e.type.__f && e.ref && ((e.props.ref = e.ref), (e.ref = null)),
      di && di(e);
  };
  var ya =
    (typeof Symbol < 'u' && Symbol.for && Symbol.for('react.forward_ref')) ||
    3911;
  function wa(e) {
    function n(t) {
      var r = fi({}, t);
      return delete r.ref, e(r, t.ref || null);
    }
    return (
      (n.$$typeof = ya),
      (n.render = n),
      (n.prototype.isReactComponent = n.__f = !0),
      (n.displayName = 'ForwardRef(' + (e.displayName || e.name) + ')'),
      n
    );
  }
  var pi = function (e, n) {
      return e == null ? null : re(re(e).map(n));
    },
    ba = {
      map: pi,
      forEach: pi,
      count: function (e) {
        return e ? re(e).length : 0;
      },
      only: function (e) {
        var n = re(e);
        if (n.length !== 1) throw 'Children.only';
        return n[0];
      },
      toArray: re,
    },
    Ca = pt.__e;
  pt.__e = function (e, n, t, r) {
    if (e.then) {
      for (var o, i = n; (i = i.__); )
        if ((o = i.__c) && o.__c)
          return (
            n.__e == null && ((n.__e = t.__e), (n.__k = t.__k)), o.__c(e, n)
          );
    }
    Ca(e, n, t, r);
  };
  var mi = pt.unmount;
  function hn() {
    (this.__u = 0), (this.t = null), (this.__b = null);
  }
  function gi(e) {
    var n = e.__.__c;
    return n && n.__a && n.__a(e);
  }
  function ka(e) {
    var n, t, r;
    function o(i) {
      if (
        (n ||
          (n = e()).then(
            function (a) {
              t = a.default || a;
            },
            function (a) {
              r = a;
            }
          ),
        r)
      )
        throw r;
      if (!t) throw n;
      return Wt(t, i);
    }
    return (o.displayName = 'Lazy'), (o.__f = !0), o;
  }
  function Fe() {
    (this.u = null), (this.o = null);
  }
  (pt.unmount = function (e) {
    var n = e.__c;
    n && n.__R && n.__R(), n && e.__h === !0 && (e.type = null), mi && mi(e);
  }),
    ((hn.prototype = new Yt()).__c = function (e, n) {
      var t = n.__c,
        r = this;
      r.t == null && (r.t = []), r.t.push(t);
      var o = gi(r.__v),
        i = !1,
        a = function () {
          i || ((i = !0), (t.__R = null), o ? o(s) : s());
        };
      t.__R = a;
      var s = function () {
          if (!--r.__u) {
            if (r.state.__a) {
              var g = r.state.__a;
              r.__v.__k[0] = (function w(b, h, _) {
                return (
                  b &&
                    ((b.__v = null),
                    (b.__k =
                      b.__k &&
                      b.__k.map(function (d) {
                        return w(d, h, _);
                      })),
                    b.__c &&
                      b.__c.__P === h &&
                      (b.__e && _.insertBefore(b.__e, b.__d),
                      (b.__c.__e = !0),
                      (b.__c.__P = _))),
                  b
                );
              })(g, g.__c.__P, g.__c.__O);
            }
            var c;
            for (r.setState({ __a: (r.__b = null) }); (c = r.t.pop()); )
              c.forceUpdate();
          }
        },
        l = n.__h === !0;
      r.__u++ || l || r.setState({ __a: (r.__b = r.__v.__k[0]) }), e.then(a, a);
    }),
    (hn.prototype.componentWillUnmount = function () {
      this.t = [];
    }),
    (hn.prototype.render = function (e, n) {
      if (this.__b) {
        if (this.__v.__k) {
          var t = document.createElement('div'),
            r = this.__v.__k[0].__c;
          this.__v.__k[0] = (function i(a, s, l) {
            return (
              a &&
                (a.__c &&
                  a.__c.__H &&
                  (a.__c.__H.__.forEach(function (g) {
                    typeof g.__c == 'function' && g.__c();
                  }),
                  (a.__c.__H = null)),
                (a = fi({}, a)).__c != null &&
                  (a.__c.__P === l && (a.__c.__P = s), (a.__c = null)),
                (a.__k =
                  a.__k &&
                  a.__k.map(function (g) {
                    return i(g, s, l);
                  }))),
              a
            );
          })(this.__b, t, (r.__O = r.__P));
        }
        this.__b = null;
      }
      var o = n.__a && Wt(qt, null, e.fallback);
      return o && (o.__h = null), [Wt(qt, null, n.__a ? null : e.children), o];
    });
  var _i = function (e, n, t) {
    if (
      (++t[1] === t[0] && e.o.delete(n),
      e.props.revealOrder && (e.props.revealOrder[0] !== 't' || !e.o.size))
    )
      for (t = e.u; t; ) {
        for (; t.length > 3; ) t.pop()();
        if (t[1] < t[0]) break;
        e.u = t = t[2];
      }
  };
  function xa(e) {
    return (
      (this.getChildContext = function () {
        return e.context;
      }),
      e.children
    );
  }
  function Sa(e) {
    var n = this,
      t = e.i;
    (n.componentWillUnmount = function () {
      he(null, n.l), (n.l = null), (n.i = null);
    }),
      n.i && n.i !== t && n.componentWillUnmount(),
      e.__v
        ? (n.l ||
            ((n.i = t),
            (n.l = {
              nodeType: 1,
              parentNode: t,
              childNodes: [],
              appendChild: function (r) {
                this.childNodes.push(r), n.i.appendChild(r);
              },
              insertBefore: function (r, o) {
                this.childNodes.push(r), n.i.appendChild(r);
              },
              removeChild: function (r) {
                this.childNodes.splice(this.childNodes.indexOf(r) >>> 1, 1),
                  n.i.removeChild(r);
              },
            })),
          he(Wt(xa, { context: n.context }, e.__v), n.l))
        : n.l && n.componentWillUnmount();
  }
  function Aa(e, n) {
    var t = Wt(Sa, { __v: e, i: n });
    return (t.containerInfo = n), t;
  }
  ((Fe.prototype = new Yt()).__a = function (e) {
    var n = this,
      t = gi(n.__v),
      r = n.o.get(e);
    return (
      r[0]++,
      function (o) {
        var i = function () {
          n.props.revealOrder ? (r.push(o), _i(n, e, r)) : o();
        };
        t ? t(i) : i();
      }
    );
  }),
    (Fe.prototype.render = function (e) {
      (this.u = null), (this.o = new Map());
      var n = re(e.children);
      e.revealOrder && e.revealOrder[0] === 'b' && n.reverse();
      for (var t = n.length; t--; ) this.o.set(n[t], (this.u = [1, 0, this.u]));
      return e.children;
    }),
    (Fe.prototype.componentDidUpdate = Fe.prototype.componentDidMount =
      function () {
        var e = this;
        this.o.forEach(function (n, t) {
          _i(e, t, n);
        });
      });
  var vi =
      (typeof Symbol < 'u' && Symbol.for && Symbol.for('react.element')) ||
      60103,
    Ea =
      /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
    La = typeof document < 'u',
    Ta = function (e) {
      return (
        typeof Symbol < 'u' && typeof Symbol() == 'symbol'
          ? /fil|che|rad/i
          : /fil|che|ra/i
      ).test(e);
    };
  function Ia(e, n, t) {
    return (
      n.__k == null && (n.textContent = ''),
      he(e, n),
      typeof t == 'function' && t(),
      e ? e.__c : null
    );
  }
  function Ra(e, n, t) {
    return Mn(e, n), typeof t == 'function' && t(), e ? e.__c : null;
  }
  (Yt.prototype.isReactComponent = {}),
    [
      'componentWillMount',
      'componentWillReceiveProps',
      'componentWillUpdate',
    ].forEach(function (e) {
      Object.defineProperty(Yt.prototype, e, {
        configurable: !0,
        get: function () {
          return this['UNSAFE_' + e];
        },
        set: function (n) {
          Object.defineProperty(this, e, {
            configurable: !0,
            writable: !0,
            value: n,
          });
        },
      });
    });
  var yi = pt.event;
  function Oa() {}
  function Da() {
    return this.cancelBubble;
  }
  function Pa() {
    return this.defaultPrevented;
  }
  pt.event = function (e) {
    return (
      yi && (e = yi(e)),
      (e.persist = Oa),
      (e.isPropagationStopped = Da),
      (e.isDefaultPrevented = Pa),
      (e.nativeEvent = e)
    );
  };
  var wi,
    bi = {
      configurable: !0,
      get: function () {
        return this.class;
      },
    },
    Ci = pt.vnode;
  pt.vnode = function (e) {
    var n = e.type,
      t = e.props,
      r = t;
    if (typeof n == 'string') {
      var o = n.indexOf('-') === -1;
      for (var i in ((r = {}), t)) {
        var a = t[i];
        (La && i === 'children' && n === 'noscript') ||
          (i === 'value' && 'defaultValue' in t && a == null) ||
          (i === 'defaultValue' && 'value' in t && t.value == null
            ? (i = 'value')
            : i === 'download' && a === !0
            ? (a = '')
            : /ondoubleclick/i.test(i)
            ? (i = 'ondblclick')
            : /^onchange(textarea|input)/i.test(i + n) && !Ta(t.type)
            ? (i = 'oninput')
            : /^onfocus$/i.test(i)
            ? (i = 'onfocusin')
            : /^onblur$/i.test(i)
            ? (i = 'onfocusout')
            : /^on(Ani|Tra|Tou|BeforeInp|Compo)/.test(i)
            ? (i = i.toLowerCase())
            : o && Ea.test(i)
            ? (i = i.replace(/[A-Z0-9]/g, '-$&').toLowerCase())
            : a === null && (a = void 0),
          /^oninput$/i.test(i) &&
            ((i = i.toLowerCase()), r[i] && (i = 'oninputCapture')),
          (r[i] = a));
      }
      n == 'select' &&
        r.multiple &&
        Array.isArray(r.value) &&
        (r.value = re(t.children).forEach(function (s) {
          s.props.selected = r.value.indexOf(s.props.value) != -1;
        })),
        n == 'select' &&
          r.defaultValue != null &&
          (r.value = re(t.children).forEach(function (s) {
            s.props.selected = r.multiple
              ? r.defaultValue.indexOf(s.props.value) != -1
              : r.defaultValue == s.props.value;
          })),
        (e.props = r),
        t.class != t.className &&
          ((bi.enumerable = 'className' in t),
          t.className != null && (r.class = t.className),
          Object.defineProperty(r, 'className', bi));
    }
    (e.$$typeof = vi), Ci && Ci(e);
  };
  var ki = pt.__r;
  pt.__r = function (e) {
    ki && ki(e), (wi = e.__c);
  };
  var za = {
    ReactCurrentDispatcher: {
      current: {
        readContext: function (e) {
          return wi.__n[e.__c].props.value;
        },
      },
    },
  };
  function Na(e) {
    return Wt.bind(null, e);
  }
  function xi(e) {
    return !!e && e.$$typeof === vi;
  }
  function Ma(e) {
    return xi(e) ? Fn.apply(null, arguments) : e;
  }
  function Fa(e) {
    return !!e.__k && (he(null, e), !0);
  }
  function Ba(e) {
    return (e && (e.base || (e.nodeType === 1 && e))) || null;
  }
  var Va = function (e, n) {
      return e(n);
    },
    ja = function (e, n) {
      return e(n);
    };
  function Si(e) {
    e();
  }
  function $a(e) {
    return e;
  }
  function Ua() {
    return [!1, Si];
  }
  function Wa(e, n) {
    var t = n(),
      r = Mt({ s: { __: t, h: n } }),
      o = r[0].s,
      i = r[1];
    return (
      en(
        function () {
          (o.__ = t), (o.h = n), o.__ !== n() && i({ s: o });
        },
        [e, t, n]
      ),
      $t(
        function () {
          return (
            o.__ !== o.h() && i({ s: o }),
            e(function () {
              o.__ !== o.h() && i({ s: o });
            })
          );
        },
        [e]
      ),
      t
    );
  }
  const Be = {
    useState: Mt,
    useReducer: Xr,
    useEffect: $t,
    useLayoutEffect: en,
    useInsertionEffect: en,
    useTransition: Ua,
    useDeferredValue: $a,
    useSyncExternalStore: Wa,
    startTransition: Si,
    useRef: _e,
    useImperativeHandle: Mo,
    useMemo: De,
    useCallback: qr,
    useContext: fe,
    useDebugValue: $n,
    version: '17.0.2',
    Children: ba,
    render: Ia,
    hydrate: Ra,
    unmountComponentAtNode: Fa,
    createPortal: Aa,
    createElement: Wt,
    createContext: Bn,
    createFactory: Na,
    cloneElement: Ma,
    createRef: Lo,
    Fragment: qt,
    isValidElement: xi,
    findDOMNode: Ba,
    Component: Yt,
    PureComponent: qn,
    memo: va,
    forwardRef: wa,
    flushSync: ja,
    unstable_batchedUpdates: Va,
    StrictMode: qt,
    Suspense: hn,
    SuspenseList: Fe,
    lazy: ka,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: za,
  };
  function Ha(e) {
    function n(T, K, H, $, P) {
      for (
        var vt = 0,
          Q = 0,
          dt = 0,
          yt = 0,
          ft,
          et,
          xt = 0,
          u = 0,
          N,
          F = (N = ft = 0),
          x = 0,
          C = 0,
          D = 0,
          G = 0,
          tt = H.length,
          z = tt - 1,
          ot,
          X = '',
          rt = '',
          _t = '',
          At = '',
          kt;
        x < tt;

      ) {
        if (
          ((et = H.charCodeAt(x)),
          x === z &&
            Q + yt + dt + vt !== 0 &&
            (Q !== 0 && (et = Q === 47 ? 10 : 47),
            (yt = dt = vt = 0),
            tt++,
            z++),
          Q + yt + dt + vt === 0)
        ) {
          if (
            x === z &&
            (0 < C && (X = X.replace(b, '')), 0 < X.trim().length)
          ) {
            switch (et) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;
              default:
                X += H.charAt(x);
            }
            et = 59;
          }
          switch (et) {
            case 123:
              for (
                X = X.trim(), ft = X.charCodeAt(0), N = 1, G = ++x;
                x < tt;

              ) {
                switch ((et = H.charCodeAt(x))) {
                  case 123:
                    N++;
                    break;
                  case 125:
                    N--;
                    break;
                  case 47:
                    switch ((et = H.charCodeAt(x + 1))) {
                      case 42:
                      case 47:
                        t: {
                          for (F = x + 1; F < z; ++F)
                            switch (H.charCodeAt(F)) {
                              case 47:
                                if (
                                  et === 42 &&
                                  H.charCodeAt(F - 1) === 42 &&
                                  x + 2 !== F
                                ) {
                                  x = F + 1;
                                  break t;
                                }
                                break;
                              case 10:
                                if (et === 47) {
                                  x = F + 1;
                                  break t;
                                }
                            }
                          x = F;
                        }
                    }
                    break;
                  case 91:
                    et++;
                  case 40:
                    et++;
                  case 34:
                  case 39:
                    for (; x++ < z && H.charCodeAt(x) !== et; );
                }
                if (N === 0) break;
                x++;
              }
              switch (
                ((N = H.substring(G, x)),
                ft === 0 && (ft = (X = X.replace(w, '').trim()).charCodeAt(0)),
                ft)
              ) {
                case 64:
                  switch (
                    (0 < C && (X = X.replace(b, '')),
                    (et = X.charCodeAt(1)),
                    et)
                  ) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      C = K;
                      break;
                    default:
                      C = gt;
                  }
                  if (
                    ((N = n(K, C, N, et, P + 1)),
                    (G = N.length),
                    0 < st &&
                      ((C = t(gt, X, D)),
                      (kt = s(3, N, C, K, V, L, G, et, P, $)),
                      (X = C.join('')),
                      kt !== void 0 &&
                        (G = (N = kt.trim()).length) === 0 &&
                        ((et = 0), (N = ''))),
                    0 < G)
                  )
                    switch (et) {
                      case 115:
                        X = X.replace(U, a);
                      case 100:
                      case 109:
                      case 45:
                        N = X + '{' + N + '}';
                        break;
                      case 107:
                        (X = X.replace(k, '$1 $2')),
                          (N = X + '{' + N + '}'),
                          (N =
                            M === 1 || (M === 2 && i('@' + N, 3))
                              ? '@-webkit-' + N + '@' + N
                              : '@' + N);
                        break;
                      default:
                        (N = X + N), $ === 112 && (N = ((rt += N), ''));
                    }
                  else N = '';
                  break;
                default:
                  N = n(K, t(K, X, D), N, $, P + 1);
              }
              (_t += N),
                (N = D = C = F = ft = 0),
                (X = ''),
                (et = H.charCodeAt(++x));
              break;
            case 125:
            case 59:
              if (
                ((X = (0 < C ? X.replace(b, '') : X).trim()),
                1 < (G = X.length))
              )
                switch (
                  (F === 0 &&
                    ((ft = X.charCodeAt(0)),
                    ft === 45 || (96 < ft && 123 > ft)) &&
                    (G = (X = X.replace(' ', ':')).length),
                  0 < st &&
                    (kt = s(1, X, K, T, V, L, rt.length, $, P, $)) !== void 0 &&
                    (G = (X = kt.trim()).length) === 0 &&
                    (X = '\0\0'),
                  (ft = X.charCodeAt(0)),
                  (et = X.charCodeAt(1)),
                  ft)
                ) {
                  case 0:
                    break;
                  case 64:
                    if (et === 105 || et === 99) {
                      At += X + H.charAt(x);
                      break;
                    }
                  default:
                    X.charCodeAt(G - 1) !== 58 &&
                      (rt += o(X, ft, et, X.charCodeAt(2)));
                }
              (D = C = F = ft = 0), (X = ''), (et = H.charCodeAt(++x));
          }
        }
        switch (et) {
          case 13:
          case 10:
            Q === 47
              ? (Q = 0)
              : 1 + ft === 0 &&
                $ !== 107 &&
                0 < X.length &&
                ((C = 1), (X += '\0')),
              0 < st * mt && s(0, X, K, T, V, L, rt.length, $, P, $),
              (L = 1),
              V++;
            break;
          case 59:
          case 125:
            if (Q + yt + dt + vt === 0) {
              L++;
              break;
            }
          default:
            switch ((L++, (ot = H.charAt(x)), et)) {
              case 9:
              case 32:
                if (yt + vt + Q === 0)
                  switch (xt) {
                    case 44:
                    case 58:
                    case 9:
                    case 32:
                      ot = '';
                      break;
                    default:
                      et !== 32 && (ot = ' ');
                  }
                break;
              case 0:
                ot = '\\0';
                break;
              case 12:
                ot = '\\f';
                break;
              case 11:
                ot = '\\v';
                break;
              case 38:
                yt + Q + vt === 0 && ((C = D = 1), (ot = '\f' + ot));
                break;
              case 108:
                if (yt + Q + vt + f === 0 && 0 < F)
                  switch (x - F) {
                    case 2:
                      xt === 112 && H.charCodeAt(x - 3) === 58 && (f = xt);
                    case 8:
                      u === 111 && (f = u);
                  }
                break;
              case 58:
                yt + Q + vt === 0 && (F = x);
                break;
              case 44:
                Q + dt + yt + vt === 0 && ((C = 1), (ot += '\r'));
                break;
              case 34:
              case 39:
                Q === 0 && (yt = yt === et ? 0 : yt === 0 ? et : yt);
                break;
              case 91:
                yt + Q + dt === 0 && vt++;
                break;
              case 93:
                yt + Q + dt === 0 && vt--;
                break;
              case 41:
                yt + Q + vt === 0 && dt--;
                break;
              case 40:
                if (yt + Q + vt === 0) {
                  if (ft === 0)
                    switch (2 * xt + 3 * u) {
                      case 533:
                        break;
                      default:
                        ft = 1;
                    }
                  dt++;
                }
                break;
              case 64:
                Q + dt + yt + vt + F + N === 0 && (N = 1);
                break;
              case 42:
              case 47:
                if (!(0 < yt + vt + dt))
                  switch (Q) {
                    case 0:
                      switch (2 * et + 3 * H.charCodeAt(x + 1)) {
                        case 235:
                          Q = 47;
                          break;
                        case 220:
                          (G = x), (Q = 42);
                      }
                      break;
                    case 42:
                      et === 47 &&
                        xt === 42 &&
                        G + 2 !== x &&
                        (H.charCodeAt(G + 2) === 33 &&
                          (rt += H.substring(G, x + 1)),
                        (ot = ''),
                        (Q = 0));
                  }
            }
            Q === 0 && (X += ot);
        }
        (u = xt), (xt = et), x++;
      }
      if (((G = rt.length), 0 < G)) {
        if (
          ((C = K),
          0 < st &&
            ((kt = s(2, rt, C, T, V, L, G, $, P, $)),
            kt !== void 0 && (rt = kt).length === 0))
        )
          return At + rt + _t;
        if (((rt = C.join(',') + '{' + rt + '}'), M * f !== 0)) {
          switch ((M !== 2 || i(rt, 2) || (f = 0), f)) {
            case 111:
              rt = rt.replace(I, ':-moz-$1') + rt;
              break;
            case 112:
              rt =
                rt.replace(E, '::-webkit-input-$1') +
                rt.replace(E, '::-moz-$1') +
                rt.replace(E, ':-ms-input-$1') +
                rt;
          }
          f = 0;
        }
      }
      return At + rt + _t;
    }
    function t(T, K, H) {
      var $ = K.trim().split(v);
      K = $;
      var P = $.length,
        vt = T.length;
      switch (vt) {
        case 0:
        case 1:
          var Q = 0;
          for (T = vt === 0 ? '' : T[0] + ' '; Q < P; ++Q)
            K[Q] = r(T, K[Q], H).trim();
          break;
        default:
          var dt = (Q = 0);
          for (K = []; Q < P; ++Q)
            for (var yt = 0; yt < vt; ++yt)
              K[dt++] = r(T[yt] + ' ', $[Q], H).trim();
      }
      return K;
    }
    function r(T, K, H) {
      var $ = K.charCodeAt(0);
      switch ((33 > $ && ($ = (K = K.trim()).charCodeAt(0)), $)) {
        case 38:
          return K.replace(m, '$1' + T.trim());
        case 58:
          return T.trim() + K.replace(m, '$1' + T.trim());
        default:
          if (0 < 1 * H && 0 < K.indexOf('\f'))
            return K.replace(
              m,
              (T.charCodeAt(0) === 58 ? '' : '$1') + T.trim()
            );
      }
      return T + K;
    }
    function o(T, K, H, $) {
      var P = T + ';',
        vt = 2 * K + 3 * H + 4 * $;
      if (vt === 944) {
        T = P.indexOf(':', 9) + 1;
        var Q = P.substring(T, P.length - 1).trim();
        return (
          (Q = P.substring(0, T).trim() + Q + ';'),
          M === 1 || (M === 2 && i(Q, 1)) ? '-webkit-' + Q + Q : Q
        );
      }
      if (M === 0 || (M === 2 && !i(P, 1))) return P;
      switch (vt) {
        case 1015:
          return P.charCodeAt(10) === 97 ? '-webkit-' + P + P : P;
        case 951:
          return P.charCodeAt(3) === 116 ? '-webkit-' + P + P : P;
        case 963:
          return P.charCodeAt(5) === 110 ? '-webkit-' + P + P : P;
        case 1009:
          if (P.charCodeAt(4) !== 100) break;
        case 969:
        case 942:
          return '-webkit-' + P + P;
        case 978:
          return '-webkit-' + P + '-moz-' + P + P;
        case 1019:
        case 983:
          return '-webkit-' + P + '-moz-' + P + '-ms-' + P + P;
        case 883:
          if (P.charCodeAt(8) === 45) return '-webkit-' + P + P;
          if (0 < P.indexOf('image-set(', 11))
            return P.replace(lt, '$1-webkit-$2') + P;
          break;
        case 932:
          if (P.charCodeAt(4) === 45)
            switch (P.charCodeAt(5)) {
              case 103:
                return (
                  '-webkit-box-' +
                  P.replace('-grow', '') +
                  '-webkit-' +
                  P +
                  '-ms-' +
                  P.replace('grow', 'positive') +
                  P
                );
              case 115:
                return (
                  '-webkit-' + P + '-ms-' + P.replace('shrink', 'negative') + P
                );
              case 98:
                return (
                  '-webkit-' +
                  P +
                  '-ms-' +
                  P.replace('basis', 'preferred-size') +
                  P
                );
            }
          return '-webkit-' + P + '-ms-' + P + P;
        case 964:
          return '-webkit-' + P + '-ms-flex-' + P + P;
        case 1023:
          if (P.charCodeAt(8) !== 99) break;
          return (
            (Q = P.substring(P.indexOf(':', 15))
              .replace('flex-', '')
              .replace('space-between', 'justify')),
            '-webkit-box-pack' + Q + '-webkit-' + P + '-ms-flex-pack' + Q + P
          );
        case 1005:
          return _.test(P)
            ? P.replace(h, ':-webkit-') + P.replace(h, ':-moz-') + P
            : P;
        case 1e3:
          switch (
            ((Q = P.substring(13).trim()),
            (K = Q.indexOf('-') + 1),
            Q.charCodeAt(0) + Q.charCodeAt(K))
          ) {
            case 226:
              Q = P.replace(A, 'tb');
              break;
            case 232:
              Q = P.replace(A, 'tb-rl');
              break;
            case 220:
              Q = P.replace(A, 'lr');
              break;
            default:
              return P;
          }
          return '-webkit-' + P + '-ms-' + Q + P;
        case 1017:
          if (P.indexOf('sticky', 9) === -1) break;
        case 975:
          switch (
            ((K = (P = T).length - 10),
            (Q = (P.charCodeAt(K) === 33 ? P.substring(0, K) : P)
              .substring(T.indexOf(':', 7) + 1)
              .trim()),
            (vt = Q.charCodeAt(0) + (Q.charCodeAt(7) | 0)))
          ) {
            case 203:
              if (111 > Q.charCodeAt(8)) break;
            case 115:
              P = P.replace(Q, '-webkit-' + Q) + ';' + P;
              break;
            case 207:
            case 102:
              P =
                P.replace(Q, '-webkit-' + (102 < vt ? 'inline-' : '') + 'box') +
                ';' +
                P.replace(Q, '-webkit-' + Q) +
                ';' +
                P.replace(Q, '-ms-' + Q + 'box') +
                ';' +
                P;
          }
          return P + ';';
        case 938:
          if (P.charCodeAt(5) === 45)
            switch (P.charCodeAt(6)) {
              case 105:
                return (
                  (Q = P.replace('-items', '')),
                  '-webkit-' + P + '-webkit-box-' + Q + '-ms-flex-' + Q + P
                );
              case 115:
                return (
                  '-webkit-' + P + '-ms-flex-item-' + P.replace(it, '') + P
                );
              default:
                return (
                  '-webkit-' +
                  P +
                  '-ms-flex-line-pack' +
                  P.replace('align-content', '').replace(it, '') +
                  P
                );
            }
          break;
        case 973:
        case 989:
          if (P.charCodeAt(3) !== 45 || P.charCodeAt(4) === 122) break;
        case 931:
        case 953:
          if (at.test(T) === !0)
            return (Q = T.substring(T.indexOf(':') + 1)).charCodeAt(0) === 115
              ? o(T.replace('stretch', 'fill-available'), K, H, $).replace(
                  ':fill-available',
                  ':stretch'
                )
              : P.replace(Q, '-webkit-' + Q) +
                  P.replace(Q, '-moz-' + Q.replace('fill-', '')) +
                  P;
          break;
        case 962:
          if (
            ((P =
              '-webkit-' + P + (P.charCodeAt(5) === 102 ? '-ms-' + P : '') + P),
            H + $ === 211 &&
              P.charCodeAt(13) === 105 &&
              0 < P.indexOf('transform', 10))
          )
            return (
              P.substring(0, P.indexOf(';', 27) + 1).replace(
                d,
                '$1-webkit-$2'
              ) + P
            );
      }
      return P;
    }
    function i(T, K) {
      var H = T.indexOf(K === 1 ? ':' : '{'),
        $ = T.substring(0, K !== 3 ? H : 10);
      return (
        (H = T.substring(H + 1, T.length - 1)),
        nt(K !== 2 ? $ : $.replace(j, '$1'), H, K)
      );
    }
    function a(T, K) {
      var H = o(K, K.charCodeAt(0), K.charCodeAt(1), K.charCodeAt(2));
      return H !== K + ';'
        ? H.replace(W, ' or ($1)').substring(4)
        : '(' + K + ')';
    }
    function s(T, K, H, $, P, vt, Q, dt, yt, ft) {
      for (var et = 0, xt = K, u; et < st; ++et)
        switch ((u = Y[et].call(c, T, xt, H, $, P, vt, Q, dt, yt, ft))) {
          case void 0:
          case !1:
          case !0:
          case null:
            break;
          default:
            xt = u;
        }
      if (xt !== K) return xt;
    }
    function l(T) {
      switch (T) {
        case void 0:
        case null:
          st = Y.length = 0;
          break;
        default:
          if (typeof T == 'function') Y[st++] = T;
          else if (typeof T == 'object')
            for (var K = 0, H = T.length; K < H; ++K) l(T[K]);
          else mt = !!T | 0;
      }
      return l;
    }
    function g(T) {
      return (
        (T = T.prefix),
        T !== void 0 &&
          ((nt = null),
          T
            ? typeof T != 'function'
              ? (M = 1)
              : ((M = 2), (nt = T))
            : (M = 0)),
        g
      );
    }
    function c(T, K) {
      var H = T;
      if (
        (33 > H.charCodeAt(0) && (H = H.trim()), (B = H), (H = [B]), 0 < st)
      ) {
        var $ = s(-1, K, H, H, V, L, 0, 0, 0, 0);
        $ !== void 0 && typeof $ == 'string' && (K = $);
      }
      var P = n(gt, H, K, 0, 0);
      return (
        0 < st &&
          (($ = s(-2, P, H, H, V, L, P.length, 0, 0, 0)),
          $ !== void 0 && (P = $)),
        (B = ''),
        (f = 0),
        (L = V = 1),
        P
      );
    }
    var w = /^\0+/g,
      b = /[\0\r\f]/g,
      h = /: */g,
      _ = /zoo|gra/,
      d = /([,: ])(transform)/g,
      v = /,\r+?/g,
      m = /([\t\r\n ])*\f?&/g,
      k = /@(k\w+)\s*(\S*)\s*/,
      E = /::(place)/g,
      I = /:(read-only)/g,
      A = /[svh]\w+-[tblr]{2}/,
      U = /\(\s*(.*)\s*\)/g,
      W = /([\s\S]*?);/g,
      it = /-self|flex-/g,
      j = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      at = /stretch|:\s*\w+\-(?:conte|avail)/,
      lt = /([^-])(image-set\()/,
      L = 1,
      V = 1,
      f = 0,
      M = 1,
      gt = [],
      Y = [],
      st = 0,
      nt = null,
      mt = 0,
      B = '';
    return (c.use = l), (c.set = g), e !== void 0 && g(e), c;
  }
  var Za = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1,
  };
  function Ya(e) {
    var n = Object.create(null);
    return function (t) {
      return n[t] === void 0 && (n[t] = e(t)), n[t];
    };
  }
  var Ga =
      /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
    Ai = Ya(function (e) {
      return (
        Ga.test(e) ||
        (e.charCodeAt(0) === 111 &&
          e.charCodeAt(1) === 110 &&
          e.charCodeAt(2) < 91)
      );
    }),
    Kn = Me.exports,
    Xa = {
      childContextTypes: !0,
      contextType: !0,
      contextTypes: !0,
      defaultProps: !0,
      displayName: !0,
      getDefaultProps: !0,
      getDerivedStateFromError: !0,
      getDerivedStateFromProps: !0,
      mixins: !0,
      propTypes: !0,
      type: !0,
    },
    qa = {
      name: !0,
      length: !0,
      prototype: !0,
      caller: !0,
      callee: !0,
      arguments: !0,
      arity: !0,
    },
    Ka = {
      $$typeof: !0,
      render: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0,
    },
    Ei = {
      $$typeof: !0,
      compare: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0,
      type: !0,
    },
    Jn = {};
  (Jn[Kn.ForwardRef] = Ka), (Jn[Kn.Memo] = Ei);
  function Li(e) {
    return Kn.isMemo(e) ? Ei : Jn[e.$$typeof] || Xa;
  }
  var Ja = Object.defineProperty,
    Qa = Object.getOwnPropertyNames,
    Ti = Object.getOwnPropertySymbols,
    ts = Object.getOwnPropertyDescriptor,
    es = Object.getPrototypeOf,
    Ii = Object.prototype;
  function Ri(e, n, t) {
    if (typeof n != 'string') {
      if (Ii) {
        var r = es(n);
        r && r !== Ii && Ri(e, r, t);
      }
      var o = Qa(n);
      Ti && (o = o.concat(Ti(n)));
      for (var i = Li(e), a = Li(n), s = 0; s < o.length; ++s) {
        var l = o[s];
        if (!qa[l] && !(t && t[l]) && !(a && a[l]) && !(i && i[l])) {
          var g = ts(n, l);
          try {
            Ja(e, l, g);
          } catch {}
        }
      }
    }
    return e;
  }
  var ns = Ri;
  function Kt() {
    return (Kt =
      Object.assign ||
      function (e) {
        for (var n = 1; n < arguments.length; n++) {
          var t = arguments[n];
          for (var r in t)
            Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }
        return e;
      }).apply(this, arguments);
  }
  var Oi = function (e, n) {
      for (var t = [e[0]], r = 0, o = n.length; r < o; r += 1)
        t.push(n[r], e[r + 1]);
      return t;
    },
    Qn = function (e) {
      return (
        e !== null &&
        typeof e == 'object' &&
        (e.toString ? e.toString() : Object.prototype.toString.call(e)) ===
          '[object Object]' &&
        !Me.exports.typeOf(e)
      );
    },
    fn = Object.freeze([]),
    de = Object.freeze({});
  function xe(e) {
    return typeof e == 'function';
  }
  function tr(e) {
    return (
      ({}.NODE_ENV !== 'production' && typeof e == 'string' && e) ||
      e.displayName ||
      e.name ||
      'Component'
    );
  }
  function er(e) {
    return e && typeof e.styledComponentId == 'string';
  }
  var Se =
      (typeof process < 'u' && ({}.REACT_APP_SC_ATTR || {}.SC_ATTR)) ||
      'data-styled',
    nr = typeof window < 'u' && 'HTMLElement' in window,
    rs = Boolean(
      typeof SC_DISABLE_SPEEDY == 'boolean'
        ? SC_DISABLE_SPEEDY
        : typeof process < 'u' &&
          {}.REACT_APP_SC_DISABLE_SPEEDY !== void 0 &&
          {}.REACT_APP_SC_DISABLE_SPEEDY !== ''
        ? {}.REACT_APP_SC_DISABLE_SPEEDY !== 'false' &&
          {}.REACT_APP_SC_DISABLE_SPEEDY
        : typeof process < 'u' &&
          {}.SC_DISABLE_SPEEDY !== void 0 &&
          {}.SC_DISABLE_SPEEDY !== ''
        ? {}.SC_DISABLE_SPEEDY !== 'false' && {}.SC_DISABLE_SPEEDY
        : {}.NODE_ENV !== 'production'
    ),
    is =
      {}.NODE_ENV !== 'production'
        ? {
            1: `Cannot create styled-component for component: %s.

`,
            2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`,
            3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`,
            4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`,
            5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`,
            6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`,
            7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
            8: `ThemeProvider: Please make your "theme" prop an object.

`,
            9: 'Missing document `<head>`\n\n',
            10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`,
            11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`,
            12: 'It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n',
            13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`,
            14: `ThemeProvider: "theme" prop is required.

`,
            15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
            16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`,
            17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`,
          }
        : {};
  function os() {
    for (
      var e = arguments.length <= 0 ? void 0 : arguments[0],
        n = [],
        t = 1,
        r = arguments.length;
      t < r;
      t += 1
    )
      n.push(t < 0 || arguments.length <= t ? void 0 : arguments[t]);
    return (
      n.forEach(function (o) {
        e = e.replace(/%[a-z]/, o);
      }),
      e
    );
  }
  function ie(e) {
    for (
      var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1;
      r < n;
      r++
    )
      t[r - 1] = arguments[r];
    throw {}.NODE_ENV === 'production'
      ? new Error(
          'An error occurred. See https://git.io/JUIaE#' +
            e +
            ' for more information.' +
            (t.length > 0 ? ' Args: ' + t.join(', ') : '')
        )
      : new Error(os.apply(void 0, [is[e]].concat(t)).trim());
  }
  var as = (function () {
      function e(t) {
        (this.groupSizes = new Uint32Array(512)),
          (this.length = 512),
          (this.tag = t);
      }
      var n = e.prototype;
      return (
        (n.indexOfGroup = function (t) {
          for (var r = 0, o = 0; o < t; o++) r += this.groupSizes[o];
          return r;
        }),
        (n.insertRules = function (t, r) {
          if (t >= this.groupSizes.length) {
            for (var o = this.groupSizes, i = o.length, a = i; t >= a; )
              (a <<= 1) < 0 && ie(16, '' + t);
            (this.groupSizes = new Uint32Array(a)),
              this.groupSizes.set(o),
              (this.length = a);
            for (var s = i; s < a; s++) this.groupSizes[s] = 0;
          }
          for (
            var l = this.indexOfGroup(t + 1), g = 0, c = r.length;
            g < c;
            g++
          )
            this.tag.insertRule(l, r[g]) && (this.groupSizes[t]++, l++);
        }),
        (n.clearGroup = function (t) {
          if (t < this.length) {
            var r = this.groupSizes[t],
              o = this.indexOfGroup(t),
              i = o + r;
            this.groupSizes[t] = 0;
            for (var a = o; a < i; a++) this.tag.deleteRule(o);
          }
        }),
        (n.getGroup = function (t) {
          var r = '';
          if (t >= this.length || this.groupSizes[t] === 0) return r;
          for (
            var o = this.groupSizes[t],
              i = this.indexOfGroup(t),
              a = i + o,
              s = i;
            s < a;
            s++
          )
            r +=
              this.tag.getRule(s) +
              `/*!sc*/
`;
          return r;
        }),
        e
      );
    })(),
    dn = new Map(),
    pn = new Map(),
    Ve = 1,
    mn = function (e) {
      if (dn.has(e)) return dn.get(e);
      for (; pn.has(Ve); ) Ve++;
      var n = Ve++;
      return (
        {}.NODE_ENV !== 'production' &&
          ((0 | n) < 0 || n > 1 << 30) &&
          ie(16, '' + n),
        dn.set(e, n),
        pn.set(n, e),
        n
      );
    },
    ss = function (e) {
      return pn.get(e);
    },
    us = function (e, n) {
      n >= Ve && (Ve = n + 1), dn.set(e, n), pn.set(n, e);
    },
    ls = 'style[' + Se + '][data-styled-version="5.3.5"]',
    cs = new RegExp('^' + Se + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
    hs = function (e, n, t) {
      for (var r, o = t.split(','), i = 0, a = o.length; i < a; i++)
        (r = o[i]) && e.registerName(n, r);
    },
    fs = function (e, n) {
      for (
        var t = (n.textContent || '').split(`/*!sc*/
`),
          r = [],
          o = 0,
          i = t.length;
        o < i;
        o++
      ) {
        var a = t[o].trim();
        if (a) {
          var s = a.match(cs);
          if (s) {
            var l = 0 | parseInt(s[1], 10),
              g = s[2];
            l !== 0 && (us(g, l), hs(e, g, s[3]), e.getTag().insertRules(l, r)),
              (r.length = 0);
          } else r.push(a);
        }
      }
    },
    ds = function () {
      return typeof window < 'u' && window.__webpack_nonce__ !== void 0
        ? window.__webpack_nonce__
        : null;
    },
    Di = function (e) {
      var n = document.head,
        t = e || n,
        r = document.createElement('style'),
        o = (function (s) {
          for (var l = s.childNodes, g = l.length; g >= 0; g--) {
            var c = l[g];
            if (c && c.nodeType === 1 && c.hasAttribute(Se)) return c;
          }
        })(t),
        i = o !== void 0 ? o.nextSibling : null;
      r.setAttribute(Se, 'active'),
        r.setAttribute('data-styled-version', '5.3.5');
      var a = ds();
      return a && r.setAttribute('nonce', a), t.insertBefore(r, i), r;
    },
    ps = (function () {
      function e(t) {
        var r = (this.element = Di(t));
        r.appendChild(document.createTextNode('')),
          (this.sheet = (function (o) {
            if (o.sheet) return o.sheet;
            for (
              var i = document.styleSheets, a = 0, s = i.length;
              a < s;
              a++
            ) {
              var l = i[a];
              if (l.ownerNode === o) return l;
            }
            ie(17);
          })(r)),
          (this.length = 0);
      }
      var n = e.prototype;
      return (
        (n.insertRule = function (t, r) {
          try {
            return this.sheet.insertRule(r, t), this.length++, !0;
          } catch {
            return !1;
          }
        }),
        (n.deleteRule = function (t) {
          this.sheet.deleteRule(t), this.length--;
        }),
        (n.getRule = function (t) {
          var r = this.sheet.cssRules[t];
          return r !== void 0 && typeof r.cssText == 'string' ? r.cssText : '';
        }),
        e
      );
    })(),
    ms = (function () {
      function e(t) {
        var r = (this.element = Di(t));
        (this.nodes = r.childNodes), (this.length = 0);
      }
      var n = e.prototype;
      return (
        (n.insertRule = function (t, r) {
          if (t <= this.length && t >= 0) {
            var o = document.createTextNode(r),
              i = this.nodes[t];
            return this.element.insertBefore(o, i || null), this.length++, !0;
          }
          return !1;
        }),
        (n.deleteRule = function (t) {
          this.element.removeChild(this.nodes[t]), this.length--;
        }),
        (n.getRule = function (t) {
          return t < this.length ? this.nodes[t].textContent : '';
        }),
        e
      );
    })(),
    gs = (function () {
      function e(t) {
        (this.rules = []), (this.length = 0);
      }
      var n = e.prototype;
      return (
        (n.insertRule = function (t, r) {
          return (
            t <= this.length && (this.rules.splice(t, 0, r), this.length++, !0)
          );
        }),
        (n.deleteRule = function (t) {
          this.rules.splice(t, 1), this.length--;
        }),
        (n.getRule = function (t) {
          return t < this.length ? this.rules[t] : '';
        }),
        e
      );
    })(),
    Pi = nr,
    _s = { isServer: !nr, useCSSOMInjection: !rs },
    zi = (function () {
      function e(t, r, o) {
        t === void 0 && (t = de),
          r === void 0 && (r = {}),
          (this.options = Kt({}, _s, {}, t)),
          (this.gs = r),
          (this.names = new Map(o)),
          (this.server = !!t.isServer),
          !this.server &&
            nr &&
            Pi &&
            ((Pi = !1),
            (function (i) {
              for (
                var a = document.querySelectorAll(ls), s = 0, l = a.length;
                s < l;
                s++
              ) {
                var g = a[s];
                g &&
                  g.getAttribute(Se) !== 'active' &&
                  (fs(i, g), g.parentNode && g.parentNode.removeChild(g));
              }
            })(this));
      }
      e.registerId = function (t) {
        return mn(t);
      };
      var n = e.prototype;
      return (
        (n.reconstructWithOptions = function (t, r) {
          return (
            r === void 0 && (r = !0),
            new e(
              Kt({}, this.options, {}, t),
              this.gs,
              (r && this.names) || void 0
            )
          );
        }),
        (n.allocateGSInstance = function (t) {
          return (this.gs[t] = (this.gs[t] || 0) + 1);
        }),
        (n.getTag = function () {
          return (
            this.tag ||
            (this.tag =
              ((o = (r = this.options).isServer),
              (i = r.useCSSOMInjection),
              (a = r.target),
              (t = o ? new gs(a) : i ? new ps(a) : new ms(a)),
              new as(t)))
          );
          var t, r, o, i, a;
        }),
        (n.hasNameForId = function (t, r) {
          return this.names.has(t) && this.names.get(t).has(r);
        }),
        (n.registerName = function (t, r) {
          if ((mn(t), this.names.has(t))) this.names.get(t).add(r);
          else {
            var o = new Set();
            o.add(r), this.names.set(t, o);
          }
        }),
        (n.insertRules = function (t, r, o) {
          this.registerName(t, r), this.getTag().insertRules(mn(t), o);
        }),
        (n.clearNames = function (t) {
          this.names.has(t) && this.names.get(t).clear();
        }),
        (n.clearRules = function (t) {
          this.getTag().clearGroup(mn(t)), this.clearNames(t);
        }),
        (n.clearTag = function () {
          this.tag = void 0;
        }),
        (n.toString = function () {
          return (function (t) {
            for (var r = t.getTag(), o = r.length, i = '', a = 0; a < o; a++) {
              var s = ss(a);
              if (s !== void 0) {
                var l = t.names.get(s),
                  g = r.getGroup(a);
                if (l && g && l.size) {
                  var c = Se + '.g' + a + '[id="' + s + '"]',
                    w = '';
                  l !== void 0 &&
                    l.forEach(function (b) {
                      b.length > 0 && (w += b + ',');
                    }),
                    (i +=
                      '' +
                      g +
                      c +
                      '{content:"' +
                      w +
                      `"}/*!sc*/
`);
                }
              }
            }
            return i;
          })(this);
        }),
        e
      );
    })(),
    vs = /(a)(d)/gi,
    Ni = function (e) {
      return String.fromCharCode(e + (e > 25 ? 39 : 97));
    };
  function rr(e) {
    var n,
      t = '';
    for (n = Math.abs(e); n > 52; n = (n / 52) | 0) t = Ni(n % 52) + t;
    return (Ni(n % 52) + t).replace(vs, '$1-$2');
  }
  var ve = function (e, n) {
      for (var t = n.length; t; ) e = (33 * e) ^ n.charCodeAt(--t);
      return e;
    },
    Mi = function (e) {
      return ve(5381, e);
    };
  function ys(e) {
    for (var n = 0; n < e.length; n += 1) {
      var t = e[n];
      if (xe(t) && !er(t)) return !1;
    }
    return !0;
  }
  var ws = Mi('5.3.5'),
    bs = (function () {
      function e(n, t, r) {
        (this.rules = n),
          (this.staticRulesId = ''),
          (this.isStatic =
            {}.NODE_ENV === 'production' &&
            (r === void 0 || r.isStatic) &&
            ys(n)),
          (this.componentId = t),
          (this.baseHash = ve(ws, t)),
          (this.baseStyle = r),
          zi.registerId(t);
      }
      return (
        (e.prototype.generateAndInjectStyles = function (n, t, r) {
          var o = this.componentId,
            i = [];
          if (
            (this.baseStyle &&
              i.push(this.baseStyle.generateAndInjectStyles(n, t, r)),
            this.isStatic && !r.hash)
          )
            if (this.staticRulesId && t.hasNameForId(o, this.staticRulesId))
              i.push(this.staticRulesId);
            else {
              var a = Ae(this.rules, n, t, r).join(''),
                s = rr(ve(this.baseHash, a) >>> 0);
              if (!t.hasNameForId(o, s)) {
                var l = r(a, '.' + s, void 0, o);
                t.insertRules(o, s, l);
              }
              i.push(s), (this.staticRulesId = s);
            }
          else {
            for (
              var g = this.rules.length,
                c = ve(this.baseHash, r.hash),
                w = '',
                b = 0;
              b < g;
              b++
            ) {
              var h = this.rules[b];
              if (typeof h == 'string')
                (w += h), {}.NODE_ENV !== 'production' && (c = ve(c, h + b));
              else if (h) {
                var _ = Ae(h, n, t, r),
                  d = Array.isArray(_) ? _.join('') : _;
                (c = ve(c, d + b)), (w += d);
              }
            }
            if (w) {
              var v = rr(c >>> 0);
              if (!t.hasNameForId(o, v)) {
                var m = r(w, '.' + v, void 0, o);
                t.insertRules(o, v, m);
              }
              i.push(v);
            }
          }
          return i.join(' ');
        }),
        e
      );
    })(),
    Cs = /^\s*\/\/.*$/gm,
    ks = [':', '[', '.', '#'];
  function xs(e) {
    var n,
      t,
      r,
      o,
      i = e === void 0 ? de : e,
      a = i.options,
      s = a === void 0 ? de : a,
      l = i.plugins,
      g = l === void 0 ? fn : l,
      c = new Ha(s),
      w = [],
      b = (function (d) {
        function v(m) {
          if (m)
            try {
              d(m + '}');
            } catch {}
        }
        return function (m, k, E, I, A, U, W, it, j, at) {
          switch (m) {
            case 1:
              if (j === 0 && k.charCodeAt(0) === 64) return d(k + ';'), '';
              break;
            case 2:
              if (it === 0) return k + '/*|*/';
              break;
            case 3:
              switch (it) {
                case 102:
                case 112:
                  return d(E[0] + k), '';
                default:
                  return k + (at === 0 ? '/*|*/' : '');
              }
            case -2:
              k.split('/*|*/}').forEach(v);
          }
        };
      })(function (d) {
        w.push(d);
      }),
      h = function (d, v, m) {
        return (v === 0 && ks.indexOf(m[t.length]) !== -1) || m.match(o)
          ? d
          : '.' + n;
      };
    function _(d, v, m, k) {
      k === void 0 && (k = '&');
      var E = d.replace(Cs, ''),
        I = v && m ? m + ' ' + v + ' { ' + E + ' }' : E;
      return (
        (n = k),
        (t = v),
        (r = new RegExp('\\' + t + '\\b', 'g')),
        (o = new RegExp('(\\' + t + '\\b){2,}')),
        c(m || !v ? '' : v, I)
      );
    }
    return (
      c.use(
        [].concat(g, [
          function (d, v, m) {
            d === 2 &&
              m.length &&
              m[0].lastIndexOf(t) > 0 &&
              (m[0] = m[0].replace(r, h));
          },
          b,
          function (d) {
            if (d === -2) {
              var v = w;
              return (w = []), v;
            }
          },
        ])
      ),
      (_.hash = g.length
        ? g
            .reduce(function (d, v) {
              return v.name || ie(15), ve(d, v.name);
            }, 5381)
            .toString()
        : ''),
      _
    );
  }
  var Fi = Be.createContext();
  Fi.Consumer;
  var Bi = Be.createContext(),
    Ss = (Bi.Consumer, new zi()),
    ir = xs();
  function As() {
    return fe(Fi) || Ss;
  }
  function Es() {
    return fe(Bi) || ir;
  }
  var Ls = (function () {
      function e(n, t) {
        var r = this;
        (this.inject = function (o, i) {
          i === void 0 && (i = ir);
          var a = r.name + i.hash;
          o.hasNameForId(r.id, a) ||
            o.insertRules(r.id, a, i(r.rules, a, '@keyframes'));
        }),
          (this.toString = function () {
            return ie(12, String(r.name));
          }),
          (this.name = n),
          (this.id = 'sc-keyframes-' + n),
          (this.rules = t);
      }
      return (
        (e.prototype.getName = function (n) {
          return n === void 0 && (n = ir), this.name + n.hash;
        }),
        e
      );
    })(),
    Ts = /([A-Z])/,
    Is = /([A-Z])/g,
    Rs = /^ms-/,
    Os = function (e) {
      return '-' + e.toLowerCase();
    };
  function Vi(e) {
    return Ts.test(e) ? e.replace(Is, Os).replace(Rs, '-ms-') : e;
  }
  var ji = function (e) {
    return e == null || e === !1 || e === '';
  };
  function Ae(e, n, t, r) {
    if (Array.isArray(e)) {
      for (var o, i = [], a = 0, s = e.length; a < s; a += 1)
        (o = Ae(e[a], n, t, r)) !== '' &&
          (Array.isArray(o) ? i.push.apply(i, o) : i.push(o));
      return i;
    }
    if (ji(e)) return '';
    if (er(e)) return '.' + e.styledComponentId;
    if (xe(e)) {
      if (
        typeof (g = e) != 'function' ||
        (g.prototype && g.prototype.isReactComponent) ||
        !n
      )
        return e;
      var l = e(n);
      return (
        {}.NODE_ENV !== 'production' &&
          Me.exports.isElement(l) &&
          console.warn(
            tr(e) +
              ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.'
          ),
        Ae(l, n, t, r)
      );
    }
    var g;
    return e instanceof Ls
      ? t
        ? (e.inject(t, r), e.getName(r))
        : e
      : Qn(e)
      ? (function c(w, b) {
          var h,
            _,
            d = [];
          for (var v in w)
            w.hasOwnProperty(v) &&
              !ji(w[v]) &&
              ((Array.isArray(w[v]) && w[v].isCss) || xe(w[v])
                ? d.push(Vi(v) + ':', w[v], ';')
                : Qn(w[v])
                ? d.push.apply(d, c(w[v], v))
                : d.push(
                    Vi(v) +
                      ': ' +
                      ((h = v),
                      (_ = w[v]) == null || typeof _ == 'boolean' || _ === ''
                        ? ''
                        : typeof _ != 'number' || _ === 0 || h in Za
                        ? String(_).trim()
                        : _ + 'px') +
                      ';'
                  ));
          return b ? [b + ' {'].concat(d, ['}']) : d;
        })(e)
      : e.toString();
  }
  var $i = function (e) {
    return Array.isArray(e) && (e.isCss = !0), e;
  };
  function Ds(e) {
    for (
      var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1;
      r < n;
      r++
    )
      t[r - 1] = arguments[r];
    return xe(e) || Qn(e)
      ? $i(Ae(Oi(fn, [e].concat(t))))
      : t.length === 0 && e.length === 1 && typeof e[0] == 'string'
      ? e
      : $i(Ae(Oi(e, t)));
  }
  var Ui = /invalid hook call/i,
    gn = new Set(),
    Ps = function (e, n) {
      if ({}.NODE_ENV !== 'production') {
        var t =
            'The component ' +
            e +
            (n ? ' with the id of "' + n + '"' : '') +
            ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`,
          r = console.error;
        try {
          var o = !0;
          (console.error = function (i) {
            if (Ui.test(i)) (o = !1), gn.delete(t);
            else {
              for (
                var a = arguments.length,
                  s = new Array(a > 1 ? a - 1 : 0),
                  l = 1;
                l < a;
                l++
              )
                s[l - 1] = arguments[l];
              r.apply(void 0, [i].concat(s));
            }
          }),
            _e(),
            o && !gn.has(t) && (console.warn(t), gn.add(t));
        } catch (i) {
          Ui.test(i.message) && gn.delete(t);
        } finally {
          console.error = r;
        }
      }
    },
    zs = function (e, n, t) {
      return (
        t === void 0 && (t = de),
        (e.theme !== t.theme && e.theme) || n || t.theme
      );
    },
    Ns = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
    Ms = /(^-|-$)/g;
  function or(e) {
    return e.replace(Ns, '-').replace(Ms, '');
  }
  var Fs = function (e) {
    return rr(Mi(e) >>> 0);
  };
  function _n(e) {
    return (
      typeof e == 'string' &&
      ({}.NODE_ENV === 'production' ||
        e.charAt(0) === e.charAt(0).toLowerCase())
    );
  }
  var ar = function (e) {
      return (
        typeof e == 'function' ||
        (typeof e == 'object' && e !== null && !Array.isArray(e))
      );
    },
    Bs = function (e) {
      return e !== '__proto__' && e !== 'constructor' && e !== 'prototype';
    };
  function Vs(e, n, t) {
    var r = e[t];
    ar(n) && ar(r) ? Wi(r, n) : (e[t] = n);
  }
  function Wi(e) {
    for (
      var n = arguments.length, t = new Array(n > 1 ? n - 1 : 0), r = 1;
      r < n;
      r++
    )
      t[r - 1] = arguments[r];
    for (var o = 0, i = t; o < i.length; o++) {
      var a = i[o];
      if (ar(a)) for (var s in a) Bs(s) && Vs(e, a[s], s);
    }
    return e;
  }
  var je = Be.createContext();
  je.Consumer;
  function js(e) {
    var n = fe(je),
      t = De(
        function () {
          return (function (r, o) {
            if (!r) return ie(14);
            if (xe(r)) {
              var i = r(o);
              return {}.NODE_ENV === 'production' ||
                (i !== null && !Array.isArray(i) && typeof i == 'object')
                ? i
                : ie(7);
            }
            return Array.isArray(r) || typeof r != 'object'
              ? ie(8)
              : o
              ? Kt({}, o, {}, r)
              : r;
          })(e.theme, n);
        },
        [e.theme, n]
      );
    return e.children
      ? Be.createElement(je.Provider, { value: t }, e.children)
      : null;
  }
  var sr = {};
  function Hi(e, n, t) {
    var r = er(e),
      o = !_n(e),
      i = n.attrs,
      a = i === void 0 ? fn : i,
      s = n.componentId,
      l =
        s === void 0
          ? (function (k, E) {
              var I = typeof k != 'string' ? 'sc' : or(k);
              sr[I] = (sr[I] || 0) + 1;
              var A = I + '-' + Fs('5.3.5' + I + sr[I]);
              return E ? E + '-' + A : A;
            })(n.displayName, n.parentComponentId)
          : s,
      g = n.displayName,
      c =
        g === void 0
          ? (function (k) {
              return _n(k) ? 'styled.' + k : 'Styled(' + tr(k) + ')';
            })(e)
          : g,
      w =
        n.displayName && n.componentId
          ? or(n.displayName) + '-' + n.componentId
          : n.componentId || l,
      b = r && e.attrs ? Array.prototype.concat(e.attrs, a).filter(Boolean) : a,
      h = n.shouldForwardProp;
    r &&
      e.shouldForwardProp &&
      (h = n.shouldForwardProp
        ? function (k, E, I) {
            return e.shouldForwardProp(k, E, I) && n.shouldForwardProp(k, E, I);
          }
        : e.shouldForwardProp);
    var _,
      d = new bs(t, w, r ? e.componentStyle : void 0),
      v = d.isStatic && a.length === 0,
      m = function (k, E) {
        return (function (I, A, U, W) {
          var it = I.attrs,
            j = I.componentStyle,
            at = I.defaultProps,
            lt = I.foldedComponentIds,
            L = I.shouldForwardProp,
            V = I.styledComponentId,
            f = I.target;
          ({}.NODE_ENV !== 'production' && $n(V));
          var M = (function ($, P, vt) {
              $ === void 0 && ($ = de);
              var Q = Kt({}, P, { theme: $ }),
                dt = {};
              return (
                vt.forEach(function (yt) {
                  var ft,
                    et,
                    xt,
                    u = yt;
                  for (ft in (xe(u) && (u = u(Q)), u))
                    Q[ft] = dt[ft] =
                      ft === 'className'
                        ? ((et = dt[ft]),
                          (xt = u[ft]),
                          et && xt ? et + ' ' + xt : et || xt)
                        : u[ft];
                }),
                [Q, dt]
              );
            })(zs(A, fe(je), at) || de, A, it),
            gt = M[0],
            Y = M[1],
            st = (function ($, P, vt, Q) {
              var dt = As(),
                yt = Es(),
                ft = P
                  ? $.generateAndInjectStyles(de, dt, yt)
                  : $.generateAndInjectStyles(vt, dt, yt);
              return (
                {}.NODE_ENV !== 'production' && $n(ft),
                {}.NODE_ENV !== 'production' && !P && Q && Q(ft),
                ft
              );
            })(
              j,
              W,
              gt,
              {}.NODE_ENV !== 'production' ? I.warnTooManyClasses : void 0
            ),
            nt = U,
            mt = Y.$as || A.$as || Y.as || A.as || f,
            B = _n(mt),
            T = Y !== A ? Kt({}, A, {}, Y) : A,
            K = {};
          for (var H in T)
            H[0] !== '$' &&
              H !== 'as' &&
              (H === 'forwardedAs'
                ? (K.as = T[H])
                : (L ? L(H, Ai, mt) : !B || Ai(H)) && (K[H] = T[H]));
          return (
            A.style &&
              Y.style !== A.style &&
              (K.style = Kt({}, A.style, {}, Y.style)),
            (K.className = Array.prototype
              .concat(lt, V, st !== V ? st : null, A.className, Y.className)
              .filter(Boolean)
              .join(' ')),
            (K.ref = nt),
            Wt(mt, K)
          );
        })(_, k, E, v);
      };
    return (
      (m.displayName = c),
      ((_ = Be.forwardRef(m)).attrs = b),
      (_.componentStyle = d),
      (_.displayName = c),
      (_.shouldForwardProp = h),
      (_.foldedComponentIds = r
        ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId)
        : fn),
      (_.styledComponentId = w),
      (_.target = r ? e.target : e),
      (_.withComponent = function (k) {
        var E = n.componentId,
          I = (function (U, W) {
            if (U == null) return {};
            var it,
              j,
              at = {},
              lt = Object.keys(U);
            for (j = 0; j < lt.length; j++)
              (it = lt[j]), W.indexOf(it) >= 0 || (at[it] = U[it]);
            return at;
          })(n, ['componentId']),
          A = E && E + '-' + (_n(k) ? k : or(tr(k)));
        return Hi(k, Kt({}, I, { attrs: b, componentId: A }), t);
      }),
      Object.defineProperty(_, 'defaultProps', {
        get: function () {
          return this._foldedDefaultProps;
        },
        set: function (k) {
          this._foldedDefaultProps = r ? Wi({}, e.defaultProps, k) : k;
        },
      }),
      {}.NODE_ENV !== 'production' &&
        (Ps(c, w),
        (_.warnTooManyClasses = (function (k, E) {
          var I = {},
            A = !1;
          return function (U) {
            if (!A && ((I[U] = !0), Object.keys(I).length >= 200)) {
              var W = E ? ' with the id of "' + E + '"' : '';
              console.warn(
                'Over 200 classes were generated for component ' +
                  k +
                  W +
                  `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`
              ),
                (A = !0),
                (I = {});
            }
          };
        })(c, w))),
      (_.toString = function () {
        return '.' + _.styledComponentId;
      }),
      o &&
        ns(_, e, {
          attrs: !0,
          componentStyle: !0,
          displayName: !0,
          foldedComponentIds: !0,
          shouldForwardProp: !0,
          styledComponentId: !0,
          target: !0,
          withComponent: !0,
        }),
      _
    );
  }
  var ur = function (e) {
    return (function n(t, r, o) {
      if ((o === void 0 && (o = de), !Me.exports.isValidElementType(r)))
        return ie(1, String(r));
      var i = function () {
        return t(r, o, Ds.apply(void 0, arguments));
      };
      return (
        (i.withConfig = function (a) {
          return n(t, r, Kt({}, o, {}, a));
        }),
        (i.attrs = function (a) {
          return n(
            t,
            r,
            Kt({}, o, {
              attrs: Array.prototype.concat(o.attrs, a).filter(Boolean),
            })
          );
        }),
        i
      );
    })(Hi, e);
  };
  [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'marker',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'textPath',
    'tspan',
  ].forEach(function (e) {
    ur[e] = ur(e);
  });
  var $s = function () {
    return fe(je);
  };
  ({}.NODE_ENV !== 'production' &&
    typeof navigator < 'u' &&
    navigator.product === 'ReactNative' &&
    console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`),
    {}.NODE_ENV !== 'production' &&
      {}.NODE_ENV !== 'test' &&
      typeof window < 'u' &&
      ((window['__styled-components-init__'] =
        window['__styled-components-init__'] || 0),
      window['__styled-components-init__'] === 1 &&
        console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`),
      (window['__styled-components-init__'] += 1)));
  const Zt = ur,
    Us = ({ svgSize: e }) =>
      O('svg', {
        width: e,
        height: e,
        viewBox: '0 0 16 14',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: O('path', {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          d: 'M14.3062 13.5002H1.69384C0.932655 13.5002 0.450552 12.6837 0.818264 12.0172L7.12444 0.587236C7.5047 -0.101994 8.49533 -0.101996 8.87559 0.587234L15.1818 12.0172C15.5495 12.6837 15.0674 13.5002 14.3062 13.5002ZM8.00001 3.25025C8.41423 3.25025 8.75002 3.58604 8.75002 4.00025V8.50025C8.75002 8.91446 8.41423 9.25025 8.00001 9.25025C7.5858 9.25025 7.25001 8.91446 7.25001 8.50025V4.00025C7.25001 3.58604 7.5858 3.25025 8.00001 3.25025ZM8.75002 11.2502C8.75002 11.6645 8.41423 12.0002 8.00001 12.0002C7.5858 12.0002 7.25001 11.6645 7.25001 11.2502C7.25001 10.836 7.5858 10.5002 8.00001 10.5002C8.41423 10.5002 8.75002 10.836 8.75002 11.2502Z',
          fill: 'currentColor',
        }),
      }),
    Ws = Zt.div`
  color: ${(e) => e.theme.colors.instructionTextColor};
  animation: spin 2s linear infinite;

  @keyframes spin {
    100% {
      transform: rotate(-360deg);
    }
  }
`,
    Hs = ({ svgSize: e }) =>
      O(Ws, {
        children: O('svg', {
          width: e,
          height: e,
          viewBox: '0 0 48 48',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg',
          children: [
            O('path', {
              d: 'M30.9229 9.75026C30.9229 12.3736 28.7533 14.5002 26.0767 14.5002C23.4003 14.5002 21.2307 12.3736 21.2307 9.75026C21.2307 7.12664 23.4003 5 26.0767 5C28.7533 5 30.9229 7.12664 30.9229 9.75026Z',
              fill: 'currentColor',
            }),
            O('path', {
              d: 'M40.6155 15.8556C40.6155 18.1044 38.7559 19.9273 36.4618 19.9273C34.1675 19.9273 32.3079 18.1044 32.3079 15.8556C32.3079 13.607 34.1675 11.7842 36.4618 11.7842C38.7559 11.7842 40.6155 13.607 40.6155 15.8556Z',
              fill: 'currentColor',
            }),
            O('path', {
              d: 'M42 27.3921C42 29.2659 40.4502 30.785 38.5386 30.785C36.6267 30.785 35.0769 29.2659 35.0769 27.3921C35.0769 25.5181 36.6267 23.999 38.5386 23.999C40.4502 23.999 42 25.5181 42 27.3921Z',
              fill: 'currentColor',
            }),
            O('path', {
              d: 'M35.0766 37.5712C35.0766 39.0704 33.837 40.2858 32.3075 40.2858C30.7779 40.2858 29.5383 39.0704 29.5383 37.5712C29.5383 36.0723 30.7779 34.8569 32.3075 34.8569C33.837 34.8569 35.0766 36.0723 35.0766 37.5712Z',
              fill: 'currentColor',
            }),
            O('path', {
              d: 'M22.6154 40.2858C22.6154 41.7848 21.3756 43.0001 19.846 43.0001C18.3168 43.0001 17.0769 41.7848 17.0769 40.2858C17.0769 38.7866 18.3168 37.5713 19.846 37.5713C21.3756 37.5713 22.6154 38.7866 22.6154 40.2858Z',
              fill: 'currentColor',
            }),
            O('path', {
              d: 'M11.5382 32.8216C11.5382 33.9457 10.6085 34.8573 9.46137 34.8573C8.31426 34.8573 7.38452 33.9457 7.38452 32.8216C7.38452 31.6972 8.31426 30.7856 9.46137 30.7856C10.6085 30.7856 11.5382 31.6972 11.5382 32.8216Z',
              fill: 'currentColor',
            }),
            O('path', {
              d: 'M8.76913 21.2849C8.76913 22.0345 8.14932 22.642 7.38456 22.642C6.6198 22.642 6 22.0345 6 21.2849C6 20.5353 6.61981 19.9277 7.38456 19.9277C8.14933 19.9277 8.76913 20.5353 8.76913 21.2849Z',
              fill: 'currentColor',
            }),
            O('path', {
              d: 'M15.6927 11.7844C15.6927 12.534 15.0729 13.1415 14.3081 13.1415C13.5434 13.1415 12.9236 12.534 12.9236 11.7844C12.9236 11.0348 13.5434 10.4272 14.3081 10.4272C15.0729 10.4272 15.6927 11.0348 15.6927 11.7844Z',
              fill: 'currentColor',
            }),
          ],
        }),
      }),
    Zs = Zt.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  ${(e) =>
    !e.isCameraReady &&
    `
    height: inherit;
    aspect-ratio: 16/9;

    @media (orientation: portrait) and (max-width: 1199px) {
      aspect-ratio: 9/16;
    }
  `}
`,
    Ys = Zt.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${(e) => e.theme.colors.instructionTextColor};
`,
    Gs = Zt.p`
  background: ${(e) => e.theme.colors.instructionColor};
  border-radius: 0.25em;
  padding: 0.583em 0.666em;
  margin: 0.8em 0;
  font-size: ${(e) => `${e.fontSize}px`};
  font-family: Montserrat, Arial, sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 1em;
  max-width: 80%;
`,
    lr = ({ text: e, fontSize: n, currentAppState: t }) => {
      const { isCameraReady: r } = Zn();
      return O(Zs, {
        isCameraReady: r,
        children: O(Ys, {
          children: [
            (() => {
              switch (t) {
                case zt.LOADING:
                  return O(Hs, { svgSize: n * 2 });
                case zt.ERROR:
                  return O(Us, { svgSize: n * 2 });
                default:
                  return null;
              }
            })(),
            O(Gs, { fontSize: n, children: e }),
          ],
        }),
      });
    },
    Xs = Zt.div`
  position: relative;
`,
    qs = Zt.div`
  position: relative;
`,
    Ks = Zt.video`
  transform: ${(e) => (e.isImageMirror ? 'rotateY(180deg)' : 'none')};
  display: block;
  width: 100%;
`,
    Js = Zt.div`
  position: absolute;
  top: ${(e) => e.placeholderRect.shiftY * 100}%;
  bottom: ${(e) =>
    (1 - e.placeholderRect.shiftY - e.placeholderRect.height) * 100}%;
  left: ${(e) => e.placeholderRect.shiftX * 100}%;
  right: ${(e) =>
    (1 - e.placeholderRect.shiftX - e.placeholderRect.width) * 100}%;
  color: ${(e) =>
    e.isInCandidateSelection
      ? `${e.theme.colors.placeholderColorSuccess}`
      : `${e.theme.colors.placeholderColor}`};

  svg {
    width: 100%;
    height: 100%;
  }
`,
    Qs = Zt.div`
  position: absolute;
  top: 0;
  right: 0;
  padding: 24px;
  z-index: 2;
`,
    Zi = Zt.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  margin-right: ${(e) => (e.marginRight ? '24px' : '0')};

  &:disabled {
    cursor: not-allowed;
  }
`,
    tu = Zt.div`
  position: absolute;
  ${(e) => (e.cssTop ? `top: ${e.cssTop}%;` : '')}
  ${(e) => (e.cssBottom ? `bottom: ${e.cssBottom}%;` : '')}
  left: 50%;
  transform: translateX(-50%)
    translateY(
      ${(e) => (e.cssTop || e.isPortrait ? '-50%' : e.isPortrait ? '' : '50%')}
    );
  z-index: 2;
`;
  class Nt extends Error {
    constructor(t, r) {
      super(t);
      Bt(this, 'cause');
      (this.name = 'AutoCaptureError'), (this.cause = r);
    }
    static fromCameraError(t) {
      if (t instanceof Nt) return t;
      let r;
      switch (t.name) {
        case 'OverconstrainedError':
          r = 'Minimum quality requirements are not met by your camera';
          break;
        case 'NotReadableError':
        case 'AbortError':
          r = 'The webcam is already in use by another application';
          break;
        case 'NotAllowedError':
          r = 'To use your camera, you must allow permissions';
          break;
        case 'NotFoundError':
          r = 'There is no camera available to you';
          break;
        default:
          r = 'An unknown camera error has occurred';
          break;
      }
      return new Nt(r, t);
    }
  }
  class Yi extends Yt {
    constructor() {
      super(...arguments);
      Bt(this, 'state', { error: null });
    }
    static getDerivedStateFromError(t) {
      return { error: t };
    }
    componentDidCatch(t) {
      this.setState({ error: t });
      const r = new Nt('An unknown error has occurred');
      this.context.setError(r), this.props.triggerOnError(r);
    }
    render() {
      return this.state.error || this.context.error
        ? O(lr, {
            fontSize: this.props.fontSize,
            text: this.context.error.message,
            currentAppState: zt.ERROR,
          })
        : this.props.children;
    }
  }
  Yi.contextType = Hn;
  const eu = { width: 1920, height: 1080, facingMode: 'user' };
  class vn {
    constructor(n) {
      Bt(this, 'videoRef');
      Bt(this, 'mediaStream', null);
      Bt(this, 'videoTrack', null);
      this.videoRef = n;
    }
    static async getDeviceList() {
      let n = await navigator.mediaDevices.enumerateDevices();
      return (n = n.filter((t) => t.kind === 'videoinput')), n;
    }
    async initWebcam(n = {}) {
      const t = await this.getBestCamera(n.facingMode),
        r = this.getConstraints(n, t);
      await this.startWebcam(r), ia() && (await this.startWebcam(r));
    }
    async startWebcam(n = {}) {
      var t;
      return (
        this.stopCamera(),
        (this.mediaStream = await navigator.mediaDevices.getUserMedia(n)),
        (this.videoRef.srcObject = this.mediaStream),
        await this.videoRef.play(),
        (this.videoTrack =
          (t = this.mediaStream) == null ? void 0 : t.getVideoTracks()[0]),
        this.checkVideoTrackSettings(),
        this.videoTrack
      );
    }
    checkVideoTrackSettings() {
      var o;
      const n = (o = this.videoTrack) == null ? void 0 : o.getSettings();
      if (!(n != null && n.height) || !(n != null && n.width))
        throw new Nt('Could not init camera settings');
      const t = Math.min(
          n == null ? void 0 : n.width,
          n == null ? void 0 : n.height
        ),
        r = Math.max(
          n == null ? void 0 : n.width,
          n == null ? void 0 : n.height
        );
      if (t < ii.shorterSide || r < ii.longerSide)
        throw (
          (this.stopCamera(),
          new Nt(
            `Could not init video because of low camera resolution: ${n.width}x${n.height}.`
          ))
        );
    }
    async getBestCamera(n) {
      if (Gn() && n === 'environment')
        return (
          (this.mediaStream = await navigator.mediaDevices.getUserMedia({
            video: !0,
          })),
          this.stopCamera(),
          (await vn.getDeviceList()).find(
            (o) => o.label.includes('back') && o.label.includes('0')
          )
        );
    }
    getConstraints(n, t) {
      return {
        video: { ...eu, ...n, deviceId: t ? { exact: t.deviceId } : void 0 },
        audio: !1,
      };
    }
    takePhoto() {
      var o;
      const n = (o = this.videoTrack) == null ? void 0 : o.getSettings();
      if (!(n != null && n.width))
        throw new Nt('Cant take photo - video width is undefined');
      if (!(n != null && n.height))
        throw new Nt('Cant take photo - video height is undefined');
      const t = document.createElement('canvas');
      (t.width = n.width), (t.height = n.height);
      const r = t.getContext('2d');
      if (!r) throw new Nt('Cant take photo - cant create context');
      return r.drawImage(this.videoRef, 0, 0), t;
    }
    getCameraResolution() {
      var t;
      const n = (t = this.videoTrack) == null ? void 0 : t.getSettings();
      if (!(n != null && n.width)) throw new Nt('Video width is undefined');
      if (!(n != null && n.height)) throw new Nt('Video height is undefined');
      return { width: n.width, height: n.height };
    }
    getCameraSettings() {
      if (!this.videoTrack)
        throw Error('Video track must be initialized to get settings');
      return this.videoTrack.getSettings();
    }
    async getDeviceName() {
      if (!this.videoTrack)
        throw Error('Video track must be initialized to get device name');
      const n = this.videoTrack.getSettings(),
        r = (await navigator.mediaDevices.enumerateDevices()).find(
          (o) => o.deviceId === n.deviceId
        );
      return r == null ? void 0 : r.label;
    }
    async applyNewConstraints(n) {
      if (!this.videoTrack)
        throw Error('Video track must be initialized to set new constraints');
      await this.videoTrack.applyConstraints(n);
    }
    async switchCamera() {
      var s;
      if (!this.videoTrack)
        throw Error('Video track must be initialized to set new constraints');
      const n = this.videoTrack.getConstraints(),
        t = this.videoTrack.getSettings();
      let r = await navigator.mediaDevices.enumerateDevices();
      if (((r = r.filter((l) => l.kind === 'videoinput')), r.length <= 1))
        return;
      const o = r.findIndex((l) => l.deviceId === t.deviceId),
        i = (s = r[o + 1]) != null ? s : r[0],
        a = this.getConstraints(n, i);
      await this.startWebcam(a);
    }
    stopCamera() {
      if (!this.mediaStream) return;
      this.mediaStream.getTracks().forEach((t) => {
        t.stop();
      }),
        (this.videoRef.srcObject = null);
    }
    checkIfStreamIsRunning() {
      return !!this.videoRef.srcObject;
    }
  }
  function nu(e) {
    const [n, t] = Mt(!1);
    return (
      $t(() => {
        (async () => {
          (await vn.getDeviceList()).length > 1 && t(!0);
        })();
      }, [e]),
      n
    );
  }
  function ru(e) {
    const [n, t] = Mt(an);
    return (
      $t(() => {
        function r() {
          var a;
          const o =
              (a = e.current) == null ? void 0 : a.getBoundingClientRect(),
            i = sa(o);
          t(i);
        }
        return (
          r(),
          window.addEventListener('resize', r),
          () => {
            window.removeEventListener('resize', r);
          }
        );
      }, [e]),
      n
    );
  }
  function cr() {
    return (
      (cr = Object.assign
        ? Object.assign.bind()
        : function (e) {
            for (var n = 1; n < arguments.length; n++) {
              var t = arguments[n];
              for (var r in t)
                Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            }
            return e;
          }),
      cr.apply(this, arguments)
    );
  }
  function iu(e) {
    if (e === void 0)
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      );
    return e;
  }
  function $e(e, n) {
    return (
      ($e = Object.setPrototypeOf
        ? Object.setPrototypeOf.bind()
        : function (r, o) {
            return (r.__proto__ = o), r;
          }),
      $e(e, n)
    );
  }
  function ou(e, n) {
    (e.prototype = Object.create(n.prototype)),
      (e.prototype.constructor = e),
      $e(e, n);
  }
  function hr(e) {
    return (
      (hr = Object.setPrototypeOf
        ? Object.getPrototypeOf.bind()
        : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
          }),
      hr(e)
    );
  }
  function au(e) {
    return Function.toString.call(e).indexOf('[native code]') !== -1;
  }
  function su() {
    if (typeof Reflect > 'u' || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == 'function') return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {})
        ),
        !0
      );
    } catch {
      return !1;
    }
  }
  function yn(e, n, t) {
    return (
      su()
        ? (yn = Reflect.construct.bind())
        : (yn = function (o, i, a) {
            var s = [null];
            s.push.apply(s, i);
            var l = Function.bind.apply(o, s),
              g = new l();
            return a && $e(g, a.prototype), g;
          }),
      yn.apply(null, arguments)
    );
  }
  function fr(e) {
    var n = typeof Map == 'function' ? new Map() : void 0;
    return (
      (fr = function (r) {
        if (r === null || !au(r)) return r;
        if (typeof r != 'function')
          throw new TypeError(
            'Super expression must either be null or a function'
          );
        if (typeof n < 'u') {
          if (n.has(r)) return n.get(r);
          n.set(r, o);
        }
        function o() {
          return yn(r, arguments, hr(this).constructor);
        }
        return (
          (o.prototype = Object.create(r.prototype, {
            constructor: {
              value: o,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            },
          })),
          $e(o, r)
        );
      }),
      fr(e)
    );
  }
  var uu = {
    1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
    2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
    3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
    4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
    5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
    6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
    7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
    8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
    9: `Please provide a number of steps to the modularScale helper.

`,
    10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
    11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
    12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
    13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
    14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
    15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
    16: `You must provide a template to this method.

`,
    17: `You passed an unsupported selector state to this method.

`,
    18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
    19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
    20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
    21: 'expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n',
    22: 'expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n',
    23: `fontFace expects a name of a font-family.

`,
    24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
    25: `fontFace expects localFonts to be an array.

`,
    26: `fontFace expects fileFormats to be an array.

`,
    27: `radialGradient requries at least 2 color-stops to properly render.

`,
    28: `Please supply a filename to retinaImage() as the first argument.

`,
    29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
    30: 'Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n',
    31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
    32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
    33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
    34: `borderRadius expects a radius value as a string or number as the second argument.

`,
    35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
    36: `Property must be a string value.

`,
    37: `Syntax Error at %s.

`,
    38: `Formula contains a function that needs parentheses at %s.

`,
    39: `Formula is missing closing parenthesis at %s.

`,
    40: `Formula has too many closing parentheses at %s.

`,
    41: `All values in a formula must have the same unit or be unitless.

`,
    42: `Please provide a number of steps to the modularScale helper.

`,
    43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
    44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
    45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
    46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
    47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
    48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
    49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
    50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
    51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
    52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
    53: `fontFace expects localFonts to be an array.

`,
    54: `fontFace expects fileFormats to be an array.

`,
    55: `fontFace expects a name of a font-family.

`,
    56: `linearGradient requries at least 2 color-stops to properly render.

`,
    57: `radialGradient requries at least 2 color-stops to properly render.

`,
    58: `Please supply a filename to retinaImage() as the first argument.

`,
    59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
    60: 'Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n',
    61: `Property must be a string value.

`,
    62: `borderRadius expects a radius value as a string or number as the second argument.

`,
    63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
    64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
    65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
    66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
    67: `You must provide a template to this method.

`,
    68: `You passed an unsupported selector state to this method.

`,
    69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
    70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
    71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
    72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
    73: `Please provide a valid CSS variable.

`,
    74: `CSS variable not found and no default was provided.

`,
    75: `important requires a valid style object, got a %s instead.

`,
    76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
    77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
    78: `base must be set in "px" or "%" but you set it in "%s".
`,
  };
  function lu() {
    for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
      n[t] = arguments[t];
    var r = n[0],
      o = [],
      i;
    for (i = 1; i < n.length; i += 1) o.push(n[i]);
    return (
      o.forEach(function (a) {
        r = r.replace(/%[a-z]/, a);
      }),
      r
    );
  }
  var Jt = (function (e) {
    ou(n, e);
    function n(t) {
      var r;
      if ({}.NODE_ENV === 'production')
        r =
          e.call(
            this,
            'An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#' +
              t +
              ' for more information.'
          ) || this;
      else {
        for (
          var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), a = 1;
          a < o;
          a++
        )
          i[a - 1] = arguments[a];
        r = e.call(this, lu.apply(void 0, [uu[t]].concat(i))) || this;
      }
      return iu(r);
    }
    return n;
  })(fr(Error));
  function dr(e) {
    return Math.round(e * 255);
  }
  function cu(e, n, t) {
    return dr(e) + ',' + dr(n) + ',' + dr(t);
  }
  function Ue(e, n, t, r) {
    if ((r === void 0 && (r = cu), n === 0)) return r(t, t, t);
    var o = (((e % 360) + 360) % 360) / 60,
      i = (1 - Math.abs(2 * t - 1)) * n,
      a = i * (1 - Math.abs((o % 2) - 1)),
      s = 0,
      l = 0,
      g = 0;
    o >= 0 && o < 1
      ? ((s = i), (l = a))
      : o >= 1 && o < 2
      ? ((s = a), (l = i))
      : o >= 2 && o < 3
      ? ((l = i), (g = a))
      : o >= 3 && o < 4
      ? ((l = a), (g = i))
      : o >= 4 && o < 5
      ? ((s = a), (g = i))
      : o >= 5 && o < 6 && ((s = i), (g = a));
    var c = t - i / 2,
      w = s + c,
      b = l + c,
      h = g + c;
    return r(w, b, h);
  }
  var Gi = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32',
  };
  function hu(e) {
    if (typeof e != 'string') return e;
    var n = e.toLowerCase();
    return Gi[n] ? '#' + Gi[n] : e;
  }
  var fu = /^#[a-fA-F0-9]{6}$/,
    du = /^#[a-fA-F0-9]{8}$/,
    pu = /^#[a-fA-F0-9]{3}$/,
    mu = /^#[a-fA-F0-9]{4}$/,
    pr = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i,
    gu =
      /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i,
    _u =
      /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i,
    vu =
      /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
  function Xi(e) {
    if (typeof e != 'string') throw new Jt(3);
    var n = hu(e);
    if (n.match(fu))
      return {
        red: parseInt('' + n[1] + n[2], 16),
        green: parseInt('' + n[3] + n[4], 16),
        blue: parseInt('' + n[5] + n[6], 16),
      };
    if (n.match(du)) {
      var t = parseFloat((parseInt('' + n[7] + n[8], 16) / 255).toFixed(2));
      return {
        red: parseInt('' + n[1] + n[2], 16),
        green: parseInt('' + n[3] + n[4], 16),
        blue: parseInt('' + n[5] + n[6], 16),
        alpha: t,
      };
    }
    if (n.match(pu))
      return {
        red: parseInt('' + n[1] + n[1], 16),
        green: parseInt('' + n[2] + n[2], 16),
        blue: parseInt('' + n[3] + n[3], 16),
      };
    if (n.match(mu)) {
      var r = parseFloat((parseInt('' + n[4] + n[4], 16) / 255).toFixed(2));
      return {
        red: parseInt('' + n[1] + n[1], 16),
        green: parseInt('' + n[2] + n[2], 16),
        blue: parseInt('' + n[3] + n[3], 16),
        alpha: r,
      };
    }
    var o = pr.exec(n);
    if (o)
      return {
        red: parseInt('' + o[1], 10),
        green: parseInt('' + o[2], 10),
        blue: parseInt('' + o[3], 10),
      };
    var i = gu.exec(n.substring(0, 50));
    if (i)
      return {
        red: parseInt('' + i[1], 10),
        green: parseInt('' + i[2], 10),
        blue: parseInt('' + i[3], 10),
        alpha:
          parseFloat('' + i[4]) > 1
            ? parseFloat('' + i[4]) / 100
            : parseFloat('' + i[4]),
      };
    var a = _u.exec(n);
    if (a) {
      var s = parseInt('' + a[1], 10),
        l = parseInt('' + a[2], 10) / 100,
        g = parseInt('' + a[3], 10) / 100,
        c = 'rgb(' + Ue(s, l, g) + ')',
        w = pr.exec(c);
      if (!w) throw new Jt(4, n, c);
      return {
        red: parseInt('' + w[1], 10),
        green: parseInt('' + w[2], 10),
        blue: parseInt('' + w[3], 10),
      };
    }
    var b = vu.exec(n.substring(0, 50));
    if (b) {
      var h = parseInt('' + b[1], 10),
        _ = parseInt('' + b[2], 10) / 100,
        d = parseInt('' + b[3], 10) / 100,
        v = 'rgb(' + Ue(h, _, d) + ')',
        m = pr.exec(v);
      if (!m) throw new Jt(4, n, v);
      return {
        red: parseInt('' + m[1], 10),
        green: parseInt('' + m[2], 10),
        blue: parseInt('' + m[3], 10),
        alpha:
          parseFloat('' + b[4]) > 1
            ? parseFloat('' + b[4]) / 100
            : parseFloat('' + b[4]),
      };
    }
    throw new Jt(5);
  }
  function yu(e) {
    var n = e.red / 255,
      t = e.green / 255,
      r = e.blue / 255,
      o = Math.max(n, t, r),
      i = Math.min(n, t, r),
      a = (o + i) / 2;
    if (o === i)
      return e.alpha !== void 0
        ? { hue: 0, saturation: 0, lightness: a, alpha: e.alpha }
        : { hue: 0, saturation: 0, lightness: a };
    var s,
      l = o - i,
      g = a > 0.5 ? l / (2 - o - i) : l / (o + i);
    switch (o) {
      case n:
        s = (t - r) / l + (t < r ? 6 : 0);
        break;
      case t:
        s = (r - n) / l + 2;
        break;
      default:
        s = (n - t) / l + 4;
        break;
    }
    return (
      (s *= 60),
      e.alpha !== void 0
        ? { hue: s, saturation: g, lightness: a, alpha: e.alpha }
        : { hue: s, saturation: g, lightness: a }
    );
  }
  function wu(e) {
    return yu(Xi(e));
  }
  var bu = function (n) {
      return n.length === 7 && n[1] === n[2] && n[3] === n[4] && n[5] === n[6]
        ? '#' + n[1] + n[3] + n[5]
        : n;
    },
    mr = bu;
  function ye(e) {
    var n = e.toString(16);
    return n.length === 1 ? '0' + n : n;
  }
  function gr(e) {
    return ye(Math.round(e * 255));
  }
  function Cu(e, n, t) {
    return mr('#' + gr(e) + gr(n) + gr(t));
  }
  function wn(e, n, t) {
    return Ue(e, n, t, Cu);
  }
  function ku(e, n, t) {
    if (typeof e == 'number' && typeof n == 'number' && typeof t == 'number')
      return wn(e, n, t);
    if (typeof e == 'object' && n === void 0 && t === void 0)
      return wn(e.hue, e.saturation, e.lightness);
    throw new Jt(1);
  }
  function xu(e, n, t, r) {
    if (
      typeof e == 'number' &&
      typeof n == 'number' &&
      typeof t == 'number' &&
      typeof r == 'number'
    )
      return r >= 1 ? wn(e, n, t) : 'rgba(' + Ue(e, n, t) + ',' + r + ')';
    if (typeof e == 'object' && n === void 0 && t === void 0 && r === void 0)
      return e.alpha >= 1
        ? wn(e.hue, e.saturation, e.lightness)
        : 'rgba(' + Ue(e.hue, e.saturation, e.lightness) + ',' + e.alpha + ')';
    throw new Jt(2);
  }
  function _r(e, n, t) {
    if (typeof e == 'number' && typeof n == 'number' && typeof t == 'number')
      return mr('#' + ye(e) + ye(n) + ye(t));
    if (typeof e == 'object' && n === void 0 && t === void 0)
      return mr('#' + ye(e.red) + ye(e.green) + ye(e.blue));
    throw new Jt(6);
  }
  function Su(e, n, t, r) {
    if (typeof e == 'string' && typeof n == 'number') {
      var o = Xi(e);
      return 'rgba(' + o.red + ',' + o.green + ',' + o.blue + ',' + n + ')';
    } else {
      if (
        typeof e == 'number' &&
        typeof n == 'number' &&
        typeof t == 'number' &&
        typeof r == 'number'
      )
        return r >= 1
          ? _r(e, n, t)
          : 'rgba(' + e + ',' + n + ',' + t + ',' + r + ')';
      if (typeof e == 'object' && n === void 0 && t === void 0 && r === void 0)
        return e.alpha >= 1
          ? _r(e.red, e.green, e.blue)
          : 'rgba(' +
              e.red +
              ',' +
              e.green +
              ',' +
              e.blue +
              ',' +
              e.alpha +
              ')';
    }
    throw new Jt(7);
  }
  var Au = function (n) {
      return (
        typeof n.red == 'number' &&
        typeof n.green == 'number' &&
        typeof n.blue == 'number' &&
        (typeof n.alpha != 'number' || typeof n.alpha > 'u')
      );
    },
    Eu = function (n) {
      return (
        typeof n.red == 'number' &&
        typeof n.green == 'number' &&
        typeof n.blue == 'number' &&
        typeof n.alpha == 'number'
      );
    },
    Lu = function (n) {
      return (
        typeof n.hue == 'number' &&
        typeof n.saturation == 'number' &&
        typeof n.lightness == 'number' &&
        (typeof n.alpha != 'number' || typeof n.alpha > 'u')
      );
    },
    Tu = function (n) {
      return (
        typeof n.hue == 'number' &&
        typeof n.saturation == 'number' &&
        typeof n.lightness == 'number' &&
        typeof n.alpha == 'number'
      );
    };
  function Iu(e) {
    if (typeof e != 'object') throw new Jt(8);
    if (Eu(e)) return Su(e);
    if (Au(e)) return _r(e);
    if (Tu(e)) return xu(e);
    if (Lu(e)) return ku(e);
    throw new Jt(8);
  }
  function qi(e, n, t) {
    return function () {
      var o = t.concat(Array.prototype.slice.call(arguments));
      return o.length >= n ? e.apply(this, o) : qi(e, n, o);
    };
  }
  function Ru(e) {
    return qi(e, e.length, []);
  }
  function Ou(e, n, t) {
    return Math.max(e, Math.min(n, t));
  }
  function Du(e, n) {
    if (n === 'transparent') return n;
    var t = wu(n);
    return Iu(cr({}, t, { lightness: Ou(0, 1, t.lightness - parseFloat(e)) }));
  }
  var Pu = Ru(Du),
    zu = Pu;
  const Nu = 16,
    Mu = 1.25,
    Fu = 960,
    Ki = {
      primary: '#021B41',
      primaryHover: '#283D5D',
      primaryActive: '#415470',
      secondary: '#AACDEB',
      secondaryHover: '#C3DCF1',
      secondaryActive: '#D5E6F5',
      action: '#80DFD8',
      actionHover: '#6DBEB8',
      actionActive: '#60A7A2',
      error: '#FF0E00',
      warning: '#FFD616',
      success: '#11EE46',
      actionOnPrimary: '#214C67',
      primarySecondary: '#567496',
      white: '#FFF',
      white0: '#ffffff00',
      white15: '#ffffff26',
      white25: '#ffffff40',
      white30: '#ffffff4d',
      white50: '#ffffff80',
      placeholderColor: 'white',
      placeholderColorSuccess: '#00BFB2',
      instructionColor: '#F8FBFB',
      instructionColorSuccess: '#00BFB2',
      instructionTextColor: '#021B41;',
    },
    Bu = { hover: { cyan: zu(0.1, Ki.secondary) } },
    Vu = {
      s40heading: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '40px',
        lineHeight: '48px',
      },
      s26heading: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '26px',
        lineHeight: '30px',
      },
      s20heading: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
      },
      s20bold: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '24px',
        '@media (min-height: 575px)': { fontSize: '20px', lineHeight: '30px' },
      },
      s20: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        '@media (min-height: 575px)': { fontSize: '20px', lineHeight: '30px' },
      },
      s18bold: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '18px',
        lineHeight: '27px',
      },
      s18: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '27px',
      },
      s16bold: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '20px',
        '@media (min-height: 575px)': { fontSize: '16px', lineHeight: '24px' },
      },
      s16: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        '@media (min-height: 575px)': { fontSize: '16px', lineHeight: '24px' },
      },
      s14bold: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '21px',
      },
      s14: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '21px',
      },
      s12bold: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '12px',
        lineHeight: '18px',
      },
      s12: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '18px',
      },
      s12input: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        lineHeight: '18px',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
      },
      s13button: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '13px',
        lineHeight: '18px',
        textTransform: 'uppercase',
        letterSpacing: '0.3em',
      },
      s11button: {
        fontFamily: 'sans-serif',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '11px',
        lineHeight: '13px',
        textTransform: 'uppercase',
        letterSpacing: '0.3em',
      },
    },
    ju = [
      0, 5, 10, 15, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140,
    ].map((e) => `${e}px`),
    $u = [Fu].map((e) => `${e}px`),
    Ji = {
      colors: Ki,
      colorStyles: Bu,
      lineHeights: { base: Mu },
      fontSizes: { base: Nu },
      textStyles: Vu,
      transitions: { buttons: 'ease-in-out 0.1s' },
      space: ju,
      breakpoints: $u,
    },
    Uu = (e) => ({ ...Ji, colors: { ...Ji.colors, ...e } }),
    Wu = () =>
      O('svg', {
        width: '0',
        height: '0',
        viewBox: '0 0 52 52',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('path', {
            d: 'M0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26Z',
            fill: '#131313',
            fillOpacity: '0.3',
          }),
          O('circle', { cx: '17.5', cy: '24.5', r: '1.5', fill: 'white' }),
          O('path', {
            d: 'M15 17H16C19.5 17 23 21 23 29C22.5 29 21.5 29 20 29C20 29 20.25 33 19.5 34.5C18.75 36 16 36 16 36H15',
            stroke: 'white',
            strokeWidth: '2',
          }),
          O('circle', {
            r: '1.5',
            transform: 'matrix(-1 0 0 1 34.5 24.5)',
            fill: 'white',
          }),
          O('path', {
            d: 'M37 17H36C32.5 17 29 21 29 29C29.5 29 30.5 29 32 29C32 29 31.75 33 32.5 34.5C33.25 36 36 36 36 36H37',
            stroke: 'white',
            strokeWidth: '2',
          }),
        ],
      }),
    Hu = () =>
      O('svg', {
        width: '0',
        height: '0',
        viewBox: '0 0 52 52',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('path', {
            d: 'M0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26Z',
            fill: '#131313',
            fillOpacity: '0.3',
          }),
          O('path', {
            d: 'M15 21.375C15 19.7181 16.3431 18.375 18 18.375H20.3222C21.1014 18.375 21.8096 17.9225 22.137 17.2155L22.163 17.1595C22.4904 16.4525 23.1986 16 23.9778 16H28.0222C28.8014 16 29.5096 16.4525 29.837 17.1595L29.863 17.2155C30.1904 17.9225 30.8986 18.375 31.6778 18.375H34C35.6569 18.375 37 19.7181 37 21.375V33C37 34.6569 35.6569 36 34 36H18C16.3431 36 15 34.6569 15 33V21.375Z',
            stroke: 'white',
            strokeWidth: '2',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }),
          O('path', {
            d: 'M31.25 27C31.25 24.1005 28.8995 21.75 26 21.75C24.4024 21.75 22.9715 22.4636 22.0086 23.5894M20.75 27C20.75 29.8995 23.1005 32.25 26 32.25C27.5958 32.25 29.0253 31.538 29.9881 30.4144',
            stroke: 'white',
            strokeWidth: '1.5',
            strokeLinecap: 'round',
          }),
          O('path', {
            d: 'M30.0835 26.4167L31.2502 28.1667L32.4168 26.4167',
            stroke: 'white',
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }),
          O('path', {
            d: 'M19.5835 27.5833L20.7502 25.8333L21.9168 27.5833',
            stroke: 'white',
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }),
        ],
      }),
    Zu = Zt.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25em;
  margin: 0 auto;
  padding: 0.583em 0.666em;
  background: ${(e) =>
    e.isInCandidateSelection
      ? `${e.theme.colors.instructionColorSuccess}`
      : `${e.theme.colors.instructionColor}`};
  color: ${(e) => e.theme.colors.instructionTextColor};
  border: 0;
  font-family: Montserrat, Arial, sans-serif;
  font-weight: 600;
  line-height: 1em;
  font-size: ${(e) => `${e.fontSize}px`};
`,
    Yu = ({ instructionText: e, fontSize: n, isInCandidateSelection: t }) =>
      e ? O(Zu, { fontSize: n, isInCandidateSelection: t, children: e }) : null;
  function Gu(e, n, t) {
    return new Promise((r) => {
      e.toBlob(
        (o) => {
          r(aa(o));
        },
        n,
        t
      );
    });
  }
  function Xu(e, n) {
    const t = document.createElement('canvas');
    (t.width = n.width * e.width), (t.height = n.height * e.height);
    const r = t.getContext('2d');
    if (!r) throw new Error('cropImage ctx error');
    return (
      r.drawImage(
        e,
        n.shiftX * e.width,
        n.shiftY * e.height,
        n.width * e.width,
        n.height * e.height,
        0,
        0,
        t.width,
        t.height
      ),
      t
    );
  }
  function qu(e) {
    const n = e.getContext('2d');
    if (!n) throw new Error('getImageDataForSam ctx error');
    return n.getImageData(0, 0, e.width, e.height).data;
  }
  const Qi = (e) => {
      const n = e.getContext('2d');
      !n || n.clearRect(0, 0, n.canvas.width, n.canvas.height);
    },
    Ku = () => {
      var e;
      return (
        ((e = {
          VITE_FACE_COUNTLY_APP_KEY: '1234567890',
          VITE_DOCUMENT_COUNTLY_APP_KEY: '1234567890',
          VITE_COUNTLY_URL: 'https://confia.count.ly',
          BASE_URL: '/',
          MODE: 'production',
          DEV: !1,
          PROD: !0,
        }.VITE_APP_ENV) == null
          ? void 0
          : e.toLowerCase()) === 'dev'
      );
    };
  class Ju extends Array {
    constructor(t) {
      super();
      Bt(this, 'size');
      this.size = t;
    }
    pushFixed(...t) {
      this.length === this.size && this.splice(0, t.length), this.push(...t);
    }
  }
  const oe = (e, n) => Math.hypot(n.x - e.x, n.y - e.y),
    to = (e, n, t) => {
      const r = (n.x - e.x) * t,
        o = (n.y - e.y) * t;
      return { x: e.x + r, y: e.y + o };
    },
    eo = (e, n, t, r) => {
      const o = oe(e, n);
      return (t * r) / o;
    },
    Qu = (e) => (e.length < 1 ? 0 : e.reduce((t, r) => t + r, 0) / e.length),
    no = Zt.canvas`
  transform: ${(e) => (e.isImageMirror ? 'rotateY(180deg)' : 'none')};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
  function Ee(e, n) {
    return e * n;
  }
  function ro(e) {
    let n;
    return (
      e.width > e.height
        ? e.height < ei
          ? (n = ei)
          : (n = e.height)
        : (n = e.width),
      n
    );
  }
  function tl(e, n) {
    return e.height < n ? e.height : n;
  }
  function Le(e) {
    const n = ro(e),
      t = tl(e, n),
      r = (e.width - n) / 2,
      o = (e.height - t) / 2;
    return {
      shiftX: r / e.width,
      shiftY: o / e.height,
      width: n / e.width,
      height: t / e.height,
    };
  }
  function el(e, n) {
    const t = Le(e);
    return {
      shiftX: t.shiftX + t.width * n,
      shiftY: t.shiftY + t.height * n,
      width: t.width - t.width * n * 2,
      height: t.height - t.height * n * 2,
    };
  }
  function vr(e) {
    const t = ro(e) * Ho,
      r = (e.width - t) / 2,
      o = t / Wo,
      i = (e.height - o) / 2;
    return {
      shiftX: r / e.width,
      shiftY: i / e.height,
      width: t / e.width,
      height: o / e.height,
    };
  }
  function bn(e, n) {
    const t = Le(e);
    return {
      x: t.width * e.width * n.x + t.shiftX * e.width,
      y: t.height * e.height * n.y + t.shiftY * e.height,
    };
  }
  function nl(e, n) {
    const t = Le({ width: e.width, height: e.height }),
      r = vr({ width: e.width, height: e.height });
    function o() {
      const g = (n.x - t.shiftX) / t.width,
        c = (n.y - t.shiftY) / t.height;
      return { x: g, y: c };
    }
    function i() {
      const g = (n.x - r.shiftX) / r.width,
        c = (n.y - r.shiftY) / r.height;
      return { x: g, y: c };
    }
    function a() {
      const g = o();
      return { x: Ee(e.width * t.width, g.x), y: Ee(e.height * t.height, g.y) };
    }
    function s() {
      const g = i();
      return { x: Ee(e.width * r.width, g.x), y: Ee(e.height * r.height, g.y) };
    }
    function l() {
      return { x: Ee(e.width, n.x), y: Ee(e.height, n.y) };
    }
    return {
      toDetectionPercent: o,
      toPlaceholderPercent: i,
      toDetectionPixels: a,
      toPlaceholderPixels: s,
      toImagePixels: l,
    };
  }
  function rl(e, n) {
    const t = nl(e, { x: n.shiftX, y: n.shiftY }).toDetectionPercent(),
      r = Le(e);
    return {
      shiftX: t.x,
      shiftY: t.y,
      width: n.width / r.width,
      height: n.height / r.height,
    };
  }
  function io(e, n) {
    return e.document
      ? {
          ...e,
          document: {
            ...e.document,
            topLeft: bn(n, e.document.topLeft),
            topRight: bn(n, e.document.topRight),
            bottomRight: bn(n, e.document.bottomRight),
            bottomLeft: bn(n, e.document.bottomLeft),
          },
        }
      : e;
  }
  const il = Zt.div`
  background-color: #00000060;
  color: #fff;
  font-size: 13px;
  width: 300px;
  padding: 10px;
  z-index: 1;
  word-break: break-word;
  position: absolute;
  top: 0;
`,
    ol = (e, n) => {
      const t = e.getContext('2d');
      if (!t || !n) return;
      const { topLeft: r, topRight: o, bottomRight: i, bottomLeft: a } = n;
      t.beginPath(),
        (t.strokeStyle = 'red'),
        t.moveTo(r.x, r.y),
        t.lineTo(o.x, o.y),
        t.lineTo(i.x, i.y),
        t.lineTo(a.x, a.y),
        t.closePath(),
        t.stroke();
    },
    oo = (e, n, t) => {
      const r = e.getContext('2d');
      if (!r) return;
      const { shiftX: o, shiftY: i, width: a, height: s } = n;
      r.beginPath(),
        (r.strokeStyle = t),
        r.moveTo(o * e.width, i * e.height),
        r.lineTo((o + a) * e.width, i * e.height),
        r.lineTo((o + a) * e.width, (i + s) * e.height),
        r.lineTo(o * e.width, (i + s) * e.height),
        r.closePath(),
        r.stroke();
    },
    al = ({ detectionDetails: e, isImageMirror: n, cameraResolution: t }) => {
      const {
          documentCameraOptions: { thresholds: r },
        } = Ne(),
        [o, i] = Mt(null),
        a = _e(null);
      return (
        $t(() => {
          if (!a.current) return;
          (a.current.width = t.width), (a.current.height = t.height);
          const s = io(e, t);
          i(s);
          const l = Le(t),
            g = el(t, r.outOfBoundsThreshold);
          Qi(a.current),
            ol(a.current, s.document),
            oo(a.current, l, 'green'),
            oo(a.current, g, 'yellow');
        }, [t, e, r]),
        O(qt, {
          children: [
            O(no, { ref: a, isImageMirror: n }),
            O(il, {
              children:
                o &&
                O(qt, {
                  children: [
                    O('div', {
                      children: [
                        'Confidence: ',
                        O('strong', { children: o.document.confidence }),
                      ],
                    }),
                    O('div', {
                      children: [
                        'Fit error: ',
                        O('strong', {
                          children: o.document.placeholderFitError,
                        }),
                      ],
                    }),
                    O('div', {
                      children: [
                        'Smallest edge: ',
                        O('strong', { children: o.document.smallestEdge }),
                      ],
                    }),
                    O('div', {
                      children: [
                        'Brightness: ',
                        O('strong', { children: o.document.brightness }),
                      ],
                    }),
                    O('div', {
                      children: [
                        'Hotspots: ',
                        O('strong', { children: o.document.hotspots }),
                      ],
                    }),
                    O('div', {
                      children: [
                        'Sharpness: ',
                        O('strong', { children: o.document.sharpness }),
                      ],
                    }),
                    O('div', {
                      children: [
                        'Detection time: ',
                        O('strong', { children: o.detectionTime }),
                      ],
                    }),
                    O('div', {
                      children: ['FPS: ', O('strong', { children: o.fps })],
                    }),
                    O('div', {
                      children: [
                        'Instruction: ',
                        O('strong', { children: o.instructionCode }),
                      ],
                    }),
                    O('div', {
                      children: [
                        'Resolution: ',
                        O('strong', { children: JSON.stringify(o.resolution) }),
                      ],
                    }),
                  ],
                }),
            }),
          ],
        })
      );
    },
    sl = (e) => {
      const { topLeft: n, bottomLeft: t, topRight: r, bottomRight: o } = e,
        i = oe(n, r),
        a = oe(r, o),
        s = oe(t, o),
        l = oe(n, t);
      return Math.min(i, a, s, l);
    },
    ul = ({ detectionDetails: e, isImageMirror: n, cameraResolution: t }) => {
      const r = _e(null),
        {
          documentCameraOptions: { thresholds: o },
        } = Ne(),
        i = $s();
      return (
        $t(() => {
          if (!r.current) return;
          const a = (g, c, w, b) => {
              var k;
              const h = eo(c, g, b, ni),
                _ = eo(c, w, b, ni),
                d = to(c, g, h),
                v = to(c, w, _),
                m =
                  (k = r == null ? void 0 : r.current) == null
                    ? void 0
                    : k.getContext('2d');
              !m ||
                (m.beginPath(),
                (m.lineWidth = Yo),
                (m.strokeStyle = i.colors.placeholderColor),
                m.moveTo(d.x, d.y),
                m.arcTo(c.x, c.y, v.x, v.y, Zo),
                m.lineTo(v.x, v.y),
                m.stroke());
            },
            s = (g) => {
              const {
                  topLeft: c,
                  topRight: w,
                  bottomLeft: b,
                  bottomRight: h,
                } = g,
                _ = sl(g);
              a(b, c, w, _), a(c, w, h, _), a(w, h, b, _), a(h, b, c, _);
            };
          if (
            ((r.current.width = t.width),
            (r.current.height = t.height),
            Qi(r.current),
            e.document.confidence < o.confidenceThreshold)
          )
            return;
          const l = io(e, t);
          s(l.document);
        }, [t, e, i.colors.placeholderColor, o.confidenceThreshold]),
        O(no, { ref: r, isImageMirror: n })
      );
    },
    ll = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('rect', {
            opacity: '0.1',
            width: '163',
            height: '104',
            rx: '4',
            fill: 'white',
          }),
          O('path', {
            d: 'M138.294 1H160C161.105 1 162 1.89543 162 3V24.5385M24.7055 1H3C1.89543 1 1 1.89543 1 3V24.5385M1 79.4615V101C1 102.105 1.89543 103 3 103H24.7055M162 79.4615V101C162 102.105 161.105 103 160 103H138.294',
            stroke: 'currentColor',
            strokeWidth: '4',
            strokeLinecap: 'round',
          }),
        ],
      }),
    cl = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: O('rect', {
          x: '1',
          y: '1',
          width: '161',
          height: '102',
          rx: '1',
          stroke: 'currentColor',
          strokeWidth: '2',
          strokeLinecap: 'square',
          strokeDasharray: '8 8',
        }),
      }),
    hl = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: O('rect', {
          x: '1',
          y: '1',
          width: '161',
          height: '102',
          stroke: 'currentColor',
          strokeWidth: '2',
          strokeLinecap: 'square',
          strokeDasharray: '1 10 1 10',
        }),
      }),
    fl = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: O('rect', {
          x: '1',
          y: '1',
          width: '161',
          height: '102',
          rx: '1',
          stroke: 'currentColor',
          strokeWidth: '2',
          strokeLinecap: 'round',
        }),
      }),
    ao = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('rect', {
            opacity: '0.1',
            width: '163',
            height: '104',
            rx: '16',
            fill: 'white',
          }),
          O('path', {
            d: 'M138 1H146C154.837 1 162 8.16344 162 17V25M25 1H17C8.16344 1 1 8.16344 1 17V25M1 79V87C1 95.8366 8.16344 103 17 103H25M162 79V87C162 95.8366 154.837 103 146 103H138',
            stroke: 'currentColor',
            strokeWidth: '2',
            strokeLinecap: 'round',
          }),
        ],
      }),
    dl = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: O('rect', {
          x: '1',
          y: '1',
          width: '161',
          height: '102',
          rx: '15',
          stroke: 'currentColor',
          strokeWidth: '2',
          strokeLinecap: 'square',
          strokeDasharray: '16 16',
        }),
      }),
    pl = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: O('rect', {
          x: '1',
          y: '1',
          width: '161',
          height: '102',
          rx: '15',
          stroke: 'currentColor',
          strokeWidth: '2',
          strokeLinecap: 'square',
          strokeDasharray: '1 10 1 10',
        }),
      }),
    ml = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('rect', {
            opacity: '0.1',
            width: '163',
            height: '104',
            rx: '16',
            fill: 'white',
          }),
          O('path', {
            d: 'M138 1H146C154.837 1 162 8.16344 162 17V25M25 1H17C8.16344 1 1 8.16344 1 17V25M1 79V87C1 95.8366 8.16344 103 17 103H25M162 79V87C162 95.8366 154.837 103 146 103H138',
            stroke: 'currentColor',
            strokeWidth: '2',
            strokeLinecap: 'round',
          }),
          O('rect', {
            x: '11',
            y: '24',
            width: '48',
            height: '58',
            rx: '4',
            stroke: 'currentColor',
          }),
        ],
      }),
    gl = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('rect', {
            opacity: '0.1',
            width: '163',
            height: '104',
            rx: '16',
            fill: 'white',
          }),
          O('rect', {
            x: '1',
            y: '1',
            width: '161',
            height: '102',
            rx: '15',
            stroke: 'currentColor',
            strokeWidth: '2',
            strokeLinecap: 'round',
          }),
          O('path', {
            d: 'M1 64H161.5',
            stroke: 'currentColor',
            strokeWidth: '2',
          }),
        ],
      }),
    _l = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '104',
        viewBox: '0 0 163 104',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('rect', {
            opacity: '0.1',
            width: '163',
            height: '104',
            rx: '16',
            fill: 'white',
          }),
          O('rect', {
            x: '1',
            y: '1',
            width: '161',
            height: '102',
            rx: '15',
            stroke: 'currentColor',
            strokeWidth: '2',
            strokeLinecap: 'round',
          }),
        ],
      }),
    vl = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '114',
        viewBox: '0 0 163 114',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('path', {
            d: 'M2 0.5H161C161.828 0.5 162.5 1.17157 162.5 2V110C162.5 111.933 160.933 113.5 159 113.5H4C2.067 113.5 0.5 111.933 0.5 110V2C0.5 1.17157 1.17157 0.5 2 0.5Z',
            stroke: 'currentColor',
            strokeLinecap: 'round',
          }),
          O('g', {
            filter: 'url(#filter0_d)',
            children: [
              O('path', {
                d: 'M12.5813 95.8096V95.0156L10.9829 94.4795L10.7846 94.4092L10.9829 94.3359L12.5813 93.791V93L10 94.0752V94.7344L12.5813 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M17.4233 95.8096V95.0156L15.825 94.4795L15.6266 94.4092L15.825 94.3359L17.4233 93.791V93L14.842 94.0752V94.7344L17.4233 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M22.2654 95.8096V95.0156L20.667 94.4795L20.4687 94.4092L20.667 94.3359L22.2654 93.791V93L19.684 94.0752V94.7344L22.2654 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M27.1074 95.8096V95.0156L25.509 94.4795L25.3107 94.4092L25.509 94.3359L27.1074 93.791V93L24.5261 94.0752V94.7344L27.1074 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M31.9494 95.8096V95.0156L30.351 94.4795L30.1527 94.4092L30.351 94.3359L31.9494 93.791V93L29.3681 94.0752V94.7344L31.9494 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M36.7914 95.8096V95.0156L35.1931 94.4795L34.9947 94.4092L35.1931 94.3359L36.7914 93.791V93L34.2101 94.0752V94.7344L36.7914 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M41.6335 95.8096V95.0156L40.0351 94.4795L39.8367 94.4092L40.0351 94.3359L41.6335 93.791V93L39.0521 94.0752V94.7344L41.6335 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M46.4755 95.8096V95.0156L44.8771 94.4795L44.6788 94.4092L44.8771 94.3359L46.4755 93.791V93L43.8942 94.0752V94.7344L46.4755 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M51.3175 95.8096V95.0156L49.7191 94.4795L49.5208 94.4092L49.7191 94.3359L51.3175 93.791V93L48.7362 94.0752V94.7344L51.3175 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M56.1595 95.8096V95.0156L54.5612 94.4795L54.3628 94.4092L54.5612 94.3359L56.1595 93.791V93L53.5782 94.0752V94.7344L56.1595 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M61.0016 95.8096V95.0156L59.4032 94.4795L59.2048 94.4092L59.4032 94.3359L61.0016 93.791V93L58.4202 94.0752V94.7344L61.0016 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M65.8436 95.8096V95.0156L64.2452 94.4795L64.0469 94.4092L64.2452 94.3359L65.8436 93.791V93L63.2623 94.0752V94.7344L65.8436 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M70.6856 95.8096V95.0156L69.0872 94.4795L68.8889 94.4092L69.0872 94.3359L70.6856 93.791V93L68.1043 94.0752V94.7344L70.6856 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M75.5276 95.8096V95.0156L73.9293 94.4795L73.7309 94.4092L73.9293 94.3359L75.5276 93.791V93L72.9463 94.0752V94.7344L75.5276 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M80.3697 95.8096V95.0156L78.7713 94.4795L78.5729 94.4092L78.7713 94.3359L80.3697 93.791V93L77.7883 94.0752V94.7344L80.3697 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M85.2117 95.8096V95.0156L83.6133 94.4795L83.415 94.4092L83.6133 94.3359L85.2117 93.791V93L82.6304 94.0752V94.7344L85.2117 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M90.0537 95.8096V95.0156L88.4553 94.4795L88.257 94.4092L88.4553 94.3359L90.0537 93.791V93L87.4724 94.0752V94.7344L90.0537 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M94.8957 95.8096V95.0156L93.2973 94.4795L93.099 94.4092L93.2973 94.3359L94.8957 93.791V93L92.3144 94.0752V94.7344L94.8957 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M99.7377 95.8096V95.0156L98.1394 94.4795L97.941 94.4092L98.1394 94.3359L99.7377 93.791V93L97.1564 94.0752V94.7344L99.7377 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M104.58 95.8096V95.0156L102.981 94.4795L102.783 94.4092L102.981 94.3359L104.58 93.791V93L101.998 94.0752V94.7344L104.58 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M109.422 95.8096V95.0156L107.823 94.4795L107.625 94.4092L107.823 94.3359L109.422 93.791V93L106.84 94.0752V94.7344L109.422 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M114.264 95.8096V95.0156L112.665 94.4795L112.467 94.4092L112.665 94.3359L114.264 93.791V93L111.683 94.0752V94.7344L114.264 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M119.106 95.8096V95.0156L117.507 94.4795L117.309 94.4092L117.507 94.3359L119.106 93.791V93L116.525 94.0752V94.7344L119.106 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M123.948 95.8096V95.0156L122.349 94.4795L122.151 94.4092L122.349 94.3359L123.948 93.791V93L121.367 94.0752V94.7344L123.948 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M128.79 95.8096V95.0156L127.192 94.4795L126.993 94.4092L127.192 94.3359L128.79 93.791V93L126.209 94.0752V94.7344L128.79 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M133.632 95.8096V95.0156L132.034 94.4795L131.835 94.4092L132.034 94.3359L133.632 93.791V93L131.051 94.0752V94.7344L133.632 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M138.474 95.8096V95.0156L136.876 94.4795L136.677 94.4092L136.876 94.3359L138.474 93.791V93L135.893 94.0752V94.7344L138.474 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M143.316 95.8096V95.0156L141.718 94.4795L141.519 94.4092L141.718 94.3359L143.316 93.791V93L140.735 94.0752V94.7344L143.316 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M148.158 95.8096V95.0156L146.56 94.4795L146.361 94.4092L146.56 94.3359L148.158 93.791V93L145.577 94.0752V94.7344L148.158 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M153 95.8096V95.0156L151.402 94.4795L151.203 94.4092L151.402 94.3359L153 93.791V93L150.419 94.0752V94.7344L153 95.8096Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M12.5813 103.81V103.016L10.9829 102.479L10.7846 102.409L10.9829 102.336L12.5813 101.791V101L10 102.075V102.734L12.5813 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M17.4233 103.81V103.016L15.825 102.479L15.6266 102.409L15.825 102.336L17.4233 101.791V101L14.842 102.075V102.734L17.4233 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M22.2654 103.81V103.016L20.667 102.479L20.4687 102.409L20.667 102.336L22.2654 101.791V101L19.684 102.075V102.734L22.2654 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M27.1074 103.81V103.016L25.509 102.479L25.3107 102.409L25.509 102.336L27.1074 101.791V101L24.5261 102.075V102.734L27.1074 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M31.9494 103.81V103.016L30.351 102.479L30.1527 102.409L30.351 102.336L31.9494 101.791V101L29.3681 102.075V102.734L31.9494 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M36.7914 103.81V103.016L35.1931 102.479L34.9947 102.409L35.1931 102.336L36.7914 101.791V101L34.2101 102.075V102.734L36.7914 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M41.6335 103.81V103.016L40.0351 102.479L39.8367 102.409L40.0351 102.336L41.6335 101.791V101L39.0521 102.075V102.734L41.6335 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M46.4755 103.81V103.016L44.8771 102.479L44.6788 102.409L44.8771 102.336L46.4755 101.791V101L43.8942 102.075V102.734L46.4755 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M51.3175 103.81V103.016L49.7191 102.479L49.5208 102.409L49.7191 102.336L51.3175 101.791V101L48.7362 102.075V102.734L51.3175 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M56.1595 103.81V103.016L54.5612 102.479L54.3628 102.409L54.5612 102.336L56.1595 101.791V101L53.5782 102.075V102.734L56.1595 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M61.0016 103.81V103.016L59.4032 102.479L59.2048 102.409L59.4032 102.336L61.0016 101.791V101L58.4202 102.075V102.734L61.0016 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M65.8436 103.81V103.016L64.2452 102.479L64.0469 102.409L64.2452 102.336L65.8436 101.791V101L63.2623 102.075V102.734L65.8436 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M70.6856 103.81V103.016L69.0872 102.479L68.8889 102.409L69.0872 102.336L70.6856 101.791V101L68.1043 102.075V102.734L70.6856 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M75.5276 103.81V103.016L73.9293 102.479L73.7309 102.409L73.9293 102.336L75.5276 101.791V101L72.9463 102.075V102.734L75.5276 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M80.3697 103.81V103.016L78.7713 102.479L78.5729 102.409L78.7713 102.336L80.3697 101.791V101L77.7883 102.075V102.734L80.3697 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M85.2117 103.81V103.016L83.6133 102.479L83.415 102.409L83.6133 102.336L85.2117 101.791V101L82.6304 102.075V102.734L85.2117 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M90.0537 103.81V103.016L88.4553 102.479L88.257 102.409L88.4553 102.336L90.0537 101.791V101L87.4724 102.075V102.734L90.0537 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M94.8957 103.81V103.016L93.2973 102.479L93.099 102.409L93.2973 102.336L94.8957 101.791V101L92.3144 102.075V102.734L94.8957 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M99.7377 103.81V103.016L98.1394 102.479L97.941 102.409L98.1394 102.336L99.7377 101.791V101L97.1564 102.075V102.734L99.7377 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M104.58 103.81V103.016L102.981 102.479L102.783 102.409L102.981 102.336L104.58 101.791V101L101.998 102.075V102.734L104.58 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M109.422 103.81V103.016L107.823 102.479L107.625 102.409L107.823 102.336L109.422 101.791V101L106.84 102.075V102.734L109.422 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M114.264 103.81V103.016L112.665 102.479L112.467 102.409L112.665 102.336L114.264 101.791V101L111.683 102.075V102.734L114.264 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M119.106 103.81V103.016L117.507 102.479L117.309 102.409L117.507 102.336L119.106 101.791V101L116.525 102.075V102.734L119.106 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M123.948 103.81V103.016L122.349 102.479L122.151 102.409L122.349 102.336L123.948 101.791V101L121.367 102.075V102.734L123.948 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M128.79 103.81V103.016L127.192 102.479L126.993 102.409L127.192 102.336L128.79 101.791V101L126.209 102.075V102.734L128.79 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M133.632 103.81V103.016L132.034 102.479L131.835 102.409L132.034 102.336L133.632 101.791V101L131.051 102.075V102.734L133.632 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M138.474 103.81V103.016L136.876 102.479L136.677 102.409L136.876 102.336L138.474 101.791V101L135.893 102.075V102.734L138.474 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M143.316 103.81V103.016L141.718 102.479L141.519 102.409L141.718 102.336L143.316 101.791V101L140.735 102.075V102.734L143.316 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M148.158 103.81V103.016L146.56 102.479L146.361 102.409L146.56 102.336L148.158 101.791V101L145.577 102.075V102.734L148.158 103.81Z',
                fill: 'currentColor',
              }),
              O('path', {
                d: 'M153 103.81V103.016L151.402 102.479L151.203 102.409L151.402 102.336L153 101.791V101L150.419 102.075V102.734L153 103.81Z',
                fill: 'currentColor',
              }),
            ],
          }),
          O('path', { d: 'M1 85H162', stroke: 'currentColor' }),
          O('defs', {
            children: O('filter', {
              id: 'filter0_d',
              x: '6',
              y: '93',
              width: '151',
              height: '18.8096',
              filterUnits: 'userSpaceOnUse',
              colorInterpolationFilters: 'sRGB',
              children: [
                O('feFlood', {
                  floodOpacity: '0',
                  result: 'BackgroundImageFix',
                }),
                O('feColorMatrix', {
                  in: 'SourceAlpha',
                  type: 'matrix',
                  values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
                  result: 'hardAlpha',
                }),
                O('feOffset', { dy: '4' }),
                O('feGaussianBlur', { stdDeviation: '2' }),
                O('feColorMatrix', {
                  type: 'matrix',
                  values:
                    '0 0 0 0 0 0 0 0 0 0.74902 0 0 0 0 0.698039 0 0 0 0.08 0',
                }),
                O('feBlend', {
                  mode: 'darken',
                  in2: 'BackgroundImageFix',
                  result: 'effect1_dropShadow',
                }),
                O('feBlend', {
                  mode: 'normal',
                  in: 'SourceGraphic',
                  in2: 'effect1_dropShadow',
                  result: 'shape',
                }),
              ],
            }),
          }),
        ],
      }),
    yl = () =>
      O('svg', {
        preserveAspectRatio: 'none',
        width: '163',
        height: '114',
        viewBox: '0 0 163 114',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
        children: [
          O('path', {
            d: 'M2 0.5H161C161.828 0.5 162.5 1.17157 162.5 2V110C162.5 111.933 160.933 113.5 159 113.5H4C2.067 113.5 0.5 111.933 0.5 110V2C0.5 1.17157 1.17157 0.5 2 0.5Z',
            stroke: 'currentColor',
            strokeLinecap: 'round',
          }),
          O('path', { d: 'M1 85H162', stroke: 'currentColor' }),
          O('defs', {
            children: O('filter', {
              id: 'filter0_d',
              x: '6',
              y: '93',
              width: '151',
              height: '18.8096',
              filterUnits: 'userSpaceOnUse',
              colorInterpolationFilters: 'sRGB',
              children: [
                O('feFlood', {
                  floodOpacity: '0',
                  result: 'BackgroundImageFix',
                }),
                O('feColorMatrix', {
                  in: 'SourceAlpha',
                  type: 'matrix',
                  values: '0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0',
                  result: 'hardAlpha',
                }),
                O('feOffset', { dy: '4' }),
                O('feGaussianBlur', { stdDeviation: '2' }),
                O('feColorMatrix', {
                  type: 'matrix',
                  values:
                    '0 0 0 0 0 0 0 0 0 0.74902 0 0 0 0 0.698039 0 0 0 0.08 0',
                }),
                O('feBlend', {
                  mode: 'darken',
                  in2: 'BackgroundImageFix',
                  result: 'effect1_dropShadow',
                }),
                O('feBlend', {
                  mode: 'normal',
                  in: 'SourceGraphic',
                  in2: 'effect1_dropShadow',
                  result: 'shape',
                }),
              ],
            }),
          }),
        ],
      }),
    wl = () => {
      const {
        documentCameraOptions: { uiCustomisation: e },
      } = Ne();
      switch (e.placeholder.documentPlaceholder) {
        case 'id-rectangle-corners-front':
          return O(ll, {});
        case 'id-rectangle-dash-front':
          return O(cl, {});
        case 'id-rectangle-dot-front':
          return O(hl, {});
        case 'id-rectangle-solid-front':
          return O(fl, {});
        case 'id-rounded-rectangle-photo-front':
          return O(ml, {});
        case 'id-rounded-rectangle-corners-front':
          return O(ao, {});
        case 'id-rounded-rectangle-dash-front':
          return O(dl, {});
        case 'id-rounded-rectangle-dot-front':
          return O(pl, {});
        case 'id-rounded-rectangle-solid-back':
          return O(gl, {});
        case 'id-rounded-rectangle-solid-front':
          return O(_l, {});
        case 'pass-rounded-rectangle-solid-back':
          return O(vl, {});
        case 'pass-rounded-rectangle-solid-back-blank':
          return O(yl, {});
        default:
          return O(ao, {});
      }
    },
    so = (e, n) => n.sharpness > e.sharpness,
    bl = (e, n) => {
      const { topLeft: t, bottomLeft: r, topRight: o, bottomRight: i } = e,
        a = oe(t, o) * n.width,
        s = oe(o, i) * n.height,
        l = oe(r, i) * n.width,
        g = oe(t, r) * n.height;
      return Math.min(a, s, l, g) / n.width;
    },
    Cl = (e, n) => {
      const { topLeft: t, bottomLeft: r, topRight: o, bottomRight: i } = n;
      return !(
        t.x < e ||
        r.x < e ||
        o.x > 1 - e ||
        i.x > 1 - e ||
        o.y < e ||
        t.y < e ||
        i.y > 1 - e ||
        r.y > 1 - e
      );
    },
    pe = (e) => (e < 0 ? -1 * na * e : e),
    kl = (e, n) => {
      const t = vr(n),
        r = rl(n, t),
        o = {
          top: r.shiftY,
          bottom: r.shiftY + r.height,
          left: r.shiftX,
          right: r.shiftX + r.width,
        };
      let i = 0;
      return (
        (i +=
          un * Math.abs(e.topLeft.x - e.bottomLeft.x) +
          un * Math.abs(e.topRight.x - e.bottomRight.x)),
        (i += sn * pe(e.topLeft.x - o.left)),
        (i += sn * pe(e.bottomLeft.x - o.left)),
        (i += sn * pe(o.right - e.topRight.x)),
        (i += sn * pe(o.right - e.bottomRight.x)),
        (i +=
          un * Math.abs(e.topLeft.y - e.topRight.y) +
          un * Math.abs(e.bottomLeft.y - e.bottomRight.y)),
        (i += pe(e.topLeft.y - o.top)),
        (i += pe(e.topRight.y - o.top)),
        (i += pe(o.bottom - e.bottomLeft.y)),
        (i += pe(o.bottom - e.bottomRight.y)),
        (i /= ra),
        i
      );
    },
    xl = (e, n, t) => {
      const r = kl(e, n),
        o = bl(e, t);
      return { ...e, placeholderFitError: r, smallestEdge: o };
    };
  var Sl = (function () {
    var e =
      typeof document < 'u' && document.currentScript
        ? document.currentScript.src
        : void 0;
    return function (n) {
      n = n || {};
      var t;
      t || (t = typeof n < 'u' ? n : {});
      var r, o;
      t.ready = new Promise(function (p, y) {
        (r = p), (o = y);
      });
      var i = {},
        a;
      for (a in t) t.hasOwnProperty(a) && (i[a] = t[a]);
      var s = './this.program',
        l = !1,
        g = !1;
      (l = typeof window == 'object'), (g = typeof importScripts == 'function');
      var c = '',
        w;
      (l || g) &&
        (g
          ? (c = self.location.href)
          : document.currentScript && (c = document.currentScript.src),
        e && (c = e),
        c.indexOf('blob:') !== 0
          ? (c = c.substr(0, c.lastIndexOf('/') + 1))
          : (c = ''),
        g &&
          (w = function (p) {
            var y = new XMLHttpRequest();
            return (
              y.open('GET', p, !1),
              (y.responseType = 'arraybuffer'),
              y.send(null),
              new Uint8Array(y.response)
            );
          }));
      var b = t.print || console.log.bind(console),
        h = t.printErr || console.warn.bind(console);
      for (a in i) i.hasOwnProperty(a) && (t[a] = i[a]);
      (i = null), t.thisProgram && (s = t.thisProgram);
      var _;
      t.wasmBinary && (_ = t.wasmBinary),
        t.noExitRuntime && t.noExitRuntime,
        typeof WebAssembly != 'object' && ft('no native wasm support detected');
      var d,
        v = !1;
      function m(p) {
        p || ft('Assertion failed: undefined');
      }
      var k = typeof TextDecoder < 'u' ? new TextDecoder('utf8') : void 0;
      function E(p, y, S) {
        var R = y + S;
        for (S = y; p[S] && !(S >= R); ) ++S;
        if (16 < S - y && p.subarray && k) return k.decode(p.subarray(y, S));
        for (R = ''; y < S; ) {
          var q = p[y++];
          if (q & 128) {
            var J = p[y++] & 63;
            if ((q & 224) == 192) R += String.fromCharCode(((q & 31) << 6) | J);
            else {
              var ht = p[y++] & 63;
              (q =
                (q & 240) == 224
                  ? ((q & 15) << 12) | (J << 6) | ht
                  : ((q & 7) << 18) | (J << 12) | (ht << 6) | (p[y++] & 63)),
                65536 > q
                  ? (R += String.fromCharCode(q))
                  : ((q -= 65536),
                    (R += String.fromCharCode(
                      55296 | (q >> 10),
                      56320 | (q & 1023)
                    )));
            }
          } else R += String.fromCharCode(q);
        }
        return R;
      }
      function I(p, y, S, R) {
        if (0 < R) {
          R = S + R - 1;
          for (var q = 0; q < p.length; ++q) {
            var J = p.charCodeAt(q);
            if (55296 <= J && 57343 >= J) {
              var ht = p.charCodeAt(++q);
              J = (65536 + ((J & 1023) << 10)) | (ht & 1023);
            }
            if (127 >= J) {
              if (S >= R) break;
              y[S++] = J;
            } else {
              if (2047 >= J) {
                if (S + 1 >= R) break;
                y[S++] = 192 | (J >> 6);
              } else {
                if (65535 >= J) {
                  if (S + 2 >= R) break;
                  y[S++] = 224 | (J >> 12);
                } else {
                  if (S + 3 >= R) break;
                  (y[S++] = 240 | (J >> 18)), (y[S++] = 128 | ((J >> 12) & 63));
                }
                y[S++] = 128 | ((J >> 6) & 63);
              }
              y[S++] = 128 | (J & 63);
            }
          }
          y[S] = 0;
        }
      }
      function A(p) {
        for (var y = 0, S = 0; S < p.length; ++S) {
          var R = p.charCodeAt(S);
          55296 <= R &&
            57343 >= R &&
            (R = (65536 + ((R & 1023) << 10)) | (p.charCodeAt(++S) & 1023)),
            127 >= R
              ? ++y
              : (y = 2047 >= R ? y + 2 : 65535 >= R ? y + 3 : y + 4);
        }
        return y;
      }
      var U = typeof TextDecoder < 'u' ? new TextDecoder('utf-16le') : void 0;
      function W(p, y) {
        for (var S = p >> 1, R = S + y / 2; !(S >= R) && Y[S]; ) ++S;
        if (((S <<= 1), 32 < S - p && U)) return U.decode(M.subarray(p, S));
        for (S = 0, R = ''; ; ) {
          var q = gt[(p + 2 * S) >> 1];
          if (q == 0 || S == y / 2) return R;
          ++S, (R += String.fromCharCode(q));
        }
      }
      function it(p, y, S) {
        if ((S === void 0 && (S = 2147483647), 2 > S)) return 0;
        S -= 2;
        var R = y;
        S = S < 2 * p.length ? S / 2 : p.length;
        for (var q = 0; q < S; ++q) (gt[y >> 1] = p.charCodeAt(q)), (y += 2);
        return (gt[y >> 1] = 0), y - R;
      }
      function j(p) {
        return 2 * p.length;
      }
      function at(p, y) {
        for (var S = 0, R = ''; !(S >= y / 4); ) {
          var q = st[(p + 4 * S) >> 2];
          if (q == 0) break;
          ++S,
            65536 <= q
              ? ((q -= 65536),
                (R += String.fromCharCode(
                  55296 | (q >> 10),
                  56320 | (q & 1023)
                )))
              : (R += String.fromCharCode(q));
        }
        return R;
      }
      function lt(p, y, S) {
        if ((S === void 0 && (S = 2147483647), 4 > S)) return 0;
        var R = y;
        S = R + S - 4;
        for (var q = 0; q < p.length; ++q) {
          var J = p.charCodeAt(q);
          if (55296 <= J && 57343 >= J) {
            var ht = p.charCodeAt(++q);
            J = (65536 + ((J & 1023) << 10)) | (ht & 1023);
          }
          if (((st[y >> 2] = J), (y += 4), y + 4 > S)) break;
        }
        return (st[y >> 2] = 0), y - R;
      }
      function L(p) {
        for (var y = 0, S = 0; S < p.length; ++S) {
          var R = p.charCodeAt(S);
          55296 <= R && 57343 >= R && ++S, (y += 4);
        }
        return y;
      }
      var V, f, M, gt, Y, st, nt, mt, B;
      function T(p) {
        (V = p),
          (t.HEAP8 = f = new Int8Array(p)),
          (t.HEAP16 = gt = new Int16Array(p)),
          (t.HEAP32 = st = new Int32Array(p)),
          (t.HEAPU8 = M = new Uint8Array(p)),
          (t.HEAPU16 = Y = new Uint16Array(p)),
          (t.HEAPU32 = nt = new Uint32Array(p)),
          (t.HEAPF32 = mt = new Float32Array(p)),
          (t.HEAPF64 = B = new Float64Array(p));
      }
      var K = t.INITIAL_MEMORY || 16777216;
      t.wasmMemory
        ? (d = t.wasmMemory)
        : (d = new WebAssembly.Memory({ initial: K / 65536, maximum: 32768 })),
        d && (V = d.buffer),
        (K = V.byteLength),
        T(V);
      var H = [],
        $ = [],
        P = [],
        vt = [];
      function Q() {
        var p = t.preRun.shift();
        H.unshift(p);
      }
      var dt = 0,
        yt = null;
      (t.preloadedImages = {}), (t.preloadedAudios = {});
      function ft(p) {
        throw (
          (t.onAbort && t.onAbort(p),
          h(p),
          (v = !0),
          (p = new WebAssembly.RuntimeError(
            'abort(' + p + '). Build with -s ASSERTIONS=1 for more info.'
          )),
          o(p),
          p)
        );
      }
      function et(p) {
        var y = u;
        return String.prototype.startsWith
          ? y.startsWith(p)
          : y.indexOf(p) === 0;
      }
      function xt() {
        return et('data:application/octet-stream;base64,');
      }
      var u = 'sam.wasm';
      if (!xt()) {
        var N = u;
        u = t.locateFile ? t.locateFile(N, c) : c + N;
      }
      function F() {
        try {
          if (_) return new Uint8Array(_);
          if (w) return w(u);
          throw 'both async and sync fetching of the wasm failed';
        } catch (p) {
          ft(p);
        }
      }
      function x() {
        return _ || (!l && !g) || typeof fetch != 'function' || et('file://')
          ? Promise.resolve().then(F)
          : fetch(u, { credentials: 'same-origin' })
              .then(function (p) {
                if (!p.ok)
                  throw "failed to load wasm binary file at '" + u + "'";
                return p.arrayBuffer();
              })
              .catch(function () {
                return F();
              });
      }
      function C(p) {
        for (; 0 < p.length; ) {
          var y = p.shift();
          if (typeof y == 'function') y(t);
          else {
            var S = y.Ka;
            typeof S == 'number'
              ? y.Ca === void 0
                ? D('v', S)()
                : D('vi', S)(y.Ca)
              : S(y.Ca === void 0 ? null : y.Ca);
          }
        }
      }
      function D(p, y) {
        var S = [];
        return function () {
          S.length = arguments.length;
          for (var R = 0; R < arguments.length; R++) S[R] = arguments[R];
          return S && S.length
            ? t['dynCall_' + p].apply(null, [y].concat(S))
            : t['dynCall_' + p].call(null, y);
        };
      }
      function G(p) {
        (this.ga = p - 16),
          (this.Xa = function (y) {
            st[(this.ga + 8) >> 2] = y;
          }),
          (this.Ua = function (y) {
            st[(this.ga + 0) >> 2] = y;
          }),
          (this.Va = function () {
            st[(this.ga + 4) >> 2] = 0;
          }),
          (this.Ta = function () {
            f[(this.ga + 12) >> 0] = 0;
          }),
          (this.Wa = function () {
            f[(this.ga + 13) >> 0] = 0;
          }),
          (this.Oa = function (y, S) {
            this.Xa(y), this.Ua(S), this.Va(), this.Ta(), this.Wa();
          });
      }
      function tt() {
        return 0 < tt.Ga;
      }
      function z(p) {
        switch (p) {
          case 1:
            return 0;
          case 2:
            return 1;
          case 4:
            return 2;
          case 8:
            return 3;
          default:
            throw new TypeError('Unknown type size: ' + p);
        }
      }
      var ot = void 0;
      function X(p) {
        for (var y = ''; M[p]; ) y += ot[M[p++]];
        return y;
      }
      var rt = {},
        _t = {},
        At = {};
      function kt(p) {
        if (p === void 0) return '_unknown';
        p = p.replace(/[^a-zA-Z0-9_]/g, '$');
        var y = p.charCodeAt(0);
        return 48 <= y && 57 >= y ? '_' + p : p;
      }
      function Ut(p, y) {
        return (
          (p = kt(p)),
          new Function(
            'body',
            'return function ' +
              p +
              `() {
    "use strict";    return body.apply(this, arguments);
};
`
          )(y)
        );
      }
      function ae(p) {
        var y = Error,
          S = Ut(p, function (R) {
            (this.name = p),
              (this.message = R),
              (R = Error(R).stack),
              R !== void 0 &&
                (this.stack =
                  this.toString() +
                  `
` +
                  R.replace(/^Error(:[^\n]*)?\n/, ''));
          });
        return (
          (S.prototype = Object.create(y.prototype)),
          (S.prototype.constructor = S),
          (S.prototype.toString = function () {
            return this.message === void 0
              ? this.name
              : this.name + ': ' + this.message;
          }),
          S
        );
      }
      var Vt = void 0;
      function St(p) {
        throw new Vt(p);
      }
      var Ot = void 0;
      function se(p) {
        throw new Ot(p);
      }
      function Qt(p, y, S) {
        function R(ut) {
          (ut = S(ut)),
            ut.length !== p.length && se('Mismatched type converter count');
          for (var Ct = 0; Ct < p.length; ++Ct) Ft(p[Ct], ut[Ct]);
        }
        p.forEach(function (ut) {
          At[ut] = y;
        });
        var q = Array(y.length),
          J = [],
          ht = 0;
        y.forEach(function (ut, Ct) {
          _t.hasOwnProperty(ut)
            ? (q[Ct] = _t[ut])
            : (J.push(ut),
              rt.hasOwnProperty(ut) || (rt[ut] = []),
              rt[ut].push(function () {
                (q[Ct] = _t[ut]), ++ht, ht === J.length && R(q);
              }));
        }),
          J.length === 0 && R(q);
      }
      function Ft(p, y, S) {
        if (((S = S || {}), !('argPackAdvance' in y)))
          throw new TypeError(
            'registerType registeredInstance requires argPackAdvance'
          );
        var R = y.name;
        if (
          (p ||
            St('type "' + R + '" must have a positive integer typeid pointer'),
          _t.hasOwnProperty(p))
        ) {
          if (S.Na) return;
          St("Cannot register type '" + R + "' twice");
        }
        (_t[p] = y),
          delete At[p],
          rt.hasOwnProperty(p) &&
            ((y = rt[p]),
            delete rt[p],
            y.forEach(function (q) {
              q();
            }));
      }
      function kn(p) {
        return {
          count: p.count,
          sa: p.sa,
          ua: p.ua,
          ga: p.ga,
          ia: p.ia,
          ka: p.ka,
          la: p.la,
        };
      }
      function We(p) {
        St(p.A.ia.ha.name + ' instance already deleted');
      }
      var He = !1;
      function xn() {}
      function Ze(p) {
        --p.count.value,
          p.count.value === 0 && (p.ka ? p.la.ra(p.ka) : p.ia.ha.ra(p.ga));
      }
      function Gt(p) {
        return typeof FinalizationGroup > 'u'
          ? ((Gt = function (y) {
              return y;
            }),
            p)
          : ((He = new FinalizationGroup(function (y) {
              for (var S = y.next(); !S.done; S = y.next())
                (S = S.value),
                  S.ga
                    ? Ze(S)
                    : console.warn('object already deleted: ' + S.ga);
            })),
            (Gt = function (y) {
              return He.register(y, y.A, y.A), y;
            }),
            (xn = function (y) {
              He.unregister(y.A);
            }),
            Gt(p));
      }
      var te = void 0,
        Ye = [];
      function wr() {
        for (; Ye.length; ) {
          var p = Ye.pop();
          (p.A.sa = !1), p.delete();
        }
      }
      function me() {}
      var lo = {};
      function Tl(p, y) {
        var S = t;
        if (S[p].na === void 0) {
          var R = S[p];
          (S[p] = function () {
            return (
              S[p].na.hasOwnProperty(arguments.length) ||
                St(
                  "Function '" +
                    y +
                    "' called with an invalid number of arguments (" +
                    arguments.length +
                    ') - expects one of (' +
                    S[p].na +
                    ')!'
                ),
              S[p].na[arguments.length].apply(this, arguments)
            );
          }),
            (S[p].na = []),
            (S[p].na[R.Ha] = R);
        }
      }
      function co(p, y, S) {
        t.hasOwnProperty(p)
          ? ((S === void 0 || (t[p].na !== void 0 && t[p].na[S] !== void 0)) &&
              St("Cannot register public name '" + p + "' twice"),
            Tl(p, p),
            t.hasOwnProperty(S) &&
              St(
                'Cannot register multiple overloads of a function with the same number of arguments (' +
                  S +
                  ')!'
              ),
            (t[p].na[S] = y))
          : ((t[p] = y), S !== void 0 && (t[p].gb = S));
      }
      function Il(p, y, S, R, q, J, ht, ut) {
        (this.name = p),
          (this.constructor = y),
          (this.qa = S),
          (this.ra = R),
          (this.ma = q),
          (this.La = J),
          (this.wa = ht),
          (this.Ja = ut);
      }
      function Sn(p, y, S) {
        for (; y !== S; )
          y.wa ||
            St(
              'Expected null or instance of ' +
                S.name +
                ', got an instance of ' +
                y.name
            ),
            (p = y.wa(p)),
            (y = y.ma);
        return p;
      }
      function Rl(p, y) {
        return y === null
          ? (this.Da && St('null is not a valid ' + this.name), 0)
          : (y.A || St('Cannot pass "' + Te(y) + '" as a ' + this.name),
            y.A.ga ||
              St(
                'Cannot pass deleted object as a pointer of type ' + this.name
              ),
            Sn(y.A.ga, y.A.ia.ha, this.ha));
      }
      function Ol(p, y) {
        if (y === null) {
          if ((this.Da && St('null is not a valid ' + this.name), this.ya)) {
            var S = this.Qa();
            return p !== null && p.push(this.ra, S), S;
          }
          return 0;
        }
        if (
          (y.A || St('Cannot pass "' + Te(y) + '" as a ' + this.name),
          y.A.ga ||
            St('Cannot pass deleted object as a pointer of type ' + this.name),
          !this.xa &&
            y.A.ia.xa &&
            St(
              'Cannot convert argument of type ' +
                (y.A.la ? y.A.la.name : y.A.ia.name) +
                ' to parameter type ' +
                this.name
            ),
          (S = Sn(y.A.ga, y.A.ia.ha, this.ha)),
          this.ya)
        )
          switch (
            (y.A.ka === void 0 &&
              St('Passing raw pointer to smart pointer is illegal'),
            this.Ya)
          ) {
            case 0:
              y.A.la === this
                ? (S = y.A.ka)
                : St(
                    'Cannot convert argument of type ' +
                      (y.A.la ? y.A.la.name : y.A.ia.name) +
                      ' to parameter type ' +
                      this.name
                  );
              break;
            case 1:
              S = y.A.ka;
              break;
            case 2:
              if (y.A.la === this) S = y.A.ka;
              else {
                var R = y.clone();
                (S = this.Ra(
                  S,
                  _o(function () {
                    R.delete();
                  })
                )),
                  p !== null && p.push(this.ra, S);
              }
              break;
            default:
              St('Unsupporting sharing policy');
          }
        return S;
      }
      function Dl(p, y) {
        return y === null
          ? (this.Da && St('null is not a valid ' + this.name), 0)
          : (y.A || St('Cannot pass "' + Te(y) + '" as a ' + this.name),
            y.A.ga ||
              St(
                'Cannot pass deleted object as a pointer of type ' + this.name
              ),
            y.A.ia.xa &&
              St(
                'Cannot convert argument of type ' +
                  y.A.ia.name +
                  ' to parameter type ' +
                  this.name
              ),
            Sn(y.A.ga, y.A.ia.ha, this.ha));
      }
      function An(p) {
        return this.fromWireType(nt[p >> 2]);
      }
      function ho(p, y, S) {
        return y === S
          ? p
          : S.ma === void 0
          ? null
          : ((p = ho(p, y, S.ma)), p === null ? null : S.Ja(p));
      }
      var Ge = {};
      function Pl(p, y) {
        for (y === void 0 && St('ptr should not be undefined'); p.ma; )
          (y = p.wa(y)), (p = p.ma);
        return Ge[y];
      }
      function En(p, y) {
        return (
          (y.ia && y.ga) || se('makeClassHandle requires ptr and ptrType'),
          !!y.la != !!y.ka &&
            se('Both smartPtrType and smartPtr must be specified'),
          (y.count = { value: 1 }),
          Gt(Object.create(p, { A: { value: y } }))
        );
      }
      function ue(p, y, S, R) {
        (this.name = p),
          (this.ha = y),
          (this.Da = S),
          (this.xa = R),
          (this.ya = !1),
          (this.ra = this.Ra = this.Qa = this.Fa = this.Ya = this.Pa = void 0),
          y.ma !== void 0
            ? (this.toWireType = Ol)
            : ((this.toWireType = R ? Rl : Dl), (this.oa = null));
      }
      function fo(p, y, S) {
        t.hasOwnProperty(p) || se('Replacing nonexistant public symbol'),
          t[p].na !== void 0 && S !== void 0
            ? (t[p].na[S] = y)
            : ((t[p] = y), (t[p].Ha = S));
      }
      function ge(p, y) {
        p = X(p);
        var S = D(p, y);
        return (
          typeof S != 'function' &&
            St('unknown function pointer with signature ' + p + ': ' + y),
          S
        );
      }
      var po = void 0;
      function zl(p) {
        p = So(p);
        var y = X(p);
        return le(p), y;
      }
      function Xe(p, y) {
        function S(J) {
          q[J] ||
            _t[J] ||
            (At[J] ? At[J].forEach(S) : (R.push(J), (q[J] = !0)));
        }
        var R = [],
          q = {};
        throw (y.forEach(S), new po(p + ': ' + R.map(zl).join([', '])));
      }
      function mo(p, y) {
        for (var S = [], R = 0; R < p; R++) S.push(st[(y >> 2) + R]);
        return S;
      }
      function br(p) {
        for (; p.length; ) {
          var y = p.pop();
          p.pop()(y);
        }
      }
      function go(p, y, S) {
        return (
          p instanceof Object || St(S + ' with invalid "this": ' + p),
          p instanceof y.ha.constructor ||
            St(S + ' incompatible with "this" of type ' + p.constructor.name),
          p.A.ga ||
            St(
              'cannot call emscripten binding method ' +
                S +
                ' on deleted object'
            ),
          Sn(p.A.ga, p.A.ia.ha, y.ha)
        );
      }
      var Cr = [],
        ee = [
          {},
          { value: void 0 },
          { value: null },
          { value: !0 },
          { value: !1 },
        ];
      function _o(p) {
        switch (p) {
          case void 0:
            return 1;
          case null:
            return 2;
          case !0:
            return 3;
          case !1:
            return 4;
          default:
            var y = Cr.length ? Cr.pop() : ee.length;
            return (ee[y] = { Sa: 1, value: p }), y;
        }
      }
      function Te(p) {
        if (p === null) return 'null';
        var y = typeof p;
        return y === 'object' || y === 'array' || y === 'function'
          ? p.toString()
          : '' + p;
      }
      function Nl(p, y) {
        switch (y) {
          case 2:
            return function (S) {
              return this.fromWireType(mt[S >> 2]);
            };
          case 3:
            return function (S) {
              return this.fromWireType(B[S >> 3]);
            };
          default:
            throw new TypeError('Unknown float type: ' + p);
        }
      }
      function Ml(p) {
        var y = Function;
        if (!(y instanceof Function))
          throw new TypeError(
            'new_ called with constructor type ' +
              typeof y +
              ' which is not a function'
          );
        var S = Ut(y.name || 'unknownFunctionName', function () {});
        return (
          (S.prototype = y.prototype),
          (S = new S()),
          (p = y.apply(S, p)),
          p instanceof Object ? p : S
        );
      }
      function Fl(p, y, S) {
        switch (y) {
          case 0:
            return S
              ? function (R) {
                  return f[R];
                }
              : function (R) {
                  return M[R];
                };
          case 1:
            return S
              ? function (R) {
                  return gt[R >> 1];
                }
              : function (R) {
                  return Y[R >> 1];
                };
          case 2:
            return S
              ? function (R) {
                  return st[R >> 2];
                }
              : function (R) {
                  return nt[R >> 2];
                };
          default:
            throw new TypeError('Unknown integer type: ' + p);
        }
      }
      var vo = {};
      function yo() {
        if (!kr) {
          var p = {
              USER: 'web_user',
              LOGNAME: 'web_user',
              PATH: '/',
              PWD: '/',
              HOME: '/home/web_user',
              LANG:
                (
                  (typeof navigator == 'object' &&
                    navigator.languages &&
                    navigator.languages[0]) ||
                  'C'
                ).replace('-', '_') + '.UTF-8',
              _: s || './this.program',
            },
            y;
          for (y in vo) p[y] = vo[y];
          var S = [];
          for (y in p) S.push(y + '=' + p[y]);
          kr = S;
        }
        return kr;
      }
      var kr,
        Bl = [null, [], []],
        wo = {};
      function Ln(p) {
        return p % 4 === 0 && (p % 100 !== 0 || p % 400 === 0);
      }
      function xr(p, y) {
        for (var S = 0, R = 0; R <= y; S += p[R++]);
        return S;
      }
      var Tn = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        In = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function Rn(p, y) {
        for (p = new Date(p.getTime()); 0 < y; ) {
          var S = p.getMonth(),
            R = (Ln(p.getFullYear()) ? Tn : In)[S];
          if (y > R - p.getDate())
            (y -= R - p.getDate() + 1),
              p.setDate(1),
              11 > S
                ? p.setMonth(S + 1)
                : (p.setMonth(0), p.setFullYear(p.getFullYear() + 1));
          else {
            p.setDate(p.getDate() + y);
            break;
          }
        }
        return p;
      }
      function Vl(p, y, S, R) {
        function q(Z, ct, Lt) {
          for (
            Z = typeof Z == 'number' ? Z.toString() : Z || '';
            Z.length < ct;

          )
            Z = Lt[0] + Z;
          return Z;
        }
        function J(Z, ct) {
          return q(Z, ct, '0');
        }
        function ht(Z, ct) {
          function Lt(jt) {
            return 0 > jt ? -1 : 0 < jt ? 1 : 0;
          }
          var Dt;
          return (
            (Dt = Lt(Z.getFullYear() - ct.getFullYear())) === 0 &&
              (Dt = Lt(Z.getMonth() - ct.getMonth())) === 0 &&
              (Dt = Lt(Z.getDate() - ct.getDate())),
            Dt
          );
        }
        function ut(Z) {
          switch (Z.getDay()) {
            case 0:
              return new Date(Z.getFullYear() - 1, 11, 29);
            case 1:
              return Z;
            case 2:
              return new Date(Z.getFullYear(), 0, 3);
            case 3:
              return new Date(Z.getFullYear(), 0, 2);
            case 4:
              return new Date(Z.getFullYear(), 0, 1);
            case 5:
              return new Date(Z.getFullYear() - 1, 11, 31);
            case 6:
              return new Date(Z.getFullYear() - 1, 11, 30);
          }
        }
        function Ct(Z) {
          Z = Rn(new Date(Z.ja + 1900, 0, 1), Z.Ba);
          var ct = new Date(Z.getFullYear() + 1, 0, 4),
            Lt = ut(new Date(Z.getFullYear(), 0, 4));
          return (
            (ct = ut(ct)),
            0 >= ht(Lt, Z)
              ? 0 >= ht(ct, Z)
                ? Z.getFullYear() + 1
                : Z.getFullYear()
              : Z.getFullYear() - 1
          );
        }
        var bt = st[(R + 40) >> 2];
        (R = {
          ab: st[R >> 2],
          $a: st[(R + 4) >> 2],
          za: st[(R + 8) >> 2],
          va: st[(R + 12) >> 2],
          ta: st[(R + 16) >> 2],
          ja: st[(R + 20) >> 2],
          Aa: st[(R + 24) >> 2],
          Ba: st[(R + 28) >> 2],
          hb: st[(R + 32) >> 2],
          Za: st[(R + 36) >> 2],
          bb: bt && bt ? E(M, bt, void 0) : '',
        }),
          (S = S ? E(M, S, void 0) : ''),
          (bt = {
            '%c': '%a %b %d %H:%M:%S %Y',
            '%D': '%m/%d/%y',
            '%F': '%Y-%m-%d',
            '%h': '%b',
            '%r': '%I:%M:%S %p',
            '%R': '%H:%M',
            '%T': '%H:%M:%S',
            '%x': '%m/%d/%y',
            '%X': '%H:%M:%S',
            '%Ec': '%c',
            '%EC': '%C',
            '%Ex': '%m/%d/%y',
            '%EX': '%H:%M:%S',
            '%Ey': '%y',
            '%EY': '%Y',
            '%Od': '%d',
            '%Oe': '%e',
            '%OH': '%H',
            '%OI': '%I',
            '%Om': '%m',
            '%OM': '%M',
            '%OS': '%S',
            '%Ou': '%u',
            '%OU': '%U',
            '%OV': '%V',
            '%Ow': '%w',
            '%OW': '%W',
            '%Oy': '%y',
          });
        for (var wt in bt) S = S.replace(new RegExp(wt, 'g'), bt[wt]);
        var Et =
            'Sunday Monday Tuesday Wednesday Thursday Friday Saturday'.split(
              ' '
            ),
          Rt =
            'January February March April May June July August September October November December'.split(
              ' '
            );
        bt = {
          '%a': function (Z) {
            return Et[Z.Aa].substring(0, 3);
          },
          '%A': function (Z) {
            return Et[Z.Aa];
          },
          '%b': function (Z) {
            return Rt[Z.ta].substring(0, 3);
          },
          '%B': function (Z) {
            return Rt[Z.ta];
          },
          '%C': function (Z) {
            return J(((Z.ja + 1900) / 100) | 0, 2);
          },
          '%d': function (Z) {
            return J(Z.va, 2);
          },
          '%e': function (Z) {
            return q(Z.va, 2, ' ');
          },
          '%g': function (Z) {
            return Ct(Z).toString().substring(2);
          },
          '%G': function (Z) {
            return Ct(Z);
          },
          '%H': function (Z) {
            return J(Z.za, 2);
          },
          '%I': function (Z) {
            return (Z = Z.za), Z == 0 ? (Z = 12) : 12 < Z && (Z -= 12), J(Z, 2);
          },
          '%j': function (Z) {
            return J(Z.va + xr(Ln(Z.ja + 1900) ? Tn : In, Z.ta - 1), 3);
          },
          '%m': function (Z) {
            return J(Z.ta + 1, 2);
          },
          '%M': function (Z) {
            return J(Z.$a, 2);
          },
          '%n': function () {
            return `
`;
          },
          '%p': function (Z) {
            return 0 <= Z.za && 12 > Z.za ? 'AM' : 'PM';
          },
          '%S': function (Z) {
            return J(Z.ab, 2);
          },
          '%t': function () {
            return '	';
          },
          '%u': function (Z) {
            return Z.Aa || 7;
          },
          '%U': function (Z) {
            var ct = new Date(Z.ja + 1900, 0, 1),
              Lt = ct.getDay() === 0 ? ct : Rn(ct, 7 - ct.getDay());
            return (
              (Z = new Date(Z.ja + 1900, Z.ta, Z.va)),
              0 > ht(Lt, Z)
                ? J(
                    Math.ceil(
                      (31 -
                        Lt.getDate() +
                        (xr(Ln(Z.getFullYear()) ? Tn : In, Z.getMonth() - 1) -
                          31) +
                        Z.getDate()) /
                        7
                    ),
                    2
                  )
                : ht(Lt, ct) === 0
                ? '01'
                : '00'
            );
          },
          '%V': function (Z) {
            var ct = new Date(Z.ja + 1901, 0, 4),
              Lt = ut(new Date(Z.ja + 1900, 0, 4));
            ct = ut(ct);
            var Dt = Rn(new Date(Z.ja + 1900, 0, 1), Z.Ba);
            return 0 > ht(Dt, Lt)
              ? '53'
              : 0 >= ht(ct, Dt)
              ? '01'
              : J(
                  Math.ceil(
                    (Lt.getFullYear() < Z.ja + 1900
                      ? Z.Ba + 32 - Lt.getDate()
                      : Z.Ba + 1 - Lt.getDate()) / 7
                  ),
                  2
                );
          },
          '%w': function (Z) {
            return Z.Aa;
          },
          '%W': function (Z) {
            var ct = new Date(Z.ja, 0, 1),
              Lt =
                ct.getDay() === 1
                  ? ct
                  : Rn(ct, ct.getDay() === 0 ? 1 : 7 - ct.getDay() + 1);
            return (
              (Z = new Date(Z.ja + 1900, Z.ta, Z.va)),
              0 > ht(Lt, Z)
                ? J(
                    Math.ceil(
                      (31 -
                        Lt.getDate() +
                        (xr(Ln(Z.getFullYear()) ? Tn : In, Z.getMonth() - 1) -
                          31) +
                        Z.getDate()) /
                        7
                    ),
                    2
                  )
                : ht(Lt, ct) === 0
                ? '01'
                : '00'
            );
          },
          '%y': function (Z) {
            return (Z.ja + 1900).toString().substring(2);
          },
          '%Y': function (Z) {
            return Z.ja + 1900;
          },
          '%z': function (Z) {
            Z = Z.Za;
            var ct = 0 <= Z;
            return (
              (Z = Math.abs(Z) / 60),
              (ct ? '+' : '-') +
                String('0000' + ((Z / 60) * 100 + (Z % 60))).slice(-4)
            );
          },
          '%Z': function (Z) {
            return Z.bb;
          },
          '%%': function () {
            return '%';
          },
        };
        for (wt in bt)
          0 <= S.indexOf(wt) && (S = S.replace(new RegExp(wt, 'g'), bt[wt](R)));
        return (wt = jl(S)), wt.length > y ? 0 : (f.set(wt, p), wt.length - 1);
      }
      var bo = [];
      function Co(p) {
        var y = {},
          S;
        for (S in p)
          (function (R) {
            var q = p[R];
            y[R] =
              typeof q == 'function'
                ? function () {
                    bo.push(R);
                    try {
                      return q.apply(null, arguments);
                    } finally {
                      if (v) return;
                      var J = bo.pop();
                      m(J === R);
                    }
                  }
                : q;
          })(S);
        return y;
      }
      for (var ko = Array(256), On = 0; 256 > On; ++On)
        ko[On] = String.fromCharCode(On);
      (ot = ko),
        (Vt = t.BindingError = ae('BindingError')),
        (Ot = t.InternalError = ae('InternalError')),
        (me.prototype.isAliasOf = function (p) {
          if (!(this instanceof me && p instanceof me)) return !1;
          var y = this.A.ia.ha,
            S = this.A.ga,
            R = p.A.ia.ha;
          for (p = p.A.ga; y.ma; ) (S = y.wa(S)), (y = y.ma);
          for (; R.ma; ) (p = R.wa(p)), (R = R.ma);
          return y === R && S === p;
        }),
        (me.prototype.clone = function () {
          if ((this.A.ga || We(this), this.A.ua))
            return (this.A.count.value += 1), this;
          var p = Gt(
            Object.create(Object.getPrototypeOf(this), {
              A: { value: kn(this.A) },
            })
          );
          return (p.A.count.value += 1), (p.A.sa = !1), p;
        }),
        (me.prototype.delete = function () {
          this.A.ga || We(this),
            this.A.sa &&
              !this.A.ua &&
              St('Object already scheduled for deletion'),
            xn(this),
            Ze(this.A),
            this.A.ua || ((this.A.ka = void 0), (this.A.ga = void 0));
        }),
        (me.prototype.isDeleted = function () {
          return !this.A.ga;
        }),
        (me.prototype.deleteLater = function () {
          return (
            this.A.ga || We(this),
            this.A.sa &&
              !this.A.ua &&
              St('Object already scheduled for deletion'),
            Ye.push(this),
            Ye.length === 1 && te && te(wr),
            (this.A.sa = !0),
            this
          );
        }),
        (ue.prototype.Ma = function (p) {
          return this.Fa && (p = this.Fa(p)), p;
        }),
        (ue.prototype.Ea = function (p) {
          this.ra && this.ra(p);
        }),
        (ue.prototype.argPackAdvance = 8),
        (ue.prototype.readValueFromPointer = An),
        (ue.prototype.deleteObject = function (p) {
          p !== null && p.delete();
        }),
        (ue.prototype.fromWireType = function (p) {
          function y() {
            return this.ya
              ? En(this.ha.qa, { ia: this.Pa, ga: S, la: this, ka: p })
              : En(this.ha.qa, { ia: this, ga: p });
          }
          var S = this.Ma(p);
          if (!S) return this.Ea(p), null;
          var R = Pl(this.ha, S);
          if (R !== void 0)
            return R.A.count.value === 0
              ? ((R.A.ga = S), (R.A.ka = p), R.clone())
              : ((R = R.clone()), this.Ea(p), R);
          if (((R = this.ha.La(S)), (R = lo[R]), !R)) return y.call(this);
          R = this.xa ? R.Ia : R.pointerType;
          var q = ho(S, this.ha, R.ha);
          return q === null
            ? y.call(this)
            : this.ya
            ? En(R.ha.qa, { ia: R, ga: q, la: this, ka: p })
            : En(R.ha.qa, { ia: R, ga: q });
        }),
        (t.getInheritedInstanceCount = function () {
          return Object.keys(Ge).length;
        }),
        (t.getLiveInheritedInstances = function () {
          var p = [],
            y;
          for (y in Ge) Ge.hasOwnProperty(y) && p.push(Ge[y]);
          return p;
        }),
        (t.flushPendingDeletes = wr),
        (t.setDelayFunction = function (p) {
          (te = p), Ye.length && te && te(wr);
        }),
        (po = t.UnboundTypeError = ae('UnboundTypeError')),
        (t.count_emval_handles = function () {
          for (var p = 0, y = 5; y < ee.length; ++y) ee[y] !== void 0 && ++p;
          return p;
        }),
        (t.get_first_emval = function () {
          for (var p = 5; p < ee.length; ++p)
            if (ee[p] !== void 0) return ee[p];
          return null;
        });
      function jl(p) {
        var y = Array(A(p) + 1);
        return I(p, y, 0, y.length), y;
      }
      $.push({
        Ka: function () {
          xo();
        },
      });
      var $l = {
        m: function (p) {
          return Dn(p + 16) + 16;
        },
        j: function (p, y, S) {
          throw (
            (new G(p).Oa(y, S),
            'uncaught_exception' in tt ? tt.Ga++ : (tt.Ga = 1),
            p)
          );
        },
        o: function (p, y, S, R, q) {
          var J = z(S);
          (y = X(y)),
            Ft(p, {
              name: y,
              fromWireType: function (ht) {
                return !!ht;
              },
              toWireType: function (ht, ut) {
                return ut ? R : q;
              },
              argPackAdvance: 8,
              readValueFromPointer: function (ht) {
                if (S === 1) var ut = f;
                else if (S === 2) ut = gt;
                else if (S === 4) ut = st;
                else throw new TypeError('Unknown boolean type size: ' + y);
                return this.fromWireType(ut[ht >> J]);
              },
              oa: null,
            });
        },
        g: function (p, y, S, R, q, J, ht, ut, Ct, bt, wt, Et, Rt) {
          (wt = X(wt)),
            (J = ge(q, J)),
            ut && (ut = ge(ht, ut)),
            bt && (bt = ge(Ct, bt)),
            (Rt = ge(Et, Rt));
          var Z = kt(wt);
          co(Z, function () {
            Xe('Cannot construct ' + wt + ' due to unbound types', [R]);
          }),
            Qt([p, y, S], R ? [R] : [], function (ct) {
              if (((ct = ct[0]), R))
                var Lt = ct.ha,
                  Dt = Lt.qa;
              else Dt = me.prototype;
              ct = Ut(Z, function () {
                if (Object.getPrototypeOf(this) !== jt)
                  throw new Vt("Use 'new' to construct " + wt);
                if (Xt.pa === void 0)
                  throw new Vt(wt + ' has no accessible constructor');
                var Ao = Xt.pa[arguments.length];
                if (Ao === void 0)
                  throw new Vt(
                    'Tried to invoke ctor of ' +
                      wt +
                      ' with invalid number of parameters (' +
                      arguments.length +
                      ') - expected (' +
                      Object.keys(Xt.pa).toString() +
                      ') parameters instead!'
                  );
                return Ao.apply(this, arguments);
              });
              var jt = Object.create(Dt, { constructor: { value: ct } });
              ct.prototype = jt;
              var Xt = new Il(wt, ct, jt, Rt, Lt, J, ut, bt);
              (Lt = new ue(wt, Xt, !0, !1)),
                (Dt = new ue(wt + '*', Xt, !1, !1));
              var qe = new ue(wt + ' const*', Xt, !1, !0);
              return (
                (lo[p] = { pointerType: Dt, Ia: qe }), fo(Z, ct), [Lt, Dt, qe]
              );
            });
        },
        f: function (p, y, S, R, q, J) {
          m(0 < y);
          var ht = mo(y, S);
          q = ge(R, q);
          var ut = [J],
            Ct = [];
          Qt([], [p], function (bt) {
            bt = bt[0];
            var wt = 'constructor ' + bt.name;
            if (
              (bt.ha.pa === void 0 && (bt.ha.pa = []),
              bt.ha.pa[y - 1] !== void 0)
            )
              throw new Vt(
                'Cannot register multiple constructors with identical number of parameters (' +
                  (y - 1) +
                  ") for class '" +
                  bt.name +
                  "'! Overload resolution is currently only performed using the parameter count, not actual type info!"
              );
            return (
              (bt.ha.pa[y - 1] = function () {
                Xe('Cannot construct ' + bt.name + ' due to unbound types', ht);
              }),
              Qt([], ht, function (Et) {
                return (
                  (bt.ha.pa[y - 1] = function () {
                    arguments.length !== y - 1 &&
                      St(
                        wt +
                          ' called with ' +
                          arguments.length +
                          ' arguments, expected ' +
                          (y - 1)
                      ),
                      (Ct.length = 0),
                      (ut.length = y);
                    for (var Rt = 1; Rt < y; ++Rt)
                      ut[Rt] = Et[Rt].toWireType(Ct, arguments[Rt - 1]);
                    return (
                      (Rt = q.apply(null, ut)), br(Ct), Et[0].fromWireType(Rt)
                    );
                  }),
                  []
                );
              }),
              []
            );
          });
        },
        b: function (p, y, S, R, q, J, ht, ut, Ct, bt) {
          (y = X(y)),
            (q = ge(R, q)),
            Qt([], [p], function (wt) {
              wt = wt[0];
              var Et = wt.name + '.' + y,
                Rt = {
                  get: function () {
                    Xe('Cannot access ' + Et + ' due to unbound types', [
                      S,
                      ht,
                    ]);
                  },
                  enumerable: !0,
                  configurable: !0,
                };
              return (
                Ct
                  ? (Rt.set = function () {
                      Xe('Cannot access ' + Et + ' due to unbound types', [
                        S,
                        ht,
                      ]);
                    })
                  : (Rt.set = function () {
                      St(Et + ' is a read-only property');
                    }),
                Object.defineProperty(wt.ha.qa, y, Rt),
                Qt([], Ct ? [S, ht] : [S], function (Z) {
                  var ct = Z[0],
                    Lt = {
                      get: function () {
                        var jt = go(this, wt, Et + ' getter');
                        return ct.fromWireType(q(J, jt));
                      },
                      enumerable: !0,
                    };
                  if (Ct) {
                    Ct = ge(ut, Ct);
                    var Dt = Z[1];
                    Lt.set = function (jt) {
                      var Xt = go(this, wt, Et + ' setter'),
                        qe = [];
                      Ct(bt, Xt, Dt.toWireType(qe, jt)), br(qe);
                    };
                  }
                  return Object.defineProperty(wt.ha.qa, y, Lt), [];
                }),
                []
              );
            });
        },
        z: function (p, y) {
          (y = X(y)),
            Ft(p, {
              name: y,
              fromWireType: function (S) {
                var R = ee[S].value;
                return (
                  4 < S && --ee[S].Sa === 0 && ((ee[S] = void 0), Cr.push(S)), R
                );
              },
              toWireType: function (S, R) {
                return _o(R);
              },
              argPackAdvance: 8,
              readValueFromPointer: An,
              oa: null,
            });
        },
        l: function (p, y, S) {
          (S = z(S)),
            (y = X(y)),
            Ft(p, {
              name: y,
              fromWireType: function (R) {
                return R;
              },
              toWireType: function (R, q) {
                if (typeof q != 'number' && typeof q != 'boolean')
                  throw new TypeError(
                    'Cannot convert "' + Te(q) + '" to ' + this.name
                  );
                return q;
              },
              argPackAdvance: 8,
              readValueFromPointer: Nl(y, S),
              oa: null,
            });
        },
        e: function (p, y, S, R, q, J) {
          var ht = mo(y, S);
          (p = X(p)),
            (q = ge(R, q)),
            co(
              p,
              function () {
                Xe('Cannot call ' + p + ' due to unbound types', ht);
              },
              y - 1
            ),
            Qt([], ht, function (ut) {
              var Ct = p,
                bt = p;
              ut = [ut[0], null].concat(ut.slice(1));
              var wt = q,
                Et = ut.length;
              2 > Et &&
                St(
                  "argTypes array size mismatch! Must at least get return value and 'this' types!"
                );
              for (
                var Rt = ut[1] !== null && !1, Z = !1, ct = 1;
                ct < ut.length;
                ++ct
              )
                if (ut[ct] !== null && ut[ct].oa === void 0) {
                  Z = !0;
                  break;
                }
              var Lt = ut[0].name !== 'void',
                Dt = '',
                jt = '';
              for (ct = 0; ct < Et - 2; ++ct)
                (Dt += (ct !== 0 ? ', ' : '') + 'arg' + ct),
                  (jt += (ct !== 0 ? ', ' : '') + 'arg' + ct + 'Wired');
              (bt =
                'return function ' +
                kt(bt) +
                '(' +
                Dt +
                `) {
if (arguments.length !== ` +
                (Et - 2) +
                `) {
throwBindingError('function ` +
                bt +
                " called with ' + arguments.length + ' arguments, expected " +
                (Et - 2) +
                ` args!');
}
`),
                Z &&
                  (bt += `var destructors = [];
`);
              var Xt = Z ? 'destructors' : 'null';
              for (
                Dt =
                  'throwBindingError invoker fn runDestructors retType classParam'.split(
                    ' '
                  ),
                  wt = [St, wt, J, br, ut[0], ut[1]],
                  Rt &&
                    (bt +=
                      'var thisWired = classParam.toWireType(' +
                      Xt +
                      `, this);
`),
                  ct = 0;
                ct < Et - 2;
                ++ct
              )
                (bt +=
                  'var arg' +
                  ct +
                  'Wired = argType' +
                  ct +
                  '.toWireType(' +
                  Xt +
                  ', arg' +
                  ct +
                  '); // ' +
                  ut[ct + 2].name +
                  `
`),
                  Dt.push('argType' + ct),
                  wt.push(ut[ct + 2]);
              if (
                (Rt && (jt = 'thisWired' + (0 < jt.length ? ', ' : '') + jt),
                (bt +=
                  (Lt ? 'var rv = ' : '') +
                  'invoker(fn' +
                  (0 < jt.length ? ', ' : '') +
                  jt +
                  `);
`),
                Z)
              )
                bt += `runDestructors(destructors);
`;
              else
                for (ct = Rt ? 1 : 2; ct < ut.length; ++ct)
                  (Et = ct === 1 ? 'thisWired' : 'arg' + (ct - 2) + 'Wired'),
                    ut[ct].oa !== null &&
                      ((bt +=
                        Et +
                        '_dtor(' +
                        Et +
                        '); // ' +
                        ut[ct].name +
                        `
`),
                      Dt.push(Et + '_dtor'),
                      wt.push(ut[ct].oa));
              return (
                Lt &&
                  (bt += `var ret = retType.fromWireType(rv);
return ret;
`),
                Dt.push(
                  bt +
                    `}
`
                ),
                (ut = Ml(Dt).apply(null, wt)),
                fo(Ct, ut, y - 1),
                []
              );
            });
        },
        d: function (p, y, S, R, q) {
          function J(bt) {
            return bt;
          }
          (y = X(y)), q === -1 && (q = 4294967295);
          var ht = z(S);
          if (R === 0) {
            var ut = 32 - 8 * S;
            J = function (bt) {
              return (bt << ut) >>> ut;
            };
          }
          var Ct = y.indexOf('unsigned') != -1;
          Ft(p, {
            name: y,
            fromWireType: J,
            toWireType: function (bt, wt) {
              if (typeof wt != 'number' && typeof wt != 'boolean')
                throw new TypeError(
                  'Cannot convert "' + Te(wt) + '" to ' + this.name
                );
              if (wt < R || wt > q)
                throw new TypeError(
                  'Passing a number "' +
                    Te(wt) +
                    '" from JS side to C/C++ side to an argument of type "' +
                    y +
                    '", which is outside the valid range [' +
                    R +
                    ', ' +
                    q +
                    ']!'
                );
              return Ct ? wt >>> 0 : wt | 0;
            },
            argPackAdvance: 8,
            readValueFromPointer: Fl(y, ht, R !== 0),
            oa: null,
          });
        },
        c: function (p, y, S) {
          function R(J) {
            J >>= 2;
            var ht = nt;
            return new q(V, ht[J + 1], ht[J]);
          }
          var q = [
            Int8Array,
            Uint8Array,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array,
          ][y];
          (S = X(S)),
            Ft(
              p,
              {
                name: S,
                fromWireType: R,
                argPackAdvance: 8,
                readValueFromPointer: R,
              },
              { Na: !0 }
            );
        },
        i: function (p, y) {
          y = X(y);
          var S = y === 'std::string';
          Ft(p, {
            name: y,
            fromWireType: function (R) {
              var q = nt[R >> 2];
              if (S)
                for (var J = R + 4, ht = 0; ht <= q; ++ht) {
                  var ut = R + 4 + ht;
                  if (ht == q || M[ut] == 0) {
                    if (((J = J ? E(M, J, ut - J) : ''), Ct === void 0))
                      var Ct = J;
                    else (Ct += String.fromCharCode(0)), (Ct += J);
                    J = ut + 1;
                  }
                }
              else {
                for (Ct = Array(q), ht = 0; ht < q; ++ht)
                  Ct[ht] = String.fromCharCode(M[R + 4 + ht]);
                Ct = Ct.join('');
              }
              return le(R), Ct;
            },
            toWireType: function (R, q) {
              q instanceof ArrayBuffer && (q = new Uint8Array(q));
              var J = typeof q == 'string';
              J ||
                q instanceof Uint8Array ||
                q instanceof Uint8ClampedArray ||
                q instanceof Int8Array ||
                St('Cannot pass non-string to std::string');
              var ht = (
                  S && J
                    ? function () {
                        return A(q);
                      }
                    : function () {
                        return q.length;
                      }
                )(),
                ut = Dn(4 + ht + 1);
              if (((nt[ut >> 2] = ht), S && J)) I(q, M, ut + 4, ht + 1);
              else if (J)
                for (J = 0; J < ht; ++J) {
                  var Ct = q.charCodeAt(J);
                  255 < Ct &&
                    (le(ut),
                    St(
                      'String has UTF-16 code units that do not fit in 8 bits'
                    )),
                    (M[ut + 4 + J] = Ct);
                }
              else for (J = 0; J < ht; ++J) M[ut + 4 + J] = q[J];
              return R !== null && R.push(le, ut), ut;
            },
            argPackAdvance: 8,
            readValueFromPointer: An,
            oa: function (R) {
              le(R);
            },
          });
        },
        h: function (p, y, S) {
          if (((S = X(S)), y === 2))
            var R = W,
              q = it,
              J = j,
              ht = function () {
                return Y;
              },
              ut = 1;
          else
            y === 4 &&
              ((R = at),
              (q = lt),
              (J = L),
              (ht = function () {
                return nt;
              }),
              (ut = 2));
          Ft(p, {
            name: S,
            fromWireType: function (Ct) {
              for (
                var bt = nt[Ct >> 2], wt = ht(), Et, Rt = Ct + 4, Z = 0;
                Z <= bt;
                ++Z
              ) {
                var ct = Ct + 4 + Z * y;
                (Z == bt || wt[ct >> ut] == 0) &&
                  ((Rt = R(Rt, ct - Rt)),
                  Et === void 0
                    ? (Et = Rt)
                    : ((Et += String.fromCharCode(0)), (Et += Rt)),
                  (Rt = ct + y));
              }
              return le(Ct), Et;
            },
            toWireType: function (Ct, bt) {
              typeof bt != 'string' &&
                St('Cannot pass non-string to C++ string type ' + S);
              var wt = J(bt),
                Et = Dn(4 + wt + y);
              return (
                (nt[Et >> 2] = wt >> ut),
                q(bt, Et + 4, wt + y),
                Ct !== null && Ct.push(le, Et),
                Et
              );
            },
            argPackAdvance: 8,
            readValueFromPointer: An,
            oa: function (Ct) {
              le(Ct);
            },
          });
        },
        p: function (p, y) {
          (y = X(y)),
            Ft(p, {
              fb: !0,
              name: y,
              argPackAdvance: 0,
              fromWireType: function () {},
              toWireType: function () {},
            });
        },
        n: function () {
          ft();
        },
        s: function (p, y, S) {
          M.copyWithin(p, y, y + S);
        },
        t: function (p) {
          p >>>= 0;
          var y = M.length;
          if (2147483648 < p) return !1;
          for (var S = 1; 4 >= S; S *= 2) {
            var R = y * (1 + 0.2 / S);
            (R = Math.min(R, p + 100663296)),
              (R = Math.max(16777216, p, R)),
              0 < R % 65536 && (R += 65536 - (R % 65536));
            t: {
              try {
                d.grow((Math.min(2147483648, R) - V.byteLength + 65535) >>> 16),
                  T(d.buffer);
                var q = 1;
                break t;
              } catch {}
              q = void 0;
            }
            if (q) return !0;
          }
          return !1;
        },
        v: function (p, y) {
          var S = 0;
          return (
            yo().forEach(function (R, q) {
              var J = y + S;
              for (q = st[(p + 4 * q) >> 2] = J, J = 0; J < R.length; ++J)
                f[q++ >> 0] = R.charCodeAt(J);
              (f[q >> 0] = 0), (S += R.length + 1);
            }),
            0
          );
        },
        w: function (p, y) {
          var S = yo();
          st[p >> 2] = S.length;
          var R = 0;
          return (
            S.forEach(function (q) {
              R += q.length + 1;
            }),
            (st[y >> 2] = R),
            0
          );
        },
        x: function () {
          return 0;
        },
        y: function (p, y, S, R) {
          return (p = wo.eb(p)), (y = wo.cb(p, y, S)), (st[R >> 2] = y), 0;
        },
        q: function () {},
        k: function (p, y, S, R) {
          for (var q = 0, J = 0; J < S; J++) {
            for (
              var ht = st[(y + 8 * J) >> 2],
                ut = st[(y + (8 * J + 4)) >> 2],
                Ct = 0;
              Ct < ut;
              Ct++
            ) {
              var bt = M[ht + Ct],
                wt = Bl[p];
              bt === 0 || bt === 10
                ? ((p === 1 ? b : h)(E(wt, 0)), (wt.length = 0))
                : wt.push(bt);
            }
            q += ut;
          }
          return (st[R >> 2] = q), 0;
        },
        a: d,
        r: function () {},
        u: function (p, y, S, R) {
          return Vl(p, y, S, R);
        },
      };
      (function () {
        function p(J) {
          (J = J.exports),
            (J = Co(J)),
            (t.asm = J),
            dt--,
            t.monitorRunDependencies && t.monitorRunDependencies(dt),
            dt == 0 && yt && ((J = yt), (yt = null), J());
        }
        function y(J) {
          p(J.instance);
        }
        function S(J) {
          return x()
            .then(function (ht) {
              return WebAssembly.instantiate(ht, R);
            })
            .then(J, function (ht) {
              h('failed to asynchronously prepare wasm: ' + ht), ft(ht);
            });
        }
        var R = { a: $l };
        if (
          (dt++,
          t.monitorRunDependencies && t.monitorRunDependencies(dt),
          t.instantiateWasm)
        )
          try {
            var q = t.instantiateWasm(R, p);
            return (q = Co(q));
          } catch (J) {
            return (
              h('Module.instantiateWasm callback failed with error: ' + J), !1
            );
          }
        return (
          (function () {
            if (
              _ ||
              typeof WebAssembly.instantiateStreaming != 'function' ||
              xt() ||
              et('file://') ||
              typeof fetch != 'function'
            )
              return S(y);
            fetch(u, { credentials: 'same-origin' }).then(function (J) {
              return WebAssembly.instantiateStreaming(J, R).then(
                y,
                function (ht) {
                  return (
                    h('wasm streaming compile failed: ' + ht),
                    h('falling back to ArrayBuffer instantiation'),
                    S(y)
                  );
                }
              );
            });
          })(),
          {}
        );
      })();
      var xo = (t.___wasm_call_ctors = function () {
          return (xo = t.___wasm_call_ctors = t.asm.B).apply(null, arguments);
        }),
        Dn = (t._malloc = function () {
          return (Dn = t._malloc = t.asm.C).apply(null, arguments);
        }),
        le = (t._free = function () {
          return (le = t._free = t.asm.D).apply(null, arguments);
        }),
        So = (t.___getTypeName = function () {
          return (So = t.___getTypeName = t.asm.E).apply(null, arguments);
        });
      (t.___embind_register_native_and_builtin_types = function () {
        return (t.___embind_register_native_and_builtin_types = t.asm.F).apply(
          null,
          arguments
        );
      }),
        (t.dynCall_ii = function () {
          return (t.dynCall_ii = t.asm.G).apply(null, arguments);
        }),
        (t.dynCall_vi = function () {
          return (t.dynCall_vi = t.asm.H).apply(null, arguments);
        }),
        (t.dynCall_iii = function () {
          return (t.dynCall_iii = t.asm.I).apply(null, arguments);
        }),
        (t.dynCall_viii = function () {
          return (t.dynCall_viii = t.asm.J).apply(null, arguments);
        }),
        (t.dynCall_fii = function () {
          return (t.dynCall_fii = t.asm.K).apply(null, arguments);
        }),
        (t.dynCall_viif = function () {
          return (t.dynCall_viif = t.asm.L).apply(null, arguments);
        }),
        (t.dynCall_viiii = function () {
          return (t.dynCall_viiii = t.asm.M).apply(null, arguments);
        }),
        (t.dynCall_viiiiii = function () {
          return (t.dynCall_viiiiii = t.asm.N).apply(null, arguments);
        }),
        (t.dynCall_i = function () {
          return (t.dynCall_i = t.asm.O).apply(null, arguments);
        }),
        (t.dynCall_iiiii = function () {
          return (t.dynCall_iiiii = t.asm.P).apply(null, arguments);
        }),
        (t.dynCall_iiiiiii = function () {
          return (t.dynCall_iiiiiii = t.asm.Q).apply(null, arguments);
        }),
        (t.dynCall_iiii = function () {
          return (t.dynCall_iiii = t.asm.R).apply(null, arguments);
        }),
        (t.dynCall_vii = function () {
          return (t.dynCall_vii = t.asm.S).apply(null, arguments);
        }),
        (t.dynCall_viijii = function () {
          return (t.dynCall_viijii = t.asm.T).apply(null, arguments);
        }),
        (t.dynCall_jiji = function () {
          return (t.dynCall_jiji = t.asm.U).apply(null, arguments);
        }),
        (t.dynCall_iiiiiiiii = function () {
          return (t.dynCall_iiiiiiiii = t.asm.V).apply(null, arguments);
        }),
        (t.dynCall_iiiiii = function () {
          return (t.dynCall_iiiiii = t.asm.W).apply(null, arguments);
        }),
        (t.dynCall_iiiiiiii = function () {
          return (t.dynCall_iiiiiiii = t.asm.X).apply(null, arguments);
        }),
        (t.dynCall_iiiiiijj = function () {
          return (t.dynCall_iiiiiijj = t.asm.Y).apply(null, arguments);
        }),
        (t.dynCall_iiiiij = function () {
          return (t.dynCall_iiiiij = t.asm.Z).apply(null, arguments);
        }),
        (t.dynCall_iiiiid = function () {
          return (t.dynCall_iiiiid = t.asm._).apply(null, arguments);
        }),
        (t.dynCall_iiiiijj = function () {
          return (t.dynCall_iiiiijj = t.asm.$).apply(null, arguments);
        }),
        (t.dynCall_v = function () {
          return (t.dynCall_v = t.asm.aa).apply(null, arguments);
        }),
        (t.dynCall_viiiii = function () {
          return (t.dynCall_viiiii = t.asm.ba).apply(null, arguments);
        }),
        (t._asyncify_start_unwind = function () {
          return (t._asyncify_start_unwind = t.asm.ca).apply(null, arguments);
        }),
        (t._asyncify_stop_unwind = function () {
          return (t._asyncify_stop_unwind = t.asm.da).apply(null, arguments);
        }),
        (t._asyncify_start_rewind = function () {
          return (t._asyncify_start_rewind = t.asm.ea).apply(null, arguments);
        }),
        (t._asyncify_stop_rewind = function () {
          return (t._asyncify_stop_rewind = t.asm.fa).apply(null, arguments);
        });
      var Pn;
      yt = function p() {
        Pn || Sr(), Pn || (yt = p);
      };
      function Sr() {
        function p() {
          if (!Pn && ((Pn = !0), (t.calledRun = !0), !v)) {
            if (
              (C($),
              C(P),
              r(t),
              t.onRuntimeInitialized && t.onRuntimeInitialized(),
              t.postRun)
            )
              for (
                typeof t.postRun == 'function' && (t.postRun = [t.postRun]);
                t.postRun.length;

              ) {
                var y = t.postRun.shift();
                vt.unshift(y);
              }
            C(vt);
          }
        }
        if (!(0 < dt)) {
          if (t.preRun)
            for (
              typeof t.preRun == 'function' && (t.preRun = [t.preRun]);
              t.preRun.length;

            )
              Q();
          C(H),
            0 < dt ||
              (t.setStatus
                ? (t.setStatus('Running...'),
                  setTimeout(function () {
                    setTimeout(function () {
                      t.setStatus('');
                    }, 1),
                      p();
                  }, 1))
                : p());
        }
      }
      if (((t.run = Sr), t.preInit))
        for (
          typeof t.preInit == 'function' && (t.preInit = [t.preInit]);
          0 < t.preInit.length;

        )
          t.preInit.pop()();
      return Sr(), n.ready;
    };
  })();
  class Al {
    constructor() {
      Bt(this, 'samWasmModule');
    }
    getOverriddenModules(n) {
      return { locateFile: (t) => n || t };
    }
    async initSamModule(n) {
      this.samWasmModule ||
        (this.samWasmModule = await Sl(this.getOverriddenModules(n)));
    }
    parseRawDocumentData(n, t) {
      const { brightness: r, hotspots: o, sharpness: i } = n.params;
      return {
        confidence: n.score / 1e3,
        topLeft: { x: n.x0 / t.width, y: n.y0 / t.height },
        topRight: { x: n.x1 / t.width, y: n.y1 / t.height },
        bottomRight: { x: n.x2 / t.width, y: n.y2 / t.height },
        bottomLeft: { x: n.x3 / t.width, y: n.y3 / t.height },
        brightness: r,
        hotspots: o,
        sharpness: i,
      };
    }
    async detectDocument(n) {
      if (this.samWasmModule == null)
        throw new Nt('SAM WASM module is not initialized');
      const t = qu(n),
        r = this.samWasmModule.detectDocumentWithImageParameters(
          n.width,
          n.height,
          t,
          0,
          0
        );
      return this.parseRawDocumentData(r, n);
    }
  }
  const uo = new Al(),
    yr = class {
      constructor() {
        Bt(this, 'isDetectorInitialized', !1);
        Bt(this, 'isInCandidateSelection', !1);
        Bt(this, 'lastImage', null);
        Bt(this, 'bestImage', null);
        Bt(this, 'validationMode', null);
        Bt(this, 'thresholds', null);
        Bt(this, 'record', []);
        Bt(this, 'candidateSelectionImages', []);
        Bt(this, 'getInstructionCode', (n, t) => {
          var r;
          if (this.isInCandidateSelection) return 'candidate_selection';
          if (((r = this.lastImage) == null ? void 0 : r.isValid) && t)
            return 'candidate_selection';
          if (this.lastImage && t) return this.lastImage.instructionCode;
          if (n.isPresent) {
            if (this.validationMode === 'strict' && !n.doesFit)
              return 'document_centering';
            if (n.isNotOutOfBounds)
              if (n.isNotSmall)
                if (n.isSharp)
                  if (n.isNotDim)
                    if (n.isNotBright) {
                      if (!n.noHotspots) return 'hotspots_present';
                    } else return 'brightness_too_high';
                  else return 'brightness_too_low';
                else return 'sharpness_too_low';
              else return 'document_too_far';
            else return 'document_centering';
          } else return 'document_not_present';
          return 'document_not_present';
        });
      }
      static getInstance() {
        return this._instance || (this._instance = new yr()), this._instance;
      }
      async initDocumentDetector(n) {
        await uo.initSamModule(n), (this.isDetectorInitialized = !0);
      }
      getCandidateSelectionImages() {
        return this.candidateSelectionImages;
      }
      getBestImage() {
        return this.bestImage;
      }
      getRecord() {
        return this.record;
      }
      setThresholds(n) {
        this.thresholds = n;
      }
      setValidationMode(n) {
        this.validationMode = n;
      }
      restart() {
        (this.isInCandidateSelection = !1),
          (this.lastImage = null),
          (this.bestImage = null),
          (this.candidateSelectionImages = []);
      }
      validateDetectedDocument(n) {
        if (!this.thresholds)
          throw new Nt('Thresholds for Document controller are not provided');
        const t = n.confidence > this.thresholds.confidenceThreshold,
          r =
            n.placeholderFitError <
            this.thresholds.placeholderErrorScoreThreshold,
          o = n.sharpness > this.thresholds.sharpnessThreshold,
          i = n.brightness > this.thresholds.brightnessLowThreshold,
          a = n.brightness < this.thresholds.brightnessHighThreshold,
          s = n.hotspots < this.thresholds.hotspotsScoreThreshold,
          l = n.smallestEdge > this.thresholds.sizeSmallThreshold,
          g = Cl(this.thresholds.outOfBoundsThreshold, n);
        return {
          isPresent: t,
          doesFit: r,
          isSharp: o,
          isNotDim: i,
          isNotBright: a,
          noHotspots: s,
          isNotOutOfBounds: g,
          isNotSmall: l,
        };
      }
      checkIfDetectedDocumentIsValid(n) {
        const t =
          n.isPresent &&
          n.isSharp &&
          n.isNotDim &&
          n.isNotBright &&
          n.noHotspots &&
          n.isNotOutOfBounds &&
          n.isNotSmall;
        return this.validationMode === 'strict' ? t && n.doesFit : t;
      }
      async processImage(n) {
        var b;
        const t = { width: n.width, height: n.height },
          r = Le(t),
          o = Xu(n, r),
          i = { width: o.width, height: o.height },
          a = await uo.detectDocument(o),
          s = xl(a, t, i),
          l = this.validateDetectedDocument(s),
          g = this.checkIfDetectedDocumentIsValid(l),
          c = this.getInstructionCode(l, g);
        if (this.isInCandidateSelection) {
          if (this.bestImage && g && so(this.bestImage.detection, s)) {
            const h = { image: o, detection: Pe(s) };
            (this.bestImage = h), this.candidateSelectionImages.push(h);
          }
        } else if (((b = this.lastImage) == null ? void 0 : b.isValid) && g) {
          const h = { image: o, detection: Pe(s) },
            _ = {
              image: this.lastImage.image,
              detection: this.lastImage.detection,
            };
          so(_.detection, h.detection)
            ? (this.bestImage = h)
            : (this.bestImage = _),
            this.candidateSelectionImages.push(_, h),
            (this.isInCandidateSelection = !0);
        } else
          g
            ? (this.lastImage = {
                instructionCode: c,
                isValid: !0,
                image: o,
                detection: Pe(s),
              })
            : (this.lastImage = {
                instructionCode: c,
                isValid: !1,
                image: o,
                detection: Pe(s),
              });
        const w = {
          detectedDocument: Pe(s),
          instructionCode: c,
          isInCandidateSelection: this.isInCandidateSelection,
        };
        return this.record.push(w.detectedDocument), w;
      }
    };
  let Cn = yr;
  Bt(Cn, '_instance');
  const El = ({ fontSize: e }) => {
      const {
          appState: n,
          setAppState: t,
          handleError: r,
          setIsCameraReady: o,
        } = Zn(),
        { documentCameraOptions: i } = Ne(),
        {
          uiCustomisation: a,
          samWasmUrl: s,
          thresholds: l,
          validationMode: g,
          cameraFacing: c,
          photoTakenCb: w,
          imageType: b,
          detectionLayerVisible: h,
        } = i,
        _ = _e(null),
        [d, v] = Mt(!1),
        [m, k] = Mt(null),
        [E, I] = Mt(null),
        [A, U] = Mt(void 0),
        [W, it] = Mt(null),
        [j, at] = Mt(!1),
        [lt, L] = Mt(null),
        [V, f] = Mt(null),
        [M, gt] = Mt(null),
        [Y, st] = Mt(null),
        nt = _e(null),
        mt = nu(Y);
      $t(
        () => (
          window.addEventListener('beforeunload', ze.endSession),
          () => {
            ze.endSession(),
              window.removeEventListener('beforeunload', ze.endSession);
          }
        ),
        []
      ),
        $t(
          () => (
            (async () => {
              if (!(_ != null && _.current)) {
                r(new Nt('Something went wrong during video initialization'));
                return;
              }
              const $ = new vn(_.current);
              try {
                await $.initWebcam({ facingMode: c });
              } catch (P) {
                if (P instanceof Error) {
                  r(Nt.fromCameraError(P));
                  return;
                }
              }
              o(!0),
                gt($.getCameraResolution()),
                f($.getCameraSettings()),
                st($),
                (nt.current = $);
            })(),
            function () {
              nt.current && nt.current.stopCamera();
            }
          ),
          [c, r, o]
        ),
        $t(() => {
          (async () => {
            const $ = Cn.getInstance();
            $.setThresholds(l), $.setValidationMode(g);
            try {
              await $.initDocumentDetector(s);
            } catch {
              r(new Nt('Cannot init document detector'));
              return;
            }
            L($);
          })();
        }, [r, s, l, g]),
        $t(() => {
          (Y == null ? void 0 : Y.videoTrack) &&
            (lt == null ? void 0 : lt.isDetectorInitialized) &&
            t(zt.RUNNING);
        }, [
          Y == null ? void 0 : Y.videoTrack,
          lt == null ? void 0 : lt.isDetectorInitialized,
          t,
        ]),
        $t(() => {
          if (n !== zt.RUNNING) return;
          if (!Y || !lt) throw new Nt('Cannot start detection');
          const H = async (ft, et, xt) => {
            const u = { width: ft.width, height: ft.height },
              N = `image/${b}`,
              F = await Gu(ft, N, 90),
              x = {
                cameraSettings: {
                  ...(Y == null ? void 0 : Y.getCameraSettings()),
                  deviceName: await (Y == null ? void 0 : Y.getDeviceName()),
                },
                detection: et,
                imageResolution: u,
                record: j ? xt : void 0,
              };
            if (Ku()) {
              const D = {
                candidateSelectionImages:
                  lt == null ? void 0 : lt.getCandidateSelectionImages(),
              };
              da('document-auto-capture:dev', D);
            }
            w(F, x);
          };
          let $ = 0,
            P = !1,
            vt = 0,
            Q = 0;
          const dt = new Ju(30);
          return (
            (async () => {
              const ft = Date.now();
              for (; Y.checkIfStreamIsRunning() && !P; ) {
                if (fa($, Q)) {
                  const { image: tt, detection: z } = lt.getBestImage() || {},
                    ot = lt.getRecord();
                  if (tt && z) {
                    const X = Date.now();
                    ze.sendDocumentData({
                      documentDetection: z,
                      imageResolution: { width: tt.width, height: tt.height },
                      deviceName: await Y.getDeviceName(),
                      averageFps: Qu(dt),
                      captureProcessDurationInMs: X - ft,
                    }),
                      await H(tt, z, ot),
                      t(zt.WAITING),
                      v(!1),
                      lt.restart();
                  } else
                    r(new Nt('Something went wrong during capturing an image'));
                  return;
                }
                const et = Date.now(),
                  xt = Y.takePhoto(),
                  u = { width: xt.width, height: xt.height };
                let N;
                try {
                  N = await lt.processImage(xt);
                } catch (tt) {
                  tt instanceof Error && r(Nt.fromCameraError(tt));
                  return;
                }
                const x = Date.now() - et,
                  C = oi(1e3 / x);
                dt.pushFixed(C);
                const D = {
                  document: N.detectedDocument,
                  detectionTime: x,
                  fps: C,
                  resolution: u,
                  instructionCode: N.instructionCode,
                };
                it(D),
                  j && console.log(D),
                  N.isInCandidateSelection && Q++,
                  N.isInCandidateSelection &&
                    $ === 0 &&
                    (($ = performance.now()),
                    v(!0),
                    U(a.instructions[N.instructionCode]));
                const G = performance.now();
                G - vt > Uo && (U(a.instructions[N.instructionCode]), (vt = G)),
                  gt(u),
                  await oa(Math.max(ri.max - x, ri.min));
              }
            })(),
            () => {
              P = !0;
            }
          );
        }, [n, Y, lt, j, i, t, r, a.instructions, b, w]),
        $t(() => {
          at(!!window.DOT_DEBUG_MODE);
        }, [window.DOT_DEBUG_MODE]),
        $t(() => {
          !M || I(vr(M));
        }, [M == null ? void 0 : M.width, M == null ? void 0 : M.height, M]);
      async function B() {
        if (!!Y) {
          t(zt.LOADING);
          try {
            await Y.switchCamera();
          } catch (H) {
            if (H instanceof Error) {
              r(Nt.fromCameraError(H));
              return;
            }
          }
          f(Y.getCameraSettings()), k(null);
        }
      }
      const T = De(
        () =>
          (V == null ? void 0 : V.facingMode) == null
            ? m != null
              ? m
              : !Gn()
            : m != null
            ? m
            : V.facingMode === 'user',
        [V, m]
      );
      function K() {
        m == null ? k(!T) : k(!m);
      }
      return (
        $t(() => {
          const H = ($) => {
            var P;
            ((P = $.detail) == null ? void 0 : P.instruction) ===
              'continue-detection' &&
              n === zt.WAITING &&
              t(zt.RUNNING);
          };
          return (
            document.addEventListener('document-auto-capture', H),
            () => {
              document.removeEventListener('document-auto-capture', H);
            }
          );
        }, [n, t]),
        O(qs, {
          children: [
            O(Ks, {
              ref: _,
              autoPlay: !0,
              muted: !0,
              playsInline: !0,
              isImageMirror: T,
            }),
            j &&
              W &&
              M &&
              n === zt.RUNNING &&
              O(al, {
                detectionDetails: W,
                isImageMirror: T,
                cameraResolution: M,
              }),
            h &&
              W &&
              M &&
              n === zt.RUNNING &&
              O(ul, {
                detectionDetails: W,
                isImageMirror: T,
                cameraResolution: M,
              }),
            n === zt.RUNNING &&
              O(Qs, {
                children: [
                  O(Zi, { marginRight: mt, onClick: K, children: O(Wu, {}) }),
                  mt && O(Zi, { onClick: B, children: O(Hu, {}) }),
                ],
              }),
            n === zt.RUNNING &&
              E &&
              O(Js, {
                isInCandidateSelection: d,
                placeholderRect: E,
                children: O(wl, {}),
              }),
            n === zt.RUNNING &&
              O(tu, {
                cssTop: 50,
                children: O(Yu, {
                  instructionText: A,
                  isInCandidateSelection: d,
                  fontSize: e,
                }),
              }),
          ],
        })
      );
    },
    Ll = () => {
      const {
          documentCameraOptions: {
            uiCustomisation: { colors: e, appStateInstructions: n },
            onError: t,
          },
        } = Ne(),
        { appState: r } = Zn(),
        o = _e(null),
        i = ru(o);
      return O(js, {
        theme: Uu(e),
        children: O(Xs, {
          ref: o,
          children: O(Yi, {
            triggerOnError: t,
            fontSize: i,
            children: [
              O(El, { fontSize: i }),
              n.loading.visible &&
                r === zt.LOADING &&
                O(lr, {
                  text: n.loading.text,
                  fontSize: i,
                  currentAppState: zt.LOADING,
                }),
              n.waiting.visible &&
                r === zt.WAITING &&
                O(lr, {
                  text: n.waiting.text,
                  fontSize: i,
                  currentAppState: zt.WAITING,
                }),
            ],
          }),
        }),
      });
    },
    ql = '';
  No(
    ({ cameraOptions: e }) => (
      $t(() => {
        ze.init('065cf6e242fc5e785cd17eebfbfbbd212a33133b');
      }, []),
      e
        ? O(ma, {
            cameraOptions: e,
            children: O(Vo, { onError: e.onError, children: O(Ll, {}) }),
          })
        : null
    ),
    'x-dot-document-auto-capture',
    ['cameraOptions']
  );
});
